var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 977,
    height: 600,
    viewBox: "0 0 977 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient60",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-91.3976) rotate(-60 -60.21 37.065)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath60",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5696.69 3163.01c-2.6 5.51-5.21 11.01-7.81 16.53 3.28-6.96 5.04-15.72 4.89-26.05-.59-38.95-28.08-85.47-61.41-103.91l15.28.63c28.93 16 52.79 56.38 53.3 90.19.12 8.97-1.4 16.57-4.25 22.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient65",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(123.755) rotate(60 1.436 51.745)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath65",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5647.79 3060.3c24.16 13.37 44.09 47.09 44.5 75.32.23 14.52-4.77 24.77-12.95 29.46l3.13-1.8c8.19-4.7 13.18-14.94 12.97-29.47-.42-28.22-20.35-61.94-44.51-75.31-11.72-6.49-22.29-7-30.01-2.56l-3.15 1.8c7.73-4.43 18.29-3.93 30.02 2.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient70",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1966.891 3166.619) scale(138.1114)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath70",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5607.95 3085.41c.42 28.22 20.35 61.94 44.51 75.31 24.16 13.37 43.4 1.32 42.98-26.91-.42-28.22-20.35-61.94-44.51-75.31-24.16-13.37-43.4-1.33-42.98 26.91zm-18.93-18.53c.12-2.09.35-4.89.63-6.96.76-5.62 2.01-9.79 2.51-11.33.73-2.23 1.82-5.18 2.91-7.27a89.3 89.3 0 013.27-5.7l2-2.76c1.35-1.75 3.5-4.01 4.67-5.02l2.42-2.04c1.35-.99 3.2-2.23 4.61-3.1 11.88-6.81 28.13-6.04 46.14 3.93 37.15 20.55 67.79 72.4 68.43 115.8.33 22.33-7.34 38.07-19.93 45.29-1.67.88-3.93 1.97-5.67 2.69-1.14.46-2.73.9-3.91 1.26-1.91.56-5.58 1.22-8.4 1.35-1.77.08-4.12.07-5.89 0-1.17-.05-2.74-.21-3.9-.39-2.32-.36-5.37-1.02-7.64-1.59-1.38-.34-3.19-.91-4.52-1.44-1.37-.53-3.23-1.2-4.58-1.81-2.14-.97-4.95-2.34-7.01-3.47-5.67-3.1-10.85-7.01-10.9-7.04-1.49-1.15-3.48-2.67-4.91-3.87-1.62-1.34-3.75-3.17-5.25-4.64-2.82-2.77-6.49-6.58-9.17-9.51-1.44-1.56-3.18-3.81-4.54-5.46-2.53-3.07-6.85-9.25-8.09-11.25-1.1-1.77-2.61-4.11-3.67-5.91-1.06-1.79-2.38-4.24-3.41-6.06-1.01-1.81-2.18-4.33-3.12-6.2-.02-.04-2.71-5.49-5.37-12.72-1.39-3.77-2.98-8.9-4.02-12.79-.29-1.07-1.77-6.76-2.72-13.36-.81-5.75-1.03-10.3-1.05-13.11-.02-1.65-.01-3.86.08-5.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient75",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(123.754) rotate(60 1.676 51.885)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath75",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5677.56 3043.22c24.16 13.37 44.09 47.09 44.51 75.32.22 14.53-4.78 24.77-12.97 29.47l3.24-1.86c8.2-4.7 13.19-14.94 12.97-29.47-.43-28.23-20.35-61.95-44.51-75.32-11.73-6.49-22.29-6.99-30.02-2.56l-3.23 1.86c7.71-4.43 18.28-3.93 30.01 2.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient80",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-116.104) rotate(-60 -47.285 29.517)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath80",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5627.78 3075.79l.48 2.47c-1.03-5.31-1.63-10.56-1.7-15.67-.52-35.18 23.45-50.2 53.57-33.54 30.1 16.66 54.94 58.69 55.47 93.87.52 35.19-23.46 50.2-53.57 33.54-5.22-2.89-10.28-6.54-15.09-10.78l1.89 1.66c5.1 4.51 10.47 8.38 16 11.44 31.96 17.68 57.41 1.75 56.85-35.59-.56-37.33-26.91-81.93-58.87-99.61-31.95-17.68-57.4-1.75-56.84 35.59.07 5.42.7 11 1.81 16.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient85",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1975.09 3170.572) scale(109.4104)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath85",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5680.21 3034.75c27.42 15.17 50.03 53.44 50.51 85.47.48 32.04-21.36 45.71-48.78 30.54-27.42-15.17-50.03-53.44-50.5-85.47-.48-32.04 21.35-45.71 48.77-30.54zm-53.65 27.84c.52 35.18 25.35 77.21 55.47 93.87 30.11 16.66 54.09 1.65 53.57-33.54-.53-35.18-25.37-77.21-55.47-93.87-30.12-16.66-54.09-1.65-53.57 33.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient90",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-123.8117) rotate(-60 -44.325 27.72)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath90",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5625.97 3059.17c.07 5.47.72 11.09 1.84 16.76v.01c.71 3.13 1.66 7.31 2.59 10.38.53 1.74 1.27 4.05 1.88 5.76.6 1.7 1.48 3.94 2.12 5.62 1.61 4.15 5.34 11.97 8.35 17.11 1.91 3.24 4.57 7.48 6.71 10.57 1.86 2.7 4.55 6.13 6.59 8.69 2.29 2.84 3.81 4.43 7.88 8.66 1.36 1.43 3.32 3.19 4.78 4.51h.01c5.13 4.55 10.53 8.46 16.11 11.54 31.96 17.68 57.41 1.75 56.85-35.59-.56-37.33-26.91-81.93-58.87-99.61-31.95-17.68-57.4-1.75-56.84 35.59zm-2.47-2.92c-.6-39.81 26.55-56.8 60.62-37.94 34.07 18.85 62.18 66.41 62.77 106.23.59 39.81-26.55 56.8-60.62 37.95-5.95-3.3-11.72-7.47-17.18-12.31.29-1.08.26-1.94-.07-2.52.33.58.36 1.44.07 2.52-21.28-18.85-38.06-48-43.62-76.04l1.62.74-1.62-.74c-1.2-6.05-1.89-12.05-1.97-17.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient95",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(186.811 0 0 -186.811 5542.8 3112.16)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath95",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5542.81 3086.11c.96 64.23 22.17 100.75 77.68 131.46 20.55 11.37 39.05 12.21 52.54 4.39 14.11-8.18 42.47-24.63 56.58-32.8-13.47 7.8-31.93 6.96-52.42-4.38-42.09-23.28-76.8-82.02-77.53-131.19-.19-12.55 1.86-23.27 5.71-31.89 8.28.97 17.29 3.96 26.72 9.18l42.43-24.16c-20.35-11.26-38.7-12.16-52.14-4.54-14.18 8.05-42.61 24.36-56.79 32.41-14.39 8.16-23.16 26.07-22.78 51.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient100",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1984 3167.019) scale(134.0828)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath100",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5684.25 3026.87c30.02 16.62 54.78 58.53 55.31 93.61.53 35.08-23.39 50.05-53.42 33.44-30.02-16.62-54.78-58.52-55.31-93.61-.53-35.08 23.39-50.05 53.42-33.44zm-65.87 26.55c.64 43.12 31.08 94.63 67.98 115.04 36.9 20.42 66.3 2.02 65.65-41.09-.64-43.12-31.08-94.63-67.99-115.05-36.89-20.42-66.29-2.01-65.64 41.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient105",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1984.56 3163.486) scale(156.709)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath105",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5681.07 3006.09c1.7 1.02 4.01 2.31 5.67 3.38 2.04 1.32 4.72 3.17 6.68 4.6 3.44 2.53 7.79 6.2 10.93 9.1 5.49 5.09 9.58 9.74 10.91 11.26 4.57 5.22 7.84 9.67 9.78 12.33.7.97 4.46 6.17 8.61 13.19 2.67 4.5 5.15 9.17 7.38 13.85 6.32 13.28 9.2 23.54 10.6 28.8.57 2.14 1.99 7.84 2.98 14.49 1.08 7.37 1.22 12.56 1.26 14.26.12 4.7-.06 9.1-.54 13.45-.24 2.16-.72 5.02-1.12 7.16-.29 1.51-.82 3.5-1.19 5-.55 2.11-1.56 4.86-2.33 6.9-.46 1.24-1.24 2.83-1.78 4.04-.92 2.06-2.42 4.7-3.74 6.52-1.37 1.88-3.29 4.33-4.79 6.09-.79.92-1.98 2.01-2.86 2.84l-2.77 2.34c-1.5 1.1-3.55 2.48-5.13 3.46-13.47 7.81-31.93 6.98-52.44-4.37-42.08-23.28-76.79-82.02-77.52-131.19-.38-25.4 8.38-43.27 22.73-51.42.97-.49 2.22-1.2 3.21-1.64 1.23-.56 2.9-1.24 4.17-1.7 2.09-.76 4.99-1.42 7.15-1.9 1.77-.39 4.17-.63 5.98-.73 2.01-.11 4.72-.13 6.73.01 1.35.08 3.13.22 4.46.45 2.63.44 6.15 1.01 8.69 1.81 3.15.99 7.31 2.43 10.35 3.7 2.46 1.02 5.6 2.67 7.94 3.92 1.78.99 2.91 3.15 2.95 6.23-36.89-20.42-66.29-2.01-65.64 41.1.64 43.12 31.08 94.63 67.98 115.04 36.9 20.42 66.3 2.02 65.65-41.09-.64-43.12-31.08-94.63-67.99-115.05-.04-3.08-1.17-5.24-2.95-6.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient115",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(129.5354) rotate(60 1.547 49.51)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath115",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5637.4 3042.94c-.62 2.14-1.25 4.28-1.86 6.42-.81 2.81-1.7 5.6-2.39 8.44 2.81.95 5.69 2.22 8.65 3.87 25.37 14.14 46.23 49.44 46.59 78.84.05 4.19-.33 8.02-1.08 11.49 3.21.33 6.36 1.15 9.49 1.97 1.72.45 3.45.85 5.2 1.24l2.11-1.23a22.41 22.41 0 004.37-3.32l4.92-2.86c8.35-4.85 13.44-15.29 13.26-30.08-.36-29.1-21-64.02-46.1-78.02-12.35-6.88-23.48-7.41-31.56-2.72-1.22.72-2.38 1.55-3.45 2.5-2.34.51-4.51 1.35-6.52 2.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient125",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(129.536) rotate(60 1.496 49.481)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath125",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5634.31 3058.21c2.43.89 4.93 2.03 7.49 3.46 25.37 14.14 46.23 49.44 46.59 78.84.05 4.1-.32 7.85-1.03 11.26 2.69.32 5.38 1.34 7.86 2.06 1.72.5 3.47.97 5.24 1.42 8.16-4.93 13.14-15.28 12.96-29.89-.35-29.1-21-64.03-46.1-78.02-12.35-6.88-23.47-7.41-31.55-2.72l-1.08.71c-.32 4.29-.52 8.58-.38 12.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient139",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 158.517 6487.49) scale(21.2003)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath139",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5689.1 3111.83c4.13-.83 10.21 1.05 15.79 4.16 3.06 1.71 5.97 3.77 8.32 5.95l3.66-2.11c-2.36-2.18-5.27-4.24-8.33-5.95-7.64-4.26-16.22-6.22-19.44-2.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient149",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.5846) rotate(60 2.658 127.823)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath149",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5668.03 3120.47c7.7 4.29 14.34 19.96 16.55 31.45 1.24-.51 2.52-.88 3.85-1.07-1.99-11.56-8.81-28.07-16.75-32.49-3.67-2.04-7.03-1.19-9.77 1.25 1.89-.54 3.95-.35 6.12.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient159",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(31.3133) rotate(60 6.034 204.94)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath159",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5659.68 3040.62l-3.65 2.11c4.84 10.22 7.84 27.39 3.78 33.34l1.13-.16c7.51-2.16 4.35-23.42-1.26-35.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient169",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(.45439) rotate(60 385.76 14281.118)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath169",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5706.04 3093.58l-.8.74c1.79-.7 3.33-1.66 4.45-2.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient179",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 166.398 6396.45) scale(61.3984)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath179",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5632.53 3075.73c8.06 4.99 16.61 13.3 18.67 21.44 1.57 6.18-.93 11.04-4.92 14.07 5.94-2.52 10.59-8.27 8.57-16.18-2.22-8.81-12.08-17.83-20.65-22.61l-1.96-1.02c.14 1.43.24 2.86.29 4.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient190",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-78.8375) rotate(-45 -83.16 67.792)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath190",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5633.03 3071.82l1.17.63c8.57 4.78 18.43 13.8 20.65 22.61 2.11 8.3-3.11 14.22-9.46 16.53 1.22 2.84 2.75 5.53 4.5 8.1 2.01 2.94 4.51 5.28 7.05 7.67 2.77-7.24 8.28-12.59 14.74-9 9.37 5.23 17.2 27.33 17.33 38.21 7.01.64 13.11-1.17 17.82-5.14-8.96-8.34-21.44-29.09-18.67-37.81 2.05-6.43 11.8-4.52 20.38.26 3.06 1.71 5.97 3.77 8.33 5.95-.64-9.26-3.19-18.98-7.18-28.36-4.16 4.4-14.04 5.89-21.86 1.53a19.456 19.456 0 01-6.31-5.62c-7.65-10.61-4.99-28.63.41-34.35-2.89-2.45-5.89-4.65-8.96-6.53l-.22-.13-.35-.21-.33-.2-.17-.09-.47-.28-.13-.07-.52-.3-.52-.28-.12-.07-.48-.25-.17-.09-.3-.16-.48-.24-.09-.05c-3.07-1.55-6.06-2.69-8.94-3.46 5.61 11.87 8.77 33.13 1.26 35.29-1.74.5-3.9-.07-6.25-1.38-7.71-4.29-17.55-16.56-21.98-25.64-.66 7.61-.22 15.29.32 22.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient200",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-17.48968) rotate(-60 -315.292 192.694)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath200",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5671.55 3108.23c-4.84-2.69-8.82-9.44-8.88-15.05-.07-5.61 3.79-7.98 8.64-5.28 4.84 2.7 8.83 9.44 8.9 15.05.06 5.61-3.8 7.99-8.66 5.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient211",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1943.58 3184.444) scale(12.41188)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef2f7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath211",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5670.16 3106.06c3.44 1.93 6.2.25 6.15-3.74-.05-3.98-2.88-8.77-6.33-10.69-3.44-1.91-6.19-.23-6.13 3.75.05 3.98 2.87 8.77 6.31 10.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient225",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 178.6 6394.175) scale(140.9554)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath225",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5678.8 3152.14c13.58 7.57 25.82 8.15 34.7 2.99l3.11-1.8c-8.89 5.16-21.12 4.57-34.7-3-27.6-15.38-50.31-53.8-50.7-85.79-.19-16.27 5.4-27.74 14.58-33.08l-3.1 1.81c-9.18 5.33-14.79 16.81-14.58 33.07.39 32 23.08 70.41 50.69 85.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient234",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-91.3974) rotate(-60 -67.146 41.07)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath234",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6330.68 3529.04c-2.6 5.51-5.2 11.02-7.81 16.54 3.29-6.95 5.04-15.72 4.89-26.06-.58-38.94-28.07-85.46-61.4-103.9l15.27.63c28.94 16 52.79 56.38 53.3 90.18.13 8.97-1.39 16.58-4.25 22.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient239",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(123.7539) rotate(60 1.436 57.661)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath239",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6281.79 3426.33c24.16 13.37 44.08 47.09 44.5 75.33.22 14.52-4.78 24.77-12.96 29.46l3.13-1.8c8.2-4.7 13.19-14.94 12.97-29.47-.42-28.23-20.35-61.95-44.51-75.32-11.72-6.49-22.28-6.99-30.01-2.56l-3.14 1.8c7.72-4.42 18.29-3.92 30.02 2.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient244",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-138.1102) rotate(-60 -44.303 27.317)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath244",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6241.94 3451.44c.42 28.23 20.35 61.95 44.52 75.32 24.16 13.37 43.39 1.32 42.97-26.91-.42-28.23-20.35-61.95-44.51-75.32-24.16-13.37-43.4-1.32-42.98 26.91zm-18.92-18.52c.11-2.1.34-4.89.62-6.97.76-5.61 2.01-9.78 2.51-11.32.74-2.23 1.83-5.19 2.91-7.27.91-1.75 2.23-4.03 3.27-5.7l2.01-2.76c1.34-1.75 3.49-4.01 4.66-5.03l2.43-2.04c1.34-.98 3.19-2.22 4.61-3.09 11.87-6.82 28.12-6.04 46.14 3.93 37.15 20.55 67.77 72.39 68.43 115.79.33 22.34-7.35 38.08-19.94 45.3-1.67.87-3.92 1.96-5.67 2.68-1.13.47-2.72.91-3.91 1.26-1.91.56-5.57 1.22-8.39 1.36-1.77.08-4.13.07-5.89 0a39.21 39.21 0 01-3.91-.39c-2.31-.36-5.36-1.03-7.64-1.59-1.37-.35-3.19-.92-4.52-1.44-1.37-.54-3.23-1.2-4.58-1.81-2.14-.98-4.95-2.35-7.01-3.47-5.66-3.11-10.85-7.01-10.9-7.04-1.48-1.15-3.47-2.67-4.91-3.87-1.61-1.35-3.75-3.16-5.24-4.64-2.83-2.78-6.5-6.59-9.17-9.51-1.45-1.57-3.19-3.82-4.55-5.46-2.52-3.08-6.84-9.25-8.08-11.25-1.1-1.77-2.62-4.12-3.67-5.91-1.07-1.8-2.39-4.24-3.41-6.06-1.02-1.82-2.19-4.34-3.13-6.2-.02-.05-2.7-5.49-5.37-12.72-1.38-3.78-2.98-8.91-4.02-12.79-.28-1.07-1.77-6.76-2.72-13.36-.81-5.75-1.02-10.3-1.05-13.11-.02-1.66-.01-3.87.09-5.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient249",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 207.389 7153.07) scale(123.7561)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath249",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6311.55 3409.26c24.16 13.37 44.09 47.09 44.51 75.32.22 14.53-4.77 24.77-12.96 29.46l3.24-1.85c8.19-4.7 13.18-14.94 12.97-29.47-.43-28.23-20.35-61.95-44.52-75.32-11.72-6.49-22.29-6.99-30.01-2.56l-3.24 1.86c7.72-4.43 18.28-3.93 30.01 2.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient254",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 2189.921 3535.645) scale(116.104)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath254",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6261.78 3441.83l.48 2.46c-1.05-5.3-1.63-10.55-1.7-15.67-.53-35.18 23.44-50.19 53.56-33.53 30.11 16.66 54.94 58.69 55.47 93.87.53 35.18-23.46 50.2-53.56 33.54-5.23-2.89-10.29-6.54-15.09-10.79l1.88 1.67c5.1 4.5 10.47 8.37 16.01 11.44 31.95 17.68 57.4 1.75 56.84-35.59-.55-37.33-26.91-81.93-58.86-99.61-31.96-17.68-57.41-1.75-56.85 35.59.08 5.42.7 11 1.82 16.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient259",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-109.4109) rotate(-60 -55.987 34.613)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath259",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6314.21 3400.79c27.41 15.17 50.03 53.44 50.51 85.47.48 32.04-21.36 45.71-48.78 30.54-27.42-15.17-50.03-53.44-50.51-85.48-.48-32.03 21.36-45.7 48.78-30.53zm-53.65 27.83c.51 35.19 25.35 77.22 55.47 93.88 30.1 16.66 54.09 1.64 53.56-33.54-.53-35.18-25.36-77.21-55.47-93.87-30.12-16.66-54.09-1.65-53.56 33.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient264",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-123.8128) rotate(-60 -49.446 30.675)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath264",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6259.96 3425.21c.08 5.46.72 11.09 1.85 16.76.7 3.14 1.66 7.32 2.58 10.39.53 1.74 1.27 4.05 1.88 5.76.6 1.7 1.48 3.94 2.13 5.62 1.6 4.14 5.33 11.97 8.35 17.11 1.9 3.23 4.58 7.48 6.71 10.57 1.85 2.69 4.55 6.13 6.59 8.68 2.28 2.85 3.81 4.44 7.87 8.67 1.37 1.42 3.32 3.19 4.79 4.51 5.13 4.55 10.53 8.45 16.12 11.54 31.95 17.68 57.4 1.75 56.84-35.59-.55-37.33-26.91-81.93-58.86-99.61-31.96-17.68-57.41-1.75-56.85 35.59zm-2.47-2.92c-.6-39.81 26.55-56.8 60.63-37.95 34.07 18.86 62.17 66.42 62.77 106.23.59 39.82-26.55 56.81-60.63 37.95-5.94-3.29-11.71-7.46-17.18-12.31.29-1.07.26-1.93-.06-2.52.32.59.35 1.45.06 2.52-21.27-18.85-38.06-48-43.62-76.03l1.62.74-1.62-.74c-1.2-6.05-1.88-12.06-1.97-17.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient269",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 171.901 7079.19) scale(215.989)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath269",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6176.81 3452.14c.95 64.23 22.17 100.75 77.68 131.47 20.54 11.37 39.05 12.21 52.53 4.38 14.11-8.18 42.47-24.61 56.58-32.79-13.46 7.8-31.93 6.96-52.42-4.38-42.09-23.28-76.8-82.02-77.53-131.19-.18-12.56 1.87-23.28 5.72-31.89 8.29.96 17.28 3.95 26.71 9.17l42.44-24.15c-20.36-11.26-38.71-12.17-52.14-4.54-14.18 8.04-42.62 24.36-56.8 32.41-14.38 8.16-23.15 26.07-22.77 51.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient274",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 2195.333 3533.054) scale(134.084)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath274",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6318.24 3392.91c30.02 16.61 54.79 58.52 55.31 93.6.53 35.09-23.38 50.06-53.41 33.44-30.02-16.61-54.79-58.52-55.32-93.6-.51-35.09 23.39-50.06 53.42-33.44zm-65.87 26.55c.65 43.12 31.09 94.62 67.98 115.04 36.91 20.42 66.3 2.02 65.66-41.1-.65-43.11-31.09-94.62-67.98-115.04-36.91-20.42-66.3-2.02-65.66 41.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient279",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 2195.892 3529.516) scale(156.7091)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath279",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6315.07 3372.13c1.7 1.01 4 2.3 5.66 3.38 2.04 1.32 4.72 3.16 6.68 4.6 3.44 2.52 7.8 6.2 10.93 9.1 5.5 5.09 9.57 9.73 10.92 11.26 4.57 5.22 7.83 9.67 9.77 12.33.71.97 4.47 6.17 8.62 13.19 2.66 4.5 5.14 9.16 7.37 13.85 6.33 13.28 9.21 23.54 10.61 28.8.56 2.14 1.99 7.84 2.97 14.49 1.09 7.37 1.22 12.55 1.26 14.26.12 4.7-.06 9.11-.53 13.45-.25 2.16-.72 5.02-1.13 7.16-.29 1.51-.82 3.5-1.19 4.99-.54 2.12-1.55 4.86-2.32 6.91-.46 1.24-1.24 2.83-1.79 4.03-.92 2.06-2.41 4.7-3.74 6.53-1.37 1.88-3.28 4.32-4.78 6.08-.8.92-1.99 2.02-2.87 2.85l-2.77 2.34c-1.49 1.1-3.54 2.48-5.13 3.46-13.46 7.81-31.93 6.97-52.44-4.37-42.08-23.28-76.79-82.02-77.52-131.19-.38-25.4 8.38-43.28 22.74-51.42.96-.5 2.21-1.2 3.2-1.65 1.23-.56 2.9-1.24 4.17-1.7 2.09-.75 4.99-1.42 7.16-1.9 1.77-.38 4.17-.62 5.97-.72 2.02-.12 4.72-.13 6.73 0 1.35.09 3.14.22 4.47.45 2.62.45 6.15 1.02 8.69 1.81 3.14.99 7.3 2.43 10.34 3.7 2.46 1.03 5.6 2.68 7.95 3.93 1.78.99 2.91 3.15 2.96 6.23-36.91-20.42-66.3-2.02-65.66 41.1.65 43.12 31.09 94.62 67.98 115.04 36.91 20.42 66.3 2.02 65.66-41.1-.65-43.11-31.09-94.62-67.98-115.04-.05-3.08-1.18-5.24-2.96-6.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient289",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(129.5333) rotate(60 1.547 55.163)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath289",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6271.4 3408.97c-.63 2.14-1.25 4.28-1.87 6.42-.81 2.81-1.7 5.61-2.37 8.45 2.79.94 5.67 2.21 8.63 3.87 25.37 14.13 46.23 49.43 46.59 78.84.05 4.19-.33 8.02-1.07 11.49 3.2.32 6.36 1.15 9.48 1.96 1.72.45 3.46.86 5.21 1.25l2.11-1.23c1.57-.91 3.02-2.02 4.36-3.32l4.92-2.87c8.35-4.85 13.44-15.28 13.26-30.07-.36-29.1-20.99-64.03-46.1-78.02-12.34-6.88-23.48-7.41-31.55-2.72-1.22.72-2.38 1.55-3.46 2.5a22.51 22.51 0 00-6.51 2.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient299",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 193.773 7141.673) scale(129.5354)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath299",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6268.3 3424.24c2.43.9 4.93 2.04 7.49 3.47 25.37 14.13 46.23 49.43 46.59 78.84.05 4.1-.32 7.85-1.02 11.26 2.68.33 5.38 1.33 7.86 2.05 1.72.51 3.47.98 5.23 1.43 8.17-4.93 13.15-15.28 12.96-29.89-.35-29.1-20.99-64.03-46.09-78.02-12.36-6.88-23.48-7.41-31.55-2.72l-1.09.71c-.32 4.28-.52 8.58-.38 12.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient313",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(21.2014) rotate(60 7.476 340.522)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath313",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6323.1 3477.87c4.13-.83 10.2 1.05 15.79 4.16 3.05 1.7 5.96 3.77 8.32 5.95l3.65-2.11c-2.35-2.18-5.26-4.25-8.32-5.95-7.65-4.26-16.22-6.22-19.44-2.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient323",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.5846) rotate(60 2.658 142.296)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath323",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6302.02 3486.5c7.71 4.3 14.35 19.96 16.55 31.45 1.24-.5 2.52-.87 3.85-1.06-1.99-11.56-8.81-28.07-16.75-32.49-3.67-2.05-7.03-1.19-9.76 1.25 1.88-.54 3.94-.35 6.11.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient333",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 188.97 7149.402) scale(31.3127)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath333",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6293.67 3406.67l-3.65 2.1c4.84 10.21 7.84 27.39 3.79 33.34l1.12-.16c7.51-2.16 4.36-23.42-1.26-35.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient343",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 175.274 7221.185) scale(.4546)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath343",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6340.03 3459.62l-.79.74c1.79-.71 3.33-1.66 4.44-2.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient353",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(61.4008) rotate(60 2.71 116.098)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath353",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6266.52 3441.77c8.06 4.99 16.61 13.3 18.68 21.43 1.57 6.18-.93 11.04-4.93 14.08 5.94-2.52 10.59-8.28 8.58-16.18-2.23-8.81-12.08-17.83-20.66-22.61l-1.96-1.03c.15 1.43.24 2.87.29 4.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient364",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(135 2454.973 3029.967) scale(78.8362)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath364",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6267.02 3437.86l1.17.63c8.58 4.78 18.43 13.8 20.66 22.61 2.11 8.29-3.12 14.22-9.47 16.53 1.23 2.83 2.76 5.53 4.51 8.1 2.01 2.93 4.51 5.28 7.05 7.66 2.76-7.23 8.28-12.59 14.73-8.99 9.38 5.22 17.2 27.33 17.34 38.2 7 .64 13.1-1.16 17.81-5.14-8.95-8.33-21.44-29.09-18.66-37.8 2.04-6.43 11.8-4.52 20.38.26 3.06 1.7 5.97 3.77 8.32 5.95-.64-9.26-3.18-18.98-7.18-28.36-4.16 4.4-14.03 5.89-21.85 1.53a19.368 19.368 0 01-6.31-5.62c-7.66-10.62-4.99-28.63.41-34.35-2.89-2.45-5.89-4.65-8.97-6.53l-.21-.13-.35-.21-.34-.2-.15-.1-.49-.27-.12-.07-.52-.3-.52-.28-.13-.07-.47-.26-.17-.09-.31-.15-.47-.25-.09-.04c-3.08-1.55-6.07-2.69-8.95-3.45 5.62 11.86 8.77 33.12 1.26 35.28-1.74.5-3.89-.07-6.25-1.38-7.7-4.3-17.55-16.56-21.98-25.65-.66 7.62-.22 15.3.32 22.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient374",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 2157.085 3549.747) scale(17.4892)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath374",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6305.55 3474.27c-4.85-2.7-8.82-9.44-8.89-15.05-.07-5.61 3.8-7.98 8.64-5.28 4.85 2.7 8.83 9.44 8.9 15.05.07 5.61-3.8 7.98-8.65 5.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient385",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-12.41189) rotate(-60 -495.462 300.713)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef2f7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath385",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6304.15 3472.1c3.45 1.92 6.2.24 6.15-3.74-.05-3.98-2.88-8.77-6.33-10.69-3.43-1.91-6.19-.23-6.13 3.75.05 3.98 2.87 8.77 6.31 10.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient399",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 178.596 7126.253) scale(140.9567)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath399",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6312.79 3518.18c13.59 7.56 25.82 8.15 34.7 2.99l3.12-1.81c-8.89 5.16-21.13 4.58-34.7-2.99-27.61-15.39-50.31-53.8-50.7-85.8-.2-16.26 5.4-27.74 14.58-33.07l-3.11 1.8c-9.18 5.34-14.79 16.81-14.58 33.08.39 32 23.09 70.41 50.69 85.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(704.865 -704.865) rotate(-60 -1.618 -6.253)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73001e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#29314a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#29314a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#47507a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#47507a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#29314a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29314a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath496",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3075.38 4104.26l-.64.01c-206.41 2.82-435.31-68.16-667.45-206.98l-190.87-110.2 1540.35-890.13 205.46 102.59 267 120.75 146.9 45.52 254.18 40.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient536",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-258.048 258.048) rotate(60 -6.094 -3.621)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath536",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1622.34 953.449c0 58.001-40.97 128.671-91.52 157.861-25.19 14.54-48.01 16.03-64.56 6.68v.01l-.01-.01-.39-.23-44.42-25.66v-44.78l129.81-178.191 40.83 23.762a43.007 43.007 0 017.27 4.23l.03.008v.012c14.29 10.269 22.96 29.621 22.96 56.308z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient542",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(181.9024 -181.9024) rotate(-60 -.333 -9.347)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath542",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1579.18 928.539c0-58.008-40.98-81.367-91.52-52.187-50.55 29.187-91.52 99.859-91.52 157.858 0 58.01 40.97 81.37 91.52 52.19 50.54-29.19 91.52-99.869 91.52-157.861z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient547",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(174.9832 -174.9832) rotate(-60 -.358 -9.72)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath547",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1573.47 929.59c0-55.801-39.42-78.27-88.04-50.199-48.62 28.07-88.04 96.058-88.04 151.859 0 55.79 39.42 78.26 88.04 50.2 48.62-28.08 88.04-96.071 88.04-151.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient560",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-258.047 258.047) rotate(60 -5.073 -.56)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath560",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.73 1120.11c0 58-40.976 128.67-91.527 157.86-25.191 14.54-48.008 16.02-64.558 6.68v.01l-.016-.01-.379-.23-44.422-25.66v-44.78l129.809-178.19 40.828 23.76a43.515 43.515 0 017.273 4.23l.024.01v.01c14.289 10.27 22.968 29.62 22.968 56.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient566",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(181.9013 -181.9013) rotate(-60 -3.368 -5.922)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath566",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.57 1095.2c0-58.01-40.976-81.37-91.523-52.19-50.547 29.19-91.524 99.86-91.524 157.86 0 58.01 40.977 81.37 91.524 52.19 50.547-29.19 91.523-99.87 91.523-157.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient571",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(174.9822 -174.9822) rotate(-60 -3.513 -6.16)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath571",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.855 1096.24c0-55.79-39.414-78.26-88.035-50.19-48.625 28.07-88.043 96.06-88.043 151.86 0 55.79 39.418 78.26 88.043 50.2 48.621-28.08 88.035-96.07 88.035-151.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient578",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-159.2991 159.2991) rotate(60 -8.117 -.483)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23222e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath578",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.984 1092.29c12.028 20.89 5.02 57.91-15.316 88.27-3.094 4.63-6.5 9.09-10.191 13.33-3.692 4.23-7.485 8.01-11.329 11.33-25.222 21.88-52.339 23.99-64.371 3.1-1.453-2.52-2.625-5.27-3.523-8.23-2.383-7.74-2.926-16.82-1.805-26.53 2.524-21.9 13.504-46.95 30.844-66.83 17.332-19.87 36.957-29.9 52.664-28.91 6.969.44 13.152 3.05 18.035 7.92 1.867 1.85 3.535 4.04 4.992 6.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient619",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-258.048 258.048) rotate(60 -5.073 -3.032)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath619",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1358.87 801.332c0 58-40.98 128.68-91.53 157.859-25.19 14.539-48.01 16.028-64.56 6.688l-.01-.008-.38-.23-44.42-25.661v-44.769l129.8-178.199 40.83 23.769a42.42 42.42 0 017.27 4.219l.03.02c14.29 10.269 22.97 29.621 22.97 56.312z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient625",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(181.9024 -181.9024) rotate(-60 -.333 -7.675)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath625",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.71 776.422c0-58.012-40.98-81.371-91.53-52.192-50.54 29.192-91.52 99.86-91.52 157.872 0 58 40.98 81.359 91.52 52.179 50.55-29.191 91.53-99.871 91.53-157.859z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient630",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(174.9811 -174.9811) rotate(-60 -.358 -7.982)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath630",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1310 777.469c0-55.797-39.42-78.27-88.04-50.188-48.63 28.059-88.04 96.051-88.04 151.848 0 55.793 39.41 78.269 88.04 50.203 48.62-28.082 88.04-96.07 88.04-151.863z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient637",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-159.2654 159.2654) rotate(60 -8.119 -4.486)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23222e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath637",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1185.58 900.43c-19.14-10.918-21.67-43.27-7.59-76.489a135.617 135.617 0 017.59-15.171c2.91-5.032 6.07-9.758 9.4-14.129 21.87-28.801 51.34-42.911 70.48-31.993a26.63 26.63 0 016.2 4.864c4.8 4.988 7.92 11.879 9.38 20.047 3.3 18.39-1.9 43.14-15.59 66.75-13.68 23.601-32.64 40.5-50.32 46.929-7.84 2.864-15.43 3.653-22.2 2.051a26.786 26.786 0 01-7.35-2.859z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient679",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-92.0973) rotate(-60 -32.145 9.16)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath679",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2222.33 2233.9c-2.62 5.55-5.25 11.1-7.87 16.66 3.31-7.01 5.08-15.83 4.92-26.25-.58-39.24-28.28-86.12-61.87-104.71l15.4.63c29.15 16.14 53.19 56.83 53.7 90.88.13 9.05-1.4 16.71-4.28 22.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient684",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(124.7031) rotate(60 -6.05 23.491)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath684",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2173.06 2130.4c24.34 13.48 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.07 29.7l3.17-1.82c8.25-4.74 13.28-15.06 13.06-29.7-.42-28.44-20.5-62.42-44.84-75.89-11.82-6.54-22.47-7.05-30.25-2.58l-3.17 1.81c7.79-4.46 18.44-3.95 30.25 2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient689",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 498.17 1698.651) scale(139.1692)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath689",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2132.92 2155.7c.42 28.45 20.5 62.42 44.84 75.9 24.35 13.47 43.74 1.33 43.31-27.12-.42-28.44-20.5-62.42-44.84-75.89-24.35-13.47-43.74-1.33-43.31 27.11zm-19.08-18.66c.12-2.11.34-4.92.63-7.02.76-5.65 2.03-9.86 2.54-11.41.73-2.24 1.83-5.22 2.92-7.33.92-1.76 2.25-4.05 3.3-5.74l2.02-2.78c1.35-1.76 3.52-4.04 4.7-5.06l2.44-2.07a85.5 85.5 0 014.65-3.11c11.96-6.87 28.33-6.08 46.5 3.96 37.42 20.71 68.29 72.95 68.95 116.68.33 22.5-7.4 38.37-20.09 45.65-1.68.88-3.96 1.98-5.72 2.7-1.14.47-2.74.92-3.94 1.27-1.92.56-5.61 1.23-8.45 1.37-1.78.08-4.16.06-5.94 0a37.29 37.29 0 01-3.94-.4c-2.33-.36-5.4-1.03-7.69-1.6-1.39-.34-3.22-.92-4.55-1.44-1.39-.55-3.27-1.22-4.62-1.83-2.15-.98-5-2.37-7.07-3.5-5.71-3.13-10.93-7.06-10.98-7.1-1.5-1.15-3.5-2.68-4.95-3.89-1.63-1.36-3.77-3.19-5.29-4.67-2.84-2.81-6.54-6.64-9.24-9.59-1.45-1.59-3.21-3.84-4.57-5.5-2.55-3.1-6.9-9.33-8.16-11.34-1.1-1.79-2.62-4.14-3.69-5.96-1.07-1.8-2.4-4.26-3.43-6.1-1.03-1.83-2.21-4.37-3.15-6.24-.02-.06-2.73-5.54-5.41-12.83-1.4-3.8-3.01-8.97-4.06-12.88-.29-1.09-1.78-6.82-2.73-13.47-.83-5.79-1.04-10.38-1.07-13.2-.01-1.67 0-3.91.09-5.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient694",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -724.418 2946.854) scale(124.7031)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath694",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2203.06 2113.2c24.34 13.47 44.42 47.45 44.85 75.89.22 14.64-4.81 24.96-13.07 29.7l3.27-1.88c8.25-4.73 13.28-15.04 13.06-29.68-.42-28.45-20.5-62.44-44.85-75.9-11.81-6.54-22.46-7.04-30.24-2.58l-3.27 1.87c7.79-4.47 18.43-3.96 30.25 2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient699",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 509.952 1701.668) scale(116.994)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath699",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2152.9 2146.02l.48 2.49c-1.05-5.35-1.64-10.65-1.71-15.8-.54-35.44 23.63-50.58 53.97-33.78 30.34 16.78 55.37 59.13 55.9 94.59.53 35.44-23.64 50.58-53.98 33.78-5.26-2.91-10.36-6.58-15.2-10.85l1.9 1.67c5.13 4.54 10.54 8.44 16.13 11.53 32.19 17.81 57.84 1.76 57.28-35.86-.57-37.63-27.12-82.57-59.32-100.38-32.2-17.81-57.84-1.76-57.28 35.86.08 5.47.71 11.08 1.83 16.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient704",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-110.2507) rotate(-60 -26.749 7.956)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath704",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2205.73 2104.66c27.62 15.29 50.41 53.86 50.9 86.13.47 32.29-21.53 46.07-49.15 30.77-27.64-15.28-50.42-53.85-50.9-86.13-.49-32.28 21.52-46.06 49.15-30.77zm-54.06 28.05c.52 35.45 25.55 77.81 55.89 94.59 30.34 16.8 54.51 1.66 53.98-33.78-.53-35.46-25.56-77.81-55.9-94.59-30.34-16.8-54.51-1.67-53.97 33.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient709",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-124.7608) rotate(-60 -23.609 7.12)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath709",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2151.07 2129.27c.08 5.51.72 11.18 1.85 16.89v.01c.71 3.16 1.67 7.37 2.62 10.46.53 1.75 1.28 4.07 1.89 5.8.6 1.72 1.5 3.97 2.15 5.67 1.6 4.18 5.36 12.06 8.41 17.24 1.92 3.25 4.6 7.53 6.76 10.65 1.87 2.71 4.58 6.18 6.64 8.75 2.3 2.87 3.83 4.47 7.93 8.74 1.38 1.42 3.35 3.21 4.83 4.54 5.17 4.58 10.61 8.51 16.24 11.63 32.19 17.81 57.84 1.76 57.28-35.86-.57-37.63-27.12-82.57-59.32-100.38-32.2-17.81-57.84-1.76-57.28 35.86zm-2.49-2.94c-.6-40.12 26.75-57.24 61.08-38.23 34.34 18.99 62.66 66.92 63.26 107.04.6 40.11-26.75 57.23-61.08 38.24-6-3.32-11.81-7.52-17.32-12.4.29-1.09.26-1.96-.07-2.54.33.58.36 1.45.07 2.54-21.44-19-38.35-48.37-43.96-76.62l1.64.74-1.64-.74c-1.21-6.11-1.89-12.15-1.98-18.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient714",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(188.244 0 0 -188.244 2067.26 2182.66)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath714",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2067.28 2156.42c.96 64.71 22.34 101.51 78.27 132.47 20.7 11.45 39.35 12.3 52.95 4.42 14.21-8.25 42.79-24.81 57-33.06-13.56 7.87-32.17 7.03-52.82-4.41-42.41-23.46-77.38-82.65-78.12-132.19-.19-12.65 1.88-23.45 5.76-32.14 8.34.97 17.41 3.99 26.91 9.25l42.77-24.33c-20.51-11.35-39-12.27-52.54-4.58-14.29 8.1-42.95 24.54-57.24 32.65-14.49 8.22-23.33 26.27-22.94 51.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient719",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 515.404 1699.055) scale(135.1127)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath719",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2209.79 2096.73c30.26 16.74 55.21 58.96 55.74 94.31.53 35.36-23.57 50.44-53.82 33.71-30.26-16.75-55.21-58.98-55.74-94.33-.53-35.35 23.57-50.44 53.82-33.69zm-66.37 26.75c.65 43.44 31.32 95.35 68.5 115.92 37.19 20.58 66.81 2.04 66.16-41.41-.65-43.45-31.32-95.35-68.5-115.93-37.19-20.58-66.81-2.03-66.16 41.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient724",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 515.967 1695.493) scale(157.91)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath724",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2206.6 2075.79c1.71 1.02 4.03 2.32 5.7 3.4 2.07 1.33 4.76 3.18 6.73 4.64 3.47 2.54 7.86 6.25 11.02 9.17 5.54 5.12 9.65 9.8 10.99 11.35 4.62 5.25 7.9 9.73 9.86 12.42.71.97 4.49 6.21 8.68 13.29 2.68 4.54 5.18 9.24 7.43 13.95 6.37 13.38 9.28 23.72 10.69 29.02.57 2.17 2.01 7.91 3 14.61 1.09 7.43 1.22 12.64 1.27 14.36.12 4.75-.06 9.18-.55 13.56-.24 2.17-.72 5.06-1.13 7.21-.29 1.53-.82 3.53-1.2 5.03-.55 2.14-1.57 4.91-2.34 6.97-.47 1.25-1.25 2.84-1.79 4.06-.94 2.07-2.44 4.74-3.78 6.58-1.38 1.89-3.3 4.35-4.82 6.13-.8.92-2 2.02-2.89 2.86l-2.79 2.36c-1.51 1.11-3.58 2.5-5.16 3.49-13.57 7.87-32.19 7.03-52.84-4.41-42.41-23.46-77.38-82.65-78.12-132.19-.39-25.59 8.44-43.61 22.91-51.81.97-.5 2.24-1.22 3.23-1.66 1.23-.57 2.91-1.25 4.19-1.71 2.11-.76 5.03-1.44 7.22-1.92 1.78-.39 4.2-.63 6.02-.73 2.03-.12 4.75-.14 6.78 0 1.35.09 3.17.22 4.5.45 2.65.46 6.2 1.02 8.76 1.84 3.17.99 7.36 2.45 10.42 3.72 2.47 1.03 5.64 2.7 8.01 3.96 1.79 1 2.93 3.17 2.98 6.27-37.19-20.58-66.81-2.03-66.16 41.42.65 43.44 31.32 95.35 68.5 115.92 37.19 20.58 66.81 2.04 66.16-41.41-.65-43.45-31.32-95.35-68.5-115.93-.05-3.1-1.19-5.27-2.98-6.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient734",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -731.512 2939.133) scale(130.5272)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath734",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2162.59 2112.91c-.63 2.16-1.26 4.32-1.88 6.47-.82 2.84-1.71 5.65-2.39 8.51 2.81.95 5.72 2.24 8.7 3.9 25.56 14.25 46.58 49.81 46.94 79.45.06 4.22-.33 8.08-1.07 11.57 3.22.33 6.4 1.16 9.55 1.98 1.73.45 3.49.86 5.25 1.25l2.12-1.24c1.59-.91 3.06-2.03 4.39-3.34l4.97-2.89c8.41-4.88 13.54-15.4 13.36-30.3-.36-29.32-21.16-64.52-46.46-78.61-12.44-6.94-23.65-7.47-31.79-2.75-1.23.72-2.4 1.57-3.48 2.51-2.35.52-4.55 1.37-6.56 2.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient744",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(130.5286) rotate(60 -5.655 22.488)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath744",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2159.47 2128.3c2.45.9 4.97 2.05 7.55 3.49 25.56 14.25 46.58 49.81 46.94 79.45.06 4.12-.31 7.91-1.03 11.34 2.71.33 5.43 1.35 7.92 2.07 1.74.52 3.51.98 5.28 1.43 8.23-4.96 13.25-15.39 13.06-30.11-.36-29.32-21.15-64.51-46.45-78.62-12.44-6.93-23.65-7.47-31.79-2.74l-1.09.71c-.33 4.33-.53 8.65-.39 12.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient758",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -773.673 3013.86) scale(21.3644)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath758",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2214.69 2182.33c4.16-.84 10.28 1.06 15.91 4.19 3.08 1.72 6.01 3.8 8.38 6l3.68-2.12c-2.37-2.2-5.3-4.29-8.38-6-7.7-4.29-16.35-6.27-19.59-2.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient768",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.9725) rotate(60 -15.653 58.7)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath768",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2193.45 2191.04c7.76 4.32 14.46 20.11 16.69 31.68 1.24-.5 2.53-.87 3.87-1.06-2.01-11.65-8.88-28.29-16.88-32.74-3.7-2.06-7.09-1.21-9.84 1.26 1.9-.55 3.98-.36 6.16.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient778",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -742.981 2943.159) scale(31.553)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath778",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2185.04 2110.59l-3.68 2.12c4.88 10.29 7.9 27.59 3.82 33.6l1.13-.17c7.57-2.18 4.39-23.6-1.27-35.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient788",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -756.753 3015.497) scale(.45789)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath788",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2231.75 2163.95l-.79.74c1.8-.71 3.35-1.67 4.47-2.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient798",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(61.8713) rotate(60 -12.376 47.229)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath798",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2157.68 2145.96c8.12 5.03 16.74 13.4 18.82 21.6 1.58 6.23-.94 11.12-4.97 14.18 5.99-2.54 10.67-8.33 8.65-16.3-2.25-8.88-12.17-17.97-20.82-22.78l-1.98-1.04c.15 1.44.25 2.88.3 4.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient809",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(135 669.189 1531.174) scale(79.4412)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath809",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2158.18 2142.02l1.18.64c8.65 4.81 18.57 13.9 20.82 22.78 2.12 8.36-3.14 14.33-9.55 16.65 1.24 2.86 2.78 5.58 4.55 8.16 2.03 2.96 4.54 5.33 7.11 7.73 2.78-7.3 8.34-12.69 14.84-9.06 9.45 5.26 17.33 27.54 17.47 38.49 7.06.65 13.21-1.17 17.95-5.17-9.02-8.41-21.6-29.32-18.81-38.1 2.06-6.48 11.89-4.56 20.54.26 3.08 1.71 6.01 3.8 8.38 6-.64-9.34-3.2-19.13-7.23-28.57-4.19 4.42-14.14 5.92-22.03 1.53a19.6 19.6 0 01-6.35-5.66c-7.72-10.7-5.03-28.85.42-34.61-2.92-2.47-5.94-4.69-9.04-6.59l-.22-.12-.35-.22-.34-.2-.16-.09-.48-.28-.13-.07-.52-.31-.52-.28-.13-.07-.48-.25-.18-.1-.3-.15-.48-.25-.09-.05c-3.09-1.55-6.11-2.7-9.01-3.47 5.66 11.95 8.84 33.37 1.27 35.55-1.75.5-3.93-.07-6.31-1.39-7.75-4.33-17.68-16.68-22.14-25.84-.66 7.67-.22 15.42.32 23.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient819",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-17.62303) rotate(-60 -168.642 46.868)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath819",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2197.01 2178.71c-4.88-2.72-8.89-9.51-8.96-15.17-.07-5.65 3.83-8.04 8.7-5.33 4.89 2.73 8.9 9.52 8.97 15.18.07 5.65-3.83 8.05-8.71 5.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient830",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-12.50622) rotate(-60 -237.743 65.74)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b1a5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#b3b1a5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#bebdb3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#bebdb3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#cacac3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cacac3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath830",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2195.6 2176.52c3.47 1.94 6.25.25 6.2-3.77-.05-4.01-2.9-8.83-6.38-10.77-3.46-1.93-6.24-.23-6.19 3.78.05 4.01 2.9 8.84 6.37 10.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient844",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -753.416 2919.818) scale(142.0373)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath844",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2204.31 2222.95c13.68 7.63 26.01 8.22 34.96 3.02l3.13-1.83c-8.95 5.21-21.28 4.62-34.96-3.01-27.82-15.51-50.69-54.21-51.09-86.45-.2-16.39 5.45-27.96 14.7-33.33l-3.13 1.81c-9.26 5.38-14.9 16.95-14.7 33.33.4 32.25 23.27 70.96 51.09 86.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient851",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 699.984 2078.096) scale(92.0986)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath851",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2861.19 2602.74c-2.63 5.56-5.25 11.11-7.87 16.66 3.31-7 5.08-15.83 4.92-26.25-.58-39.24-28.28-86.12-61.87-104.7l15.39.63c29.15 16.13 53.2 56.82 53.7 90.88.14 9.04-1.39 16.71-4.27 22.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient856",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(124.7042) rotate(60 -6.05 29.407)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath856",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2811.91 2499.25c24.35 13.47 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.06 29.69l3.17-1.82c8.25-4.73 13.28-15.05 13.06-29.69-.43-28.45-20.51-62.43-44.85-75.9-11.81-6.54-22.46-7.04-30.25-2.58l-3.16 1.82c7.78-4.46 18.43-3.96 30.24 2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient861",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-139.1703) rotate(-60 -25.731 8.85)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#121212",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath861",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2771.77 2524.55c.43 28.44 20.51 62.42 44.85 75.89 24.34 13.48 43.73 1.34 43.31-27.11-.43-28.45-20.51-62.43-44.85-75.9-24.34-13.47-43.74-1.33-43.31 27.12zm-19.07-18.67c.12-2.11.34-4.92.63-7.02.76-5.66 2.02-9.86 2.53-11.4.74-2.25 1.84-5.23 2.93-7.33.92-1.77 2.25-4.06 3.29-5.75l2.03-2.78c1.35-1.76 3.52-4.04 4.69-5.06l2.45-2.06c1.35-.99 3.21-2.24 4.64-3.12 11.97-6.86 28.34-6.09 46.5 3.97 37.43 20.71 68.3 72.95 68.95 116.68.33 22.5-7.39 38.37-20.09 45.65-1.67.87-3.96 1.97-5.71 2.69-1.15.48-2.75.92-3.94 1.27-1.92.57-5.61 1.23-8.46 1.37-1.78.08-4.16.07-5.93 0a39.81 39.81 0 01-3.94-.39c-2.33-.36-5.41-1.03-7.69-1.6-1.4-.35-3.22-.93-4.56-1.45-1.39-.55-3.26-1.22-4.62-1.83-2.15-.98-4.99-2.36-7.06-3.5-5.71-3.13-10.94-7.06-10.99-7.1-1.49-1.15-3.5-2.68-4.95-3.89-1.62-1.36-3.77-3.19-5.28-4.67-2.85-2.8-6.54-6.64-9.24-9.59-1.45-1.58-3.21-3.84-4.57-5.49-2.56-3.11-6.91-9.33-8.16-11.35-1.11-1.78-2.62-4.14-3.69-5.95-1.07-1.81-2.41-4.28-3.43-6.11-1.03-1.83-2.21-4.37-3.16-6.24-.02-.05-2.72-5.54-5.41-12.82-1.4-3.81-3-8.97-4.05-12.89-.29-1.08-1.79-6.81-2.73-13.46-.83-5.8-1.04-10.38-1.07-13.21-.02-1.67-.01-3.9.09-5.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient866",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -724.41 3684.54) scale(124.703)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#383838",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#292929",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath866",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2841.91 2482.04c24.35 13.47 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.06 29.69l3.26-1.87c8.25-4.73 13.29-15.06 13.07-29.7-.43-28.44-20.5-62.42-44.85-75.89-11.82-6.54-22.47-7.05-30.25-2.58l-3.26 1.87c7.78-4.46 18.43-3.96 30.24 2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient871",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 722.903 2070.51) scale(116.9953)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath871",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2791.75 2514.86l.49 2.48c-1.05-5.34-1.64-10.63-1.72-15.78-.53-35.46 23.64-50.58 53.98-33.8 30.34 16.79 55.36 59.14 55.9 94.6.52 35.45-23.64 50.58-53.98 33.79-5.26-2.91-10.37-6.59-15.2-10.87l1.89 1.68c5.14 4.54 10.55 8.44 16.13 11.53 32.2 17.81 57.84 1.76 57.28-35.86-.56-37.62-27.12-82.56-59.31-100.38-32.2-17.82-57.84-1.76-57.29 35.86.08 5.46.71 11.08 1.83 16.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient876",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-110.2501) rotate(-60 -32.543 11.302)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath876",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2844.58 2473.51c27.63 15.28 50.42 53.85 50.9 86.13.48 32.28-21.52 46.05-49.15 30.77-27.63-15.29-50.42-53.85-50.9-86.13-.48-32.28 21.52-46.06 49.15-30.77zm-54.06 28.05c.53 35.45 25.55 77.8 55.9 94.59 30.34 16.79 54.5 1.66 53.97-33.79-.53-35.46-25.55-77.8-55.89-94.6-30.34-16.78-54.51-1.66-53.98 33.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient881",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-124.7618) rotate(-60 -28.729 10.076)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f1f1f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath881",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2789.92 2498.11c.08 5.51.73 11.18 1.86 16.89v.01c.71 3.16 1.67 7.37 2.61 10.46.53 1.76 1.28 4.08 1.89 5.81.6 1.71 1.5 3.96 2.15 5.66 1.61 4.18 5.36 12.06 8.41 17.24 1.92 3.26 4.61 7.54 6.76 10.65 1.87 2.71 4.59 6.18 6.64 8.75 2.3 2.87 3.84 4.47 7.93 8.73 1.38 1.44 3.35 3.22 4.83 4.55 5.17 4.58 10.62 8.52 16.24 11.63 32.2 17.81 57.84 1.76 57.28-35.86-.56-37.62-27.12-82.56-59.31-100.38-32.2-17.82-57.84-1.76-57.29 35.86zm-2.48-2.93c-.6-40.13 26.74-57.25 61.08-38.25s62.66 66.93 63.25 107.05c.6 40.12-26.75 57.24-61.08 38.24-5.99-3.32-11.8-7.52-17.32-12.4.3-1.08.26-1.95-.06-2.54.32.59.36 1.46.06 2.54-21.43-19-38.35-48.37-43.95-76.62l1.63.74-1.63-.74c-1.21-6.1-1.9-12.15-1.98-18.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient886",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(217.645) rotate(60 -3.493 16.587)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath886",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2706.13 2525.26c.96 64.72 22.35 101.52 78.28 132.47 20.7 11.45 39.34 12.3 52.94 4.42 14.22-8.24 42.8-24.81 57.01-33.05-13.57 7.86-32.18 7.02-52.83-4.41-42.4-23.46-77.37-82.65-78.12-132.2-.19-12.65 1.88-23.45 5.76-32.13 8.35.97 17.42 3.99 26.92 9.24l42.76-24.34c-20.51-11.34-38.99-12.26-52.54-4.57-14.28 8.11-42.94 24.54-57.23 32.65-14.5 8.23-23.33 26.28-22.95 51.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient891",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 728.353 2067.896) scale(135.1126)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath891",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2848.65 2465.57c30.26 16.74 55.21 58.97 55.73 94.32.54 35.35-23.56 50.44-53.82 33.69-30.25-16.73-55.21-58.97-55.74-94.32-.52-35.35 23.57-50.43 53.83-33.69zm-66.37 26.75c.65 43.45 31.32 95.35 68.5 115.93 37.18 20.57 66.8 2.03 66.15-41.42-.65-43.45-31.31-95.35-68.5-115.92-37.18-20.58-66.8-2.04-66.15 41.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient896",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-157.911) rotate(-60 -22.643 7.995)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath896",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2845.45 2444.63c1.71 1.02 4.04 2.32 5.71 3.4 2.06 1.33 4.75 3.19 6.73 4.64 3.47 2.54 7.86 6.25 11.01 9.17 5.55 5.13 9.65 9.81 11 11.34 4.62 5.27 7.89 9.75 9.85 12.43.72.98 4.5 6.22 8.68 13.29 2.69 4.54 5.19 9.23 7.43 13.96 6.38 13.38 9.29 23.72 10.69 29.01.57 2.16 2.01 7.91 3 14.61 1.09 7.43 1.23 12.65 1.28 14.36.11 4.75-.07 9.18-.55 13.56-.25 2.18-.72 5.06-1.13 7.21-.29 1.53-.82 3.53-1.21 5.04-.54 2.13-1.56 4.89-2.33 6.95-.47 1.25-1.25 2.86-1.8 4.07-.93 2.08-2.44 4.74-3.78 6.58-1.37 1.89-3.3 4.35-4.82 6.13-.8.93-2 2.03-2.88 2.87l-2.8 2.36c-1.5 1.1-3.57 2.5-5.15 3.48-13.57 7.87-32.19 7.03-52.85-4.4-42.4-23.46-77.37-82.65-78.12-132.2-.38-25.59 8.45-43.61 22.92-51.81.96-.5 2.23-1.21 3.22-1.66 1.24-.56 2.92-1.25 4.2-1.72 2.1-.75 5.02-1.43 7.21-1.9 1.78-.4 4.21-.63 6.03-.74 2.03-.11 4.75-.13 6.78.01 1.35.09 3.16.22 4.5.45 2.64.45 6.19 1.02 8.75 1.82 3.17 1 7.36 2.45 10.43 3.73 2.47 1.03 5.64 2.7 8 3.96 1.8.99 2.93 3.17 2.98 6.28-37.18-20.58-66.8-2.04-66.15 41.41.65 43.45 31.32 95.35 68.5 115.93 37.18 20.57 66.8 2.03 66.15-41.42-.65-43.45-31.31-95.35-68.5-115.92-.05-3.11-1.18-5.29-2.98-6.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient906",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -731.51 3676.825) scale(130.5273)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath906",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2801.45 2481.76c-.63 2.15-1.26 4.3-1.88 6.46-.82 2.83-1.71 5.65-2.4 8.51 2.82.95 5.72 2.24 8.7 3.9 25.57 14.24 46.59 49.82 46.95 79.45.05 4.22-.33 8.08-1.08 11.58 3.23.33 6.4 1.16 9.55 1.98 1.74.45 3.5.86 5.25 1.25l2.13-1.24c1.58-.92 3.05-2.04 4.39-3.35l4.96-2.88c8.42-4.89 13.55-15.4 13.37-30.31-.36-29.32-21.16-64.51-46.46-78.61-12.44-6.93-23.65-7.47-31.79-2.74-1.24.71-2.4 1.55-3.49 2.51-2.35.52-4.55 1.36-6.56 2.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient916",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(130.5286) rotate(60 -5.655 28.14)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath916",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2798.33 2497.14c2.45.91 4.97 2.05 7.54 3.49 25.57 14.24 46.59 49.82 46.95 79.45.05 4.13-.32 7.91-1.03 11.35 2.71.32 5.42 1.34 7.92 2.07 1.74.5 3.5.98 5.28 1.43 8.23-4.96 13.24-15.39 13.06-30.12-.36-29.32-21.16-64.52-46.45-78.61-12.44-6.94-23.66-7.47-31.8-2.74l-1.09.71c-.32 4.32-.52 8.64-.38 12.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient930",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -773.673 3751.541) scale(21.3636)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath930",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2853.54 2551.18c4.17-.84 10.29 1.05 15.92 4.19 3.07 1.71 6 3.8 8.38 6l3.67-2.13c-2.36-2.2-5.29-4.28-8.37-5.99-7.71-4.3-16.35-6.28-19.6-2.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient940",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.9726) rotate(60 -15.654 73.172)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath940",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2832.31 2559.88c7.76 4.33 14.46 20.12 16.68 31.69 1.25-.52 2.54-.88 3.87-1.07-2.01-11.65-8.88-28.29-16.87-32.74-3.7-2.06-7.09-1.2-9.84 1.26 1.9-.54 3.98-.35 6.16.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient950",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -742.98 3680.84) scale(31.553)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath950",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2823.89 2479.42l-3.68 2.13c4.88 10.3 7.91 27.6 3.82 33.6l1.14-.17c7.56-2.17 4.39-23.6-1.28-35.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient960",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(.45794) rotate(60 -1652.54 8195.844)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath960",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2870.61 2532.79l-.8.75c1.81-.72 3.35-1.68 4.48-2.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient970",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -765.708 3659.795) scale(61.872)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath970",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2796.53 2514.8c8.12 5.03 16.75 13.4 18.82 21.6 1.58 6.23-.93 11.13-4.96 14.19 5.99-2.55 10.66-8.34 8.64-16.31-2.24-8.87-12.16-17.97-20.81-22.79l-1.98-1.03c.15 1.44.24 2.89.29 4.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient981",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-79.4408) rotate(-45 -56.158 27.723)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath981",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2797.04 2510.86l1.18.63c8.65 4.82 18.57 13.92 20.81 22.79 2.13 8.36-3.13 14.33-9.54 16.66 1.24 2.85 2.78 5.57 4.55 8.16 2.02 2.96 4.54 5.31 7.1 7.72 2.79-7.29 8.34-12.69 14.85-9.06 9.44 5.26 17.33 27.54 17.46 38.49 7.06.65 13.21-1.17 17.96-5.17-9.03-8.4-21.61-29.32-18.82-38.1 2.06-6.48 11.9-4.55 20.54.27 3.09 1.71 6.01 3.79 8.38 5.99-.63-9.33-3.2-19.13-7.22-28.57-4.2 4.43-14.14 5.93-22.03 1.53-2.38-1.32-4.56-3.18-6.36-5.66-7.71-10.7-5.02-28.84.42-34.62-2.91-2.46-5.93-4.67-9.03-6.57l-.22-.13-.36-.22-.33-.2-.16-.09-.49-.28-.12-.07-.53-.3-.51-.29-.14-.06-.47-.26-.18-.1-.3-.15-.48-.25-.09-.04c-3.1-1.56-6.11-2.71-9.02-3.49 5.67 11.96 8.84 33.39 1.28 35.56-1.76.51-3.93-.06-6.31-1.39-7.76-4.32-17.68-16.68-22.15-25.84-.65 7.67-.21 15.42.33 23.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient991",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-17.62328) rotate(-60 -204.89 67.797)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#bebebe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#a0a0a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#91929a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#84858f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath991",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2835.86 2547.55c-4.88-2.72-8.88-9.51-8.96-15.16-.06-5.66 3.83-8.05 8.71-5.33 4.89 2.73 8.9 9.52 8.97 15.17.06 5.66-3.83 8.04-8.72 5.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1002",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-12.5054) rotate(-60 -288.845 95.239)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b1a5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#b3b1a5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#bebdb3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#bebdb3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#cacac3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cacac3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f5ee",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1002",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2834.45 2545.37c3.48 1.93 6.25.24 6.2-3.77-.05-4.01-2.9-8.84-6.38-10.77-3.45-1.93-6.23-.24-6.18 3.77.05 4.01 2.9 8.84 6.36 10.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1016",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(142.0363) rotate(60 -5.304 25.75)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#a5a7b3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#b3b4be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c3c3ca",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e3e3e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#eef2f7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#e2e2e2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1016",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2843.16 2591.8c13.69 7.62 26.01 8.21 34.97 3.01l3.13-1.82c-8.95 5.2-21.28 4.61-34.96-3.01-27.82-15.51-50.69-54.22-51.09-86.46-.2-16.39 5.44-27.95 14.69-33.33l-3.13 1.82c-9.25 5.38-14.89 16.94-14.69 33.33.39 32.24 23.26 70.95 51.08 86.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1100",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -17.67 4107.162) scale(198.4862)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1100",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3586.52 2123.83c0 8.67 2.17 18.15 6.23 27.1.81 1.63 1.36 3.25 2.44 4.87 6.24 10.58 14.09 20.05 22.76 27.37 1.9 1.36 3.8 2.98 5.69 3.8l.81.54.27.26c8.14 4.35 15.18 5.16 21.14 3.27 3.26-3.53 5.15-8.95 5.69-15.73.27-1.08.27-2.43.27-3.79 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.97zm-38.56-54.58c2.14-1.2 6.31-3.95 6.31-3.95l24.12-13.82 2.98 5.41 13.28 23.32c1.08.53 1.89 1.07 2.7 1.62 33.61 22.76 60.44 68.82 63.96 108.93v.28c.27 2.16.27 4.59.27 6.76l9.75 17.62 4.89 8.67-23.04 13.27s-4.62 2.54-6.93 3.66c-9.35 4.55-23.2 1.53-42.12-9.34-38.75-22.22-70.18-76.69-70.18-121.4 0-22.29 4.67-35.77 14.01-41.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1105",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-139.8654) rotate(-60 -25.954 15.249)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1105",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3592.75 2150.93c.81 1.63 1.36 3.25 2.44 4.87 6.24 10.58 14.09 20.05 22.76 27.37 2.17 1.63 4.61 3.26 6.77 4.6 8.14 4.35 15.18 5.16 21.14 3.27 3.8-4.34 5.96-11.12 5.96-19.52 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.97 0 8.67 2.17 18.15 6.23 27.1zm-36.04-53.65c0-12.2 2.44-22.5 6.5-30.36 11.38-21.13 35.77-26.01 63.96-9.75 38.74 22.21 70.45 76.69 70.45 121.39 0 31.99-16.53 50.4-40.38 49.59-9.21-.26-19.24-3.25-30.07-9.48-38.75-22.49-70.46-76.95-70.46-121.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1110",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1230.946 2096.394) scale(129.0689)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1110",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3591.94 2104.84c-3.23 4.37-5.44 10.84-5.44 19.01 0 8.64 2.21 18.11 6.24 27.08.84 1.64 1.36 3.23 2.44 4.88 6.24 10.56 14.08 20.03 22.76 27.35 1.92 1.36 3.8 2.73 5.73 3.8l.79.57.29.23c8.11 4.37 15.15 5.16 21.11 3.28 3.24-3.51 5.17-8.96 5.68-15.72.28-1.07.28-2.43.28-3.8 0-23.03-16.23-51.19-36.56-62.87-8.68-5.16-16.84-6.25-23.03-4.04zm-27.35-7.83c0-11.4 2.16-21.16 6.47-28.48 2.72-4.84 6.24-8.92 10.33-11.64 11.92-8.4 29.23-8.12 48.23 3 35.76 20.84 65.04 71 65.04 111.92 0 23.03-8.96 38.19-23.32 43.59-3.52 1.36-7.32 2.21-11.4 2.21-8.91.51-19.24-2.44-30.32-8.68-35.8-20.6-65.03-70.72-65.03-111.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1140",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -17.668 3657.46) scale(198.4861)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1140",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3197.06 1898.97c0 8.68 2.17 18.16 6.24 27.1.81 1.64 1.35 3.26 2.44 4.88 6.23 10.57 14.08 20.06 22.75 27.37 1.9 1.36 3.8 2.98 5.69 3.8l.82.54.27.26c8.13 4.35 15.17 5.16 21.14 3.26 3.25-3.52 5.15-8.94 5.68-15.72.28-1.09.28-2.43.28-3.79 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.96zm-38.55-54.58c2.13-1.2 6.31-3.94 6.31-3.94l24.11-13.82 2.98 5.41 13.29 23.31c1.07.55 1.89 1.09 2.7 1.62 33.6 22.77 60.43 68.83 63.95 108.94v.27c.27 2.17.27 4.6.27 6.77l9.76 17.62 4.88 8.67-23.04 13.28s-4.61 2.53-6.92 3.65c-9.35 4.55-23.21 1.53-42.13-9.34-38.75-22.22-70.18-76.69-70.18-121.4 0-22.29 4.68-35.77 14.02-41.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1145",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1101.54 1870.95) scale(139.8665)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1145",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3203.3 1926.07c.81 1.64 1.35 3.26 2.44 4.88 6.23 10.57 14.08 20.06 22.75 27.37 2.17 1.63 4.62 3.25 6.78 4.6 8.13 4.35 15.17 5.16 21.14 3.26 3.8-4.33 5.96-11.11 5.96-19.51 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.96 0 8.68 2.17 18.16 6.24 27.1zm-36.05-53.65c0-12.2 2.44-22.49 6.51-30.35 11.38-21.13 35.77-26.02 63.95-9.76 38.75 22.22 70.45 76.69 70.45 121.4 0 31.98-16.52 50.4-40.37 49.6-9.22-.27-19.25-3.26-30.08-9.49-38.75-22.49-70.46-76.95-70.46-121.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1150",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(120 1101.133 1871.54) scale(129.0678)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1150",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3202.49 1879.99c-3.24 4.37-5.44 10.84-5.44 19 0 8.65 2.2 18.12 6.24 27.08.84 1.64 1.36 3.25 2.43 4.89 6.25 10.55 14.08 20.04 22.77 27.35 1.92 1.36 3.8 2.73 5.72 3.8l.79.57.29.23c8.12 4.37 15.15 5.16 21.12 3.28 3.23-3.51 5.16-8.95 5.67-15.71.28-1.09.28-2.44.28-3.81 0-23.04-16.23-51.19-36.55-62.87-8.68-5.17-16.85-6.24-23.04-4.04zm-27.36-7.83c0-11.41 2.16-21.16 6.48-28.49 2.72-4.83 6.24-8.91 10.32-11.63 11.92-8.4 29.24-8.11 48.24 3 35.76 20.84 65.04 71 65.04 111.91 0 23.05-8.96 38.21-23.33 43.6-3.52 1.36-7.31 2.2-11.4 2.2-8.91.52-19.24-2.44-30.31-8.68-35.8-20.59-65.04-70.71-65.04-111.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1165",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-21.2467) rotate(-17.408 -376.415 456.147)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#7d7d7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#8e8e8e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#8e8e8e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#8e8e8e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e8e8e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1165",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3238.98 1909.47c-1.15 1.1-1.58 2.2-1.35 3.15l9.25 37.82c-.24-.95 11.12 48.38 12.28 47.29 2.48-2.33 11.26-3.54 14.81-2.85 1.9.36-11.78-49.32-11.52-48.24l-9.24-37.82c-.26-1.1-1.4-1.96-3.3-2.33-3.55-.68-8.45.65-10.93 2.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1192",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(19.33558) rotate(60 -24.957 203.779)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1192",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3176.88 2403.88c2.16.97 4.08.87 5.39-.09l2.73-1.99c-1.3.95-3.23 1.06-5.39.09-4.09-1.83-7.5-6.81-7.62-11.11-.06-2.02.62-3.53 1.78-4.38l-2.73 1.99c-1.16.85-1.84 2.36-1.79 4.38.13 4.31 3.53 9.28 7.63 11.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1198",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -479.683 3941.803) scale(18.99771)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475152",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1198",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3179.61 2401.89c2.95 1.32 5.45.64 6.56-1.46l.84-1.57c-1.02 1.92-3.3 2.54-6 1.33-3.74-1.68-6.85-6.23-6.97-10.16-.07-2.61 1.2-4.29 3.15-4.64l-1.76.31c-2.13.38-3.52 2.22-3.44 5.08.12 4.3 3.53 9.28 7.62 11.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1204",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(21.423) rotate(60 -21.524 184.314)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1204",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3181.01 2400.19c1.98.88 3.74.79 4.93-.09l31.06-22.63c-1.2.87-2.96.97-4.94.08-3.73-1.67-6.85-6.22-6.96-10.15-.06-1.85.57-3.23 1.63-4.01l-31.05 22.63c-1.07.78-1.69 2.16-1.64 4.01.12 3.93 3.23 8.48 6.97 10.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1211",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -443.85 3957.11) scale(19.7678)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475152",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1211",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3212.06 2377.55l2.29.61 3.45.24c-.91-.07-1.91-.32-2.95-.79-4.81-2.16-8.82-8.02-8.97-13.08l.22-2.2-.84 3.36-.16 1.71c.11 3.93 3.23 8.48 6.96 10.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1217",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(23.0882) rotate(60 -18.945 171.434)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1217",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3214.85 2377.61c2.55 1.14 4.82 1.02 6.36-.11l5.67-4.12c-1.55 1.12-3.81 1.24-6.36.1-4.82-2.15-8.84-8.01-8.98-13.08-.06-2.38.74-4.16 2.11-5.16l-5.67 4.13c-1.36 1-2.16 2.78-2.1 5.16.15 5.06 4.16 10.92 8.97 13.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1234",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(22.4688) rotate(60 -11.914 180.14)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475152",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1234",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3377.29 2274.53c2.74 1.86 5.07 1.49 6.18-.6.64-1.19 1.28-2.38 1.91-3.57-.86 1.62-2.67 1.91-4.8.46-3.08-2.08-5.66-6.97-5.77-10.92-.09-3 1.28-4.6 3.29-4.27-1.34-.21-2.67-.43-4-.65-2.59-.42-4.35 1.63-4.24 5.49.15 5.08 3.47 11.38 7.43 14.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1240",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(22.9597) rotate(60 -11.89 176.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1240",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3370.35 2277.96c1.84 1.25 3.5 1.49 4.72.89l6.94-3.43c-1.23.6-2.88.36-4.72-.89-3.96-2.68-7.28-8.98-7.43-14.06-.07-2.71.77-4.53 2.18-5.23l-6.94 3.43c-1.41.7-2.25 2.52-2.18 5.24.16 5.07 3.48 11.37 7.43 14.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1246",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -249.203 4061.368) scale(20.1786)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1246",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3380.58 2270.82c1.43.97 2.71 1.16 3.66.69l38.05-18.82c-.95.47-2.23.28-3.66-.69-3.07-2.09-5.66-6.98-5.77-10.92-.06-2.12.6-3.52 1.69-4.07l-38.06 18.82c-1.09.55-1.74 1.96-1.68 4.07.11 3.95 2.69 8.84 5.77 10.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1252",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(18.59795) rotate(60 -12.451 219.063)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#364041",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#475152",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475152",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1252",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3418.63 2252c1.01.68 1.94.98 2.74.93l1.98-.12c-.86.05-1.89-.27-2.98-1.02-3.35-2.27-6.17-7.6-6.29-11.9-.05-1.71.32-3 1.01-3.79l-1.3 1.51c-.63.72-.97 1.9-.93 3.47.11 3.94 2.7 8.83 5.77 10.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1258",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(60 -228.76 4075.563) scale(19.26965)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#424e50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#545f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1258",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3420.37 2251.79c1.56 1.06 2.96 1.27 4 .75l3.36-1.66c-1.03.51-2.43.3-3.99-.75-3.35-2.28-6.17-7.61-6.29-11.91-.07-2.3.65-3.85 1.84-4.43l-3.37 1.67c-1.2.58-1.91 2.13-1.84 4.43.12 4.3 2.94 9.63 6.29 11.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1269",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(227.624 -227.624) rotate(-60 9.253 -23.03)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1269",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5596.69 880.559c0-55.18-2.03-118.95 46.05-91.188 48.09 27.758 87.07 95 87.07 150.18 0 55.179-38.98 77.399-87.07 49.64-48.08-27.761-46.05-53.461-46.05-108.632z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1274",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(245.49 -245.49) rotate(-60 8.723 -21.352)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1274",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5637.53 750.559l-56.42 32.562 123.92 211.93 56.76-32.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1280",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(245.495 -245.495) rotate(-60 8.605 -24.76)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1280",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6294.64 1265.65c0-55.17 38.98-77.4 87.07-49.63 48.08 27.76 87.07 95 87.07 150.17 0 55.18-38.99 77.4-87.07 49.64-48.09-27.76-87.07-95-87.07-150.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1285",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(245.49 -245.49) rotate(-60 8.723 -24.828)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181818",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#262626",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2e2e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1285",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6376.49 1177.21l-56.41 32.56 123.91 211.92 56.76-32.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1338",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-173.0468 173.0468) rotate(60 -20.505 -26.484)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1338",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5612.72 806.07c0-55.172 38.98-77.398 87.07-49.629 48.08 27.758 87.07 95 87.07 150.168 0 55.18-38.99 77.403-87.07 49.641-48.09-27.762-87.07-95-87.07-150.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1343",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-166.464 166.464) rotate(60 -21.327 -27.528)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1343",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5618.15 807.082c0-53.082 37.5-74.461 83.75-47.75 46.26 26.707 83.76 91.379 83.76 144.457 0 53.082-37.5 74.461-83.76 47.75-46.25-26.707-83.75-91.379-83.75-144.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1350",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(178.6286 -178.6286) rotate(-60 12.048 -29.6)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eceef7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1350",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5762.55 883.48c-2.83-24.589-15.16-52.66-34.6-74.992-19.44-22.289-41.44-33.508-59.08-32.418-7.82.532-14.76 3.418-20.2 8.918a27.677 27.677 0 00-4.8 6.024l-.81 1.32c-.99 1.68-1.86 3.418-2.55 5.277a52.497 52.497 0 00-2.43 7.692c-1.1 4.801-1.62 10.008-1.62 15.449 0 2.488.11 5.031.35 7.582.06 1.328.23 2.609.41 3.879l.34 2.598.41 2.441c.4 2.422.87 4.91 1.5 7.398.29 1.211.58 2.372.93 3.582.23 1.051.52 2.032.86 3.008a59.26 59.26 0 001.4 4.403c.34 1.101.69 2.199 1.09 3.25 1.68 4.679 3.65 9.308 5.91 13.937.46.992.92 1.91 1.38 2.832 1.63 3.129 3.31 6.199 5.15 9.262l1.39 2.258c.87 1.39 1.8 2.781 2.66 4.109 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868 2.5 2.191c10.06 8.738 20.37 14.648 30.08 17.602 17.13 5.148 32.47 1.148 41.26-12.852l.81-1.27c1.68-2.832 2.95-5.96 4-9.261 2.66-8.68 3.3-18.86 2.02-29.739z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1357",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-88.1172 88.1172) rotate(60 -40.498 -51.326)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23222e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1357",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5724.77 896.488c-2.44-21.109-13.02-45.25-29.75-64.398-9.2-10.59-19.15-18.281-28.7-22.789v-.059c-7.76-3.711-15.22-5.39-21.99-4.98l-1.57.168c-1.61.121-3.17.402-4.68.871-1.1 4.801-1.62 10.008-1.62 15.449 0 2.488.11 5.031.35 7.582.06 1.328.23 2.609.41 3.879l.34 2.598.41 2.441c.4 2.422.87 4.91 1.5 7.398.29 1.211.58 2.372.93 3.582.23 1.051.52 2.032.86 3.008a59.26 59.26 0 001.4 4.403c.34 1.101.69 2.199 1.09 3.25 1.68 4.679 3.65 9.308 5.91 13.937.46.992.92 1.91 1.38 2.832 1.63 3.129 3.31 6.199 5.15 9.262 1.28 2.137 2.67 4.289 4.05 6.367 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868 2.5 2.191c10.06 8.738 20.37 14.648 30.08 17.602 1.92-1.852 3.66-4.051 5.16-6.661a37.497 37.497 0 003.41-7.921c1.22-4.11 1.97-8.622 2.19-13.43.18-3.871 0-7.93-.45-12.102z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1362",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-36.829 36.829) rotate(-16 8.246 562.096)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1362",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5676.13 861.039l1.59-14.828v-.063l-1.59 14.891-11.55 6.691-8.39 17.192c1.28 2.137 2.67 4.289 4.05 6.367 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868c2.26-1.329 4.12-2.489 4.23-2.598l-14.46-16.629z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1367",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-30.883 30.883) rotate(22 -160.104 -459.66)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1367",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5676.13 861.039l1.59-14.828v-.063l-11.4-36.847-5.09-16.61c-1.74-3.66 3.41-11.929 1.04-11.461-3.82.75-13.31 6.36-18.4 9.782l-.81 1.32c-.99 1.68-1.86 3.418-2.55 5.277.12.86.41 1.731.87 2.653l1.38 4.168 20.84 61.34.98 1.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1372",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-33.0644 33.0644) rotate(60 -109.564 -136.724)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1372",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5745.79 916.129c-.97.519-2.28.402-3.71-.418l-55.31-23.422-1.55-.879-.05-29.691 12.28 7.062 45.83 17.969c2.86 1.648 5.21 5.57 5.37 8.941.31 6.5 10.31 7.899 9.07 13.52-.23 1.059-11.2 6.527-11.93 6.918z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1382",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-173.0468 173.0468) rotate(60 -24.775 -28.95)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#141414",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a2a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1382",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6351.69 1232.71c0-55.17 38.97-77.4 87.06-49.63 48.09 27.76 87.07 95 87.07 150.17 0 55.19-38.98 77.4-87.07 49.64-48.09-27.76-87.06-95-87.06-150.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1387",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-166.464 166.464) rotate(60 -25.766 -30.09)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1387",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6357.12 1233.72c0-53.08 37.5-74.45 83.75-47.75 46.26 26.71 83.76 91.38 83.76 144.46 0 53.09-37.5 74.46-83.76 47.75-46.25-26.71-83.75-91.38-83.75-144.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1394",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(178.628 -178.628) rotate(-60 12.048 -34.378)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eceef7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9aa8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1394",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6501.51 1310.12c-2.83-24.59-15.15-52.66-34.6-74.99-19.44-22.29-41.43-33.51-59.08-32.42-7.81.53-14.75 3.42-20.19 8.92-1.8 1.68-3.42 3.7-4.81 6.02l-.81 1.32c-.98 1.68-1.84 3.42-2.55 5.28-.97 2.42-1.78 4.97-2.42 7.69-1.1 4.8-1.62 10.01-1.62 15.45 0 2.49.11 5.03.34 7.58.06 1.33.24 2.61.41 3.88l.34 2.61.41 2.43c.4 2.43.87 4.91 1.51 7.4.28 1.22.57 2.37.92 3.59.23 1.04.52 2.02.86 3.01.41 1.45.87 2.95 1.4 4.4.34 1.1.69 2.19 1.09 3.24 1.68 4.68 3.65 9.31 5.91 13.94.46.99.92 1.91 1.39 2.83 1.62 3.13 3.3 6.2 5.15 9.26l1.38 2.26c.87 1.39 1.8 2.78 2.67 4.11 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87 2.49 2.19c10.07 8.74 20.37 14.65 30.09 17.6 17.13 5.15 32.47 1.15 41.26-12.85l.81-1.27c1.68-2.83 2.95-5.96 3.99-9.26 2.67-8.68 3.3-18.86 2.02-29.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1401",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-88.1176 88.1176) rotate(60 -48.884 -56.168)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23222e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1401",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6463.73 1323.13c-2.43-21.11-13.02-45.24-29.75-64.4-9.19-10.59-19.15-18.28-28.7-22.79v-.06c-7.75-3.71-15.21-5.38-21.99-4.98l-1.56.17c-1.61.12-3.18.4-4.68.87-1.1 4.8-1.62 10.01-1.62 15.45 0 2.49.11 5.03.34 7.58.06 1.33.24 2.61.41 3.88l.34 2.61.41 2.43c.4 2.43.87 4.91 1.51 7.4.28 1.22.57 2.37.92 3.59.23 1.04.52 2.02.86 3.01.41 1.45.87 2.95 1.4 4.4.34 1.1.69 2.19 1.09 3.24 1.68 4.68 3.65 9.31 5.91 13.94.46.99.92 1.91 1.39 2.83 1.62 3.13 3.3 6.2 5.15 9.26 1.28 2.15 2.66 4.29 4.05 6.37 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87 2.49 2.19c10.07 8.74 20.37 14.65 30.09 17.6 1.91-1.85 3.65-4.05 5.15-6.65 1.39-2.43 2.54-5.04 3.41-7.93 1.22-4.11 1.97-8.62 2.2-13.43.18-3.87 0-7.93-.46-12.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1406",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-36.829 36.829) rotate(-16 39.427 639.273)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1406",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6415.1 1287.69l1.59-14.84v-.06l-1.59 14.9-11.56 6.68-8.38 17.19c1.28 2.15 2.66 4.29 4.05 6.37 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87c2.26-1.33 4.11-2.48 4.23-2.6l-14.46-16.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1411",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-30.8828 30.8828) rotate(22 -207.604 -514.305)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1411",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6415.1 1287.69l1.59-14.84v-.06l-11.41-36.85-5.08-16.61c-1.74-3.65 3.4-11.93 1.03-11.46-3.82.75-13.31 6.36-18.4 9.78l-.81 1.32c-.98 1.68-1.84 3.42-2.55 5.28.12.86.41 1.73.87 2.65l1.39 4.17 20.84 61.34.97 1.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1416",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-33.0648 33.0648) rotate(60 -131.911 -149.625)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#868490",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1416",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6484.76 1342.77c-.97.52-2.29.4-3.72-.42l-55.31-23.41-1.54-.89-.06-29.69 12.29 7.06 45.83 17.97c2.86 1.65 5.2 5.57 5.37 8.94.31 6.5 10.3 7.9 9.07 13.52-.23 1.06-11.2 6.53-11.93 6.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1479",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(107.6863 -107.6863) rotate(-59.089 -.964 -38.677)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1479",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3568.56 2112.21c-.5-2.11-4.36-4.63-7.36-5.42l-2.34-.19-.45.15-5.59 1.89c-1.91.65-3.4 2.15-4.05 4.06l-11.06 27.64c-2.45 7.27-6.99 13.66-13.11 18.27-3.52 2.67-6.8 5.76-7.81 7.96-1.54 3.38-1.9 6.59-1.68 9.38.09 1.12.27 2.17.5 3.14.3 1.27.69 2.4 1.08 3.35.85 2.01 1.71 3.2 1.71 3.2s1.91 3.3 6.24 5.24c1.24.56 2.31.93 3.21 1.19 2.11.6 4.38.15 6.11-1.21l10.41-8.13a42.835 42.835 0 0015.67-25.57s6.39-29.94 8.11-41.11c.24-1.52.39-2.7.42-3.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1495",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(55.319 92.3925 92.3925 -55.319 2884.08 2718.69)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1495",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2929.7 2716.37c-.52-2.1-4.37-4.63-7.37-5.41l-2.34-.19-.45.15-5.58 1.89a6.478 6.478 0 00-4.06 4.06l-11.06 27.64c-2.45 7.26-6.99 13.65-13.11 18.27-3.52 2.66-6.8 5.75-7.81 7.96-1.53 3.38-1.89 6.59-1.67 9.37.08 1.13.25 2.18.48 3.15.31 1.27.7 2.4 1.1 3.34.84 2.02 1.7 3.2 1.7 3.2s1.91 3.3 6.24 5.24c1.25.56 2.31.94 3.21 1.19 2.11.6 4.38.15 6.11-1.2l10.41-8.13a42.86 42.86 0 0015.67-25.58s6.38-29.94 8.12-41.1c.23-1.53.38-2.71.42-3.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1511",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(152.5417 -152.5417) rotate(-59.089 -.955 -11.949)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1511",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1557.6 1008.01c-.72-2.97-6.19-6.55-10.44-7.67-1.27-.33-2.42-.449-3.31-.26l-.64.21-7.91 2.69a9.09 9.09 0 00-5.73 5.74l-15.68 39.15c-3.47 10.29-9.9 19.35-18.56 25.88-5 3.78-9.64 8.14-11.07 11.28-2.18 4.78-2.69 9.34-2.38 13.28.12 1.59.38 3.08.7 4.45.43 1.8.98 3.4 1.55 4.74 1.19 2.86 2.41 4.54 2.41 4.54s2.7 4.67 8.84 7.41c1.76.79 3.27 1.33 4.54 1.69 3 .85 6.21.21 8.66-1.7l14.74-11.52a60.65 60.65 0 0022.2-36.23s9.05-42.41 11.5-58.21c.33-2.17.54-3.84.59-4.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1541",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-19.362 30.6813 30.6813 19.362 5813.21 3264.62)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1541",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5824.16 3294.55c-2.7-12.28-10.92-24.76-18.42-26.26-7.5-1.51-31.8 5.55-31.42 11.61.38 6.05 22.67 33.97 22.67 33.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1548",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-231.897 60.7247 60.7247 231.897 5845.53 3263.1)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1548",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5820.87 3295.49c4.18-3.7 5.64-6.47 6.27-9.18.61-2.69-1.75-10.88-1.75-10.88-.55-3.44-11.84-1.96-14.34-1.3l-54.34 13.1c-5.31-1.25-9.02.55-13.72-11.82-2.72-7.14-6.95-13.43-9.45-16.82-7.93-10.8-24.94-6.72-24.94-6.72s-6.76 1.72-20.64 11.92c-3.06 2.25-4.42 8.03-3.01 11.55l8.46 21.2c1.19 2.99 2.58 5.89 4.13 8.67 14.66 26.22 47.89 36.88 74.4 22.76l.71-.38c2.35-1.28 31.5-17.3 48.22-32.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1557",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-46.517 46.517) rotate(25.305 -204.801 -257.901)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1557",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5997.86 2970.33c.78-8.7 1.11-16.63.76-22.79-1.66-28.82-3.36-39.42-3.36-39.42s31.41-7.2 31.83 6.79c.39 12.71 2.41 24.98 3.67 46.21-11.72 3.62-20.93 6.53-32.9 9.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1561",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-46.5172 46.5172) rotate(25.305 -203.111 -257.52)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1561",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6027.37 2920.71s2.44-7.92-6.1-16.47c-8.56-8.56-22.36-31.87-36.02-29.02-13.65 2.86 7.28 22.95 11.57 47.08 1.37 7.75 1.11 14.22 1.11 14.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1566",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-42.0307 42.0307) rotate(25.278 -225.15 -280.042)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1566",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5904.1 2939.46c.03-8.84-13.62-28.5-17.82-38.25-4.21-9.76 19.93-2.14 26.25 6.13 6.31 8.27 17.86 11.72 24.01 19.53 6.16 7.8.78 22.48.78 22.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1570",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-42.0313 42.0313) rotate(25.278 -226.567 -280.357)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1570",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5898.93 2986.53c3.75-25.78 6.34-47.96 4.84-51.99-3.82-10.18-6.37-15.06-6.37-15.06s15.32-1.01 26.78 5.57 15.11 15.68 15.11 15.68-1.38 19.48-1.53 40.4c-12.87 1.99-25.83 3.85-38.83 5.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1576",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-34.4465 34.4465) rotate(28.179 -280.614 -292.515)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1576",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5884.44 3428.93s-20.27-64.2-20.97-70.83c-.71-6.63 19.28-32.35 27.53-24.28 8.24 8.08 18.4 76.52 18.4 76.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1581",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-51.9534 51.9534) rotate(57.745 -113.913 -70.457)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1581",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5846.27 3309.68c12.6 4.78 25.68 9.67 37.13 16.87 2.47 1.56 5.41 3.37 6.93 5.96 6.13 10.47-6.75 17.38-6.75 17.38-1.29 2.33-18.52 7.98-20.13 6.43-1.6-1.54-40.35-34.78-41.31-35.08l-3.26.89c-2.08.7-4.15 1.42-6.27 2-2.32.63-4.16.82-6.51.63-3.22-.27-6.5.57-9.61 1.3-1.76.42-3.53.83-5.2 1.54-1.34.56-2.6 1.3-3.9 1.93-3.56 1.72-7.52 2.6-11.47 2.56l-2.21-.47c-.86-.58-1.21-1.71-1.07-2.74.12-1.02.66-1.95 1.25-2.8 2.98-4.31 7.58-7.27 12.41-9.33 2.82-1.21 6.06-1.86 8.75-3.29 3.2-1.71 6.21-4.12 9.24-6.13 6.25-4.13 12.49-8.26 18.74-12.38l1.13-.4c1.08.18 1.94 3.9 2.56 4.85 1.36 2.13 3.11 4.01 5.41 5.12 4.42 2.15 9.53 3.41 14.14 5.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1585",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-52.8937 3.40028 3.40028 52.8937 6068.03 3323.85)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1585",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6016.91 3347.75c.65-1.29 3.36-36.21 4.91-41.78 1.54-5.56 8.24-7.57 18.88-4.2 10.66 3.37 19.35 10.11 19.61 19.74.27 9.63-.69 29-.69 29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1594",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-99.6977 99.6977) rotate(14.723 -165.62 -215.685)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1594",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5941.27 3502.71c1.02-4.54-1.13-26.64-2.82-35.91-1.69-9.27 5.89-15.18 20.85-16.85 14.96-1.67 30.1 8.39 36.19 16.58 6.08 8.18-5.07 18.95-5.53 27.28-.46 8.32-1.4 20.03 1.6 28.33 3.01 8.3 4.04 26.16-5.39 27.39-9.43 1.24-44.9-46.82-44.9-46.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1598",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-99.6974 99.6974) rotate(14.723 -166.726 -215.828)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1598",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5988.43 3540.45s-5.28-30.89-11.28-36.48c-6.01-5.59-31.34-17.83-38.54-18.13-7.2-.3-11.75.74-14.22 5.63-2.46 4.9-8.28 19.09-7.8 37.73.47 18.65 6.05 46.35 8.59 50.24 2.53 3.88 37.82 9.03 40.76 3.97 2.95-5.05 22.49-42.96 22.49-42.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1603",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-96.422 25.3372 25.3372 96.422 6015.56 3522.48)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1603",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5988.59 3535.14s4.15 5.52 7.19 5.19c3.04-.33 6.31-4.67 3.34-11.77-2.97-7.09-6.97-11.97-11.92-11.3-4.96.66 1.39 17.88 1.39 17.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1607",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-49.033 5.86523 5.86523 49.033 6061.93 3230.82)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1607",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6029.28 3313.8s-8.34-1.32-7.46-7.83c.89-6.5 3.09-79.17-.31-91.03s-7.47-19.46-7.47-19.46-5.04-.72-6.74-5.87c-1.7-5.16-6.2-18.63-8.34-21.25-2.16-2.61.83-7.02.83-7.02s-.27-3.5 3.22-7.49 4.21-4.32 11.57-2.77c7.35 1.56 18.45 6.91 20.68 12.95 2.24 6.04 2.41 30.53 2.41 30.53s20.64 85.64 21.8 103.68c1.17 18.04.37 19.84.37 19.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1612",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(38.0694 0 0 -38.0694 5773.91 3277.44)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff9574",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#ffcab8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcab8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1612",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5793.12 3281.09c1.19.04 2.34.56 3.53.52 1.06-.03 2.07-.49 3.04-.95 3.25-1.52 6.5-3.04 9.74-4.57.97-.46 2.02-.99 2.4-1.98l-.2-2.26c-.69-1.44-2.13-2.43-3.66-2.91-1.52-.48-3.16-.51-4.77-.46-3.25.09-6.51.48-9.62 1.43-3.07.94-5.95 2.43-8.62 4.22-1.38.93-2.66 1.99-3.99 2.97-1.17.85-5.74 1.67-6.65 2.8-1.71 2.09 2.37 4.43 4.51 5.72 2.56 1.53 5.06.68 7.3-.89 2.12-1.48 4.19-3.75 6.99-3.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1620",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(186.11 -186.11) rotate(-59.089 10.792 -29.47)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d6d6d6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1620",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5761.35 940.07c-.88-3.629-7.55-8-12.74-9.359-1.54-.41-2.96-.539-4.04-.332l-.78.262-9.65 3.281a11.136 11.136 0 00-7 7.008l-19.13 47.769c-4.22 12.551-12.06 23.601-22.64 31.571-6.09 4.6-11.76 9.94-13.5 13.76-2.66 5.84-3.28 11.39-2.91 16.2.15 1.95.46 3.76.85 5.43.53 2.2 1.21 4.15 1.89 5.79 1.46 3.48 2.95 5.54 2.95 5.54s3.29 5.69 10.79 9.05c2.14.95 3.98 1.61 5.54 2.06 3.65 1.03 7.56.25 10.55-2.08l17.99-14.06a74 74 0 0027.09-44.21s11.04-51.738 14.02-71.02c.41-2.652.67-4.679.74-5.89z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f8fc",
    d: "M3658.38 683.301c-46.48 0-90.83 9.379-123.99 28.519L925.492 2218.07c-71.133 41.06-64.445 111.94 13.598 160.68l2595.3-1498.391c33.16-19.14 77.53-28.519 124.01-28.519 56.1 0 115.26 13.672 161.47 40.351l1631.86 942.159c2.36 1.36 4.65 2.73 6.89 4.13l13.61-7.86c73.17-42.24 63.99-116.03-20.5-164.82L3819.87 723.648c-46.21-26.679-105.39-40.347-161.49-40.347",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d35",
    d: "M5521.63 2019.88l-90.73 3.15-2567.57 1482.39c-73.18 42.24-201 36.94-285.49-11.84L945.988 2551.43c-2.593-1.5-5.113-3.02-7.566-4.56l-62.324 2.15v-90.97h.05c.059-26.78 16.25-52.34 49.344-71.45L3534.39 880.359c73.18-42.238 200.99-36.949 285.48 11.832l1631.86 942.159c46.4 26.78 70.03 61.11 69.84 93.61h.06v91.92",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M2863.33 3505.42c-73.18 42.24-201 36.94-285.49-11.84L945.988 2551.43c-2.593-1.5-5.113-3.02-7.566-4.56l-62.324 2.15v-19.64h.05c.059-26.79 16.25-52.34 49.344-71.45L3534.39 951.68c73.18-42.25 200.99-36.942 285.48 11.84l1631.86 942.14c46.4 26.79 70.03 61.12 69.84 93.63h.06v20.59l-90.73 3.15-2567.57 1482.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b92",
    d: "M5451.73 1834.35c46.4 26.78 70.03 61.11 69.84 93.61h.06v91.92l-90.73 3.15-51.78 29.89-510.33-463.3v-91.84l582.94 336.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bbbbbf",
    d: "M3534.39 972.199L925.492 2478.44c-73.172 42.25-63.996 116.05 20.496 164.83l1631.852 942.15c84.49 48.79 212.31 54.08 285.49 11.83l2608.9-1506.24c73.17-42.25 63.99-116.05-20.5-164.83L3819.87 984.031c-84.49-48.793-212.3-54.082-285.48-11.832",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M1994.91 3248.86L945.988 2643.27c-84.492-48.78-93.668-122.58-20.496-164.82L3534.39 972.199c73.18-42.25 200.99-36.961 285.48 11.832l1048.92 605.589-2873.88 1659.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7f8fc",
    d: "M5882.55 2341.41c-46.47 0-90.83 9.38-123.98 28.52l-749.96 432.99c-73.17 42.25-64 116.04 20.5 164.82l3.95 2.28 725.51-413.22c33.15-18.88 77.52-28.14 123.99-28.14 56.1 0 115.27 13.49 161.48 39.81l850.64 484.5 23.46-13.55c73.18-42.25 64.01-116.04-20.49-164.83l-853.61-492.82c-46.21-26.68-105.39-40.36-161.49-40.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d35",
    d: "M6967.55 3237.7l-90.72 3.1-708.64 403.61c-73.17 41.67-200.98 36.45-285.47-11.68l-853.61-486.18c-2.6-1.48-5.12-2.98-7.57-4.5l-62.32 2.13v-89.75h.05c.06-26.42 16.25-51.63 49.34-70.49l749.96-427.14c73.17-41.68 200.98-36.45 285.47 11.67l853.61 486.19c46.4 26.42 70.03 60.29 69.84 92.36h.06v90.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M6168.19 3640.95c-73.17 42.24-200.98 36.94-285.47-11.84l-853.61-492.83c-2.6-1.5-5.12-3.02-7.57-4.56l-62.32 2.16v-19.65l.05-.01c.06-26.77 16.25-52.33 49.34-71.44l749.96-432.98c73.17-42.25 200.98-36.95 285.47 11.83l853.61 492.83c46.4 26.79 70.03 61.11 69.84 93.62h.06v20.59l-90.72 3.15-708.64 409.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M5758.57 2630.31l-749.96 432.99c-73.17 42.24-64 116.04 20.5 164.82l853.61 492.83c84.49 48.78 212.3 54.08 285.47 11.84l749.95-432.99c73.18-42.25 64.01-116.05-20.49-164.82l-853.61-492.84c-84.49-48.78-212.3-54.07-285.47-11.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7f8fc",
    d: "M1427.83 170.43c-56.11 0-115.29 13.672-161.5 40.351L412.727 703.609c-84.493 48.782-93.676 122.582-20.5 164.832l20.781 12L1266.33 394.41c46.22-26.32 105.38-39.801 161.49-39.801 46.47 0 90.84 9.25 124 28.129L2280 797.488l1.27-.726c84.49-48.782 93.67-122.582 20.5-164.832l-749.95-432.981c-33.16-19.14-77.52-28.519-123.99-28.519",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d35",
    d: "M342.828 1063.63l90.727 3.11 708.625 403.61c73.17 41.67 200.99 36.45 285.49-11.68l853.6-486.182c2.59-1.476 5.11-2.976 7.56-4.496l62.33 2.129v-89.75l-.05-.012c-.06-26.41-16.25-51.629-49.35-70.48l-749.94-427.141c-73.18-41.679-200.99-36.449-285.49 11.672L412.727 880.602c-46.399 26.418-70.032 60.289-69.84 92.347h-.059v90.681",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M1142.18 1469.96c73.17 42.25 200.99 36.95 285.49-11.83l853.6-492.841c2.59-1.488 5.11-3.008 7.56-4.559l62.33 2.161v-19.653h-.05c-.06-26.769-16.25-52.328-49.35-71.437L1551.82 438.82c-73.18-42.261-200.99-36.961-285.49 11.821L412.727 943.48c-46.399 26.782-70.032 61.11-69.84 93.62h-.059v20.6l90.727 3.14 708.625 409.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M1551.82 459.332l749.95 432.988c73.17 42.239 63.99 116.04-20.5 164.82l-853.6 492.83c-84.5 48.78-212.32 54.07-285.49 11.83l-749.953-432.98c-73.176-42.25-63.993-116.05 20.5-164.832L1266.33 471.16c84.5-48.781 212.31-54.078 285.49-11.828",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7f8fc",
    d: "M5738.09 219.422c-46.48 0-90.84 9.379-123.99 28.519l-824.28 475.911c-71.13 41.07-64.45 111.937 13.6 160.679L5614.1 416.48c33.15-19.14 77.53-28.519 124-28.519 56.11 0 115.27 13.668 161.49 40.348l1102.76 636.681c2.36 1.36 4.66 2.74 6.89 4.14l13.6-7.85c73.18-42.25 64.01-116.042-20.49-164.819L5899.59 259.77c-46.22-26.668-105.4-40.348-161.5-40.348",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d35",
    d: "M7072.25 1250.54l-90.73 3.14-782.96 452.04c-73.17 42.25-200.98 36.95-285.47-11.83l-1102.77-636.68c-2.59-1.51-5.12-3.03-7.57-4.56l-62.32 2.15v-90.968h.05c.06-26.781 16.25-52.344 49.34-71.453L5614.1 416.48c73.18-42.238 200.99-36.949 285.49 11.829l1102.76 636.681c46.4 26.8 70.02 61.12 69.84 93.62h.06v91.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M6198.56 1705.72c-73.17 42.25-200.98 36.95-285.47-11.83l-1102.77-636.68c-2.59-1.51-5.12-3.03-7.57-4.56l-62.32 2.15v-19.64l.05-.01c.06-26.78 16.25-52.341 49.34-71.451l824.28-475.898c73.18-42.242 200.99-36.942 285.49 11.84l1102.76 636.679c46.4 26.79 70.02 61.11 69.84 93.62h.06v20.6l-90.73 3.14-782.96 452.04",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M6092.06 1272.94L4789.82 984.219c-73.17 42.251-64 116.041 20.5 164.821l1102.77 636.68c84.49 48.79 212.3 54.08 285.47 11.84l824.28-475.9c73.18-42.25 64.01-116.05-20.49-164.82L5899.59 520.16c-84.5-48.789 265.64 710.53 192.47 752.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999da4",
    d: "M3461.82 2776.19l-43.37 10.31c-50.28 40.2-112.79 72.84-188.62 98.56-25.55 8.66-55.67 7.27-74.06-3.35-13.41-7.74-26.81-15.47-40.22-23.21l-31.38 7.45v-19.18c.03-6.67 3.27-13.61 9.82-20.05 55.05-54.11 128.39-96.47 222.17-128.27 25.54-8.66 55.66-7.28 74.05 3.34l56 32.33c10.29 5.94 15.57 14 15.6 22.52h.01v19.55",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3316.16 2717.9c-93.78 31.79-167.12 74.15-222.17 128.26-15 14.75-12.61 32.14 5.79 42.76 18.66 10.78 37.32 21.55 55.99 32.33 18.39 10.62 48.51 12 74.06 3.34 93.72-31.78 167.09-74.13 222.17-128.27 15-14.75 12.6-32.14-5.79-42.76l-56-32.32c-18.39-10.62-48.51-12.01-74.05-3.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M3306.44 2745.12c-66.28 25.62-120.95 57.18-165.3 95.43-17.48 15.08-16.04 33.75 3.4 44.97 5.7 3.3 11.41 6.59 17.12 9.89 19.43 11.22 51.77 12.05 77.89 1.96 66.25-25.6 120.93-57.17 165.29-95.44 17.49-15.07 16.05-33.75-3.39-44.97l-17.12-9.88c-19.44-11.23-51.78-12.06-77.89-1.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M3417.05 2779.52v392.82l-288.11 83.38V2862.9l288.11-83.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M3306.44 3137.78c-66.28 25.61-120.95 57.19-165.3 95.43-17.48 15.08-16.04 33.75 3.4 44.97 5.7 3.29 11.41 6.59 17.12 9.89 19.43 11.22 51.77 12.05 77.89 1.96 66.25-25.61 120.93-57.17 165.29-95.44 17.49-15.08 16.05-33.75-3.39-44.97l-17.12-9.88c-19.44-11.22-51.78-12.06-77.89-1.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25467c",
    d: "M3306.14 3150.96c-58.82 24.2-107.9 52.55-148.41 85.69-15.97 13.06-15.74 27.96.47 35.9 4.76 2.34 9.53 4.67 14.29 7 16.22 7.94 44.18 6.83 67.35-2.7 58.79-24.19 107.88-52.54 148.41-85.69 15.97-13.06 15.75-27.97-.46-35.91l-14.29-7c-16.22-7.94-44.18-6.83-67.36 2.71",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M3306.26 3153.98c-56.01 23.77-103.04 50.93-142.18 82.09-15.44 12.29-15.75 25.67-.8 32.25 4.39 1.92 8.77 3.85 13.16 5.79 14.94 6.57 41.21 4.61 63.28-4.76 55.98-23.76 103.02-50.91 142.19-82.09 15.44-12.29 15.74-25.67.8-32.25l-13.16-5.79c-14.94-6.57-41.22-4.61-63.29 4.76",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3384.33 2747.08v240.79l17.12 9.88v-240.79l-17.12-9.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3241.05 2922.58l-58.51 33.78c-12.78 7.39-23.15 27.19-23.15 44.24v156.69c0 17.06 10.37 24.89 23.15 17.51l58.51-33.78c12.79-7.39 23.15-27.19 23.15-44.24v-156.7c0-17.05-10.36-24.88-23.15-17.5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989fa9",
    d: "M3241.05 3141.02l-54.81 31.64V3016.1c0-17.05 10.37-36.85 23.15-44.23l54.82-31.65v156.56c0 17.05-10.37 36.85-23.16 44.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3196.59 3122.8c-2.17-1.25-3.31-3.79-3.31-7.34v-51.03c0-9.09 7.47-20.81 16.65-26.1l32.43-18.73c4.48-2.59 8.62-3.17 11.36-1.6 2.16 1.25 3.31 3.79 3.31 7.34v51.03c0 9.09-7.48 20.8-16.65 26.1l-32.43 18.73c-2.84 1.63-5.53 2.47-7.81 2.47-1.35 0-2.55-.29-3.55-.87zm43.79-106.63l-32.43 18.72c-10.45 6.03-18.63 19.01-18.63 29.54v51.03c0 4.97 1.88 8.81 5.29 10.78 3.98 2.3 9.58 1.7 15.32-1.61l32.43-18.72c10.45-6.04 18.63-19.01 18.63-29.54v-51.03c0-4.98-1.88-8.8-5.3-10.77-1.6-.93-3.47-1.39-5.49-1.39-3.01 0-6.39 1.01-9.82 2.99",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M3205.92 3105.91v-52.81c0-3.59 2.91-8.17 6.5-10.24l4.06-2.35 14.75-8.51 6.66-3.85c3.59-2.07 6.49-.85 6.49 2.74v52.82l-.01.48c-.25 3.5-3.06 7.78-6.48 9.76l-25.47 14.7c-3.59 2.07-6.5.84-6.5-2.74",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3207.63 3083.26l.12-2.53.19-1.5c.16-.95.35-1.91.59-2.88 1.34-5.35 4.07-10.77 7.62-15.27l2.13-2.47c1.88-2.01 3.94-3.75 6.09-5.1l.79-.48c4.11-2.38 7.89-2.93 10.88-1.94 2.47.83 4.39 2.7 5.52 5.48.73 1.79 1.12 3.95 1.12 6.45 0 3.32-.7 6.86-1.94 10.34-1.76 4.93-4.61 9.74-8.08 13.64-2.2 2.46-4.63 4.55-7.21 6.09l-.29.17-2.49 1.24c-8.5 3.52-15.04-1.1-15.04-11.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3394.62 3065.04l-17.5-16.12 20.76 57.87z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3389.83 3030.01l1.85 38.71 16.98 16.5z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999da4",
    d: "M4111.82 2400.91l-43.37 10.31c-50.28 40.21-112.79 72.85-188.63 98.56-25.54 8.66-55.66 7.28-74.05-3.34-13.41-7.74-26.81-15.48-40.21-23.22l-31.39 7.46v-19.19c.04-6.67 3.27-13.61 9.82-20.05 55.04-54.11 128.39-96.47 222.16-128.27 25.55-8.66 55.68-7.28 74.06 3.34l56 32.33c10.28 5.94 15.57 14 15.6 22.53l.01-.01v19.55",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3966.15 2342.62c-93.77 31.79-167.12 74.15-222.16 128.26-15.01 14.75-12.6 32.15 5.79 42.76 18.66 10.78 37.33 21.56 55.99 32.33 18.39 10.62 48.51 12 74.05 3.35 93.73-31.79 167.1-74.13 222.17-128.28 15.01-14.75 12.62-32.13-5.78-42.75l-56-32.33c-18.38-10.62-48.51-12-74.06-3.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M3956.44 2369.84c-66.28 25.62-120.95 57.19-165.3 95.43-17.48 15.08-16.04 33.75 3.39 44.97 5.71 3.3 11.42 6.6 17.13 9.89 19.43 11.22 51.77 12.05 77.89 1.96 66.24-25.6 120.93-57.17 165.29-95.43 17.48-15.08 16.05-33.75-3.38-44.98l-17.13-9.88c-19.44-11.22-51.77-12.05-77.89-1.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M4067.05 2404.24v392.82l-288.11 83.38v-392.82l288.11-83.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M3956.44 2762.5c-66.28 25.62-120.95 57.19-165.3 95.43-17.48 15.08-16.04 33.75 3.39 44.98 5.71 3.29 11.42 6.58 17.13 9.88 19.43 11.22 51.77 12.05 77.89 1.96 66.24-25.6 120.93-57.17 165.29-95.43 17.48-15.08 16.05-33.75-3.38-44.97l-17.13-9.89c-19.44-11.22-51.77-12.05-77.89-1.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3956.14 2775.68c-58.82 24.2-107.9 52.55-148.41 85.69-15.97 13.06-15.75 27.97.47 35.91 4.77 2.33 9.52 4.66 14.29 6.99 16.21 7.94 44.18 6.83 67.35-2.7 58.78-24.19 107.88-52.53 148.41-85.69 15.98-13.06 15.75-27.97-.47-35.91l-14.28-7c-16.22-7.94-44.18-6.83-67.36 2.71",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M3956.26 2778.7c-56.01 23.77-103.04 50.93-142.19 82.09-15.43 12.29-15.73 25.67-.8 32.25 4.4 1.93 8.78 3.86 13.17 5.79 14.94 6.57 41.21 4.61 63.29-4.76 55.97-23.75 103.01-50.91 142.18-82.09 15.43-12.29 15.75-25.67.8-32.24l-13.16-5.79c-14.94-6.58-41.22-4.62-63.29 4.75",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M4034.33 2371.8v240.79l17.13 9.89v-240.8l-17.13-9.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3891.05 2547.3l-58.51 33.78c-12.78 7.39-23.16 27.19-23.16 44.24v156.7c0 17.05 10.38 24.88 23.16 17.5l58.51-33.78c12.79-7.38 23.16-27.19 23.16-44.24v-156.7c0-17.05-10.37-24.88-23.16-17.5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989fa9",
    d: "M3891.05 2765.74l-54.81 31.64v-156.55c0-17.06 10.37-36.86 23.15-44.24l54.82-31.65v156.56c0 17.05-10.37 36.86-23.16 44.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3846.59 2747.52c-2.17-1.25-3.32-3.78-3.32-7.34v-51.02c0-9.1 7.48-20.82 16.66-26.11l32.43-18.72c4.48-2.6 8.62-3.18 11.35-1.61 2.17 1.25 3.31 3.79 3.31 7.34v51.03c0 9.1-7.47 20.81-16.64 26.11l-32.43 18.72c-2.84 1.64-5.53 2.47-7.81 2.47-1.35 0-2.54-.28-3.55-.87zm43.79-106.63l-32.43 18.72c-10.45 6.03-18.63 19.01-18.63 29.55v51.02c0 4.98 1.87 8.81 5.29 10.78 3.98 2.31 9.58 1.71 15.32-1.6l32.43-18.73c10.45-6.04 18.63-19.01 18.63-29.54v-51.03c0-4.98-1.89-8.8-5.3-10.77-1.6-.93-3.47-1.39-5.49-1.39-3.01 0-6.38 1.01-9.82 2.99",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M3855.92 2730.63v-52.81c0-3.59 2.91-8.17 6.49-10.24l4.07-2.35 14.75-8.51 6.66-3.85c3.59-2.07 6.49-.84 6.49 2.75v52.81l-.01.49c-.25 3.49-3.05 7.77-6.48 9.75l-25.48 14.7c-3.58 2.08-6.49.85-6.49-2.74",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M3857.63 2707.99l.12-2.54.2-1.49c.15-.96.33-1.92.58-2.89 1.33-5.35 4.08-10.77 7.62-15.26l2.13-2.48c1.88-2.01 3.94-3.75 6.09-5.1l.79-.48c4.11-2.37 7.89-2.93 10.88-1.93 2.47.82 4.39 2.7 5.52 5.47.73 1.79 1.13 3.95 1.13 6.45 0 3.32-.71 6.86-1.95 10.35-1.76 4.92-4.61 9.73-8.08 13.63-2.19 2.46-4.63 4.55-7.21 6.1l-.29.17-2.49 1.23c-8.51 3.52-15.04-1.1-15.04-11.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M4044.62 2689.77l-17.5-16.13 20.76 57.87z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M4039.83 2654.74l1.86 38.71 16.97 16.49z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M5830.63 3861.71c-29.47 16.28-37.96 17.42-47.36 13.29-2.91-1.29-6.2-2.66-7.17-5.9-2.28-7.7 1.61-20.6 4.52-29.4 4.14-12.5 22.74-21.23 37.86-25.87 9.31-2.85 24.24 4.76 28.39 8.33 4.14 3.58 3.15 6.22 2.24 14.47-.92 8.25-8.56 19.6-18.48 25.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M5818.75 3854.21c7.97-5.54 10.07-7.3 11.4-12.33 1.32-5.04 4.05-15.99 2.58-20.46-1.44-4.48-15.44-6.95-28.2 0-12.75 6.94-20.15 13.42-21.15 15.44-1.01 2.01-4.14 15.67-4.7 23.61-.56 7.95.77 9.96 2.01 10.3 1.23.34 14.66-1.79 38.06-16.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3c2ce",
    d: "M5781.37 3869.1c6.94.33 39.84-17.24 44.71-23.98 1.63-2.27 7.78-27.66 1.96-27.36-5.82.3-9.96-.71-24.07 6.68-14.1 7.38-18.24 11.97-19.02 13.43-.79 1.45-3.7 15.22-4.15 21.26-.44 6.05.57 9.97.57 9.97",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5744.16 3217.08c8.41-14.38 19.43-29.22 19.5-54.53l-2.03-42.54-377.04 226.85 4.99 42.47c-.08 25.31-28.49 55.16-36.9 69.54l391.48-241.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient60)",
    d: "M5696.69 3163.01c-2.6 5.51-5.21 11.01-7.81 16.53 3.28-6.96 5.04-15.72 4.89-26.05-.59-38.95-28.08-85.47-61.41-103.91l15.28.63c28.93 16 52.79 56.38 53.3 90.19.12 8.97-1.4 16.57-4.25 22.61",
    clipPath: "url(#clipPath60)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient65)",
    d: "M5647.79 3060.3c24.16 13.37 44.09 47.09 44.5 75.32.23 14.52-4.77 24.77-12.95 29.46l3.13-1.8c8.19-4.7 13.18-14.94 12.97-29.47-.42-28.22-20.35-61.94-44.51-75.31-11.72-6.49-22.29-7-30.01-2.56l-3.15 1.8c7.73-4.43 18.29-3.93 30.02 2.56",
    clipPath: "url(#clipPath65)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M5717.98 3181.25l-11.3 6.47c12.59-7.22 20.26-22.96 19.93-45.29-.64-43.4-31.28-95.25-68.43-115.8l11.3-6.47c37.14 20.55 67.78 72.39 68.43 115.79.33 22.33-7.34 38.07-19.93 45.3",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient70)",
    d: "M5607.95 3085.41c.42 28.22 20.35 61.94 44.51 75.31 24.16 13.37 43.4 1.32 42.98-26.91-.42-28.22-20.35-61.94-44.51-75.31-24.16-13.37-43.4-1.33-42.98 26.91zm-18.93-18.53c.12-2.09.35-4.89.63-6.96.76-5.62 2.01-9.79 2.51-11.33.73-2.23 1.82-5.18 2.91-7.27a89.3 89.3 0 013.27-5.7l2-2.76c1.35-1.75 3.5-4.01 4.67-5.02l2.42-2.04c1.35-.99 3.2-2.23 4.61-3.1 11.88-6.81 28.13-6.04 46.14 3.93 37.15 20.55 67.79 72.4 68.43 115.8.33 22.33-7.34 38.07-19.93 45.29-1.67.88-3.93 1.97-5.67 2.69-1.14.46-2.73.9-3.91 1.26-1.91.56-5.58 1.22-8.4 1.35-1.77.08-4.12.07-5.89 0-1.17-.05-2.74-.21-3.9-.39-2.32-.36-5.37-1.02-7.64-1.59-1.38-.34-3.19-.91-4.52-1.44-1.37-.53-3.23-1.2-4.58-1.81-2.14-.97-4.95-2.34-7.01-3.47-5.67-3.1-10.85-7.01-10.9-7.04-1.49-1.15-3.48-2.67-4.91-3.87-1.62-1.34-3.75-3.17-5.25-4.64-2.82-2.77-6.49-6.58-9.17-9.51-1.44-1.56-3.18-3.81-4.54-5.46-2.53-3.07-6.85-9.25-8.09-11.25-1.1-1.77-2.61-4.11-3.67-5.91-1.06-1.79-2.38-4.24-3.41-6.06-1.01-1.81-2.18-4.33-3.12-6.2-.02-.04-2.71-5.49-5.37-12.72-1.39-3.77-2.98-8.9-4.02-12.79-.29-1.07-1.77-6.76-2.72-13.36-.81-5.75-1.03-10.3-1.05-13.11-.02-1.65-.01-3.86.08-5.52",
    clipPath: "url(#clipPath70)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient75)",
    d: "M5677.56 3043.22c24.16 13.37 44.09 47.09 44.51 75.32.22 14.53-4.78 24.77-12.97 29.47l3.24-1.86c8.2-4.7 13.19-14.94 12.97-29.47-.43-28.23-20.35-61.95-44.51-75.32-11.73-6.49-22.29-6.99-30.02-2.56l-3.23 1.86c7.71-4.43 18.28-3.93 30.01 2.56",
    clipPath: "url(#clipPath75)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient80)",
    d: "M5627.78 3075.79l.48 2.47c-1.03-5.31-1.63-10.56-1.7-15.67-.52-35.18 23.45-50.2 53.57-33.54 30.1 16.66 54.94 58.69 55.47 93.87.52 35.19-23.46 50.2-53.57 33.54-5.22-2.89-10.28-6.54-15.09-10.78l1.89 1.66c5.1 4.51 10.47 8.38 16 11.44 31.96 17.68 57.41 1.75 56.85-35.59-.56-37.33-26.91-81.93-58.87-99.61-31.95-17.68-57.4-1.75-56.84 35.59.07 5.42.7 11 1.81 16.62",
    clipPath: "url(#clipPath80)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient85)",
    d: "M5680.21 3034.75c27.42 15.17 50.03 53.44 50.51 85.47.48 32.04-21.36 45.71-48.78 30.54-27.42-15.17-50.03-53.44-50.5-85.47-.48-32.04 21.35-45.71 48.77-30.54zm-53.65 27.84c.52 35.18 25.35 77.21 55.47 93.87 30.11 16.66 54.09 1.65 53.57-33.54-.53-35.18-25.37-77.21-55.47-93.87-30.12-16.66-54.09-1.65-53.57 33.54",
    clipPath: "url(#clipPath85)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient90)",
    d: "M5625.97 3059.17c.07 5.47.72 11.09 1.84 16.76v.01c.71 3.13 1.66 7.31 2.59 10.38.53 1.74 1.27 4.05 1.88 5.76.6 1.7 1.48 3.94 2.12 5.62 1.61 4.15 5.34 11.97 8.35 17.11 1.91 3.24 4.57 7.48 6.71 10.57 1.86 2.7 4.55 6.13 6.59 8.69 2.29 2.84 3.81 4.43 7.88 8.66 1.36 1.43 3.32 3.19 4.78 4.51h.01c5.13 4.55 10.53 8.46 16.11 11.54 31.96 17.68 57.41 1.75 56.85-35.59-.56-37.33-26.91-81.93-58.87-99.61-31.95-17.68-57.4-1.75-56.84 35.59zm-2.47-2.92c-.6-39.81 26.55-56.8 60.62-37.94 34.07 18.85 62.18 66.41 62.77 106.23.59 39.81-26.55 56.8-60.62 37.95-5.95-3.3-11.72-7.47-17.18-12.31.29-1.08.26-1.94-.07-2.52.33.58.36 1.44.07 2.52-21.28-18.85-38.06-48-43.62-76.04l1.62.74-1.62-.74c-1.2-6.05-1.89-12.05-1.97-17.89",
    clipPath: "url(#clipPath90)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient95)",
    d: "M5542.81 3086.11c.96 64.23 22.17 100.75 77.68 131.46 20.55 11.37 39.05 12.21 52.54 4.39 14.11-8.18 42.47-24.63 56.58-32.8-13.47 7.8-31.93 6.96-52.42-4.38-42.09-23.28-76.8-82.02-77.53-131.19-.19-12.55 1.86-23.27 5.71-31.89 8.28.97 17.29 3.96 26.72 9.18l42.43-24.16c-20.35-11.26-38.7-12.16-52.14-4.54-14.18 8.05-42.61 24.36-56.79 32.41-14.39 8.16-23.16 26.07-22.78 51.52",
    clipPath: "url(#clipPath95)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient100)",
    d: "M5684.25 3026.87c30.02 16.62 54.78 58.53 55.31 93.61.53 35.08-23.39 50.05-53.42 33.44-30.02-16.62-54.78-58.52-55.31-93.61-.53-35.08 23.39-50.05 53.42-33.44zm-65.87 26.55c.64 43.12 31.08 94.63 67.98 115.04 36.9 20.42 66.3 2.02 65.65-41.09-.64-43.12-31.08-94.63-67.99-115.05-36.89-20.42-66.29-2.01-65.64 41.1",
    clipPath: "url(#clipPath100)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient105)",
    d: "M5681.07 3006.09c1.7 1.02 4.01 2.31 5.67 3.38 2.04 1.32 4.72 3.17 6.68 4.6 3.44 2.53 7.79 6.2 10.93 9.1 5.49 5.09 9.58 9.74 10.91 11.26 4.57 5.22 7.84 9.67 9.78 12.33.7.97 4.46 6.17 8.61 13.19 2.67 4.5 5.15 9.17 7.38 13.85 6.32 13.28 9.2 23.54 10.6 28.8.57 2.14 1.99 7.84 2.98 14.49 1.08 7.37 1.22 12.56 1.26 14.26.12 4.7-.06 9.1-.54 13.45-.24 2.16-.72 5.02-1.12 7.16-.29 1.51-.82 3.5-1.19 5-.55 2.11-1.56 4.86-2.33 6.9-.46 1.24-1.24 2.83-1.78 4.04-.92 2.06-2.42 4.7-3.74 6.52-1.37 1.88-3.29 4.33-4.79 6.09-.79.92-1.98 2.01-2.86 2.84l-2.77 2.34c-1.5 1.1-3.55 2.48-5.13 3.46-13.47 7.81-31.93 6.98-52.44-4.37-42.08-23.28-76.79-82.02-77.52-131.19-.38-25.4 8.38-43.27 22.73-51.42.97-.49 2.22-1.2 3.21-1.64 1.23-.56 2.9-1.24 4.17-1.7 2.09-.76 4.99-1.42 7.15-1.9 1.77-.39 4.17-.63 5.98-.73 2.01-.11 4.72-.13 6.73.01 1.35.08 3.13.22 4.46.45 2.63.44 6.15 1.01 8.69 1.81 3.15.99 7.31 2.43 10.35 3.7 2.46 1.02 5.6 2.67 7.94 3.92 1.78.99 2.91 3.15 2.95 6.23-36.89-20.42-66.29-2.01-65.64 41.1.64 43.12 31.08 94.63 67.98 115.04 36.9 20.42 66.3 2.02 65.65-41.09-.64-43.12-31.08-94.63-67.99-115.05-.04-3.08-1.17-5.24-2.95-6.23",
    clipPath: "url(#clipPath105)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient115)",
    d: "M5637.4 3042.94c-.62 2.14-1.25 4.28-1.86 6.42-.81 2.81-1.7 5.6-2.39 8.44 2.81.95 5.69 2.22 8.65 3.87 25.37 14.14 46.23 49.44 46.59 78.84.05 4.19-.33 8.02-1.08 11.49 3.21.33 6.36 1.15 9.49 1.97 1.72.45 3.45.85 5.2 1.24l2.11-1.23a22.41 22.41 0 004.37-3.32l4.92-2.86c8.35-4.85 13.44-15.29 13.26-30.08-.36-29.1-21-64.02-46.1-78.02-12.35-6.88-23.48-7.41-31.56-2.72-1.22.72-2.38 1.55-3.45 2.5-2.34.51-4.51 1.35-6.52 2.51l-1.63.95",
    clipPath: "url(#clipPath115)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient125)",
    d: "M5634.31 3058.21c2.43.89 4.93 2.03 7.49 3.46 25.37 14.14 46.23 49.44 46.59 78.84.05 4.1-.32 7.85-1.03 11.26 2.69.32 5.38 1.34 7.86 2.06 1.72.5 3.47.97 5.24 1.42 8.16-4.93 13.14-15.28 12.96-29.89-.35-29.1-21-64.03-46.1-78.02-12.35-6.88-23.47-7.41-31.55-2.72l-1.08.71c-.32 4.29-.52 8.58-.38 12.88",
    clipPath: "url(#clipPath125)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient139)",
    d: "M5689.1 3111.83c4.13-.83 10.21 1.05 15.79 4.16 3.06 1.71 5.97 3.77 8.32 5.95l3.66-2.11c-2.36-2.18-5.27-4.24-8.33-5.95-7.64-4.26-16.22-6.22-19.44-2.05",
    clipPath: "url(#clipPath139)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient149)",
    d: "M5668.03 3120.47c7.7 4.29 14.34 19.96 16.55 31.45 1.24-.51 2.52-.88 3.85-1.07-1.99-11.56-8.81-28.07-16.75-32.49-3.67-2.04-7.03-1.19-9.77 1.25 1.89-.54 3.95-.35 6.12.86",
    clipPath: "url(#clipPath149)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient159)",
    d: "M5659.68 3040.62l-3.65 2.11c4.84 10.22 7.84 27.39 3.78 33.34l1.13-.16c7.51-2.16 4.35-23.42-1.26-35.29",
    clipPath: "url(#clipPath159)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient169)",
    d: "M5706.04 3093.58l-.8.74c1.79-.7 3.33-1.66 4.45-2.85l-3.65 2.11",
    clipPath: "url(#clipPath169)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient179)",
    d: "M5632.53 3075.73c8.06 4.99 16.61 13.3 18.67 21.44 1.57 6.18-.93 11.04-4.92 14.07 5.94-2.52 10.59-8.27 8.57-16.18-2.22-8.81-12.08-17.83-20.65-22.61l-1.96-1.02c.14 1.43.24 2.86.29 4.3",
    clipPath: "url(#clipPath179)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient190)",
    d: "M5633.03 3071.82l1.17.63c8.57 4.78 18.43 13.8 20.65 22.61 2.11 8.3-3.11 14.22-9.46 16.53 1.22 2.84 2.75 5.53 4.5 8.1 2.01 2.94 4.51 5.28 7.05 7.67 2.77-7.24 8.28-12.59 14.74-9 9.37 5.23 17.2 27.33 17.33 38.21 7.01.64 13.11-1.17 17.82-5.14-8.96-8.34-21.44-29.09-18.67-37.81 2.05-6.43 11.8-4.52 20.38.26 3.06 1.71 5.97 3.77 8.33 5.95-.64-9.26-3.19-18.98-7.18-28.36-4.16 4.4-14.04 5.89-21.86 1.53a19.456 19.456 0 01-6.31-5.62c-7.65-10.61-4.99-28.63.41-34.35-2.89-2.45-5.89-4.65-8.96-6.53l-.22-.13-.35-.21-.33-.2-.17-.09-.47-.28-.13-.07-.52-.3-.52-.28-.12-.07-.48-.25-.17-.09-.3-.16-.48-.24-.09-.05c-3.07-1.55-6.06-2.69-8.94-3.46 5.61 11.87 8.77 33.13 1.26 35.29-1.74.5-3.9-.07-6.25-1.38-7.71-4.29-17.55-16.56-21.98-25.64-.66 7.61-.22 15.29.32 22.93",
    clipPath: "url(#clipPath190)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient200)",
    d: "M5671.55 3108.23c-4.84-2.69-8.82-9.44-8.88-15.05-.07-5.61 3.79-7.98 8.64-5.28 4.84 2.7 8.83 9.44 8.9 15.05.06 5.61-3.8 7.99-8.66 5.28",
    clipPath: "url(#clipPath200)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient211)",
    d: "M5670.16 3106.06c3.44 1.93 6.2.25 6.15-3.74-.05-3.98-2.88-8.77-6.33-10.69-3.44-1.91-6.19-.23-6.13 3.75.05 3.98 2.87 8.77 6.31 10.68",
    clipPath: "url(#clipPath211)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient225)",
    d: "M5678.8 3152.14c13.58 7.57 25.82 8.15 34.7 2.99l3.11-1.8c-8.89 5.16-21.12 4.57-34.7-3-27.6-15.38-50.31-53.8-50.7-85.79-.19-16.27 5.4-27.74 14.58-33.08l-3.1 1.81c-9.18 5.33-14.79 16.81-14.58 33.07.39 32 23.08 70.41 50.69 85.8",
    clipPath: "url(#clipPath225)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e4",
    d: "M5635.74 3067.06c-.35-29.1 19.71-41.35 44.82-27.36 25.1 14 45.74 48.92 46.1 78.02.35 29.1-19.71 41.35-44.81 27.36-25.11-13.99-45.75-48.92-46.11-78.02zm46.17 83.27c27.61 15.39 49.67 1.92 49.28-30.08-.39-32-23.09-70.42-50.7-85.8-27.61-15.38-49.67-1.92-49.28 30.09.39 31.99 23.1 70.41 50.7 85.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b7fd4",
    d: "M5594.65 3129.35c.66 1.82 2.66-11.39 3.4-9.58.73 1.81 1.49 3.63 2.27 5.43.79 1.8 1.61 3.58 2.45 5.37.85 1.78 1.73 3.58 2.62 5.34 1.35 2.64 2.73 5.25 4.18 7.83.98 1.73 1.97 3.46 2.99 5.18 1.51 2.54 3.08 5.06 4.72 7.53l1.64 2.5c1.01 1.48 2.05 2.97 3.09 4.42l.56.8c1.06 1.47 2.13 2.92 3.23 4.35v.02c1.12 1.47 2.26 2.92 3.43 4.35 4.33 5.42 8.92 10.54 13.72 15.33 1.33 1.33 2.68 2.65 4.07 3.93l2.08 1.92c3.48 3.13 7.04 6.09 10.68 8.83 4.36 3.28 8.82 6.27 13.38 8.89 27.12 15.66 51.44 15.59 67.67 2.77 1.3-1.02 2.54-2.12 3.7-3.29l.88-.91 1.44-1.57 1.08-1.29c2.15-2.66 4.07-5.65 5.74-8.92.64-1.22 1.23-2.5 1.79-3.81 3.92-9.17 6.08-20.36 6.11-33.34l.06-32.12 6.45 2.54 12.43 8.33v43.41c-.2 67.92-48.27 106.12-107.38 71.99-37.21-21.48-69.92-66.48-89-113.82-.28-6.35 3.43-10.58 10.52-12.41",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5578.86 3059.68l.03-24.47 6.54 1.27-.09 23.2c-.02 7.23.64 14.68 1.86 22.21.24 1.49.52 2.99.8 4.48.61 3.14 1.33 6.29 2.14 9.45.34 1.35.69 2.68 1.08 4.02l.45 1.58c.37 1.27.75 2.56 1.15 3.84.97 3.02 1.99 6.04 3.12 9.07.66 1.82 1.37 3.63 2.11 5.44.73 1.81 1.49 3.63 2.27 5.43.79 1.8 1.61 3.58 2.45 5.37.85 1.78 1.73 3.58 2.62 5.34 1.35 2.64 2.73 5.25 4.18 7.83.98 1.73 1.97 3.46 2.99 5.18 1.51 2.54 3.08 5.06 4.72 7.53l1.64 2.5c1.01 1.48 2.05 2.97 3.09 4.42l.56.8c1.06 1.47 2.13 2.92 3.23 4.35v.02c1.12 1.47 2.26 2.92 3.43 4.35 4.33 5.42 8.92 10.54 13.72 15.33 1.33 1.33 2.68 2.65 4.07 3.93l2.08 1.92c3.48 3.13 7.04 6.09 10.68 8.83 4.36 3.28 8.82 6.27 13.38 8.89 27.12 15.66 51.44 15.59 67.67 2.77 1.3-1.02 2.54-2.12 3.7-3.29l.88-.91 1.44-1.57 1.08-1.29c2.15-2.66 4.07-5.65 5.74-8.92.64-1.22 1.23-2.5 1.79-3.81 3.92-9.17 6.08-20.36 6.11-33.34l.06-33.7 6.45 3.73v37.47c-.16 60.04-42.66 84.25-94.92 54.08-52.25-30.16-94.47-103.28-94.3-163.33",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M6378.15 3583.12c8.41-14.39 19.44-29.23 19.51-54.53l-2.03-25.16-377.05 226.85 4.99 25.09c-.07 25.31-28.49 55.15-36.9 69.54l391.48-241.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient234)",
    d: "M6330.68 3529.04c-2.6 5.51-5.2 11.02-7.81 16.54 3.29-6.95 5.04-15.72 4.89-26.06-.58-38.94-28.07-85.46-61.4-103.9l15.27.63c28.94 16 52.79 56.38 53.3 90.18.13 8.97-1.39 16.58-4.25 22.61",
    clipPath: "url(#clipPath234)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient239)",
    d: "M6281.79 3426.33c24.16 13.37 44.08 47.09 44.5 75.33.22 14.52-4.78 24.77-12.96 29.46l3.13-1.8c8.2-4.7 13.19-14.94 12.97-29.47-.42-28.23-20.35-61.95-44.51-75.32-11.72-6.49-22.28-6.99-30.01-2.56l-3.14 1.8c7.72-4.42 18.29-3.92 30.02 2.56",
    clipPath: "url(#clipPath239)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M6351.97 3547.29l-11.3 6.47c12.59-7.22 20.27-22.96 19.94-45.3-.65-43.4-31.28-95.24-68.43-115.79l11.3-6.48c37.14 20.55 67.77 72.39 68.42 115.79.34 22.34-7.34 38.08-19.93 45.31",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient244)",
    d: "M6241.94 3451.44c.42 28.23 20.35 61.95 44.52 75.32 24.16 13.37 43.39 1.32 42.97-26.91-.42-28.23-20.35-61.95-44.51-75.32-24.16-13.37-43.4-1.32-42.98 26.91zm-18.92-18.52c.11-2.1.34-4.89.62-6.97.76-5.61 2.01-9.78 2.51-11.32.74-2.23 1.83-5.19 2.91-7.27.91-1.75 2.23-4.03 3.27-5.7l2.01-2.76c1.34-1.75 3.49-4.01 4.66-5.03l2.43-2.04c1.34-.98 3.19-2.22 4.61-3.09 11.87-6.82 28.12-6.04 46.14 3.93 37.15 20.55 67.77 72.39 68.43 115.79.33 22.34-7.35 38.08-19.94 45.3-1.67.87-3.92 1.96-5.67 2.68-1.13.47-2.72.91-3.91 1.26-1.91.56-5.57 1.22-8.39 1.36-1.77.08-4.13.07-5.89 0a39.21 39.21 0 01-3.91-.39c-2.31-.36-5.36-1.03-7.64-1.59-1.37-.35-3.19-.92-4.52-1.44-1.37-.54-3.23-1.2-4.58-1.81-2.14-.98-4.95-2.35-7.01-3.47-5.66-3.11-10.85-7.01-10.9-7.04-1.48-1.15-3.47-2.67-4.91-3.87-1.61-1.35-3.75-3.16-5.24-4.64-2.83-2.78-6.5-6.59-9.17-9.51-1.45-1.57-3.19-3.82-4.55-5.46-2.52-3.08-6.84-9.25-8.08-11.25-1.1-1.77-2.62-4.12-3.67-5.91-1.07-1.8-2.39-4.24-3.41-6.06-1.02-1.82-2.19-4.34-3.13-6.2-.02-.05-2.7-5.49-5.37-12.72-1.38-3.78-2.98-8.91-4.02-12.79-.28-1.07-1.77-6.76-2.72-13.36-.81-5.75-1.02-10.3-1.05-13.11-.02-1.66-.01-3.87.09-5.52",
    clipPath: "url(#clipPath244)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient249)",
    d: "M6311.55 3409.26c24.16 13.37 44.09 47.09 44.51 75.32.22 14.53-4.77 24.77-12.96 29.46l3.24-1.85c8.19-4.7 13.18-14.94 12.97-29.47-.43-28.23-20.35-61.95-44.52-75.32-11.72-6.49-22.29-6.99-30.01-2.56l-3.24 1.86c7.72-4.43 18.28-3.93 30.01 2.56",
    clipPath: "url(#clipPath249)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient254)",
    d: "M6261.78 3441.83l.48 2.46c-1.05-5.3-1.63-10.55-1.7-15.67-.53-35.18 23.44-50.19 53.56-33.53 30.11 16.66 54.94 58.69 55.47 93.87.53 35.18-23.46 50.2-53.56 33.54-5.23-2.89-10.29-6.54-15.09-10.79l1.88 1.67c5.1 4.5 10.47 8.37 16.01 11.44 31.95 17.68 57.4 1.75 56.84-35.59-.55-37.33-26.91-81.93-58.86-99.61-31.96-17.68-57.41-1.75-56.85 35.59.08 5.42.7 11 1.82 16.62",
    clipPath: "url(#clipPath254)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient259)",
    d: "M6314.21 3400.79c27.41 15.17 50.03 53.44 50.51 85.47.48 32.04-21.36 45.71-48.78 30.54-27.42-15.17-50.03-53.44-50.51-85.48-.48-32.03 21.36-45.7 48.78-30.53zm-53.65 27.83c.51 35.19 25.35 77.22 55.47 93.88 30.1 16.66 54.09 1.64 53.56-33.54-.53-35.18-25.36-77.21-55.47-93.87-30.12-16.66-54.09-1.65-53.56 33.53",
    clipPath: "url(#clipPath259)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient264)",
    d: "M6259.96 3425.21c.08 5.46.72 11.09 1.85 16.76.7 3.14 1.66 7.32 2.58 10.39.53 1.74 1.27 4.05 1.88 5.76.6 1.7 1.48 3.94 2.13 5.62 1.6 4.14 5.33 11.97 8.35 17.11 1.9 3.23 4.58 7.48 6.71 10.57 1.85 2.69 4.55 6.13 6.59 8.68 2.28 2.85 3.81 4.44 7.87 8.67 1.37 1.42 3.32 3.19 4.79 4.51 5.13 4.55 10.53 8.45 16.12 11.54 31.95 17.68 57.4 1.75 56.84-35.59-.55-37.33-26.91-81.93-58.86-99.61-31.96-17.68-57.41-1.75-56.85 35.59zm-2.47-2.92c-.6-39.81 26.55-56.8 60.63-37.95 34.07 18.86 62.17 66.42 62.77 106.23.59 39.82-26.55 56.81-60.63 37.95-5.94-3.29-11.71-7.46-17.18-12.31.29-1.07.26-1.93-.06-2.52.32.59.35 1.45.06 2.52-21.27-18.85-38.06-48-43.62-76.03l1.62.74-1.62-.74c-1.2-6.05-1.88-12.06-1.97-17.89",
    clipPath: "url(#clipPath264)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient269)",
    d: "M6176.81 3452.14c.95 64.23 22.17 100.75 77.68 131.47 20.54 11.37 39.05 12.21 52.53 4.38 14.11-8.18 42.47-24.61 56.58-32.79-13.46 7.8-31.93 6.96-52.42-4.38-42.09-23.28-76.8-82.02-77.53-131.19-.18-12.56 1.87-23.28 5.72-31.89 8.29.96 17.28 3.95 26.71 9.17l42.44-24.15c-20.36-11.26-38.71-12.17-52.14-4.54-14.18 8.04-42.62 24.36-56.8 32.41-14.38 8.16-23.15 26.07-22.77 51.51",
    clipPath: "url(#clipPath269)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient274)",
    d: "M6318.24 3392.91c30.02 16.61 54.79 58.52 55.31 93.6.53 35.09-23.38 50.06-53.41 33.44-30.02-16.61-54.79-58.52-55.32-93.6-.51-35.09 23.39-50.06 53.42-33.44zm-65.87 26.55c.65 43.12 31.09 94.62 67.98 115.04 36.91 20.42 66.3 2.02 65.66-41.1-.65-43.11-31.09-94.62-67.98-115.04-36.91-20.42-66.3-2.02-65.66 41.1",
    clipPath: "url(#clipPath274)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient279)",
    d: "M6315.07 3372.13c1.7 1.01 4 2.3 5.66 3.38 2.04 1.32 4.72 3.16 6.68 4.6 3.44 2.52 7.8 6.2 10.93 9.1 5.5 5.09 9.57 9.73 10.92 11.26 4.57 5.22 7.83 9.67 9.77 12.33.71.97 4.47 6.17 8.62 13.19 2.66 4.5 5.14 9.16 7.37 13.85 6.33 13.28 9.21 23.54 10.61 28.8.56 2.14 1.99 7.84 2.97 14.49 1.09 7.37 1.22 12.55 1.26 14.26.12 4.7-.06 9.11-.53 13.45-.25 2.16-.72 5.02-1.13 7.16-.29 1.51-.82 3.5-1.19 4.99-.54 2.12-1.55 4.86-2.32 6.91-.46 1.24-1.24 2.83-1.79 4.03-.92 2.06-2.41 4.7-3.74 6.53-1.37 1.88-3.28 4.32-4.78 6.08-.8.92-1.99 2.02-2.87 2.85l-2.77 2.34c-1.49 1.1-3.54 2.48-5.13 3.46-13.46 7.81-31.93 6.97-52.44-4.37-42.08-23.28-76.79-82.02-77.52-131.19-.38-25.4 8.38-43.28 22.74-51.42.96-.5 2.21-1.2 3.2-1.65 1.23-.56 2.9-1.24 4.17-1.7 2.09-.75 4.99-1.42 7.16-1.9 1.77-.38 4.17-.62 5.97-.72 2.02-.12 4.72-.13 6.73 0 1.35.09 3.14.22 4.47.45 2.62.45 6.15 1.02 8.69 1.81 3.14.99 7.3 2.43 10.34 3.7 2.46 1.03 5.6 2.68 7.95 3.93 1.78.99 2.91 3.15 2.96 6.23-36.91-20.42-66.3-2.02-65.66 41.1.65 43.12 31.09 94.62 67.98 115.04 36.91 20.42 66.3 2.02 65.66-41.1-.65-43.11-31.09-94.62-67.98-115.04-.05-3.08-1.18-5.24-2.96-6.23",
    clipPath: "url(#clipPath279)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient289)",
    d: "M6271.4 3408.97c-.63 2.14-1.25 4.28-1.87 6.42-.81 2.81-1.7 5.61-2.37 8.45 2.79.94 5.67 2.21 8.63 3.87 25.37 14.13 46.23 49.43 46.59 78.84.05 4.19-.33 8.02-1.07 11.49 3.2.32 6.36 1.15 9.48 1.96 1.72.45 3.46.86 5.21 1.25l2.11-1.23c1.57-.91 3.02-2.02 4.36-3.32l4.92-2.87c8.35-4.85 13.44-15.28 13.26-30.07-.36-29.1-20.99-64.03-46.1-78.02-12.34-6.88-23.48-7.41-31.55-2.72-1.22.72-2.38 1.55-3.46 2.5a22.51 22.51 0 00-6.51 2.51l-1.63.94",
    clipPath: "url(#clipPath289)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient299)",
    d: "M6268.3 3424.24c2.43.9 4.93 2.04 7.49 3.47 25.37 14.13 46.23 49.43 46.59 78.84.05 4.1-.32 7.85-1.02 11.26 2.68.33 5.38 1.33 7.86 2.05 1.72.51 3.47.98 5.23 1.43 8.17-4.93 13.15-15.28 12.96-29.89-.35-29.1-20.99-64.03-46.09-78.02-12.36-6.88-23.48-7.41-31.55-2.72l-1.09.71c-.32 4.28-.52 8.58-.38 12.87",
    clipPath: "url(#clipPath299)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient313)",
    d: "M6323.1 3477.87c4.13-.83 10.2 1.05 15.79 4.16 3.05 1.7 5.96 3.77 8.32 5.95l3.65-2.11c-2.35-2.18-5.26-4.25-8.32-5.95-7.65-4.26-16.22-6.22-19.44-2.05",
    clipPath: "url(#clipPath313)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient323)",
    d: "M6302.02 3486.5c7.71 4.3 14.35 19.96 16.55 31.45 1.24-.5 2.52-.87 3.85-1.06-1.99-11.56-8.81-28.07-16.75-32.49-3.67-2.05-7.03-1.19-9.76 1.25 1.88-.54 3.94-.35 6.11.85",
    clipPath: "url(#clipPath323)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient333)",
    d: "M6293.67 3406.67l-3.65 2.1c4.84 10.21 7.84 27.39 3.79 33.34l1.12-.16c7.51-2.16 4.36-23.42-1.26-35.28",
    clipPath: "url(#clipPath333)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient343)",
    d: "M6340.03 3459.62l-.79.74c1.79-.71 3.33-1.66 4.44-2.85l-3.65 2.11",
    clipPath: "url(#clipPath343)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient353)",
    d: "M6266.52 3441.77c8.06 4.99 16.61 13.3 18.68 21.43 1.57 6.18-.93 11.04-4.93 14.08 5.94-2.52 10.59-8.28 8.58-16.18-2.23-8.81-12.08-17.83-20.66-22.61l-1.96-1.03c.15 1.43.24 2.87.29 4.31",
    clipPath: "url(#clipPath353)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient364)",
    d: "M6267.02 3437.86l1.17.63c8.58 4.78 18.43 13.8 20.66 22.61 2.11 8.29-3.12 14.22-9.47 16.53 1.23 2.83 2.76 5.53 4.51 8.1 2.01 2.93 4.51 5.28 7.05 7.66 2.76-7.23 8.28-12.59 14.73-8.99 9.38 5.22 17.2 27.33 17.34 38.2 7 .64 13.1-1.16 17.81-5.14-8.95-8.33-21.44-29.09-18.66-37.8 2.04-6.43 11.8-4.52 20.38.26 3.06 1.7 5.97 3.77 8.32 5.95-.64-9.26-3.18-18.98-7.18-28.36-4.16 4.4-14.03 5.89-21.85 1.53a19.368 19.368 0 01-6.31-5.62c-7.66-10.62-4.99-28.63.41-34.35-2.89-2.45-5.89-4.65-8.97-6.53l-.21-.13-.35-.21-.34-.2-.15-.1-.49-.27-.12-.07-.52-.3-.52-.28-.13-.07-.47-.26-.17-.09-.31-.15-.47-.25-.09-.04c-3.08-1.55-6.07-2.69-8.95-3.45 5.62 11.86 8.77 33.12 1.26 35.28-1.74.5-3.89-.07-6.25-1.38-7.7-4.3-17.55-16.56-21.98-25.65-.66 7.62-.22 15.3.32 22.94",
    clipPath: "url(#clipPath364)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient374)",
    d: "M6305.55 3474.27c-4.85-2.7-8.82-9.44-8.89-15.05-.07-5.61 3.8-7.98 8.64-5.28 4.85 2.7 8.83 9.44 8.9 15.05.07 5.61-3.8 7.98-8.65 5.28",
    clipPath: "url(#clipPath374)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient385)",
    d: "M6304.15 3472.1c3.45 1.92 6.2.24 6.15-3.74-.05-3.98-2.88-8.77-6.33-10.69-3.43-1.91-6.19-.23-6.13 3.75.05 3.98 2.87 8.77 6.31 10.68",
    clipPath: "url(#clipPath385)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient399)",
    d: "M6312.79 3518.18c13.59 7.56 25.82 8.15 34.7 2.99l3.12-1.81c-8.89 5.16-21.13 4.58-34.7-2.99-27.61-15.39-50.31-53.8-50.7-85.8-.2-16.26 5.4-27.74 14.58-33.07l-3.11 1.8c-9.18 5.34-14.79 16.81-14.58 33.08.39 32 23.09 70.41 50.69 85.8",
    clipPath: "url(#clipPath399)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e4",
    d: "M6269.74 3433.1c-.36-29.1 19.7-41.35 44.81-27.36 25.11 13.99 45.74 48.92 46.1 78.02.36 29.1-19.7 41.35-44.81 27.35-25.11-13.99-45.74-48.91-46.1-78.01zm46.17 83.27c27.61 15.38 49.67 1.92 49.28-30.09-.4-31.99-23.1-70.41-50.71-85.79-27.6-15.39-49.67-1.92-49.27 30.08.39 32 23.09 70.41 50.7 85.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M6424.62 3629.82l-2.48-62.29-19.28-57.96-.82-2.41v27.8c0 18.59-4.13 33.74-11.29 44.89-5.44 8.47-12.67 14.66-21.28 18.24-16.66 7.16-38.48 4.75-62.29-9.02-11.63-6.74-22.79-15.55-32.97-25.95-35.73-35.86-61.07-89.9-61.34-136.29v-36.21l-444.81-257.66v35.94c0 11.7-1.66 22.02-4.62 30.83-12.45 36.63-48.19 47.57-90.25 23.27-33.24-19.14-62.36-55.62-79.09-95.13-9.49-22.24-15.07-45.36-15.21-66.91v-25.74l-127.69-24.44-62.29 13.01-95.82 45.98-94.73 54.87-23.41 14.04-60.3 43.17-17.82 35.37-3.66 16.59-.07.08-3.36 15.41v42.27l2.06 7.91v.14l8.44 37.06 2.03 13.26 3.23 22.24 5.34 25.28 3.79 10.74 91.09 63.51 14.66 10.19 114.89 106.77 95.69 71.24 92.38 57.68 65.46 36.08 68.03 34.4 37.5 15.64 66.09 19.25 93.85 6.49 111.4 37.8 61.48 16.04 31.11 2.2 49.53 2.92 25.72-3.37 95.16-40.5 100.31-57.97 20.02-14.46 40.65-40.54 6.95-8.88 13.76-23.2 9.57-32.7 2.69-7.58.76-10.8 1.24-18.59",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6274.21 3563.12c-35.73-35.86-61.07-89.9-61.34-136.29v-36.21l-444.81-257.66v35.94c0 11.7-1.66 22.02-4.62 30.83-12.45 36.63-48.19 47.57-90.25 23.27-33.24-19.14-62.36-55.62-79.09-95.13-9.49-22.24-15.07-45.37-15.21-66.91a6071.76 6071.76 0 00-93.97 45.36c-52.52 25.89-88.24 44.4-88.24 44.4l9.91 16.73 91.21 4.62s32.22 3.09 45.02 4.81c12.74 1.72 139.94 83.64 139.94 83.64l262.83 121.87 272.54 125.41 26.82 51.33 29.26 3.99",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M6243.95 3524.54c.66 1.82-12.64-40.54-11.91-38.74.73 1.82 1.5 3.63 2.28 5.44.79 1.8 1.61 3.58 2.45 5.36.85 1.78 1.73 3.58 2.61 5.35 1.35 2.64 2.73 5.24 4.18 7.83.98 1.73 1.98 3.46 2.99 5.17 1.52 2.55 3.1 5.07 4.72 7.53l1.64 2.5c1.02 1.48 2.04 2.97 3.1 4.42l.55.81c1.07 1.47 2.13 2.92 3.23 4.35v.01c1.13 1.48 2.26 2.93 3.43 4.36 4.34 5.42 8.93 10.54 13.72 15.33 1.33 1.32 2.69 2.65 4.08 3.93l2.08 1.92c3.47 3.13 7.04 6.08 10.67 8.83 4.36 3.28 8.83 6.27 13.39 8.89 27.12 15.66 51.43 15.59 67.66 2.76 1.3-1.01 2.54-2.11 3.71-3.28l.87-.92 1.44-1.57 1.08-1.29c2.15-2.65 4.08-5.64 5.75-8.91.63-1.23 1.23-2.5 1.78-3.81 3.92-9.17 6.09-20.36 6.12-33.35l.06-20.83 6.41.53 12.45 37.39v5.08c-.18 67.92-48.26 106.12-107.37 71.99-37.21-21.48-69.91-66.48-88.99-113.82 0 0 15.51 10.15 25.82 16.74",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M6212.85 3425.72l.04-35.1 6.53 3.75-.08 31.35c-.01 7.23.63 14.68 1.85 22.21.25 1.48.53 2.99.8 4.47.62 3.15 1.33 6.3 2.14 9.46.35 1.34.69 2.67 1.08 4.02l.45 1.57c.38 1.28.76 2.57 1.16 3.85.96 3.02 1.99 6.04 3.11 9.07.67 1.81 1.38 3.63 2.11 5.43.73 1.82 1.5 3.63 2.28 5.44.79 1.8 1.61 3.58 2.45 5.36.85 1.78 1.73 3.58 2.61 5.35 1.35 2.64 2.73 5.24 4.18 7.83.98 1.73 1.98 3.46 2.99 5.17 1.52 2.55 3.1 5.07 4.72 7.53l1.64 2.5c1.02 1.48 2.04 2.97 3.1 4.42l.55.81c1.07 1.47 2.13 2.92 3.23 4.35v.01c1.13 1.48 2.26 2.93 3.43 4.36 4.34 5.42 8.93 10.54 13.72 15.33 1.33 1.32 2.69 2.65 4.08 3.93l2.08 1.92c3.47 3.13 7.04 6.08 10.67 8.83 4.36 3.28 8.83 6.27 13.39 8.89 27.12 15.66 51.43 15.59 67.66 2.76 1.3-1.01 2.54-2.11 3.71-3.28l.87-.92 1.44-1.57 1.08-1.29c2.15-2.65 4.08-5.64 5.75-8.91.63-1.23 1.23-2.5 1.78-3.81 3.92-9.17 6.09-20.36 6.12-33.35l.06-24.03 6.44 3.73v27.8c-.16 60.05-42.66 84.25-94.91 54.09-52.26-30.16-94.47-103.28-94.31-163.33",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M6212.87 3426.83v-36.21l-444.81-257.66v35.94c0 11.7-1.66 22.02-4.62 30.83l23.47 11.71 161.15 72.41 262.06 140.64 2.75 2.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6402.86 3509.57l-.82-2.41v3.72z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5383.58 3138.17l-60.44 25.75-27.6 9.79-110.55 64.16-18.54 16.33-46.68 34.88-.44-7.72 22.7-28.5 41.41-30.05 116.99-66.91 42.96-19.59 33.85-4.01 6.34 5.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5442.69 3196.86l9.57 14.25 28.04 19.14 86.38 51.8 53.43 87.26 63.51 87.54 62.33 58.48 57.59 39.94 78.86 45.39 81.18 35.77 38.33 5.34h68.75l106.71-23.14 4.6 7.42 16.62 11.88 19.3 3.26 65.89 35.62 46.89 22.55 24.94 17.81 23.61 22.38 10.45-7.98-.23-4.01-13.13-30.27-40.73-32.28-4.91-10.02-71.01-28.94-73.09-43.63-267.99-137.8-234.96-126.01-164.14-98.82-76.79-22.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5612 3161.81c-20.38-31.74-33.25-68.91-33.11-102.16v-24.44l-127.69-24.43-62.29 13.01-95.82 45.98-94.73 54.87-23.41 14.04-60.3 43.17-17.82 35.37-7.09 32.08v42.27l2.98 25.69 7.52 19.42 2.03 13.26 12.34-14.47 5.82-34.75-1.09-19.34 22.71-28.5 41.37-30.08 117.03-66.91 42.95-19.56 33.87-4.05 20.65 19.2 8.67 15.97 34.7-11.56 43.44 9.5 13.07 6.68 21.68-9.51 20.45-4.88 72.07 4.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6003.29 3646.82l63.52 1.18 101.51-20.17 13.65-1.78 16.62 11.88 2.97 6.82-19.29 24.64-58.18 46.3-109.35 64.91-89.05 38.29-41.4 7.12-39.5.32-79.23-4.79-37.62-10.68 6.24-2.68 79.91-37.39 88.88-50.66 85.18-60.25 15.14-13.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5646.57 3437.8l36.16 34.49 34.73 33.84 45.11 32.94 111.61 64.41 86.85 37.4 26.53 7.12h14.35l-8.77 7.56-8.85-.41-34.72-9.82s-68.87-26.72-82.52-34.13c-13.65-7.43-81.91-45.12-112.2-66.49-30.27-21.37-46.59-34.13-46.59-34.13l-35.32-32.06-32.06-32.06 5.69-8.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5371.24 3601.3s40.6 32.58 61.74 47.94c21.15 15.36 84.15 54.98 105.08 66.56 20.92 11.58 110.41 59.66 141.79 73.91 31.39 14.25 52.04 19.45 52.04 19.45l-3.95 1.7s-18.7-4.01-41.41-14.25c-22.7-10.24-70.34-33.17-87.48-42.07-17.15-8.91-65-35.84-65-35.84s-96.17-60.33-105.3-66.34c-9.12-6.02-64.78-50.8-64.78-50.8l7.27-.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M6259.95 3624.32l.36.14 71.62 29.19 5.01 10.26 40.95 32.7 13.27 30.87.28 4.91-64.02 48.93-109.83 63.7-80.73 39.57-1.52-3.09 80.63-39.52 109.54-63.52 62.38-47.71-.15-2.78-12.84-29.59-40.88-32.61-4.61-9.43-70.04-28.55-28.56 1.32-11.27 1.09-10.24 3.91-6.22 11.46-3.03-1.63 6.83-12.59 12.1-4.56 11.58-1.11 29.39-1.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aaccf7",
    d: "M6023.96 3882.47h11.25l21.25.6 28.22 3.98 30.68.37-7.57.99h-46.08l-34.58-5.11-3.17-.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M6207.72 3406.47l4.03 111.35-3.22 15.81-32.52 65.49-14.71 11.7-79.85 21.21-97.45-2.67-57.98-19.11-60.09-31.05 43.2-116.61 7.21-10.51 11.08-19.56 19.75-49.47 2.63-102.83-.53-24.3 252.69 141.09zm-261.35-126.25l-2.51 101.85-19.53 48.97-10.9 19.22-7.33 10.76-44.45 119.84 63.04 32.56 58.47 19.29 98.44 2.76h.26l80.66-21.41 15.93-12.48 33.26-66.63 3.45-16.84-4.03-112.66-6.7-11-256.1-143-2.63-1.46.67 30.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f5f6",
    d: "M6330.67 3654.99l12.91-9.57h10.58l8.46 4.79 10.47 1.78 15.02.04h5.04l5.64-4.01 7.42 1.63 13.73 17.14-9.57 32.73-13.81 23.15-6.89 8.9-.23-4.01-13.13-30.27-40.73-32.28-4.91-10.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd52",
    d: "M6399.58 3692.37l-19.88-3.87-39.15-26.96v-5.48h13.8l38.53 6.59 10.7-4 6.98 6.52 3.93 8.03-14.91 19.17",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5577.79 3125.6l16.31 2.27c-9.49-22.24-15.07-45.37-15.21-66.91v-25.75l-127.69-24.43-62.29 13.01-95.82 45.98-94.73 54.87-23.41 14.04-60.3 43.17-17.82 35.37-3.66 16.59-.06.08-3.37 15.41v42.27l2.98 25.69-.92-28.17 18.85-30.91 27.61-21.82 131.49-80.47 77.85-37.38 84.19-19.62 36.96 4.06 16.17 3.37 92.87 19.28",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6432.5 3629.82l-2.48-62.29-27.16-57.96-.82-2.41v27.8c0 18.59-4.13 33.74-11.29 44.89-5.44 8.47-12.67 14.66-21.28 18.24l23.68 53.94 7.89.02 5.65-4.05 7.43 1.65 13.69 17.14 2.69-7.58.76-10.8 1.24-18.59",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M6432.5 3629.82l-2.48-62.29-27.16-57.96-.82-2.41v27.8c0 18.59-4.13 33.74-11.29 44.89l18.86 21.54 21.65 47.02 1.24-18.59",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M6406.69 3648l7.43 1.65 13.69 17.14-3.19 7.81-10.13 10.77 5.45-18.58-13.73-17.14-1.4-.31 1.88-1.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5570.56 3288.38l-51.08-2.7-2.42 3.15-30.97 2.39-88.6 33.64-110.43 64.46-63.45 51.38v37l14.07 19.41 97.57 91.58 20.86 15.52 270.67-153.66 20.63-17.44-6.53-13.06-26.12-52.67-44.2-79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5114.6 3408.17l12.11-15.15 16.7-19.66 92.69-61.73 101.73-56.89 85.27-35.62 29.16-8.01-9.57-14.25-20.27-23.15-87.7 60.1-201.82 110.77-24.04 28.94 1.95 23.97 3.79 10.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M6208.09 3639.53l9.8 1.66s95.52 53.43 113.72 65c18.21 11.58 43.7 37.64 43.7 37.64h-11.25s-16.91-16.27-28.48-25.62c-11.59-9.34-127.49-78.68-127.49-78.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5981.84 3794.75s87.1 32.45 91.9 34.68c4.81 2.22 97.94 25 109.29 24.78l11.35-.23s-20.1 1.41-42.14-2.15c-22.04-3.56-68.34-16.62-94.76-25.82s-81.42-28.78-81.42-28.78l5.78-2.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5535.51 3303.71s-16.92-3.56-27.31-3.56c-10.39 0-35.02 2.67-46.6 6.53-11.57 3.86-62.03 25.53-62.03 25.53s-102.24 58.67-110.84 64.9c-8.6 6.23-54.22 38.96-61.85 52.36-3.45 6.05-3.45 10.66-3.45 10.66s-.93 9.29 3.37 13.25c4.29 3.97 76.18 81.03 92.2 94.38 16.03 13.37 35.03 30.28 37.7 32.06 2.67 1.78 11.58 2.38 14.54 1.48 2.98-.89 69.99-32.35 84.86-40.95 14.88-8.61 96.93-56.6 104.05-61.35 7.12-4.75 78.36-50.46 80.73-52.54 2.37-2.07 7.42-9.79 6.53-13.35-.9-3.56-111.9-129.4-111.9-129.4",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5508.2 3307.03c-10.18 0-33.85 2.66-44.42 6.18-10.68 3.56-56.7 23.27-61.15 25.17-25.58 14.46-103.09 59.4-109.86 64.31-8.88 6.43-53.05 38.31-59.94 50.22l-1.71 8.93c-.29 8.05 7.42 13.89 8.27 15.88 3.61 5.69 63.68 74.74 80.33 88.61 7.89 6.58 16.48 14 23.52 20.08 6.08 5.26 12.39 10.7 13.61 11.55.42.15 7.42 1.24 10.44 0 1.2-.49 3.17-1.28 3.34-1.32 3.66-1.37 67.6-33.91 82.03-42.26l12.51-7.21c24.23-13.99 85.47-50.11 91.16-53.9 2.46-1.63 12.49-8.12 24.72-16.01 19.77-12.77 48.68-30.85 51.32-32.87.94-.86 2.96-4.09 3.76-6.1-9.54-11.78-69.86-82.88-109.99-126.25-4.59-2.68-10.46-5.01-17.94-5.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M5476.67 3378.81l-191.51 108.9-32.62 4.91c-7.12-7.69-12.19-13.38-13.15-14.9-.85-1.99-8.56-7.83-8.27-15.88l1.72-8.92c6.88-11.92 51.05-43.8 59.93-50.23 6.77-4.91 84.28-49.85 109.86-64.3 4.45-1.91 50.47-21.62 61.15-25.18 10.57-3.52 34.24-6.17 44.42-6.17 7.48 0 13.35 2.32 17.94 5l26.77 28.94-76.24 37.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161d1d",
    d: "M5399.87 3339.95c-3.23 1.82-6.95 3.93-10.97 6.22 0 .01.01.02.02.03 4.11-2.36 7.81-4.47 10.95-6.25m152.64 1.23c19.56 22 40.2 45.86 56.23 64.62-16.03-18.76-36.67-42.63-56.23-64.62m83.62 97.11c-.8 2.02-2.82 5.24-3.76 6.1.94-.86 2.96-4.09 3.76-6.09v-.01m-3.94 6.24c-3.59 2.58-31.76 20.21-51.14 32.73 19.38-12.51 47.55-30.15 51.14-32.73m-51.14 32.73c-12.09 7.8-22.03 14.22-24.63 15.95 2.6-1.73 12.55-8.15 24.63-15.95m-24.76 16.03c-.02.02-.04.03-.06.05.02-.02.04-.03.06-.05m-.07.05c-.01.01-.02.01-.03.02.01 0 .02-.01.03-.02m-.04.03c-.01 0-.01.01-.02.01.01 0 .01-.01.02-.01m-.04.03c-.01 0-.01 0-.02.01.01-.01.01-.01.02-.01m-.05.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M5459 3314.96c-15.64 5.98-52.42 21.73-56.37 23.43-.87.49-1.8 1.01-2.76 1.56a1939.1 1939.1 0 012.76-1.56c3.95-1.7 40.73-17.45 56.37-23.43m93.51 26.22l-75.84 37.63-46.86 26.65c31.59 45.59 54.79 76.92 89.15 109.83 17.63-10.23 33.52-19.52 37.13-21.86.01-.01.02-.02.03-.02.01-.01.01-.01.02-.01l.02-.02c.01 0 .01-.01.02-.01l.01-.01c.01-.01.02-.01.03-.02h.01c.02-.02.04-.03.06-.05.01 0 .03-.01.04-.02l.09-.06c2.6-1.73 12.54-8.15 24.63-15.95 19.38-12.52 47.55-30.15 51.14-32.73.07-.05.13-.1.18-.14.94-.86 2.96-4.08 3.76-6.1-3.49-4.31-13.78-16.56-27.39-32.49-16.03-18.76-36.67-42.62-56.23-64.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303942",
    d: "M5508.2 3307.04c-10.18 0-33.85 2.65-44.42 6.17-1.19.4-2.82 1-4.78 1.75-15.64 5.98-52.42 21.73-56.37 23.43a1939.1 1939.1 0 00-13.71 7.81c15.58 22.42 28.84 41.87 40.89 59.26l46.86-26.65 75.84-37.63c-9.23-10.37-18.21-20.33-26.37-29.14-4.59-2.68-10.46-5-17.94-5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M6005 3653.79s48.7 2.44 79.56-1.34c30.85-3.78 93.18-19.72 93.18-19.72s5.79 4.79 6.68 7.96c.89 3.17-14.69 17.86-14.69 17.86l-53.43 40.97-71.68 46.3s-76.14 40.86-85.27 44.43c-9.14 3.55-59.43 27.44-68.11 30.11-8.68 2.67-34.85 1.69-34.85 1.69l-90.83-.51-29.17-8.29-4.5-1.27s65.95-27.84 85.98-37.85c20.04-10.02 90.29-52.45 107.43-63.58 17.14-11.12 73.68-53.69 73.68-53.69l6.02-3.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M5405.04 3168.18l8.1 18.19 1.19 20.32 1.99 6.9 5.47 6.65 84.18 48.79 11.79 11.59v4.48l-1.59 2.07-30.2 2.33-89.35 33.88-110.64 64.61-63.45 51.37-.46.37-4.19 17.95-7.02-.54-17.15-6.97-65.66-58.26-5.33-8.94-3.82-12.99 2.42-7.48-4.96-27.04 5.79-34.84-1.08-18.71 22.16-27.79 41.07-29.82 116.84-66.83 42.72-19.48 32.79-3.89 19.91 18.41zm-61.86-33.58l-43.6 19.81-117.16 67.01-41.4 30.05-23.45 29.33 1.17 19.63-5.83 34.76-.05.3 4.92 26.79-2.49 7.65 4.2 14.23 5.74 9.74 66.41 59.04 18.16 7.49 10.77.89 4.59-19.65 62.77-50.86 110.18-64.34 88.36-33.55 31.49-2.44 3.24-4.21v-7.1l-12.98-12.75-84-48.64-4.71-5.5-1.81-6.17-1.13-20.25-8.44-19.2-8.68-16.03-21.63-20.13-34.64 4.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M5946.65 3254.46l255.31 142.55 5.75 9.44v7.3l4.04 104.07-3.22 15.81-23.48 48.01-9.04 17.47-14.71 11.71-79.85 21.21-97.45-2.67-57.98-19.11-61.36-31.7-57.87-33.89-56.79-42.25-44.88-46.37-19.78-122.64-.88-10.57 2.8-13.04 8.46-18.11 45.34-42.1 21.08-26.59 41.96-33.52 3.14-1.21 29.65 6.32zm-144.03-68.11l-42.9 34.23-21.18 26.66-45.41 42.15-9.11 19.31-3.02 13.9.92 11.21 19.9 123.31.07.54 45.85 47.32 57.15 42.54 58.11 34.04 61.69 31.86 58.47 19.29 98.44 2.76h.26l80.66-21.41 15.93-12.48 9.67-18.4 23.59-48.23 3.45-16.85-4.02-104.42v-8.2l-6.71-11.03-256.12-143-109.98-60.01-31.38-6.76-4.33 1.67",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6177.37 3600.23l-493.75-266.69 19.89 123.31 45.26 46.75 56.99 42.45 58.03 33.98 61.43 31.76 58.48 19.29 97.95 2.67 80.44-21.35 15.28-12.17",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5727.55 3369.31l410.5 220.24-4.46 18.1-52.24 16.9-95.28-1.78-57.57-18.7-78.67-40.96-39.47-24.93-57.88-43.93-30.57-31.16-7.94-47.77 13.58-46.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5849.83 3563.11l36.71-119.97 46.4 25.07-51.35 111.44-29.69-15.46-2.07-1.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5683.62 3333.54l-17.21-9.35h-16.33l-13.95 15.74v15.43l47.49 79.23 19.89 22.26-19.89-123.31",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5690.45 3425.98l-12.76-81.01-12.17-7.42-14.54 10.98v8.91l39.47 68.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5706.23 3304.52s-.11 5.2 6.14 9.73 33.02 20.47 35.18 17.88c2.21-2.63 10.14-11.06 10.05-15.38-.08-4.31-1.74-7.69-3.63-10.44-1.26-1.83-11.04-7.78-17.47-11.57-3.37-1.99-14.43-.65-17.96 1.05l-4.99 1.46-7.32 7.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M5753.4 3314.4l-5.44-3.04a2.765 2.765 0 00-3.53.7l-1.51 1.92-29.37-16.73s-4.05-2.01-5.82 2.25c-1.76 4.25-2.5 6.24.72 9.22 3.2 2.97 40.19 24.04 42.03 25.07 1.82 1.04 5.79-.71 6.52-4.69.09-.49.61-2.38 1.05-4.51a9.488 9.488 0 00-4.65-10.19",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5942.75 3441.07s-.1 5.21 6.15 9.74c6.26 4.53 33.01 20.46 35.17 17.88 2.21-2.64 10.14-11.06 10.06-15.38-.09-4.32-1.74-7.69-3.63-10.44-1.25-1.83-11.05-7.78-17.47-11.57-3.37-1.99-14.44-.65-17.97 1.04l-4.98 1.47-7.33 7.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M5989.92 3450.96l-5.44-3.04a2.752 2.752 0 00-3.52.7l-1.52 1.92-29.36-16.73s-4.05-2.01-5.82 2.24c-1.77 4.26-2.5 6.24.71 9.22 3.2 2.98 40.2 24.05 42.03 25.08 1.83 1.04 5.79-.71 6.53-4.69.08-.49.6-2.37 1.05-4.5a9.495 9.495 0 00-4.66-10.2",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M5578.89 3055.52v-20.31l-127.69-24.43-62.29 13.01-95.82 45.98-94.73 54.87-23.41 14.04-60.3 43.17-17.82 35.37-3.72 16.67.06-.08 14.32-19.68 45.44-32.08 95.89-57.76 121.15-62.78 64.5-21.68h37.8l95.61 12.46 11.01 3.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5369.99 3041.63l-6.32 15.13-77.48 36.21-124.5 73.52-48.67 35.91-2.38-7.12 8.69-16.77 55.65-39.85 23.37-14.02 94.74-54.89 79.29-38-2.39 9.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M5113.02 3202.4l1.99-1.47-.81-6.04 9.94-15.03 57.55-41.2 23.37-14.02 94.74-54.89 71.69-34.36.89-3.64-79.29 38-94.74 54.89-23.37 14.02-55.65 39.85-8.69 16.77 2.38 7.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5167.85 3319.87l2.45-42.63 8.46-22.6 132.37-77.96 11.3 5.8 14.33 39.04-34.32 13.41-102.3 60.23-16.7 11.13-15.59 13.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5178.01 3244.02l-10.53 22.09-4.57 37.45 15.26 7.32 2.45-39.6 8.45-22.59-11.06-4.67",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5162.91 3303.56l4.94 16.31 10.32-8.99z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5189.07 3248.69l-11.06-4.67 6.98-6.15 110.55-64.16 6.37-2.26 9.22 5.23-122.06 72.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2303d",
    d: "M5105.52 3372.18l5.29 25.31 5.72-19.07 17.52-15.67 33.24-26.07-2.56-5.61-4.37-9.56-7.76-14.35-37.99 28.31-7.63 6.38-4.69 8.12 3.23 22.21",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4652",
    d: "M5110.05 3393.86l4.56-17.62 4.72-4.57-4.49-31.45-7.78 7.57-4.07 7.01 2.53 17.38 4.53 21.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2303d",
    d: "M5349.35 3231.93l37.91-18.38 28.63-8.91 26.8-7.78 32.94 12.47 37.17 17.58 6.68-7.12v-10.02l-9.34-20.03-12.33-17.66-13.05-6.68-43.49-9.5-34.65 11.58-21.38 7.12-43.33 20.17 2.38 22.79 5.06 14.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4652",
    d: "M5477.04 3203.72l-35.44-11.71-26.99 7.57-4.2-28.13 30.12-9.57 38.49 8.37 15.16 7.51 12.69 19.1 9.12 19.34-3.55 4.71-35.4-17.19",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M5344.29 3217.56l5.06 14.37-42.02 20.36-105.64 61.79-30.72 19.81-3.68 2.79-11.28-24.72 11.84 7.91 15.59-13.58 16.7-11.13 102.3-60.23 41.85-17.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M5370.63 3596.64l4.05-1.95-23.37-55.53-12.17-7.41-14.54 10.98v8.9l46.03 45.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M6205.81 3614.14c-15 11.92-26.3 13.55-40.07 5.82-7.96-4.46-6.6-13.38-3.12-25.96 3.48-12.59 19.98-28.88 32.7-33.84 7.83-3.05 20.4 4.24 23.88 7.73 3.49 3.48 4.21 9.44 3.45 17.71-.77 8.27-8.93 22.26-16.84 28.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a8ad",
    d: "M6166.87 3619.13c4.38.78 17.5-4 25.79-11.06 8.3-7.06 16.48-12.8 16.78-28.56.32-15.76-1.75-25.63-17.46-17.46-15.69 8.16-29.2 25.12-30.73 39.6-1.54 14.47 1.84 16.8 5.62 17.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3c2ce",
    d: "M6200.55 3563.57c1.34 0 2.39.43 3.28 1.33 3.7 3.78 4.34 7.9 4.2 15.56-.28 13.46-6.69 18.86-14.13 25.12l-1.72 1.46c-7.4 6.3-18.73 10.49-22.97 10.49l-.61-.05c-1.04-.18-5.01.34-3.42-14.55 1.43-13.42 14.03-29.54 29.3-37.49 2.4-1.24 4.43-1.87 6.07-1.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999da4",
    d: "M6846.44 3272.59l-41.62 9.89c-48.24 38.58-108.22 69.9-180.98 94.58-24.51 8.31-53.42 6.98-71.07-3.21-12.86-7.43-25.72-14.86-38.59-22.28l-30.11 7.16v-18.41c.03-6.4 3.14-13.06 9.43-19.25 52.82-51.91 123.19-92.56 213.17-123.07 24.51-8.32 53.42-6.99 71.06 3.2l53.73 31.02c9.88 5.7 14.94 13.43 14.98 21.62v-.01 18.76",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M6706.67 3216.66c-89.98 30.51-160.35 71.15-213.17 123.08-14.4 14.15-12.1 30.83 5.54 41.02l53.73 31.02c17.65 10.19 46.56 11.52 71.07 3.21 89.93-30.49 160.33-71.13 213.17-123.08 14.4-14.15 12.1-30.84-5.55-41.03l-53.73-31.02c-17.64-10.19-46.55-11.52-71.06-3.2",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M6697.34 3242.78c-63.59 24.58-116.05 54.87-158.6 91.57-16.78 14.47-15.39 32.38 3.25 43.15 5.48 3.16 10.96 6.32 16.44 9.49 18.64 10.76 49.68 11.56 74.73 1.88 63.57-24.57 116.04-54.86 158.61-91.58 16.77-14.46 15.4-32.38-3.25-43.15l-16.44-9.48c-18.64-10.77-49.68-11.57-74.74-1.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M6803.49 3275.79v456.73l-276.47 80.01V3355.8l276.47-80.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M6697.34 3699.36c-63.59 24.58-116.05 54.87-158.6 91.57-16.78 14.46-15.39 32.38 3.25 43.15l16.44 9.48c18.64 10.77 49.68 11.57 74.73 1.89 63.57-24.57 116.04-54.86 158.61-91.58 16.77-14.47 15.4-32.38-3.25-43.15l-16.44-9.49c-18.64-10.76-49.68-11.56-74.74-1.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M6697.06 3712.01c-56.43 23.22-103.53 50.42-142.4 82.21-15.32 12.54-15.11 26.84.45 34.46 4.57 2.24 9.14 4.47 13.71 6.71 15.56 7.62 42.39 6.56 64.63-2.59 56.4-23.21 103.51-50.41 142.4-82.22 15.33-12.54 15.12-26.84-.45-34.46l-13.71-6.71c-15.56-7.62-42.39-6.56-64.63 2.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M6697.18 3714.9c-53.75 22.81-98.87 48.87-136.44 78.77-14.8 11.79-15.1 24.63-.76 30.94 4.21 1.85 8.42 3.71 12.63 5.56 14.33 6.31 39.54 4.42 60.72-4.56 53.72-22.8 98.86-48.86 136.44-78.77 14.81-11.8 15.1-24.64.77-30.95l-12.64-5.55c-14.34-6.31-39.54-4.43-60.72 4.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M6772.08 3244.66v231.04l16.44 9.49v-231.05l-16.44-9.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M6634.61 3413.06l-56.14 32.41c-12.28 7.09-22.22 26.09-22.22 42.45v150.36c0 16.36 9.94 23.88 22.22 16.79l56.14-32.41c12.27-7.09 22.22-26.09 22.22-42.45v-150.36c0-16.36-9.95-23.88-22.22-16.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989fa9",
    d: "M6634.61 3622.66l-52.6 30.36V3502.8c0-16.36 9.95-35.37 22.22-42.45l52.6-30.36v150.22c0 16.36-9.95 35.36-22.22 42.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M6591.94 3605.18c-2.08-1.2-3.18-3.64-3.18-7.04v-48.97c0-8.72 7.18-19.97 15.99-25.05l31.11-17.96c4.3-2.49 8.27-3.05 10.9-1.55 2.07 1.21 3.17 3.64 3.17 7.05v48.97c0 8.72-7.17 19.96-15.97 25.05l-31.12 17.96c-2.72 1.57-5.3 2.37-7.5 2.37-1.29 0-2.44-.27-3.4-.83zm42.02-102.32l-31.12 17.96c-10.03 5.79-17.88 18.25-17.88 28.35v48.97c0 4.77 1.81 8.44 5.08 10.33 3.82 2.22 9.2 1.64 14.71-1.54l31.11-17.96c10.03-5.79 17.87-18.24 17.87-28.34v-48.97c0-4.77-1.81-8.45-5.08-10.34-1.53-.89-3.33-1.33-5.27-1.33-2.89 0-6.12.97-9.42 2.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M6600.9 3588.97v-50.67c0-3.44 2.79-7.84 6.23-9.83l3.91-2.25 14.14-8.17 6.39-3.69c3.45-1.99 6.23-.81 6.23 2.63v50.68l-.02.47c-.23 3.35-2.93 7.46-6.21 9.35l-24.44 14.11c-3.44 1.99-6.23.81-6.23-2.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M6602.53 3567.24l.13-2.44.18-1.43c.14-.91.32-1.83.56-2.76 1.28-5.14 3.9-10.34 7.31-14.65l2.04-2.37c1.81-1.93 3.78-3.61 5.84-4.9l.77-.46c3.94-2.28 7.56-2.82 10.43-1.86h.01c2.36.79 4.21 2.59 5.29 5.26h.01c.69 1.71 1.07 3.79 1.07 6.19 0 3.19-.67 6.58-1.86 9.92-1.69 4.72-4.43 9.35-7.77 13.08-2.1 2.36-4.43 4.38-6.9 5.85l-.28.17-2.4 1.18c-8.15 3.38-14.43-1.05-14.43-10.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M6781.96 3549.76l-16.79-15.48 19.92 55.53z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M6777.36 3516.14l1.78 37.15 16.29 15.83z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M2831.8 4085.49l-18.26 10.54 242.44-892.8 18.25-10.53-242.43 892.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M2746.89 4003.73l1.8 33.77 83.11 47.99 15.36-56.57c9.17 2.54 18.3 5.2 27.41 7.94l-30.87 111.16-110.82-63.98-5.19-84.84 19.2 4.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M2727.05 3988.78l-62.7-1023.35v-15.49l27.7 16v6.1l54.29 1021.29c-6.43-1.51-12.86-3.03-19.29-4.55",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M2877.25 4027.22c-9.13-2.75-18.29-5.41-27.47-7.95l224.46-826.57v-6.11l27.7 16v15.48l-224.69 809.15",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    d: "M2664.35 2949.95l-18.26 10.53v15.49l18.26-10.54v-15.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M2732.88 4084.04l-18.25 10.53-68.54-1118.6 18.26-10.54 68.53 1118.61",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2732.88 4084.04l-18.25 10.53 110.82 63.98 18.25-10.53-110.82-63.98",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    d: "M3074.23 3186.59l-18.25 10.54v6.1l18.25-10.53v-6.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2842.97 4061.05s-206.58-52.63-435.19-189.32l-195.74-134.58-4.75 44.67-13.69 7.91 200 115.47c232.39 138.96 461.51 209.95 668.08 206.97l13.7-7.91-232.41-43.21",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0097ff",
    d: "M3064.97 4075.33c-203.22 2.91-428.58-66.91-657.19-203.6-.16 8.52-.32 17.04-.49 25.56 232.38 138.96 461.51 209.96 668.09 206.97-3.47-9.64-6.94-19.28-10.41-28.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0097ff",
    d: "M3053.15 4075.42l1541.24-889.83 10.41 28.93-1541.25 889.84-10.4-28.94",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M3075.38 4104.26l-.64.01c-206.41 2.82-435.31-68.16-667.45-206.98l-190.87-110.2 1540.35-890.13 205.46 102.59 267 120.75 146.9 45.52 254.18 40.7-1554.93 897.74",
    clipPath: "url(#clipPath496)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M4606.21 3185.5c-203.22 2.91-615.38-164.73-843.98-301.42l-13.69 7.91 8.23 4.97 191.77 110.5c232.38 138.96 461.51 209.95 668.08 206.97l13.69-7.91s-21.37-13.46-24.1-21.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M4619.9 3155.45c-203.22 2.91-428.57-66.91-657.19-203.59-.01 1.21-200-115.47-200-115.47l-.48 47.69 27.94 17.26 172.06 98.21c232.38 138.96 461.51 209.96 668.08 206.97-3.46-9.64-6.94-41.42-10.41-51.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2207.29 3781.82l1541.25-889.83 9.12 5.27-1541.24 889.83-9.13-5.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M2194.09 3742.03l1568.62-905.64-.48 47.69-1568.63 905.65.49-47.7",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M3063.55 4104.36l1541.25-889.84 25.51-8-1554.93 897.74-11.83.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2795.18 3673.34c232.15 138.82 461.05 209.8 667.45 206.98l.13-.1.51.1-7.6 4.38c-206.57 2.98-435.7-68.01-668.08-206.97l7.59-4.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M3179.17 3451.65c232.15 138.81 461.04 209.8 667.44 206.98l.13-.11.52.1-7.6 4.38c-206.57 2.98-435.7-68-668.09-206.97l7.6-4.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M3563.15 3229.95c232.15 138.82 461.05 209.81 667.46 206.98l.12-.1.51.09-7.6 4.39c-206.57 2.98-435.69-68.01-668.08-206.97l7.59-4.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M4418.67 3169.31l-18.25 10.54 242.44-892.8 18.25-10.54-242.44 892.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M4430.58 3231.84l-110.82-63.98-68.53-1118.61v-15.49l27.71 16v6.1l56.63 1065.46 83.1 47.99 242.44-892.8v-6.1l27.71 16v15.48l-258.24 929.95",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    d: "M4251.23 2033.76l-18.26 10.54v15.49l18.26-10.54v-15.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M4319.76 3167.86l-18.26 10.53-68.53-1118.6 18.26-10.54 68.53 1118.61",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M4319.76 3167.86l-18.26 10.53 110.82 63.98 18.26-10.53-110.82-63.98",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    d: "M4661.11 2270.41l-18.25 10.54v6.1l18.25-10.54v-6.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M3368.17 3117.38l-7.59 4.38 194.98 112.58 7.59-4.39-194.98-112.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2984.19 3339.07l-7.6 4.39 194.98 112.57 7.6-4.38-194.98-112.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M2600.21 3560.77l-7.6 4.39 194.98 112.57 7.59-4.39-194.97-112.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999da4",
    d: "M2131.26 939.02l-42.83 10.179c-49.64 39.711-111.37 71.931-186.27 97.331-25.22 8.56-54.96 7.19-73.13-3.3-13.24-7.64-26.48-15.29-39.71-22.93l-30.99 7.37v-18.95c.03-6.58 3.22-13.439 9.69-19.798 54.36-53.442 126.79-95.274 219.4-126.66 25.22-8.563 54.97-7.203 73.13 3.289l55.3 31.918c10.16 5.871 15.37 13.832 15.4 22.25h.01v19.301",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M1987.42 881.461c-92.61 31.398-165.04 73.23-219.4 126.659-14.81 14.57-12.44 31.74 5.72 42.23 18.43 10.64 36.86 21.28 55.29 31.93 18.17 10.47 47.91 11.84 73.13 3.3 92.56-31.39 165.02-73.22 219.4-126.67 14.82-14.57 12.45-31.738-5.71-42.23l-55.3-31.918c-18.16-10.492-47.91-11.864-73.13-3.301",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M1977.82 908.34c-65.46 25.289-119.44 56.469-163.24 94.24-17.26 14.89-15.83 33.33 3.36 44.41 5.63 3.25 11.27 6.51 16.91 9.77 19.19 11.07 51.12 11.89 76.91 1.93 65.42-25.28 119.43-56.45 163.24-94.249 17.27-14.89 15.84-33.332-3.35-44.402l-16.91-9.769c-19.19-11.079-51.13-11.899-76.92-1.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M2087.05 942.309v387.911l-284.52 82.35v-387.92l284.52-82.341",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M1977.82 1296.09c-65.46 25.31-119.44 56.48-163.24 94.25-17.26 14.89-15.83 33.33 3.36 44.41 5.63 3.26 11.27 6.51 16.91 9.76 19.19 11.09 51.12 11.91 76.91 1.94 65.42-25.29 119.43-56.46 163.24-94.24 17.27-14.9 15.84-33.33-3.35-44.42l-16.91-9.76c-19.19-11.08-51.13-11.9-76.92-1.94",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1977.52 1309.11c-58.07 23.91-106.54 51.9-146.55 84.62-15.77 12.9-15.55 27.62.47 35.46 4.7 2.3 9.4 4.61 14.1 6.91 16.02 7.84 43.63 6.75 66.52-2.67 58.05-23.89 106.53-51.88 146.55-84.61 15.77-12.91 15.56-27.63-.46-35.47l-14.11-6.9c-16.01-7.85-43.63-6.75-66.52 2.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e9",
    d: "M1977.65 1312.1c-55.32 23.47-101.76 50.28-140.42 81.06-15.24 12.13-15.54 25.36-.78 31.85 4.33 1.9 8.66 3.81 12.99 5.71 14.76 6.5 40.7 4.56 62.49-4.69 55.29-23.46 101.74-50.28 140.42-81.07 15.24-12.14 15.55-25.35.79-31.84l-13-5.72c-14.75-6.49-40.7-4.56-62.49 4.7",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2054.74 910.27v237.79l16.91 9.76V920.039l-16.91-9.769",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M1913.25 1083.58l-57.78 33.36c-12.63 7.3-22.86 26.85-22.86 43.68v154.75c0 16.84 10.23 24.58 22.86 17.29l57.78-33.36c12.63-7.3 22.86-26.85 22.86-43.68v-154.75c0-16.84-10.23-24.57-22.86-17.29",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989fa9",
    d: "M1913.25 1299.3l-54.12 31.25v-154.61c0-16.84 10.23-36.39 22.86-43.68l54.12-31.25v154.61c0 16.83-10.23 36.38-22.86 43.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1869.34 1281.31c-2.14-1.24-3.27-3.74-3.27-7.25v-50.39c0-8.98 7.38-20.55 16.44-25.79l32.03-18.49c4.42-2.55 8.51-3.13 11.21-1.58 2.14 1.23 3.27 3.74 3.27 7.26v50.39c0 8.97-7.37 20.55-16.43 25.77l-32.03 18.5c-2.8 1.61-5.46 2.44-7.71 2.44-1.34 0-2.52-.29-3.51-.86zm43.25-105.3l-32.03 18.48c-10.32 5.96-18.4 18.78-18.4 29.18v50.39c0 4.91 1.85 8.69 5.22 10.64 3.94 2.28 9.47 1.69 15.13-1.58l32.03-18.49c10.32-5.96 18.39-18.77 18.39-29.17v-50.39c0-4.92-1.85-8.7-5.22-10.65-1.58-.91-3.43-1.36-5.43-1.36-2.97 0-6.3.99-9.69 2.95",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd2d7",
    d: "M1878.56 1264.63v-52.16c0-3.53 2.87-8.07 6.41-10.11l4.02-2.31 14.56-8.41 6.58-3.81c3.54-2.04 6.41-.83 6.41 2.72v52.15l-.02.48c-.24 3.46-3.01 7.68-6.39 9.63l-25.16 14.52c-3.54 2.05-6.41.83-6.41-2.7",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0b3b9",
    d: "M1880.24 1242.27l.13-2.51.19-1.48c.14-.94.33-1.88.57-2.84 1.32-5.28 4.03-10.65 7.53-15.08l2.1-2.44c1.86-1.99 3.89-3.71 6.01-5.05l.78-.47c4.07-2.34 7.8-2.89 10.75-1.91h.01c2.42.82 4.33 2.67 5.44 5.42.72 1.76 1.11 3.89 1.11 6.37 0 3.28-.69 6.77-1.92 10.21-1.74 4.86-4.55 9.61-7.98 13.46-2.17 2.43-4.57 4.5-7.12 6.02l-.29.17-2.45 1.22c-8.4 3.48-14.86-1.08-14.86-11.09",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2064.91 1224.27l-17.29-15.92 20.5 57.15z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2060.18 1189.68l1.82 38.22 16.76 16.29z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5252",
    d: "M672.012 1389.52l-7.696-20.73-4.355-11.68-4.906-13.2-18.903-4.41-27.695-6.46-8.66-5.4-7.387 12.14-.222.4-.114.15.133.16.066.09c1.965 2.43 17.965 22.1 26.426 29.06 1.672 1.36 4.531 2.92 8.121 4.52 3.485 1.56 7.657 3.19 12.032 4.78 14.976 5.44 32.316 10.36 33.16 10.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient536)",
    d: "M1622.34 953.449c0 58.001-40.97 128.671-91.52 157.861-25.19 14.54-48.01 16.03-64.56 6.68v.01l-.01-.01-.39-.23-44.42-25.66v-44.78l129.81-178.191 40.83 23.762a43.007 43.007 0 017.27 4.23l.03.008v.012c14.29 10.269 22.96 29.621 22.96 56.308",
    clipPath: "url(#clipPath536)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M1579.18 928.531c0-58-40.98-81.359-91.52-52.179-50.55 29.187-91.52 99.859-91.52 157.858 0 58.01 40.97 81.37 91.52 52.19 50.54-29.19 91.52-99.869 91.52-157.869",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient542)",
    d: "M1579.18 928.539c0-58.008-40.98-81.367-91.52-52.187-50.55 29.187-91.52 99.859-91.52 157.858 0 58.01 40.97 81.37 91.52 52.19 50.54-29.19 91.52-99.869 91.52-157.861",
    clipPath: "url(#clipPath542)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient547)",
    d: "M1573.47 929.59c0-55.801-39.42-78.27-88.04-50.199-48.62 28.07-88.04 96.058-88.04 151.859 0 55.79 39.42 78.26 88.04 50.2 48.62-28.08 88.04-96.071 88.04-151.86",
    clipPath: "url(#clipPath547)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504f58",
    d: "M1551.25 944.66c0-40.301-28.47-56.539-63.59-36.25-35.12 20.27-63.59 69.371-63.59 109.68 0 40.29 28.47 56.53 63.59 36.25 35.12-20.28 63.59-69.379 63.59-109.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1549.26 948.859c0-38.199-26.98-53.589-60.27-34.371-33.28 19.223-60.26 65.762-60.26 103.962 0 38.19 26.98 53.57 60.26 34.35 33.29-19.21 60.27-65.749 60.27-103.941",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f5e67",
    d: "M1449.05 1052.54c-19.14-10.91-21.67-43.26-7.58-76.501a136.165 136.165 0 017.58-15.148c2.92-5.032 6.07-9.762 9.4-14.129 21.87-28.801 51.34-42.91 70.49-32a26.796 26.796 0 016.2 4.859c4.79 5 7.92 11.891 9.37 20.051 3.3 18.398-1.89 43.148-15.58 66.758-13.69 23.6-32.64 40.5-50.33 46.93-7.84 2.85-15.43 3.65-22.19 2.05-2.58-.6-5.04-1.55-7.36-2.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1489.81 1002.82l-43.95-25.07c-1.67-.941-1.89-3.871-.46-6.859 1.48-3.11 3.12-6.211 4.91-9.289 1.78-3.082 3.66-6.043 5.62-8.883 1.89-2.731 4.55-4.02 6.22-3.059l43.95 25.059-16.29 28.101",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1494.5 986.801l-7.31-20.86 1.32-1.261 40.88-39.309c2.11-2.031 4.44-2.402 5.6-.891 2.6 3.43 4.56 7.571 5.86 12.25.68 2.43-.66 6.141-3.08 8.469l-32.88 31.61-10.39 9.992",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1460.57 1052.83c-1.9-.22-2.75-2.41-2.04-5.24l13.68-54.809.45-1.761 21.84-4.219-3.47 13.919-11.01 44.08c-.81 3.25-3.37 6.25-5.83 6.9-4.73 1.24-9.32 1.65-13.62 1.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1612.23 1072.54c-12.61 19.1-42.01 57.65-84.06 76.24-33.48 14.78-54.29 10.65-66.09 3.53l-.01-.01-.05-.01-47.15-27.23.01-.01c-10.28-5.62-14.42-13.67-14.42-15.35 0-3.66 7.64-8.86 15.07-8.89 7.42-.02 46.81 24.16 116.86-41.36 0 0 3.01-42.48 13.08-43.73 2.31-.45 8.15.48 17.4 4.2 31.3 12.6 35.31 20.36 46.15 31.16 5.12 5.11 7.19 15.43 3.21 21.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1605.94 1072.8c5.34-9.78-23.86-33.87-47.27-36.5-2.99-.44-11.54 6.08-22.68 18.11-13.05 14.09-47.96 34.67-47.96 34.67s35.51-15.51 60.44-18.33c24.94-2.82 39.44 15.38 39.44 15.38s13.64-5.27 18.03-13.33",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient560)",
    d: "M806.73 1120.11c0 58-40.976 128.67-91.527 157.86-25.191 14.54-48.008 16.02-64.558 6.68v.01l-.016-.01-.379-.23-44.422-25.66v-44.78l129.809-178.19 40.828 23.76a43.515 43.515 0 017.273 4.23l.024.01v.01c14.289 10.27 22.968 29.62 22.968 56.31",
    clipPath: "url(#clipPath560)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M763.57 1095.2c0-58.01-40.976-81.37-91.523-52.19-50.547 29.19-91.524 99.86-91.524 157.86 0 58.01 40.977 81.37 91.524 52.19 50.547-29.19 91.523-99.87 91.523-157.86",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient566)",
    d: "M763.57 1095.2c0-58.01-40.976-81.37-91.523-52.19-50.547 29.19-91.524 99.86-91.524 157.86 0 58.01 40.977 81.37 91.524 52.19 50.547-29.19 91.523-99.87 91.523-157.86",
    clipPath: "url(#clipPath566)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient571)",
    d: "M757.855 1096.24c0-55.79-39.414-78.26-88.035-50.19-48.625 28.07-88.043 96.06-88.043 151.86 0 55.79 39.418 78.26 88.043 50.2 48.621-28.08 88.035-96.07 88.035-151.87",
    clipPath: "url(#clipPath571)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504f58",
    d: "M735.637 1111.32c0-40.29-28.473-56.53-63.59-36.25-35.121 20.27-63.59 69.37-63.59 109.68 0 40.29 28.469 56.52 63.59 36.25 35.117-20.28 63.59-69.38 63.59-109.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M733.648 1115.52c0-38.2-26.984-53.58-60.269-34.37-33.281 19.22-60.266 65.76-60.266 103.96 0 38.19 26.985 53.57 60.266 34.35 33.285-19.21 60.269-65.75 60.269-103.94",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient578)",
    d: "M723.984 1092.29c12.028 20.89 5.02 57.91-15.316 88.27-3.094 4.63-6.5 9.09-10.191 13.33-3.692 4.23-7.485 8.01-11.329 11.33-25.222 21.88-52.339 23.99-64.371 3.1-1.453-2.52-2.625-5.27-3.523-8.23-2.383-7.74-2.926-16.82-1.805-26.53 2.524-21.9 13.504-46.95 30.844-66.83 17.332-19.87 36.957-29.9 52.664-28.91 6.969.44 13.152 3.05 18.035 7.92 1.867 1.85 3.535 4.04 4.992 6.55",
    clipPath: "url(#clipPath578)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M684.262 1132.61l21.426 44.04c1.05 1.83.406 5.17-1.551 7.82-2.032 2.77-4.18 5.45-6.446 8.05a118.211 118.211 0 01-6.894 7.26c-2.246 2.15-4.699 2.36-5.754.53l-21.422-44.04 20.641-23.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M676.117 1148.21l-.054 26.48-1.379.79-49.309 20.88c-2.227 1.28-4.168.62-4.652-1.59-1.098-5-1.489-10.48-1.211-16.26.144-3.01 2.23-6.51 4.785-7.97l40.863-16.03 10.957-6.3",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M715 1086.68c1.441 1.12 1.492 3.94.145 6.75l-19.825 58.39-.84 1.74-18.363-5.35 6.61-13.84 14.73-47.71c1.543-3.22 4.395-5.39 6.512-4.97 4.066.8 7.789 2.45 11.031 4.99",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5c1c9",
    d: "M1588.98 1125.89l-5.01-10.74s.23-22.58-5.33-33.51c-5.57-10.95-14.23-11.85-15.57-19.81-6.09-36.67-22.47-17.47-69.58-16.86-66.03.85-124.91-40.46-124.91-40.46-300.27 166.83-302.06 163.81-317.53 180.24-7.57 7.99 21.66 96.19-18.5 175.07-40.187 78.9-113.269 107.71-129.437 142.62-8.867 19.11 12.141 43.1.598 70.53s-22.688 58.76-22.688 58.76v17.57l4.586 6.04s1.657 2.23 4.262 5.65c5.031 6.68 13.582 17.95 20.141 26.2 5.535 7.03-4.285 5.96 4.922 14.16 7.238 6.46 13.898 11.51 17.293 12.39 7.683 1.94 110.003-42.51 143.953-62.11 33.93-19.61 135.87-72.15 176.99-110.65l.06-.07.21-.22c3.48-3.24 7.32-6.98 11.46-11.11l.19-.2c20.39-20.41 47.98-50.37 76.03-81.65 20.69-23.06 41.63-46.87 60.15-68.08l.18-.2c31.97-36.63 56.65-65.52 60.2-69.68l.44-.51 27.86-26.16 2.99-2.81c2.06-1.93 4.27-3.98 6.6-6.19v-.02l14.26-13.39 45.87-62.7 29.31-72.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cab242",
    d: "M885.602 1655.33c73.468-59.15 218.818-154.64 218.818-154.64s282.74-202.19 285.92-204.03c3.18-1.84 79.58-18.55 79.58-18.55-9.34 15.95-17.78 30.5-17.78 30.5s-33.21 27.87-95.27 104.79c-62.07 76.92-95.02 110.49-123.27 133.64-28.25 23.16-102.05 68.55-102.05 68.55-55.56 30.7-109.8 51.16-154.359 72.03-43.855 20.52-56.824 18.14-57.226 18.06h-.004a165.468 165.468 0 01-5.027-4.32c-9.204-8.21.625-7.15-4.922-14.16-6.559-8.27-15.102-19.52-20.145-26.2-2.594-3.44-4.265-5.67-4.265-5.67",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cab242",
    d: "M889.867 1661l13.641-12.36 25.863-19.49 139.639-99.35 15.46 90.85s-144.411 79.02-169.536 80.71c-9.204-8.21.625-7.15-4.922-14.16-6.559-8.27-15.102-19.52-20.145-26.2",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cab242",
    d: "M1452.14 1308.61s37-63.82 41.78-70.68c4.77-6.87 15.11-48.91 15.91-55.75.8-6.86-38.41-44.11-38.41-44.11s-67.08-5.29-83.79-23.94c-16.71-18.65-36.2-35.71-41.78-40.25-5.57-4.54-115.5 61.95-127.44 68.84 1.77-1.02-91.63 91.35-98.93 103.4-23.6 38.96-15.06 216.69-15.06 224.67v29.9l27.13 114.9s73.8-45.39 102.05-68.55c28.25-23.15 57.91-60.62 121.31-126.06 68.76-71 97.23-112.37 97.23-112.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cab242",
    d: "M1045.23 1330.97c-8.07 22.37 37.11 35.26-89.609 115.88-62.066 39.49-90.176 17.37-90.176 17.37s-14.59 15.42-15.648 23.94c-1.067 8.53 27.316 38.1 73.465 21.2 46.152-16.91 121.218-72.07 149.858-130.61 28.64-58.54-3.77-124.08-3.77-124.08s-6.12 16.98-24.12 76.3",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82a4bf",
    d: "M1588.98 1125.89s-11.4-6.82-45.88 19.18c-9.2 6.95-44.81 33.44-92.05 68.51-105.64 78.47-269.45 199.97-326.34 242.17-12.88 9.55-20.29 15.05-20.29 15.05l-2.89 1.91 147.18 66.07 3.1 1.41 1.36.79.06-.07.21-.22c3.48-3.24 7.32-6.98 11.46-11.11l.19-.2c20.39-20.41 47.98-50.37 76.03-81.65 20.69-23.06 41.63-46.87 60.15-68.08l.18-.2c31.97-36.63 56.65-65.52 60.2-69.68l.44-.51 27.86-26.16 2.99-2.81c2.06-1.93 4.27-3.98 6.6-6.19v-.02l14.26-13.39 32.13-43.91a188.687 188.687 0 0022.51-40.36l20.54-50.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1467.84 1396.18c-5.48-11.13-6.44-18.78-6.75-33.58-.32-14.82-.42-55.07.48-57.11.89-2.04 18.01-7.17 18.83 11.43.62 14.19 10.29 69.36 5.75 87.18-.87 3.4-12.63 5.2-13.44 3.34-3.37-7.78-4.87-11.26-4.87-11.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1481.14 1394.12c-5.47-11.13-6.43-18.78-6.75-33.58-.31-14.82-.41-55.07.49-57.11.89-2.04 11.79 17.22 12.61 35.83.82 18.6 1.11 72.07-2.27 64.28-3.38-7.8-4.08-9.42-4.08-9.42",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1479.38 1335.73l8.64-75.28 17.85-7.26v14.66l-20.87 79.68-5.62-11.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404b4d",
    d: "M1542.62 1017.21c0 9.28-118.69-36.499-142.68-29.741-13.22 3.73-142.87 78.451-171.98 99.301-19.1 13.68-159.67 150.23-168.16 155.74-8.49 5.51-19.62 21.68-23.34 32.34-3.71 10.67-9.22 99.58-80.839 138.5-71.613 38.91-90.176 17.36-90.176 17.36s-12.734 13.74-15.648 23.95c0 0 6.316-22.85 19.621-35.07 13.309-12.22 23.609 16.81 77.316-19.07 53.706-35.88 52.856-83.38 76.196-129.43 23.34-46.03 15.39-96.23 28.12-119.86-16.49 30.62 67.98-299.652 219.35-312.25 37.76-3.359 21.77-47.109 54.38-31.691 1.76.832 41.71 39.352 52.52 44.781 11.03 5.539 61.66 34.95 82.05 42.141 27.64 9.75 44.33 8.719 46.75 9.891 10.28 5.019 24.89-1.372 30.86 29.75 4.71 24.589 5.66 80.738 5.66 83.358",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cab242",
    d: "M1068.62 1247.49s6.19-37.15 10.46-40.54c4.26-3.38 80.79-61.37 85.47-65.44 4.67-4.06 28.06-19.08 28.06-19.08l-123.99 125.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db9845",
    d: "M1499.54 1274.1c-2.33 2.21-4.54 4.26-6.6 6.19-1.02.96-2.02 1.9-2.99 2.81l-27.86 26.16-.44.51-144.36 160.07-64.06 71.07.21-.22c3.16-3.26 34.06-35.26 87.68-92.96 40.55-43.62 94.09-101.93 158.42-173.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c5757",
    d: "M1090.29 1435.88l-62.28-24.9 223.8 129.2-41.81-35.19-119.71-69.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1588.98 1125.89c.87-2.83-3.13-13.09-3.13-13.09l-11.01-17.18s-56.15-49.96-77.76-62.41c-21.38-12.31-92.05-35.608-92.05-35.608l-52.41-8.18-29.3 72.098 42.84 13.69 169.81 98.05 15.23 34.85s14.32-6.37 37.78-82.22",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M1588.98 1098.49l-14.14-30.26-69.16-65.41-89.48-40.25-63.58-20-19.71 18.969c3.03 2.59 6.6 5.563 9.38 11.043 5.56 10.93 10.33 16.84 10.33 16.84l52.41 8.18s30.67 10.908 83.96 39.898c54.29 29.54 85.85 58.12 85.85 58.12l11.01 17.18 3.13-14.31",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1556.77 1047.46s-8.03-58.128-14.15-63.812c-73.12-67.859-169.82-98.039-169.82-98.039l-53.56 24.692c3.82 3.789 6.41 8.687 7.47 15.039 1.34 7.98 9.99 8.89 15.58 19.851 5.56 10.918 10.33 16.84 10.33 16.84l63.58.539 89.48 40.25 69.16 65.42-18.07-20.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1303.71 1073.65s19.85-15.3 55.16-12.57c35.3 2.74 83.77 18.29 128.32 49.42 44.55 31.12 64.59 55.17 67.83 61.89 3.25 6.72 4.32 29-3.82 35.72-8.14 6.71-247.49-134.46-247.49-134.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1549.14 1211.32c6.04-7.65 5.52-18.57-1.22-25.6l-11.95-12.46s-23.68-24.08-75.03-53.21c-48.61-27.59-94.78-44.84-94.78-44.84l-12.71-4.06a68.71 68.71 0 00-57.03 7.01l-47.67 29.5-10.14 9.53-4.14 3.87 18.23 2.85a185.523 185.523 0 0164.15 22.62l147.36 85.08a77.76 77.76 0 0131.54 34.39l3.79 8.1 49.6-62.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f5e67",
    d: "M592.41 1339.78c-.871-2.73-2.879-9.49-4.621-17.59.895 7.57 2.277 14.53 4.399 17.99l.625.88-.403-1.28",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404b4d",
    d: "M1319.17 910.238v-.019c-.17-4.821-62.1-42.149-107.98-40.699-17.45.562-34.35-7.461-46.89-15.622-14.26-9.269-32.63-9.418-47.29-.75-35.86 21.231-102.37 60.821-164.049 98.961-70.231 43.411-134.262 84.891-139.84 95.251-12.738 23.64-20.422 52.33-43.762 98.37-23.343 46.04-36.089 75.03-89.804 110.91-53.692 35.87-76.121 11.74-89.422 23.98-7.496 6.87-5.715 25.16-2.699 39.85l.355 1.63c-1.07-8.93-1.426-18.72-1.582-24.71v-.09c-.023-.91-.023-1.73-.047-2.48-.023-1.93-.023-3.09-.023-3.09l.09.07c1.722 1.63 31.425 28.06 100.898-9.69 43.027-23.39 73.242-54.94 91.293-78.71 7.68-10.09 13.145-18.79 16.492-24.86l.024-.05c1.875-3.41 3.058-5.98 3.589-7.49 3.707-10.68 14.844-26.85 23.348-32.37 5.313-3.45 62.598-58.44 109.285-102.34 27.739-26.11 51.754-48.27 58.871-53.38 19.103-13.68 134.363-55.551 158.353-62.308 24-6.762 170.79-1.071 170.79-10.364",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M1352.63 989.422V962.02s-4.78-5.918-10.34-16.821c-1.65-3.219-3.54-5.59-5.44-7.488-4.6-4.609-9.19-6.731-10.13-12.359-1.07-6.364-3.66-11.25-7.48-15.063l-.07-.051v-.019c-18.3-17.957-64.33-10.289-103.25-9.789-66.02.84-101.63-22.551-101.63-22.551s-94.36 58.203-173.649 107.793c-55.567 34.768-103.727 65.308-106.832 68.608l-.02.04-.113.13-1.231 1.84c-7.34 13.63-19.101 75.87-54.027 147.11-1.227 2.5-2.477 5.02-3.77 7.54-40.191 78.89-121.468 91.78-137.652 126.7l-.844 1.86c-4.621 10.47-4.398 14.93-6.007 22.73-.625 3.21-1.582 6.96-3.325 11.93-.375 1.12-.8 2.28-1.269 3.53-.738 1.99-1.606 4.16-2.613 6.54-11.336 26.96-8.504 58.6-8.391 59.66v37.02l4.598 6.04v.02h.019c.113.16.742 1.01 1.742 2.38l1.567 2.05.933 1.22c5.024 6.7 17.653 28.92 24.215 37.18 5.531 7.03 32.961 33.36 42.152 41.56 7.235 6.46 13.926 11.51 17.301 12.38 7.696 1.96 109.996-42.49 143.942-62.11 13.078-7.54 36.195-19.95 62.086-34.57 16.136-9.15 33.32-19.12 49.808-29.3 2.145-1.33 4.262-2.65 6.383-3.99 3.168-1.99 6.316-3.99 9.398-6.01 2.051-1.33 4.106-2.65 6.114-3.99 7.031-4.67 13.746-9.33 19.975-13.88 2.68-1.96 5.24-3.9 7.72-5.83l2.46-1.91c1.6-1.28 3.17-2.53 4.66-3.8 3.01-2.5 5.82-4.95 8.39-7.36l.02-.02c.9-.83 1.79-1.7 2.68-2.62l1.38-1.38c58.03-58.67 164.95-250.75 164.95-250.75l37.42-35.15 14.29-13.41 74.58-46.13 29.3-72.108",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1336.85 937.711c-4.6-4.609-9.19-6.731-10.13-12.359-1.07-6.364-3.66-11.25-7.48-15.063l-.07-.051v-.019c-18.3-17.957-64.33-10.289-103.25-9.789-66.02.84-101.63-22.551-101.63-22.551s-94.36 58.203-173.649 107.793c-55.567 34.768-103.727 65.308-106.832 68.608l-.02.04-.113.13-1.231 1.84c-7.34 13.63-19.101 75.87-54.027 147.11-1.227 2.5-2.477 5.02-3.77 7.54-40.191 78.89-121.468 91.78-137.652 126.7l-.844 1.86c-4.621 10.47-4.398 14.93-6.007 22.73-.625 3.21-1.582 6.96-3.325 11.93-.375 1.12-.8 2.28-1.269 3.53 3.101 2.06 7.496 2.46 13.301 1.25 6.582-1.34 14.996-4.75 25.464-10.15 9.012-4.65 19.571-10.78 31.801-18.35 69.379-42.96 90.492-97.76 131.821-142.09 10.269-9.88 49.296-35.91 98.132-66.12l.043-.05c100.577-62.24 242.737-142.289 260.817-135.53 26.84 10.02 51.64 4.82 66.82 0 15.15-4.84 54.85-27.47 54.85-27.47s11.31-19.149 28.25-41.469",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M1352.62 962.031c-19.71-.492-44.02 17.149-44.02 17.149l44.02 10.242v-27.391",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1253.16 1540.96l-1.36-.78-41.8-35.2-119.7-69.09-62.27-24.92h-.02l-122.768 65.98-182.168 97.95-16 8.84 43.16 35.95s7.188 12.27 55.813 43.92c42.512 27.68 63.894 25.2 63.894 25.2s60.497 24.48 62.286 24.92c7.675 1.94 110.003-42.49 143.943-62.1 12.61-7.3 35.39-19.39 60.81-33.56 35.55-19.85 76.26-43.79 101.56-64.42 5.27-4.28 10.18-8.54 14.62-12.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1352.63 989.422s-33.46-.711-64.32 13.318c-7.27 3.31-69.94 28.08-76.5 33.06-26.31 19.82-240.173 144.39-340.107 202.36-31.09 18.01-51.152 29.59-51.152 29.59s-169.985 139.15-206.004 176.14v37.02l4.598 6.04.019.02c.113.16.742 1.01 1.742 2.38l1.567 2.05.933 1.22c5.024 6.7 17.653 28.92 24.215 37.18 5.531 7.03 32.961 33.36 42.152 41.56 7.235 6.46 13.926 11.51 17.301 12.38 7.696 1.96 109.996-42.49 143.942-62.11 13.078-7.54 36.195-19.95 62.086-34.57 16.136-9.15 33.32-19.12 49.808-29.3 2.145-1.33 4.262-2.65 6.383-3.99 3.168-1.99 6.316-3.99 9.398-6.01 2.051-1.33 4.106-2.65 6.114-3.99 7.031-4.67 13.746-9.33 19.975-13.88 2.68-1.96 5.24-3.9 7.72-5.83l2.46-1.91c1.6-1.28 3.17-2.55 4.66-3.8 3.01-2.52 5.82-4.98 8.39-7.38h.02l2.68-2.62 1.38-1.38c58.03-58.67 164.95-250.75 164.95-250.75l37.42-35.15 14.29-13.41 74.58-46.13 29.3-72.108",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M909.109 1031.02l-.304.31-53.508 53.97c-18.832 28.91-38.988 97.94-43.231 111.7-4.246 13.76-51.281 93.54-104.461 133.53l-.027.02c-12.113 10.49-25.512 18.62-40.855 24.24-2.344.87-4.594 1.66-6.762 2.32-12.738 4.16-22.203 5.59-29.816 5.12-16.399-1.01-24.168-10.78-37.332-21.17l-.54-.48-.066-.09-.133-.16c-2.344-3.04-3.773-11.13-4.64-19.86-.801-8.41-1.118-17.43-1.227-23.08v-.09c-.023-.91-.047-1.73-.047-2.48-.023-1.93-.023-3.09-.023-3.09l.09.07c1.855 1.18 31.711 19.25 91.816-18.98 62.059-39.47 93.66-112.22 93.66-112.22 15.953-37.28 53.18-93.11 60.742-104.31.629-.92 1.032-1.54 1.231-1.84l.113-.13c-.344 1.25-7.203 26.02-17.172 58.3 10.848-19.56 19.145-34.15 22.617-39.74.661-1.64 1.301-2.82 1.911-3.3 4.265-3.38 80.789-61.38 85.464-65.44 4.68-4.06 28.063-19.081 28.063-19.081s111.028-71.637 130.268-78.84c19.24-7.207 31.26-5.18 34.09-6.539 2.83-1.371-173.811 94.922-209.921 131.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1e1e",
    d: "M619.133 1486.95c104.605-107.33 211.32-167.44 211.32-167.44s147.649-96.64 294.837-175.88c3.24-1.75 79.58-18.55 79.58-18.55-9.34 15.96-17.78 30.51-17.78 30.51s1.2 2.94-56.39 83.27c-57.57 80.33-94 155.04-122.25 178.19-28.251 23.16-123.27 75.58-123.27 75.58-55.563 30.71-88.575 44.13-133.133 65-43.859 20.52-56.832 18.14-57.227 18.06h-.011a170.488 170.488 0 01-5.028-4.32c-9.199-8.21-36.617-34.54-42.164-41.56-6.558-8.26-19.179-30.5-24.222-37.19-2.594-3.43-4.262-5.67-4.262-5.67",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939a9f",
    d: "M885.691 1491.37l-54.414-172.12c-.07-.37-9.859-43.69-9.859-51.5 0-6.86 8.672-102.79 32.383-141.94 13.765-22.72 86.566-96.14 98.625-103.11 1.582-.92 5.41-3.19 10.851-6.41 88.783-52.528 137.093-79.142 143.693-79.142l.47.082c3.27 2.668 6.46 6.391 12.26 13.149 3.8 4.41 8.51 9.902 15.06 17.211 16.6 18.512 51.36 39.59 51.71 39.8 9.75 9.18 24.47 24.45 24.47 28.4 0 29.22 0 78.15-4.61 84.79-4.75 6.8-19.37 33.45-19.99 34.6l-.2.35.05.12c-.48 1.44-5.49 11.97-56.2 82.7-24.41 34.09-44.83 66.83-62.84 95.71-24.06 38.6-43.08 69.09-59.23 82.33-26.393 21.62-112.361 69.5-122.229 74.98zm221.649-555.819c-5.67 0-31.71 12.258-144.942 79.269-5.429 3.22-9.25 5.47-10.832 6.38-12.875 7.45-85.117 80.41-99.222 103.71-23.91 39.46-32.637 135.94-32.637 142.84 0 7.99 9.508 50.16 9.918 51.95l55.063 174.2.914-.53c.945-.52 95.41-52.72 123.398-75.65 16.37-13.43 35.46-44.02 59.62-82.75 18-28.86 38.39-61.57 62.79-95.61 34.5-48.14 54.76-78.1 56.38-83.39l.04.02c.17-.28 15.2-27.69 19.91-34.45 4.54-6.53 4.92-45.94 4.92-85.75 0-5.97-22.58-27.35-25.15-29.77-.5-.32-35.05-21.25-51.49-39.579-6.53-7.3-11.23-12.769-15.02-17.179-5.86-6.832-9.1-10.614-12.54-13.422l-1.12-.289",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1234.47 1121.06l-37.43 35.17-168.96 254.66c3.12-3.74 82.05-117.67 206.39-289.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M625.258 1495.27l61.758-58.55 109.425-79.75 62.879 133.69s-144.414 79.02-169.539 80.71c-9.199-8.21-36.617-34.54-42.164-41.56-6.558-8.26-17.312-27.86-22.359-34.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M644.117 1473.02c-1.191 1.12-9.152 17.28 2.168 33.55 11.313 16.27 65.07 53.25 65.07 53.25s-5.613 6.5-23.496 8.99c-8.394-7.76-42.16-41.55-42.16-41.55l-22.359-34.55 20.777-19.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M641.633 1475.37c-.93.88-16.922 15.8-7.727 33.67-7.097-10.95-10.566-16.33-10.566-16.33l-4.199-5.74 22.492-11.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M909.453 1466.75l-36.758-160.66 246.075-148.54 60.48-15.32s-12.99 32.88-43.69 76.89c-54.16 77.61-108.01 171.65-125.52 186.32-17.505 14.68-100.587 61.31-100.587 61.31",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient619)",
    d: "M1358.87 801.332c0 58-40.98 128.68-91.53 157.859-25.19 14.539-48.01 16.028-64.56 6.688l-.01-.008-.38-.23-44.42-25.661v-44.769l129.8-178.199 40.83 23.769a42.42 42.42 0 017.27 4.219l.03.02c14.29 10.269 22.97 29.621 22.97 56.312",
    clipPath: "url(#clipPath619)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M1315.71 776.422c0-58.012-40.98-81.371-91.53-52.192-50.54 29.192-91.52 99.86-91.52 157.872 0 58 40.98 81.359 91.52 52.179 50.55-29.191 91.53-99.871 91.53-157.859",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient625)",
    d: "M1315.71 776.422c0-58.012-40.98-81.371-91.53-52.192-50.54 29.192-91.52 99.86-91.52 157.872 0 58 40.98 81.359 91.52 52.179 50.55-29.191 91.53-99.871 91.53-157.859",
    clipPath: "url(#clipPath625)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient630)",
    d: "M1310 777.469c0-55.797-39.42-78.27-88.04-50.188-48.63 28.059-88.04 96.051-88.04 151.848 0 55.793 39.41 78.269 88.04 50.203 48.62-28.082 88.04-96.07 88.04-151.863",
    clipPath: "url(#clipPath630)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504f58",
    d: "M1287.77 792.539c0-40.289-28.47-56.519-63.59-36.25-35.12 20.27-63.58 69.383-63.58 109.68 0 40.301 28.46 56.531 63.58 36.25 35.12-20.278 63.59-69.379 63.59-109.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1285.79 796.742c0-38.203-26.99-53.582-60.27-34.363-33.28 19.211-60.27 65.75-60.27 103.953 0 38.188 26.99 53.566 60.27 34.359 33.28-19.222 60.27-65.761 60.27-103.949",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient637)",
    d: "M1185.58 900.43c-19.14-10.918-21.67-43.27-7.59-76.489a135.617 135.617 0 017.59-15.171c2.91-5.032 6.07-9.758 9.4-14.129 21.87-28.801 51.34-42.911 70.48-31.993a26.63 26.63 0 016.2 4.864c4.8 4.988 7.92 11.879 9.38 20.047 3.3 18.39-1.9 43.14-15.59 66.75-13.68 23.601-32.64 40.5-50.32 46.929-7.84 2.864-15.43 3.653-22.2 2.051a26.786 26.786 0 01-7.35-2.859",
    clipPath: "url(#clipPath637)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1232.53 854.621l-50.15-28.98c-1.67-.95-1.89-3.879-.46-6.871 1.49-3.11 3.12-6.211 4.91-9.29 1.79-3.07 3.67-6.039 5.63-8.871 1.88-2.738 4.54-4.031 6.22-3.07l50.14 28.973-16.29 28.109",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1237.22 838.602l-7.31-20.864 1.32-1.258 34.68-43.23c2.12-2.02 4.45-2.398 5.6-.891 2.61 3.442 4.56 7.571 5.86 12.25.68 2.43-.66 6.141-3.08 8.473l-26.68 35.527-10.39 9.993",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M1197.09 900.719c-1.9-.227-2.74-2.41-2.04-5.239l19.88-50.89.44-1.77 21.85-4.218-3.47 13.918-17.2 40.171c-.81 3.239-3.38 6.25-5.84 6.891-4.72 1.238-9.31 1.648-13.62 1.137",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1264.69 996.66c-33.48 14.8-54.28 10.65-66.09 3.54h-.01l-.03-.02-47.16-27.239 11.94-3.57c-6.14-4.133-10.39-7.391-7.39-7.41 2.37-.012 6.17 3.391 12.51 5.879l5.92-1.77 6.29 4.321c14.99.578 38.11-7 74.08-40.629 0 0 37.24-47.313 47.32-48.563 1.58-.308 27.1-8.48 64.87 22.903 13.35 11.097-8.68 38.679-15.56 40.886-44.69 14.364-44.63 33.094-86.69 51.672",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1367 916.18c3.86-10.461-28.52-30.071-52.05-29.282-3.03 0-10.54 7.692-19.83 21.211-10.88 15.821-42.44 41.243-42.44 41.243s32.89-20.493 57.16-26.891c24.27-6.402 41.24 9.519 41.24 9.519s12.73-7.191 15.92-15.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1268.92 907.34s23.07-24.891 33.15-26.141c2.31-.449 4.9-.097 4.9-.097s-33.76 62.187-90.95 87.449c-59.6 26.34-79.04-7.321-79.04-10.969 0-3.652 7.65-8.852 15.08-8.883 7.42-.027 46.81 24.153 116.86-41.359",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1e1e",
    d: "M1499.54 1274.1l-3.8-8.1-.61-1.3c-7.62-15.28-33.32-51.8-88.57-79.74-76.22-38.55-131.26-57.53-153.86-61.04l-18.23-2.86c-6.76 9.39-13.41 18.57-19.9 27.59-112.8 156.64-183.54 258.72-186.49 262.25l-.05.04-.02.05 46.7 18.67c10.38 4.14 20.44 9.03 30.11 14.62l49.25 28.43 38.02 21.94c11.93 6.87 23.2 14.79 33.74 23.66l14.8 12.45 11.18 9.43 247.73-266.09",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M1484.37 1271.72l-.6-1.27-.08-.17c-2.44-4.82-23.49-43.92-82.88-73.97-82.19-41.56-133-57.17-150.06-59.82l-10.53-1.63-.59.82c-4.99 6.9-9.91 13.71-14.73 20.42-3.24 4.5-6.45 8.96-9.63 13.37-74.08 103-129.35 181.57-156.49 220.14-4.62 6.54-8.19 11.63-10.97 15.58l31.64 12.65c10.79 4.31 21.47 9.48 31.74 15.4l49.25 28.44 5.09 2.95 32.93 18.98c12.48 7.2 24.45 15.6 35.57 24.95l16.15 13.59.57.49 7.51-8.09.15-.13 82.24-88.35 143.72-154.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M1483.77 1270.45l-.08-.17c-2.44-4.82-23.49-43.92-82.88-73.97-82.19-41.56-133-57.17-150.06-59.82l-10.53-1.63-.59.82c-4.99 6.9-9.91 13.71-14.73 20.42-3.24 4.5-6.45 8.96-9.63 13.37l1.02 1.53c6.02 4.32 50.93 19.61 58.88 28.09 7.96 8.49 6.9 20.16 19.1 31.76 12.2 11.61 101.87 55.77 101.87 55.77s32.93 1.83 87.63-16.17",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6f2",
    d: "M1491.8 1258.69c.71 5.05.59 9.46-1.36 11.67-7.56 8.51-20.03 22.58-38.26 43.15-36.29 40.88-191.2 211.76-202.85 224.6l-.62.67-.06.09 4.52 2.11.06-.07.21-.22 11.46-11.11.19-.2c20.39-20.41 47.98-50.37 76.03-81.65 40.55-43.62 94.09-101.93 158.42-173.63l14.26-13.41-29.35-27.12s5.76 14.07 7.35 25.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6f2",
    d: "M1036.68 1414.43s192.1-276.11 198.32-281.53c6.22-5.43 22.45-9.73 44.29-2.24 11.26-7.43-44.82-9.6-44.82-9.6l-206.46 289.92 8.67 3.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M1444.31 1295.25l-60.48 15.33-218.3 154.05 32.93 18.98c12.48 7.2 24.45 15.6 35.57 24.95l16.15 13.59c2.5-2.32 5.21-4.84 8.08-7.6l.15-.13c20.41-19.41 49.67-49.37 82.24-88.35 7.49-8.93 15.13-18.34 22.88-28.18 33.16-42.19 80.78-102.64 80.78-102.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e6ea",
    d: "M1412.03 1006.65c-19.1-7.31-55.7-11.259-62.29-10.138-6.58 1.109-29.69 4.218-35.85 14.788-4.92 8.45-6.4 19.57-4.71 27.86 1.6 7.79 6.01 13.08 13.01 11.22 30.34-8.02 41.59.14 53.98 1.1 4.46.35 9.08-.25 14.82-2.88 10.67-4.88 40.14-34.64 21.04-41.95",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f39737",
    d: "M1393.91 1016.87s-29.9-7.93-41.29-7.93-31.91 6.32-33.45 5.45c-1.53-.86 7.51-13.54 33.46-13.76 25.94-.21 47.83 8.12 47.83 8.12l-6.55 8.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e6ea",
    d: "M1561.8 1093.93c-5.73-3.68-10.35 8.02-12.59 22.49-2.44 15.89-1.95 35.11 3.23 40.93 4.39 4.94 6.77 8.74 7.92 12.12 2.31 6.81-.3 11.95-1.26 21.41-1.59 15.92 22.77-43.26 23.58-59.52.78-16.23-8.85-29.71-20.88-37.43",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f39737",
    d: "M1570.09 1154.37c2.84-7.86 4.27-23.95-1.58-31.63-5.84-7.67-13.49-15.97-13.49-17.72 0-1.75 3.75-4.81 7.23-3.06 3.47 1.75 15.26 18.05 15.48 21.91.22 3.86-.65 27.23-7.64 30.5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c93",
    d: "M622.152 1154.79c6.719-23.25 34.309-71.52 75.59-76.65-2.117 11.94-12.465 24.67-12.465 24.67s-6.5 16.98-9.414 18.83c-13.668 8.7-26.308 28.67-26.308 28.67l-27.403 4.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M703.988 1088.21l-.785 1.19-15.105 48.5-18.84 21.6-41.785 16.55c-.614.35-1.559 1.86-1.606 2.77-.16 3.42-.066 6.68.281 9.74l50.879-21.77 11.301 26.47c1.555-1.58 3.082-3.23 4.563-4.93 2.121-2.42 4.175-4.99 6.117-7.63l.762-1.57-11.629-27.04 21.324-61.52c-1.672-1.06-3.504-1.84-5.477-2.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M1232.21 824.371l-34.56-20.082c-1.85 2.68-3.64 5.5-5.31 8.391a124.992 124.992 0 00-4.6 8.691l34.54 20.078-20.43 53.102c2.24-.09 4.61-.449 7.05-1.071.42-.3 1.2-1.25 1.47-2.339l17.42-41.032 14.76-25.461 27.33-36.148 1.3-2.418c-.68-2.402-1.56-4.594-2.62-6.551l-36.35 44.84",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1546.63 1041.53s-6.99-13.87-28.97-29.49a166.31 166.31 0 00-16.36-10.2c-35.03-19.231-73.97-35.93-89.48-40.262-2.44-.668-3.88-.226-4.54 1.051-3.5 6.781 15.36 37.25 21.45 44.811 7.22 8.96 14.07 45.76 21.86 50.01 30.47 10.55 56.14 30.2 66.88 38.72 2.99 2.37 4.82 3.87 5.26 4.08 6.65 3.1 15.58-8.36 23.88-14.92 2.69-2.12 5.3-3.76 7.74-4.18 1.93-.33 3.76.05 5.43 1.51 3.91 3.41-13.15-41.13-13.15-41.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1546.63 1041.53s-1.62-25.56-5.35-37.02c-.53-1.61-1.1-2.95-1.7-3.89a53.987 53.987 0 00-2.44-3.53c-4.75-6.469-9.91-10.668-20.6-18.871-12.53-9.571-37.5-27.571-60.33-39.598-22.83-12.031-60.99-24.391-54.26-10.391 4.42 9.18 5.22 21.122 5.27 28.18.02 3.711-.17 6.09-.17 6.09l.23.129 109.94 62.251 29.41 16.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0acb2",
    d: "M1546.63 1041.53s-1.62-25.56-5.35-37.02c-.53-1.61-1.1-2.95-1.7-3.89a53.987 53.987 0 00-2.44-3.53l-18.12-.77-1.36 15.72-.32 3.57s-.06 4.03-.12 9.27c-.09 7.79-.13 18.19.12 21.79.43 6.01 15.81 38.19 15.81 38.19l13.46.47c4.81-3.82 9.4-5.98 13.17-2.67 3.91 3.41-13.15-41.13-13.15-41.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1541.28 1004.51c-.53-1.61-1.1-2.95-1.7-3.89-5.6-8.698-10.53-12.811-23.04-22.401-12.53-9.571-37.5-27.571-60.33-39.598-22.83-12.031-60.99-24.391-54.26-10.391 4.42 9.18 5.22 21.122 5.27 28.18 61.76 19.352 110.12 59.2 110.12 59.2s13.69-9.29 23.94-11.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e979e",
    d: "M1554.35 1081.15s-19.52 2.08-26.14 6.03c-2.67 1.59-6.77 5.22-10.74 8.99 2.99 2.37 4.82 3.87 5.26 4.08 6.65 3.1 15.58-8.36 23.88-14.92 2.69-2.12 5.3-3.76 7.74-4.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfc",
    d: "M1375.96 1025.62c-8.76-5.3-24.75-10.01-49.97-3.4-19.7 5.16-16.53 8.22-16.81 16.94 1.6 7.79 6.01 13.08 13.01 11.22 30.34-8.02 41.59.14 53.98 1.1 2.61-8.45 5.75-22.25-.21-25.86",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1556.06 1076.68c-5.24-15.13-62.4-65.14-134.14-82.891 3.72 7.031 6.4 9.791 10.59 12.851 4.19 3.07 33.84 11.39 61.99 28.59 28.16 17.21 57.79 43.77 57.79 43.77l3.77-2.32",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfc",
    d: "M1560.36 1130.65c-1.64-5.55-6.33-10.45-11.15-14.23-2.44 15.89-1.95 35.11 3.23 40.93 4.39 4.94 6.77 8.74 7.92 12.12.74-15.86 3.85-25.74 0-38.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d29",
    d: "M614.988 1474.14c9.375-5.13 1.75-32.86 11.414-41.7 9.657-8.84 20.953-17.98 15.907-26.46-5.039-8.49-14.668-15.66-13.036-23.34 1.633-7.7-2.449-8.48-2.449-8.48s-9.656 23.41-11.301 32.61c-1.644 9.21-2.386 48.01-.535 67.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1e1e",
    d: "M1205.35 1491.95c16.69-22.32 19.54-24.39 1.46-36.07-18.08-11.67-57.25-33.62-64.68-33.62-7.43 0-14.04 8.54-24.48 21.6-3.06 3.83 87.7 48.09 87.7 48.09",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1085.94 1179.32c-16.34 1.2-19.21-3.14-20.15-14.39-.95-11.25-1.24-43.22 1.43-46.5l4.22-6.75c5.74-3.17 31.14-.42 33.44 12.11 2.02 10.98 7.18 34.73 1.83 45.2-.5.98-5.25 8.52-5.87 9.12-.8.78-1.7 1.2-2.72 1.21-10.1.01-12.18 0-12.18 0",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1090.15 1172.56c-16.34 1.21-19.21-3.13-20.15-14.38-.94-11.25-1.24-43.22 1.44-46.5 2.67-3.28 35.21-7.99 37.66 5.36 2.44 13.35 3.34 55.51-6.77 55.52-10.1.02-12.18 0-12.18 0",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1093.13 1123.85l27.03-25.36 19.79-4.18v11.71l-46.82 29.42v-11.59",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e42",
    d: "M1493.65 1130.44l-19.34-11.17c-3.07-1.78-4.71-5.02-4.29-8.51l3.1-25.48c.6-4.98 6.85-8.03 11.25-5.49l19.34 11.18c3.08 1.77 4.71 5.02 4.29 8.5l-3.09 25.48c-.6 4.98-6.86 8.04-11.26 5.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1935.57 2682.38c0-3.48-.27-6.76-1-9.03l-.07-.33c-.33-.94-.74-1.68-1.27-2.21l-1.61-1.34c-2.61-2.01-7.09-4.55-12.37-5.48-1.94-.34-3.95-.47-6.02-.27h-.07l-1.13.13h-.07c-2.21.27-4.48.94-6.69 2.08l-1.53.87h-.07l-1.6.93-.08.07c-10.03 6.16-21.73 17.85-26.75 28.15-.73 1.55-1.33 3.08-1.73 4.62-.54 1.87-.94 3.81-1.14 5.81l-.13 1.41c-.2 1.67-.27 3.21-.27 4.68 0 1.21 0 2.34.13 3.41l.2 2.01c.2 2.2.61 4.35 1.21 6.35l.06.2c1.14 4.42 3.08 8.09 5.62 10.23 2.14 1.81 4.61 2.55 7.83 2.14 6.61-.8 16.25-6.61 32.5-17.65 6.75-4.61 13.1-12.57 15.11-19.79l.2-.61c.27-1.13.4-2.27.47-3.41 0-1.54.13-3.34.2-5.14v-.08c.07-2.54.13-5.21.07-7.75",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1922.32 2688.6v-2.21l-.06-.07v-.47c-.07-4.88-.87-9.42-2.41-12.97v-.07l-.07-.06c-1.26-3.08-3.14-5.35-5.68-6.49-2.68-1.2-6.09-1.2-10.3.6v.07l-1.73.8-.08.07c-11.63 6.02-21.93 17.05-26.75 28.15-.73 1.55-1.33 3.08-1.73 4.62-.6 1.8-.94 3.61-1.14 5.42v.39l-.13 1.41c-.2 1.67-.27 3.21-.27 4.68 0 1.21 0 2.34.13 3.41l.14 1.81v.06c.2 2.61.67 4.75 1.27 6.49l.06.2c1.01 2.81 2.41 4.42 3.88 4.69.8.13 1.88.06 3.21-.14 5.62-.94 15.12-5.02 21.67-10.57 8.02-6.82 19.73-14.64 19.99-29.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M2270.17 2288.39c8.47-14.49 19.58-29.44 19.65-54.95l-2.05-31.02-412.46 247.37 5.02 30.95c-.07 25.51-17.81 48.5-26.28 63l416.12-255.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient679)",
    d: "M2222.33 2233.9c-2.62 5.55-5.25 11.1-7.87 16.66 3.31-7.01 5.08-15.83 4.92-26.25-.58-39.24-28.28-86.12-61.87-104.71l15.4.63c29.15 16.14 53.19 56.83 53.7 90.88.13 9.05-1.4 16.71-4.28 22.79",
    clipPath: "url(#clipPath679)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient684)",
    d: "M2173.06 2130.4c24.34 13.48 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.07 29.7l3.17-1.82c8.25-4.74 13.28-15.06 13.06-29.7-.42-28.44-20.5-62.42-44.84-75.89-11.82-6.54-22.47-7.05-30.25-2.58l-3.17 1.81c7.79-4.46 18.44-3.95 30.25 2.58",
    clipPath: "url(#clipPath684)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M2243.78 2252.28l-11.38 6.53c12.69-7.28 20.42-23.15 20.09-45.65-.66-43.73-31.53-95.97-68.95-116.68l11.38-6.53c37.42 20.71 68.29 72.95 68.95 116.68.33 22.51-7.4 38.37-20.09 45.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient689)",
    d: "M2132.92 2155.7c.42 28.45 20.5 62.42 44.84 75.9 24.35 13.47 43.74 1.33 43.31-27.12-.42-28.44-20.5-62.42-44.84-75.89-24.35-13.47-43.74-1.33-43.31 27.11zm-19.08-18.66c.12-2.11.34-4.92.63-7.02.76-5.65 2.03-9.86 2.54-11.41.73-2.24 1.83-5.22 2.92-7.33.92-1.76 2.25-4.05 3.3-5.74l2.02-2.78c1.35-1.76 3.52-4.04 4.7-5.06l2.44-2.07a85.5 85.5 0 014.65-3.11c11.96-6.87 28.33-6.08 46.5 3.96 37.42 20.71 68.29 72.95 68.95 116.68.33 22.5-7.4 38.37-20.09 45.65-1.68.88-3.96 1.98-5.72 2.7-1.14.47-2.74.92-3.94 1.27-1.92.56-5.61 1.23-8.45 1.37-1.78.08-4.16.06-5.94 0a37.29 37.29 0 01-3.94-.4c-2.33-.36-5.4-1.03-7.69-1.6-1.39-.34-3.22-.92-4.55-1.44-1.39-.55-3.27-1.22-4.62-1.83-2.15-.98-5-2.37-7.07-3.5-5.71-3.13-10.93-7.06-10.98-7.1-1.5-1.15-3.5-2.68-4.95-3.89-1.63-1.36-3.77-3.19-5.29-4.67-2.84-2.81-6.54-6.64-9.24-9.59-1.45-1.59-3.21-3.84-4.57-5.5-2.55-3.1-6.9-9.33-8.16-11.34-1.1-1.79-2.62-4.14-3.69-5.96-1.07-1.8-2.4-4.26-3.43-6.1-1.03-1.83-2.21-4.37-3.15-6.24-.02-.06-2.73-5.54-5.41-12.83-1.4-3.8-3.01-8.97-4.06-12.88-.29-1.09-1.78-6.82-2.73-13.47-.83-5.79-1.04-10.38-1.07-13.2-.01-1.67 0-3.91.09-5.57",
    clipPath: "url(#clipPath689)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient694)",
    d: "M2203.06 2113.2c24.34 13.47 44.42 47.45 44.85 75.89.22 14.64-4.81 24.96-13.07 29.7l3.27-1.88c8.25-4.73 13.28-15.04 13.06-29.68-.42-28.45-20.5-62.44-44.85-75.9-11.81-6.54-22.46-7.04-30.24-2.58l-3.27 1.87c7.79-4.47 18.43-3.96 30.25 2.58",
    clipPath: "url(#clipPath694)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient699)",
    d: "M2152.9 2146.02l.48 2.49c-1.05-5.35-1.64-10.65-1.71-15.8-.54-35.44 23.63-50.58 53.97-33.78 30.34 16.78 55.37 59.13 55.9 94.59.53 35.44-23.64 50.58-53.98 33.78-5.26-2.91-10.36-6.58-15.2-10.85l1.9 1.67c5.13 4.54 10.54 8.44 16.13 11.53 32.19 17.81 57.84 1.76 57.28-35.86-.57-37.63-27.12-82.57-59.32-100.38-32.2-17.81-57.84-1.76-57.28 35.86.08 5.47.71 11.08 1.83 16.75",
    clipPath: "url(#clipPath699)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient704)",
    d: "M2205.73 2104.66c27.62 15.29 50.41 53.86 50.9 86.13.47 32.29-21.53 46.07-49.15 30.77-27.64-15.28-50.42-53.85-50.9-86.13-.49-32.28 21.52-46.06 49.15-30.77zm-54.06 28.05c.52 35.45 25.55 77.81 55.89 94.59 30.34 16.8 54.51 1.66 53.98-33.78-.53-35.46-25.56-77.81-55.9-94.59-30.34-16.8-54.51-1.67-53.97 33.78",
    clipPath: "url(#clipPath704)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient709)",
    d: "M2151.07 2129.27c.08 5.51.72 11.18 1.85 16.89v.01c.71 3.16 1.67 7.37 2.62 10.46.53 1.75 1.28 4.07 1.89 5.8.6 1.72 1.5 3.97 2.15 5.67 1.6 4.18 5.36 12.06 8.41 17.24 1.92 3.25 4.6 7.53 6.76 10.65 1.87 2.71 4.58 6.18 6.64 8.75 2.3 2.87 3.83 4.47 7.93 8.74 1.38 1.42 3.35 3.21 4.83 4.54 5.17 4.58 10.61 8.51 16.24 11.63 32.19 17.81 57.84 1.76 57.28-35.86-.57-37.63-27.12-82.57-59.32-100.38-32.2-17.81-57.84-1.76-57.28 35.86zm-2.49-2.94c-.6-40.12 26.75-57.24 61.08-38.23 34.34 18.99 62.66 66.92 63.26 107.04.6 40.11-26.75 57.23-61.08 38.24-6-3.32-11.81-7.52-17.32-12.4.29-1.09.26-1.96-.07-2.54.33.58.36 1.45.07 2.54-21.44-19-38.35-48.37-43.96-76.62l1.64.74-1.64-.74c-1.21-6.11-1.89-12.15-1.98-18.03",
    clipPath: "url(#clipPath709)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient714)",
    d: "M2067.28 2156.42c.96 64.71 22.34 101.51 78.27 132.47 20.7 11.45 39.35 12.3 52.95 4.42 14.21-8.25 42.79-24.81 57-33.06-13.56 7.87-32.17 7.03-52.82-4.41-42.41-23.46-77.38-82.65-78.12-132.19-.19-12.65 1.88-23.45 5.76-32.14 8.34.97 17.41 3.99 26.91 9.25l42.77-24.33c-20.51-11.35-39-12.27-52.54-4.58-14.29 8.1-42.95 24.54-57.24 32.65-14.49 8.22-23.33 26.27-22.94 51.92",
    clipPath: "url(#clipPath714)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient719)",
    d: "M2209.79 2096.73c30.26 16.74 55.21 58.96 55.74 94.31.53 35.36-23.57 50.44-53.82 33.71-30.26-16.75-55.21-58.98-55.74-94.33-.53-35.35 23.57-50.44 53.82-33.69zm-66.37 26.75c.65 43.44 31.32 95.35 68.5 115.92 37.19 20.58 66.81 2.04 66.16-41.41-.65-43.45-31.32-95.35-68.5-115.93-37.19-20.58-66.81-2.03-66.16 41.42",
    clipPath: "url(#clipPath719)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient724)",
    d: "M2206.6 2075.79c1.71 1.02 4.03 2.32 5.7 3.4 2.07 1.33 4.76 3.18 6.73 4.64 3.47 2.54 7.86 6.25 11.02 9.17 5.54 5.12 9.65 9.8 10.99 11.35 4.62 5.25 7.9 9.73 9.86 12.42.71.97 4.49 6.21 8.68 13.29 2.68 4.54 5.18 9.24 7.43 13.95 6.37 13.38 9.28 23.72 10.69 29.02.57 2.17 2.01 7.91 3 14.61 1.09 7.43 1.22 12.64 1.27 14.36.12 4.75-.06 9.18-.55 13.56-.24 2.17-.72 5.06-1.13 7.21-.29 1.53-.82 3.53-1.2 5.03-.55 2.14-1.57 4.91-2.34 6.97-.47 1.25-1.25 2.84-1.79 4.06-.94 2.07-2.44 4.74-3.78 6.58-1.38 1.89-3.3 4.35-4.82 6.13-.8.92-2 2.02-2.89 2.86l-2.79 2.36c-1.51 1.11-3.58 2.5-5.16 3.49-13.57 7.87-32.19 7.03-52.84-4.41-42.41-23.46-77.38-82.65-78.12-132.19-.39-25.59 8.44-43.61 22.91-51.81.97-.5 2.24-1.22 3.23-1.66 1.23-.57 2.91-1.25 4.19-1.71 2.11-.76 5.03-1.44 7.22-1.92 1.78-.39 4.2-.63 6.02-.73 2.03-.12 4.75-.14 6.78 0 1.35.09 3.17.22 4.5.45 2.65.46 6.2 1.02 8.76 1.84 3.17.99 7.36 2.45 10.42 3.72 2.47 1.03 5.64 2.7 8.01 3.96 1.79 1 2.93 3.17 2.98 6.27-37.19-20.58-66.81-2.03-66.16 41.42.65 43.44 31.32 95.35 68.5 115.92 37.19 20.58 66.81 2.04 66.16-41.41-.65-43.45-31.32-95.35-68.5-115.93-.05-3.1-1.19-5.27-2.98-6.27",
    clipPath: "url(#clipPath724)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient734)",
    d: "M2162.59 2112.91c-.63 2.16-1.26 4.32-1.88 6.47-.82 2.84-1.71 5.65-2.39 8.51 2.81.95 5.72 2.24 8.7 3.9 25.56 14.25 46.58 49.81 46.94 79.45.06 4.22-.33 8.08-1.07 11.57 3.22.33 6.4 1.16 9.55 1.98 1.73.45 3.49.86 5.25 1.25l2.12-1.24c1.59-.91 3.06-2.03 4.39-3.34l4.97-2.89c8.41-4.88 13.54-15.4 13.36-30.3-.36-29.32-21.16-64.52-46.46-78.61-12.44-6.94-23.65-7.47-31.79-2.75-1.23.72-2.4 1.57-3.48 2.51-2.35.52-4.55 1.37-6.56 2.53l-1.65.96",
    clipPath: "url(#clipPath734)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient744)",
    d: "M2159.47 2128.3c2.45.9 4.97 2.05 7.55 3.49 25.56 14.25 46.58 49.81 46.94 79.45.06 4.12-.31 7.91-1.03 11.34 2.71.33 5.43 1.35 7.92 2.07 1.74.52 3.51.98 5.28 1.43 8.23-4.96 13.25-15.39 13.06-30.11-.36-29.32-21.15-64.51-46.45-78.62-12.44-6.93-23.65-7.47-31.79-2.74l-1.09.71c-.33 4.33-.53 8.65-.39 12.98",
    clipPath: "url(#clipPath744)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient758)",
    d: "M2214.69 2182.33c4.16-.84 10.28 1.06 15.91 4.19 3.08 1.72 6.01 3.8 8.38 6l3.68-2.12c-2.37-2.2-5.3-4.29-8.38-6-7.7-4.29-16.35-6.27-19.59-2.07",
    clipPath: "url(#clipPath758)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient768)",
    d: "M2193.45 2191.04c7.76 4.32 14.46 20.11 16.69 31.68 1.24-.5 2.53-.87 3.87-1.06-2.01-11.65-8.88-28.29-16.88-32.74-3.7-2.06-7.09-1.21-9.84 1.26 1.9-.55 3.98-.36 6.16.86",
    clipPath: "url(#clipPath768)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient778)",
    d: "M2185.04 2110.59l-3.68 2.12c4.88 10.29 7.9 27.59 3.82 33.6l1.13-.17c7.57-2.18 4.39-23.6-1.27-35.55",
    clipPath: "url(#clipPath778)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient788)",
    d: "M2231.75 2163.95l-.79.74c1.8-.71 3.35-1.67 4.47-2.86l-3.68 2.12",
    clipPath: "url(#clipPath788)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient798)",
    d: "M2157.68 2145.96c8.12 5.03 16.74 13.4 18.82 21.6 1.58 6.23-.94 11.12-4.97 14.18 5.99-2.54 10.67-8.33 8.65-16.3-2.25-8.88-12.17-17.97-20.82-22.78l-1.98-1.04c.15 1.44.25 2.88.3 4.34",
    clipPath: "url(#clipPath798)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient809)",
    d: "M2158.18 2142.02l1.18.64c8.65 4.81 18.57 13.9 20.82 22.78 2.12 8.36-3.14 14.33-9.55 16.65 1.24 2.86 2.78 5.58 4.55 8.16 2.03 2.96 4.54 5.33 7.11 7.73 2.78-7.3 8.34-12.69 14.84-9.06 9.45 5.26 17.33 27.54 17.47 38.49 7.06.65 13.21-1.17 17.95-5.17-9.02-8.41-21.6-29.32-18.81-38.1 2.06-6.48 11.89-4.56 20.54.26 3.08 1.71 6.01 3.8 8.38 6-.64-9.34-3.2-19.13-7.23-28.57-4.19 4.42-14.14 5.92-22.03 1.53a19.6 19.6 0 01-6.35-5.66c-7.72-10.7-5.03-28.85.42-34.61-2.92-2.47-5.94-4.69-9.04-6.59l-.22-.12-.35-.22-.34-.2-.16-.09-.48-.28-.13-.07-.52-.31-.52-.28-.13-.07-.48-.25-.18-.1-.3-.15-.48-.25-.09-.05c-3.09-1.55-6.11-2.7-9.01-3.47 5.66 11.95 8.84 33.37 1.27 35.55-1.75.5-3.93-.07-6.31-1.39-7.75-4.33-17.68-16.68-22.14-25.84-.66 7.67-.22 15.42.32 23.11",
    clipPath: "url(#clipPath809)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient819)",
    d: "M2197.01 2178.71c-4.88-2.72-8.89-9.51-8.96-15.17-.07-5.65 3.83-8.04 8.7-5.33 4.89 2.73 8.9 9.52 8.97 15.18.07 5.65-3.83 8.05-8.71 5.32",
    clipPath: "url(#clipPath819)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient830)",
    d: "M2195.6 2176.52c3.47 1.94 6.25.25 6.2-3.77-.05-4.01-2.9-8.83-6.38-10.77-3.46-1.93-6.24-.23-6.19 3.78.05 4.01 2.9 8.84 6.37 10.76",
    clipPath: "url(#clipPath830)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient844)",
    d: "M2204.31 2222.95c13.68 7.63 26.01 8.22 34.96 3.02l3.13-1.83c-8.95 5.21-21.28 4.62-34.96-3.01-27.82-15.51-50.69-54.21-51.09-86.45-.2-16.39 5.45-27.96 14.7-33.33l-3.13 1.81c-9.26 5.38-14.9 16.95-14.7 33.33.4 32.25 23.27 70.96 51.09 86.46",
    clipPath: "url(#clipPath844)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e4",
    d: "M2160.92 2137.22c-.36-29.32 19.86-41.66 45.15-27.56 25.3 14.09 46.1 49.29 46.46 78.61.36 29.32-19.85 41.66-45.15 27.57-25.3-14.1-46.1-49.3-46.46-78.62zm46.52 83.91c27.82 15.5 50.06 1.94 49.66-30.31-.4-32.25-23.27-70.96-51.09-86.46-27.82-15.5-50.05-1.93-49.66 30.32.4 32.24 23.27 70.94 51.09 86.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M2909.02 2657.24c8.48-14.5 19.58-29.45 19.66-54.96l-2.05-23.31-379.94 240.51-11.24 32.64c-.07 25.51-17.81 48.5-26.28 63l399.85-257.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient851)",
    d: "M2861.19 2602.74c-2.63 5.56-5.25 11.11-7.87 16.66 3.31-7 5.08-15.83 4.92-26.25-.58-39.24-28.28-86.12-61.87-104.7l15.39.63c29.15 16.13 53.2 56.82 53.7 90.88.14 9.04-1.39 16.71-4.27 22.78",
    clipPath: "url(#clipPath851)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient856)",
    d: "M2811.91 2499.25c24.35 13.47 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.06 29.69l3.17-1.82c8.25-4.73 13.28-15.05 13.06-29.69-.43-28.45-20.51-62.43-44.85-75.9-11.81-6.54-22.46-7.04-30.25-2.58l-3.16 1.82c7.78-4.46 18.43-3.96 30.24 2.58",
    clipPath: "url(#clipPath856)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M2882.64 2621.13l-11.39 6.53c12.7-7.28 20.42-23.15 20.09-45.65-.65-43.73-31.52-95.97-68.95-116.68l11.38-6.53c37.43 20.71 68.3 72.95 68.95 116.68.34 22.5-7.39 38.37-20.08 45.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient861)",
    d: "M2771.77 2524.55c.43 28.44 20.51 62.42 44.85 75.89 24.34 13.48 43.73 1.34 43.31-27.11-.43-28.45-20.51-62.43-44.85-75.9-24.34-13.47-43.74-1.33-43.31 27.12zm-19.07-18.67c.12-2.11.34-4.92.63-7.02.76-5.66 2.02-9.86 2.53-11.4.74-2.25 1.84-5.23 2.93-7.33.92-1.77 2.25-4.06 3.29-5.75l2.03-2.78c1.35-1.76 3.52-4.04 4.69-5.06l2.45-2.06c1.35-.99 3.21-2.24 4.64-3.12 11.97-6.86 28.34-6.09 46.5 3.97 37.43 20.71 68.3 72.95 68.95 116.68.33 22.5-7.39 38.37-20.09 45.65-1.67.87-3.96 1.97-5.71 2.69-1.15.48-2.75.92-3.94 1.27-1.92.57-5.61 1.23-8.46 1.37-1.78.08-4.16.07-5.93 0a39.81 39.81 0 01-3.94-.39c-2.33-.36-5.41-1.03-7.69-1.6-1.4-.35-3.22-.93-4.56-1.45-1.39-.55-3.26-1.22-4.62-1.83-2.15-.98-4.99-2.36-7.06-3.5-5.71-3.13-10.94-7.06-10.99-7.1-1.49-1.15-3.5-2.68-4.95-3.89-1.62-1.36-3.77-3.19-5.28-4.67-2.85-2.8-6.54-6.64-9.24-9.59-1.45-1.58-3.21-3.84-4.57-5.49-2.56-3.11-6.91-9.33-8.16-11.35-1.11-1.78-2.62-4.14-3.69-5.95-1.07-1.81-2.41-4.28-3.43-6.11-1.03-1.83-2.21-4.37-3.16-6.24-.02-.05-2.72-5.54-5.41-12.82-1.4-3.81-3-8.97-4.05-12.89-.29-1.08-1.79-6.81-2.73-13.46-.83-5.8-1.04-10.38-1.07-13.21-.02-1.67-.01-3.9.09-5.57",
    clipPath: "url(#clipPath861)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient866)",
    d: "M2841.91 2482.04c24.35 13.47 44.43 47.45 44.85 75.9.22 14.64-4.81 24.96-13.06 29.69l3.26-1.87c8.25-4.73 13.29-15.06 13.07-29.7-.43-28.44-20.5-62.42-44.85-75.89-11.82-6.54-22.47-7.05-30.25-2.58l-3.26 1.87c7.78-4.46 18.43-3.96 30.24 2.58",
    clipPath: "url(#clipPath866)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient871)",
    d: "M2791.75 2514.86l.49 2.48c-1.05-5.34-1.64-10.63-1.72-15.78-.53-35.46 23.64-50.58 53.98-33.8 30.34 16.79 55.36 59.14 55.9 94.6.52 35.45-23.64 50.58-53.98 33.79-5.26-2.91-10.37-6.59-15.2-10.87l1.89 1.68c5.14 4.54 10.55 8.44 16.13 11.53 32.2 17.81 57.84 1.76 57.28-35.86-.56-37.62-27.12-82.56-59.31-100.38-32.2-17.82-57.84-1.76-57.29 35.86.08 5.46.71 11.08 1.83 16.75",
    clipPath: "url(#clipPath871)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient876)",
    d: "M2844.58 2473.51c27.63 15.28 50.42 53.85 50.9 86.13.48 32.28-21.52 46.05-49.15 30.77-27.63-15.29-50.42-53.85-50.9-86.13-.48-32.28 21.52-46.06 49.15-30.77zm-54.06 28.05c.53 35.45 25.55 77.8 55.9 94.59 30.34 16.79 54.5 1.66 53.97-33.79-.53-35.46-25.55-77.8-55.89-94.6-30.34-16.78-54.51-1.66-53.98 33.8",
    clipPath: "url(#clipPath876)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient881)",
    d: "M2789.92 2498.11c.08 5.51.73 11.18 1.86 16.89v.01c.71 3.16 1.67 7.37 2.61 10.46.53 1.76 1.28 4.08 1.89 5.81.6 1.71 1.5 3.96 2.15 5.66 1.61 4.18 5.36 12.06 8.41 17.24 1.92 3.26 4.61 7.54 6.76 10.65 1.87 2.71 4.59 6.18 6.64 8.75 2.3 2.87 3.84 4.47 7.93 8.73 1.38 1.44 3.35 3.22 4.83 4.55 5.17 4.58 10.62 8.52 16.24 11.63 32.2 17.81 57.84 1.76 57.28-35.86-.56-37.62-27.12-82.56-59.31-100.38-32.2-17.82-57.84-1.76-57.29 35.86zm-2.48-2.93c-.6-40.13 26.74-57.25 61.08-38.25s62.66 66.93 63.25 107.05c.6 40.12-26.75 57.24-61.08 38.24-5.99-3.32-11.8-7.52-17.32-12.4.3-1.08.26-1.95-.06-2.54.32.59.36 1.46.06 2.54-21.43-19-38.35-48.37-43.95-76.62l1.63.74-1.63-.74c-1.21-6.1-1.9-12.15-1.98-18.02",
    clipPath: "url(#clipPath881)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient886)",
    d: "M2706.13 2525.26c.96 64.72 22.35 101.52 78.28 132.47 20.7 11.45 39.34 12.3 52.94 4.42 14.22-8.24 42.8-24.81 57.01-33.05-13.57 7.86-32.18 7.02-52.83-4.41-42.4-23.46-77.37-82.65-78.12-132.2-.19-12.65 1.88-23.45 5.76-32.13 8.35.97 17.42 3.99 26.92 9.24l42.76-24.34c-20.51-11.34-38.99-12.26-52.54-4.57-14.28 8.11-42.94 24.54-57.23 32.65-14.5 8.23-23.33 26.28-22.95 51.92",
    clipPath: "url(#clipPath886)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient891)",
    d: "M2848.65 2465.57c30.26 16.74 55.21 58.97 55.73 94.32.54 35.35-23.56 50.44-53.82 33.69-30.25-16.73-55.21-58.97-55.74-94.32-.52-35.35 23.57-50.43 53.83-33.69zm-66.37 26.75c.65 43.45 31.32 95.35 68.5 115.93 37.18 20.57 66.8 2.03 66.15-41.42-.65-43.45-31.31-95.35-68.5-115.92-37.18-20.58-66.8-2.04-66.15 41.41",
    clipPath: "url(#clipPath891)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient896)",
    d: "M2845.45 2444.63c1.71 1.02 4.04 2.32 5.71 3.4 2.06 1.33 4.75 3.19 6.73 4.64 3.47 2.54 7.86 6.25 11.01 9.17 5.55 5.13 9.65 9.81 11 11.34 4.62 5.27 7.89 9.75 9.85 12.43.72.98 4.5 6.22 8.68 13.29 2.69 4.54 5.19 9.23 7.43 13.96 6.38 13.38 9.29 23.72 10.69 29.01.57 2.16 2.01 7.91 3 14.61 1.09 7.43 1.23 12.65 1.28 14.36.11 4.75-.07 9.18-.55 13.56-.25 2.18-.72 5.06-1.13 7.21-.29 1.53-.82 3.53-1.21 5.04-.54 2.13-1.56 4.89-2.33 6.95-.47 1.25-1.25 2.86-1.8 4.07-.93 2.08-2.44 4.74-3.78 6.58-1.37 1.89-3.3 4.35-4.82 6.13-.8.93-2 2.03-2.88 2.87l-2.8 2.36c-1.5 1.1-3.57 2.5-5.15 3.48-13.57 7.87-32.19 7.03-52.85-4.4-42.4-23.46-77.37-82.65-78.12-132.2-.38-25.59 8.45-43.61 22.92-51.81.96-.5 2.23-1.21 3.22-1.66 1.24-.56 2.92-1.25 4.2-1.72 2.1-.75 5.02-1.43 7.21-1.9 1.78-.4 4.21-.63 6.03-.74 2.03-.11 4.75-.13 6.78.01 1.35.09 3.16.22 4.5.45 2.64.45 6.19 1.02 8.75 1.82 3.17 1 7.36 2.45 10.43 3.73 2.47 1.03 5.64 2.7 8 3.96 1.8.99 2.93 3.17 2.98 6.28-37.18-20.58-66.8-2.04-66.15 41.41.65 43.45 31.32 95.35 68.5 115.93 37.18 20.57 66.8 2.03 66.15-41.42-.65-43.45-31.31-95.35-68.5-115.92-.05-3.11-1.18-5.29-2.98-6.28",
    clipPath: "url(#clipPath896)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient906)",
    d: "M2801.45 2481.76c-.63 2.15-1.26 4.3-1.88 6.46-.82 2.83-1.71 5.65-2.4 8.51 2.82.95 5.72 2.24 8.7 3.9 25.57 14.24 46.59 49.82 46.95 79.45.05 4.22-.33 8.08-1.08 11.58 3.23.33 6.4 1.16 9.55 1.98 1.74.45 3.5.86 5.25 1.25l2.13-1.24c1.58-.92 3.05-2.04 4.39-3.35l4.96-2.88c8.42-4.89 13.55-15.4 13.37-30.31-.36-29.32-21.16-64.51-46.46-78.61-12.44-6.93-23.65-7.47-31.79-2.74-1.24.71-2.4 1.55-3.49 2.51-2.35.52-4.55 1.36-6.56 2.53l-1.64.96",
    clipPath: "url(#clipPath906)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient916)",
    d: "M2798.33 2497.14c2.45.91 4.97 2.05 7.54 3.49 25.57 14.24 46.59 49.82 46.95 79.45.05 4.13-.32 7.91-1.03 11.35 2.71.32 5.42 1.34 7.92 2.07 1.74.5 3.5.98 5.28 1.43 8.23-4.96 13.24-15.39 13.06-30.12-.36-29.32-21.16-64.52-46.45-78.61-12.44-6.94-23.66-7.47-31.8-2.74l-1.09.71c-.32 4.32-.52 8.64-.38 12.97",
    clipPath: "url(#clipPath916)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient930)",
    d: "M2853.54 2551.18c4.17-.84 10.29 1.05 15.92 4.19 3.07 1.71 6 3.8 8.38 6l3.67-2.13c-2.36-2.2-5.29-4.28-8.37-5.99-7.71-4.3-16.35-6.28-19.6-2.07",
    clipPath: "url(#clipPath930)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient940)",
    d: "M2832.31 2559.88c7.76 4.33 14.46 20.12 16.68 31.69 1.25-.52 2.54-.88 3.87-1.07-2.01-11.65-8.88-28.29-16.87-32.74-3.7-2.06-7.09-1.2-9.84 1.26 1.9-.54 3.98-.35 6.16.86",
    clipPath: "url(#clipPath940)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient950)",
    d: "M2823.89 2479.42l-3.68 2.13c4.88 10.3 7.91 27.6 3.82 33.6l1.14-.17c7.56-2.17 4.39-23.6-1.28-35.56",
    clipPath: "url(#clipPath950)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient960)",
    d: "M2870.61 2532.79l-.8.75c1.81-.72 3.35-1.68 4.48-2.87l-3.68 2.12",
    clipPath: "url(#clipPath960)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient970)",
    d: "M2796.53 2514.8c8.12 5.03 16.75 13.4 18.82 21.6 1.58 6.23-.93 11.13-4.96 14.19 5.99-2.55 10.66-8.34 8.64-16.31-2.24-8.87-12.16-17.97-20.81-22.79l-1.98-1.03c.15 1.44.24 2.89.29 4.34",
    clipPath: "url(#clipPath970)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient981)",
    d: "M2797.04 2510.86l1.18.63c8.65 4.82 18.57 13.92 20.81 22.79 2.13 8.36-3.13 14.33-9.54 16.66 1.24 2.85 2.78 5.57 4.55 8.16 2.02 2.96 4.54 5.31 7.1 7.72 2.79-7.29 8.34-12.69 14.85-9.06 9.44 5.26 17.33 27.54 17.46 38.49 7.06.65 13.21-1.17 17.96-5.17-9.03-8.4-21.61-29.32-18.82-38.1 2.06-6.48 11.9-4.55 20.54.27 3.09 1.71 6.01 3.79 8.38 5.99-.63-9.33-3.2-19.13-7.22-28.57-4.2 4.43-14.14 5.93-22.03 1.53-2.38-1.32-4.56-3.18-6.36-5.66-7.71-10.7-5.02-28.84.42-34.62-2.91-2.46-5.93-4.67-9.03-6.57l-.22-.13-.36-.22-.33-.2-.16-.09-.49-.28-.12-.07-.53-.3-.51-.29-.14-.06-.47-.26-.18-.1-.3-.15-.48-.25-.09-.04c-3.1-1.56-6.11-2.71-9.02-3.49 5.67 11.96 8.84 33.39 1.28 35.56-1.76.51-3.93-.06-6.31-1.39-7.76-4.32-17.68-16.68-22.15-25.84-.65 7.67-.21 15.42.33 23.11",
    clipPath: "url(#clipPath981)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient991)",
    d: "M2835.86 2547.55c-4.88-2.72-8.88-9.51-8.96-15.16-.06-5.66 3.83-8.05 8.71-5.33 4.89 2.73 8.9 9.52 8.97 15.17.06 5.66-3.83 8.04-8.72 5.32",
    clipPath: "url(#clipPath991)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1002)",
    d: "M2834.45 2545.37c3.48 1.93 6.25.24 6.2-3.77-.05-4.01-2.9-8.84-6.38-10.77-3.45-1.93-6.23-.24-6.18 3.77.05 4.01 2.9 8.84 6.36 10.77",
    clipPath: "url(#clipPath1002)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1016)",
    d: "M2843.16 2591.8c13.69 7.62 26.01 8.21 34.97 3.01l3.13-1.82c-8.95 5.2-21.28 4.61-34.96-3.01-27.82-15.51-50.69-54.22-51.09-86.46-.2-16.39 5.44-27.95 14.69-33.33l-3.13 1.82c-9.25 5.38-14.89 16.94-14.69 33.33.39 32.24 23.26 70.95 51.08 86.46",
    clipPath: "url(#clipPath1016)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e4",
    d: "M2799.78 2506.06c-.36-29.32 19.85-41.66 45.15-27.56 25.3 14.09 46.1 49.29 46.46 78.61.35 29.33-19.86 41.67-45.16 27.57-25.3-14.1-46.09-49.29-46.45-78.62zm46.52 83.92c27.82 15.5 50.05 1.92 49.65-30.32-.39-32.25-23.26-70.95-51.08-86.46-27.82-15.5-50.06-1.93-49.66 30.32.4 32.24 23.27 70.95 51.09 86.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M3014.32 2778.29v-39.61l-6.6-55.34-14.21-29.75-60.42-68.82v23.93c-.07 34.12-13.73 56.8-35.1 64.64l46.4 62.43 25.46 54.38 11.86 10.06 19.08 22.54 13.53-44.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1650.61 2376.95v-1.65s.05-2.5.2-6.59l2.42-27.91c.14-3.31 4.48-35.1 4.54-35.59l.22-1.11c2.01-8.52 13.61-32.14 15.48-37.48l.27-.83.14-.34 49.84-43.26 124.05-72.66 98.02-36.7 82.45-16.94 75.39 5.61v28.31c-.14 32.82 12.35 69.5 32.25 101.06 8.27 13.25 17.9 25.52 28.45 36.28 10.6 10.89 22.2 20.18 34.34 27.2 18.92 10.94 36.62 14.83 51.54 12.41 26.41-4.23 43.97-28.17 44.03-66.88v-33.7l448.23 258.65v33.79c-.13 43 21.3 92.6 52.58 128.61 12.77 14.69 27.19 27.18 42.46 35.98 11.59 6.66 22.69 10.75 32.93 12.28 10.07 1.6 19.37.77 27.47-2.15 13.89 18.74 40.18 54.24 46.48 62.43 8.4 10.96 24.43 51.74 25.39 54.24l.07.14 11.86 10.07 19.09 22.54s-.7 7.69-1.2 15.67c-.42 6.24-.61 12.69-.33 15.67.06.98.2 2.01.2 2.99.13 2.91.13 5.69.08 7.76 0 2.16-.14 3.61-.14 3.61l-6.32 11.86-5 5.05-3.48 3.49-29.3 29.57-65.88 48.57-119.98 69.59-83.34 35.16-1.97.83-19.36 4.93-6.02 1.53h-20.04l-96.77-42.45-100.46-8.46s-54.16-18.87-92.03-37.68c-37.88-18.73-95.38-50.84-138.74-77.4-43.34-26.63-97.18-64.37-112.02-75.53-14.83-11.18-146.12-120.5-221.55-204.54-9.99-7.8-23-16.44-31.07-22.72-42.88-33.31-62.96-51.86-79-66.16-16.51-14.69-42.95-37.23-49.8-43.07h-.08c-1.03-.9-1.58-1.4-1.58-1.4l-18.74-18.86-25.52-33.99-9.22-37.08-5.36 6.66-.41-.9c-.5-1.05-1.12-2.56-1.81-4.45l-.08-.2 3.47-4.75c-.75-2.42-5.69-2.81-6.17-5.93-.14-.98-.28-1.95-.36-2.92-.76-7.41-.81-16.57-.81-20.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M1650.61 2376.95v-1.65s.05-2.5.2-6.59l2.42-27.91c.14-3.31 4.48-35.1 4.54-35.59l.22-1.11c2.01-8.52 13.61-32.14 15.48-37.48l.27-.83.14-.34 49.84-43.26 124.05-72.66s297.8 212.34 510.94 342.4c334.31 204.01 640.39 360.36 640.56 362.17.06.98.2 2.01.2 2.99.13 2.91.13 5.69.08 7.76 0 2.16-.14 3.61-.14 3.61l-6.32 11.86-5 5.05-3.48 3.49-29.3 29.57-65.88 48.57-119.98 69.59-83.34 35.16-1.97.83-19.36 4.93-6.02 1.53h-20.04l-96.77-42.45-100.46-8.46s-54.16-18.87-92.03-37.68c-37.88-18.73-95.38-50.84-138.74-77.4-43.34-26.63-97.18-64.37-112.02-75.53-14.83-11.18-146.12-120.5-221.55-204.54-9.99-7.8-23-16.44-31.07-22.72-42.88-33.31-62.96-51.86-79-66.16-16.51-14.69-42.95-37.23-49.8-43.07h-.08c-1.03-.9-1.58-1.4-1.58-1.4l-18.74-18.86-25.52-33.99-9.22-37.08-5.36 6.66-.41-.9c-.5-1.05-1.12-2.56-1.81-4.45l-.08-.2 3.47-4.75c-.75-2.42-5.69-2.81-6.17-5.93-.14-.98-.28-1.95-.36-2.92-.76-7.41-.81-16.57-.81-20.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M2135.88 2230.87c-19.9-31.56-32.39-68.25-32.25-101.07v-28.3l-75.4-5.61-82.43 16.94-98.02 36.7-124.06 72.66-49.83 43.25-.14.35c-1.18 2.98-13.47 26.03-15.76 38.31l-.21 1.11c-.07.48-6.76 55.38-6.97 63.49-.14 4.09-.21 6.59-.21 6.59v1.67c.14 3.95.42 13.87.83 20.25.07.97.21 1.95.35 2.92.83 6.45 2.77 10.89 2.77 10.89l2.22 5.34 7.22.75-1.85-7.42 2.35-14.93 4.16-21.22 2.49-3.33 3.61.41 16.71 7.35 3.96 10.41-.76 4.78-4.93 13.11 7.22 1.19 10.61-3.06 42.73-33.78 117.61-68.49 60.34-26.15 13.25-10.82.56-4.23-17.06-4.03-3.47-12.2 15.07-31.73 23.25-8.04 58.41 1.75 32.19 10.19 10.61 7.14 16.29 16.29 33.3-5.34 25.24-4.09",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2142.41 2256.19c5.13 2.42 13.24 6.52 21.92 10.95-10.55-10.74-20.19-23.02-28.45-36.27-19.9-31.56-32.39-68.25-32.25-101.07v-28.3l-75.4-5.61-82.43 16.94-98.02 36.7-124.06 72.66-49.83 43.25-.14.35-.28.83c-1.87 5.34-13.47 28.95-15.48 37.48l-.21 1.11-6.97 63.49c-.14 4.09-.21 6.59-.21 6.59v1.67c0 3.67.07 12.83.83 20.25 0 0 11.1-51.19 17.2-63.33 6.04-12.14 55.78-53.57 55.78-53.57l121.22-67.94s55.49-16.92 84.97-19.07c29.48-2.15 82.58-11.12 106.44-4.61 15.4 4.24 48 27.96 73.6 46.27 14.08 10.06 26.08 18.59 31.77 21.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M2142.41 2256.19c-5.69-2.64-17.69-11.17-31.77-21.23-25.6-18.31-58.2-42.03-73.6-46.27-23.86-6.51-76.96 2.46-106.44 4.61-29.48 2.15-84.97 19.07-84.97 19.07l-121.22 67.94s-49.74 41.43-55.78 53.57c-6.1 12.14-17.2 63.33-17.2 63.33-.76-7.42-.83-16.58-.83-20.25v-1.67s.07-2.5.21-6.59l6.97-63.49.21-1.11c.24-.99 7.79-13.8 8.15-15.1l-.35 13.02 2.75 8.52 4.45 3.76 3.76-1.78 45.1-40.46 119-66.76 73.5-29.77 13.89-11.27 39.2-40.75 16.68-15.05 44.11-12.57 75.4 5.61v28.3c-.14 32.82 12.35 69.51 32.25 101.07 8.26 13.25 17.9 25.53 28.45 36.27-8.68-4.43-16.79-8.53-21.92-10.95",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M2774.66 2614.38s8.4 5.28 20.39 12.84c-31.28-36-52.71-85.6-52.57-128.61v-33.78l-448.24-258.66v33.71c-.07 38.71-11.33 80.27-24.73 87.79 17 1.3 25.94 8.75 25.94 8.75l268.34 157.89 210.87 120.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M2969.79 2790.01c-.98-2.5-17-43.28-25.4-54.24-6.3-8.19-32.59-43.7-46.47-62.43-8.12 2.91-17.41 3.75-27.47 2.15l2.02 1.32c19.62 13.32 69.36 68.81 69.36 68.81l27.96 44.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2535.87 2546.77s.44 4.2-5.49 4.63c-5.92.43-36.27-17.49-37.28-18.64-1.02-1.16-5.06-9.54-4.92-13.3.15-3.76.44-10.69 1.45-12.79 1.01-2.09 7.95-3.25 7.95-3.25s15.32 2.53 22.83 11.06c7.51 8.52 9.83 19.72 9.83 19.72l5.63 12.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2771.71 2682.93s.43 4.2-5.49 4.63c-5.93.43-36.27-17.49-37.28-18.64-1.02-1.16-5.06-9.54-4.92-13.3.15-3.75.44-10.69 1.45-12.79 1.01-2.09 7.95-3.25 7.95-3.25s15.32 2.53 22.83 11.06c7.51 8.53 9.82 19.72 9.82 19.72l5.64 12.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M2999.47 2857.09l-57.64-50.08s-119.65-63.4-153.92-81.92c-34.27-18.52-155.24-93.37-218.08-133.67-62.85-40.3-300.83-195.54-346.41-223.7-45.5-28.16-98.7-78.73-98.7-78.73l-5.48-8.39-177.19-19.67-.56 4.23-10.4 8.53s41.68 24.28 53.69 27.54c12.07 3.26 84.14 39.88 84.14 39.88 36.41 20.81 146.49 84.56 146.49 84.56l23.31 5.7 18 8.83 75.95 119.45 62.92 88.79 87.12 74.56 107.65 61.74 82.34 34.06 68.8 15.88 130.97-1.18s24.2 4.1 32.95 5.14c8.66.97 87.67 41.68 87.67 41.68l6.31-11.86s.35-5.48.07-11.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M2115.23 2307.47h12.69l76.88 58.53 7.58 46.67 3.04 13-42.92 12.58-75.43 31.21-62 30.35s-77.83 47.76-93 59.03c-15.18 11.27-38.15 29.05-38.15 29.05l-28.4 29.91-2.38 4.55-2.15 1.81c-51.15-39.42-87.19-65.16-103.91-80.06-19.05-16.97-51.36-44.36-51.46-44.45l-14.45-27.73-11.41-53.18v-12.43l7.22 1.16 10.55-3.04 42.77-33.81 117.57-68.5 60.37-26.1 13.22-10.86.62-4.22s96.64 12.16 107.52 17.05c10.88 4.88 65.63 29.48 65.63 29.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1707.53 2404.43s9.01 38.71 19.94 59.25c10.93 20.53 69.37 85.4 82.37 99.27 13.01 13.88 61.14 61.21 61.14 61.21s-10.75-8.27-13.13-10.09c-2.39-1.82-62.46-61.52-76.91-76.26-14.45-14.74-48.26-53.76-57.51-70.52-9.26-16.76-20.67-61.49-20.67-61.49l4.77-1.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1e1e",
    d: "M1984.12 2108.46l-16.68 15.05-39.2 40.75-13.89 11.27-73.5 29.77-119 66.76-45.1 40.46-3.76 1.77-4.45-3.75-2.75-8.52.21-13.22 7.88-23.35 49.84-43.24 124.06-72.69 97.98-36.71 38.36-4.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14191f",
    d: "M1958.4 2116.61l-39.2 40.75-13.89 11.27-73.5 29.77-119 66.76-45.1 40.46-.66.31 1.49 4.61 4.45 3.75 3.76-1.77 45.1-40.46 119-66.76 73.5-29.77 13.89-11.27 39.2-40.75 16.68-15.05-19.09 2.16-6.63 5.99",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M1875.52 2617.8s49.84 56.82 122.47 124.53c71.04 66.22 85.62 75.98 87.79 75.33 2.17-.65 84.55-45.37 122.7-67.48 38.15-22.11 160.45-90.41 173.63-103.91v-8.23s-41.18-60.92-80.2-124.21c-39.01-63.3-46.85-70.42-48.58-71.29-.77-.38-11.57-6.82-22.92-9.54-14.12-3.39-29.29-3.14-29.29-3.14l-28.63 8.39-75.42 31.21-62 30.35-93 59.03-38.15 29.04-28.4 29.92",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M2741.51 2843.53l122.69-2.83 3.02 17.59-8.66 16.67-59.62 47.1-111.71 66.33-92.7 34.97s-34.5 10.39-68.21 8.56c-33.71-1.82-79.55-7.42-79.55-7.42l-6.29-3.37 83.67-39.31 117.21-67.99 88.88-58.82 11.27-11.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M3000.79 2822.75l-19.08-22.54-11.79-9.99c.76 1.46 13.6 24.28 29.69 48.21.49-7.98 1.18-15.68 1.18-15.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2741.51 2843.53s-59.4-13.87-71.1-17.34c-11.7-3.47-90.17-39.89-90.17-39.89l-107.23-63.73-79.19-65.46-11.71-19.07-8.61 15 12.52 12.31 84.1 68.5 105.35 61.99 92.34 38.87 66.82 15.83 6.88-7.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2082.7 2816.49s6.33 6.66 17.9 15.33c11.55 8.67 134.25 88.88 168.2 108.96 33.95 20.08 88.44 50.58 115.32 62.14 26.88 11.56 56.36 18.21 56.36 18.21l5.02-2.37s-42.88-11.22-57.62-18.44c-14.75-7.23-117.34-64.16-117.34-64.16s-156.94-99.13-165.9-106.36c-8.96-7.23-16.42-13.31-16.42-13.31h-5.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M1893.95 2624.16s36.85-29.56 102.74-72.04c65.9-42.49 129.85-72.69 129.85-72.69s85.04-37.72 88.87-37.72c3.84 0 26.66 2.87 26.66 2.87s62.01 100.79 81.52 128.1c19.51 27.31 46.39 67.52 46.39 67.52l-6.94 7.37s-74.36 41.48-111.21 63.59c-36.85 22.11-110.34 65.75-112.07 66.61-1.74.87-52.46 30.78-52.46 30.78h-10.41s-85.4-77.39-176.88-171.9c-6.93-8.23-6.93-9.64-6.93-9.64l.87-2.85",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M1963.43 2662.8l-.63 11.37 7.58 23.14 41.72 46.9 68.84 64.34h6.36s50.72-29.91 52.46-30.78l-176.33-114.97",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M2077.63 2580.05l-121.96 70.72-25.83 4.85-18.6-7.49c-3.73-3.78-7.47-7.59-11.23-11.47-6.93-8.24-6.93-9.65-6.93-9.65l.87-2.85s36.85-29.56 102.74-72.04c65.9-42.49 129.85-72.69 129.85-72.69s85.04-37.71 88.87-37.71c3.84-.01 26.66 2.86 26.66 2.86s7.33 11.86 10.44 16.92l-69.6 26.62-96.18 49.8-9.1 42.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M2858.85 2863.54s0-9.25-2.6-11.27c-2.6-2.03-83.53 6-110.69 1.88-35.71 26.41-51.98 35.8-51.98 35.8l-60.82 37.9-100.37 57.73-79.77 36.99s7.66-1.77 14.88.11c7.23 1.88 27.1 5.39 48.55 7.51 21.46 2.13 59.97-3.93 74.79-7.48 14.82-3.55 86.05-32.08 90.39-34.68 4.34-2.6 101.67-58.82 108.39-63.37 6.72-4.55 66.12-53.61 66.12-53.61l3.11-7.51",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M2539.05 2542.66s-31.64-16.69-33.38-20.59c-1.73-3.91-.87-6.73-3.9-9.55-3.03-2.81-12.14-5.85-12.14-5.85s-3.55 10.19-2.86 12.36 4.81 7.8 6.11 8.45c1.3.65 32.74 19.29 39.45 21.03 6.72 1.73 6.72-5.85 6.72-5.85",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M2774.89 2678.82s-31.65-16.69-33.38-20.6c-1.73-3.9-.87-6.72-3.9-9.53-3.03-2.82-12.14-5.86-12.14-5.86s-3.55 10.19-2.86 12.36 4.81 7.8 6.11 8.45c1.3.65 32.73 19.29 39.45 21.03 6.72 1.74 6.72-5.85 6.72-5.85",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2566.01 2380.53l-1.51 23.44-2.47 24.49.04 65.5-21.27 100.6-16.87 139.53-57.02-36.24-54.63-46.53-72.45-99.35-57.92-101.35-3.19-23.19-1.95-26.65 20.41-64.21 8.42-102.62c-.03-1.25.35-4.16 1.7-5.16.24-.18.97-.71 2.78-.15zm-260.77-154.52c-3.15 2.32-3.12 7.44-3.1 7.84l-8.34 102.04-20.54 64.47 2.01 27.43 3.25 23.63 58.4 102.43 72.83 99.81 55.11 46.96 61.85 39.35 17.51-144.84 21.28-100.81-.01-65.69 2.46-24.38 1.66-25.62-257.93-153.07-.33-.16c-1.02-.33-1.92-.47-2.7-.47-1.55 0-2.66.52-3.41 1.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2707.8 2478.03c1.95 3.84 24.34 48.02 28.69 56.73 4.52 9.03 15.31 28.69 15.34 28.71l21.16 51.39 9.93 70.48-2.58 27.08-4.1 11.09-9.84 8.66-10.62 6.47-55.27 68.3-51.97-10.75-64.83-27.21-56.53-32.88 17.04-140.97 21.28-100.81-.01-65.72 3.82-46.09 104.6 63.34zm-145.77-49.57l.04 65.5-21.27 100.6-17.2 142.26-.14 1.13 58.71 34.13 65.34 27.41 54.37 11.27 55.96-69.31 10.61-6.49 10.4-9.13 4.82-12.41 2.69-28.16-9.97-71.1-21.44-52.18c-.11-.2-10.87-19.8-15.36-28.77-4.55-9.1-28.83-57.02-28.83-57.02l-34.6-32.99-109.85-66.55-4.28 51.81",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M2770.94 2730.47l21.29 13.56 8.67 16.04v29.48c0 4.33-29.96 9.1-29.96 9.1l-69.75 10.2 55.49-68.72 14.26-9.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M2276.99 2427.55l493.95 302.92-14.26 9.66-55.49 68.72-53.32-11.06-65.03-27.31-57.52-33.45-59.53-37.86-54.92-46.83-72.55-99.51-58.08-101.65-3.25-23.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M2321.86 2465.56l397.9 243.34-11.49 61.63-23.69 28.39-37.58-7.85-65.9-28.32-108.09-68.21-57.22-48.55-71.72-98.46-21.24-41.25-3.94-27.09 2.97-13.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M2509.62 2717.64l9.7-131.32 45.22 27.65-22.77 123.96-32.15-20.29",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M2769.25 2740.7l10.99 6.94 8.09 30.64-8.09 8.71-57.52 15.07 46.53-61.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2562.91 3035.42l9.63-4.71 25.82-5.28 91.58-33.41 113.95-69.11 66.12-54.92 2.78-15.42 4.13-5 15.77-7.19 19.4 5.98c26.18 14.91 65.59 37.3 69.15 39.03.93.03 4 .02 6.75-.02h.1l-3.48 3.49c-1.69.02-3.43.02-3.99-.04-.46-.06-1.33-.16-70.07-39.36l-17.62-5.39-13.84 6.32-3.05 3.67-2.85 15.79-67.39 55.96-114.34 69.35-92.27 33.65-25.73 5.26-3.58 1.76 10.54 6.94 78.14 31.92 4.08.83 21.5-2.94-19.36 4.92-6.73.72-.4-.16-78.99-32.31-15.75-10.33",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70c02",
    d: "M3000.8 2822.74l-8.43-17.74-22.51-14.86-15.06 7.63-12.96 9.23v12.62l36.55 26.43 21.16 18.8c.06-2.08.06-4.85-.07-7.77 0-.97-.14-2.01-.21-2.98-.28-2.98-.07-9.43.34-15.68.49-7.98 1.19-15.68 1.19-15.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1724.41 2280.31l121.22-67.94s71.76-26.32 101.24-28.46c29.48-2.15 66.31-1.73 90.17 4.78 15.4 4.24 48 27.96 73.6 46.27l-33.3 5.34-16.29-16.29-10.61-7.14-32.19-10.19-58.41-1.75-27.85 6.96-10.43 3.5-.04 29.31 3.47 12.2 17.06 4.03-.56 4.23-13.25 10.82-60.34 26.15-117.61 68.49-42.73 33.78-10.61 3.06-7.22-1.19 3.99-12.54 1.7-5.35-3.96-10.41-16.71-7.35-3.61-.41-2.49 3.33-4.16 21.22-2.35 14.93 5.38 21.68-10.75-15.01-2.22-5.34s-1.94-4.44-2.77-10.89c-.14-.97-.28-1.95-.35-2.92 0 0 1.24-14.35 4.73-28.51 3.55-14.41 9.39-28.69 12.47-34.82 6.04-12.14 55.78-53.57 55.78-53.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M1695.42 2388.38s35.52-27.45 39.42-30.91c3.91-3.48 127.88-75.37 127.88-75.37l42.29-16.5 19.94-8.67 17.13 4-.62 4.23-10.38 8.52-2.84 2.34-60.37 26.1-117.57 68.5-42.77 33.81-4.77 1.37-5.78 1.67-7.22-1.16 5.66-17.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1657.99 2304.1c2.29-12.28 14.58-35.33 15.76-38.31l-.28.83c-1.87 5.34-13.47 28.95-15.48 37.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1915.69 2212.75l.31 14 .15 6.6.31 13.97-.58.98c-7.13 12.11-9.29 12.95-10.76 13.23-2.71.87-27.86 10.93-43.46 17.22l-96.66 55.72-29.97 19.27-29.08 24.46-6.46-.18-2.46-.12-2.62-3.94-6.07-9.23-9.97-15.05v-9.57l6.86-12.33 35.23-33.2 29.41-19.99 96.36-55.63 22.01-6.26 36-6.9 11.45 6.95",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M1682.34 2348.49v-7.35l6.12-10.98 34.58-32.52 28.94-19.68 95.81-55.31 21.37-6.09 34.32-6.57 8.28 5.03.27 11.82.15 6.61.28 12.83s-6.51 11.06-8.24 11.38c-1.73.34-44.31 17.52-44.31 17.52l-96.89 55.85-30.34 19.5-28.13 23.66-4.95-.14-.37-.02-1.51-2.27-3.7-5.62-2.36-3.59-3.72-5.6-5.6-8.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363b41",
    d: "M1699.23 2374.03l5.33.16.63-.61-10.8-22.46 3.06-8.33 7.74-8.64 25.45-24.62 37.85-25.58 93.11-53.76 20.78-5.9 29.37-6.96.11 1.47-.09-3.77-8.28-5.04-34.32 6.58-21.39 6.07-95.81 55.32-28.94 19.67-34.58 32.52-6.1 10.99v7.36l16.88 25.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1682.35 2348.5l12.04 2.62 10.8 22.46-.63.61-5.33-.16-16.88-25.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363b41",
    d: "M1701 2351.46l23.59-24.84 38.23-25.84 97.68-56.41 18.17-6.39 33.47-6.14-.11-5-.05-2.04-31.85 6.39-21.97 7.66-98.49 56.86-38.95 26.34-24.57 25.86-4.49 14.64 2.98.37 6.36-11.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363b41",
    d: "M1860.87 2250.49l-98.49 56.86-38.95 26.34-24.57 25.86-2.95 5.31.72 5.26 2.98.37 4.1-7.39 23.59-24.84 38.24-25.84 97.68-56.41 18.17-6.39 31.02-6.34-.15-6.99-29.42 6.55-21.97 7.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363b41",
    d: "M1885.56 2254.48l-21.97 7.65-98.5 56.86-38.94 26.34-24.57 25.86-.69 1.24 1.13 1.69 2.53.07 11.92-10.03 13.55-14.26 38.23-25.85 97.68-56.4 18.17-6.39 22.95-5.99c1.3-.81 4.08-5.01 5.98-8.04l-27.47 7.25",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M2018.76 2203.73l33.09 10.47 12.49 9.58 15.16 14.43 16.13 18.57 25.88 21.81 6.07 9.27 3.88 22.59h-16.87l-66.03-29.66-39.97-11.99-66.96-4.91-19.07-4.46-4.05-14.34.07-31.85 12.57-4.21 28.39-7.08 59.22 1.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M1928.24 2276.02l39.42 19.38s95.92 48.77 131.3 68.28c35.39 19.51 116.46 61.99 116.46 61.99l-3.04-13-7.58-46.68-76.88-58.52h-12.69l-65.63-29.48-40.46-12.14-67.06-4.92-.62 4.23-13.22 10.86",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M1928.24 2275.98l6.74-5.5s17.61 0 280.43 155.19l-183.84-97.5-103.33-52.19",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e6ea",
    d: "M2127.92 2307.47l-3.17-18.5-5.5-8.38-25.72-21.68-16.18-18.64-14.96-14.23-11.94-9.16-32.19-10.19-58.4-1.75-27.87 6.95-10.43 3.5-.08 29.29 3.47 12.25 17.13 4 67.06 4.92 40.46 12.14 65.63 29.48h12.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f5f6",
    d: "M2045.03 2226.69l-27.64-7.9h-47.67l-21.84 8.75-5.8 13.59v17.68s41.54-2.52 72.33 5.39c30.79 7.92 59.26 17.35 59.26 17.35l-17.42-34.97-11.22-19.89",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1694.1 2376.52l4.48 11.77-5.87 18.45v11.7l11.29 52.4 18.32 33.17h-6.16l-.91-.73-1.69-1.46-18.94-19.1-26.01-34.63-9.5-38.27 2.43-15.52 4.31-22.01 2.77-3.68 8.04-15.3 17.44 23.21",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e6ea",
    d: "M1689.73 2418.76v-12.49l5.69-17.89-3.96-10.41-14.36-19.11-5.96 11.35-2.49 3.33-4.16 21.22-2.35 14.93 9.21 37.09 25.53 33.99 18.73 18.87 1.59 1.39h.07l-16.09-29.14-11.45-53.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd52",
    d: "M1681.08 2436.78s1.43 13.06 3.54 18.89c2.12 5.84 13.37 23.07 13.99 23.94l13.18 12.68-10.62-20.37-20.09-35.14",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f5f6",
    d: "M1681.46 2438.54c2.54 11.28 11.55 31 22.79 39.29l.31.18-3.38-6.12-11.45-53.13v-12.49l5.69-17.89-3.96-10.41-2.05-2.73-2.69.65-9.96 31.58s2.17 19.79 4.7 31.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd52",
    d: "M2108.9 2298.48c3.5 1.56 9.65-3.4 3.2-14.2-.71-1.2-25.89-18.08-26.6-19.21-7.08-11.21-20.7-23.74-24.08-28.16-3.39-4.41-12.77-9.22-16.39-10.22-.77-.21 10.36 35.9 12.58 39.97 6.66 12.21 13.82 14.22 16.06 14.89 6.74 2.02 31.33 15.2 35.23 16.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M1668.54 2310.54l4.45 3.75 3.76-1.77.84-.76-1.4-1.18-2.71-8.43.21-13.07 7.79-23.09 49.29-42.79 122.73-71.89 96.91-36.31 30.26-3.44 3.45-3.1-38.36 4.35-97.98 36.71-124.06 72.69-49.84 43.24-7.88 23.35-.21 13.22 2.75 8.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1687.94 2356.95l5.23-9.42 24.57-25.86 38.94-26.33 98.5-56.86 21.97-7.66 34.8-6.98.16 6.61-33.61 6.17-20.98 7.37-97.68 56.41-38.23 25.84-23.6 24.85-6.35 11.46-3.72-5.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1879.86 2242.46l-21.96 7.65-98.5 56.87-38.95 26.34-24.57 25.85-2.95 5.32 1.09 1.65 2.61 3.98 4.1-7.39 23.6-24.85 38.23-25.84 97.68-56.41 20.97-7.37 31.17-6.37-.14-6.57-32.38 7.14",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272c32",
    d: "M1913.72 2246.12l-31.14 7.98-21.97 7.65-98.5 56.87-38.94 26.34-24.57 25.86-.69 1.24 1.32 1.97.37.02 4.04.12 23.4-24.65 38.23-25.84 97.68-56.4 20.98-7.38 24.76-6.32c1.63-2.05 3.71-5.32 5.03-7.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2742.46 2498.63l.02-33.8 6.58 3.79-.07 30.01c-.02 7.29.63 14.79 1.87 22.38.24 1.49.53 3.01.81 4.51.62 3.17 1.33 6.34 2.15 9.52.35 1.36.7 2.7 1.09 4.06l.46 1.58c.37 1.29.75 2.59 1.16 3.88.97 3.04 2.01 6.09 3.13 9.14.67 1.83 1.39 3.66 2.13 5.47.74 1.84 1.5 3.67 2.29 5.48.79 1.81 1.62 3.61 2.47 5.4.86 1.8 1.74 3.61 2.64 5.39 1.36 2.66 2.74 5.29 4.21 7.89.98 1.75 1.99 3.49 3.01 5.21 1.53 2.58 3.12 5.11 4.75 7.6l1.66 2.51c1.02 1.5 2.06 3 3.12 4.46l.56.81c1.07 1.48 2.15 2.94 3.26 4.38v.02c1.12 1.48 2.27 2.94 3.45 4.39 4.37 5.45 9 10.62 13.83 15.44 1.33 1.34 2.71 2.68 4.1 3.96l2.09 1.94c3.51 3.15 7.1 6.13 10.76 8.89 4.4 3.31 8.9 6.33 13.5 8.97 27.32 15.78 51.82 15.71 68.18 2.78 1.3-1.02 2.55-2.13 3.73-3.31l.88-.92 1.44-1.58 1.1-1.3c2.17-2.68 4.1-5.7 5.79-8.99.64-1.23 1.23-2.52 1.8-3.83 3.95-9.25 6.13-20.52 6.16-33.61l.06-22.18 6.5 3.75v25.99c-.17 60.51-42.99 84.9-95.64 54.5-52.66-30.39-95.21-104.07-95.03-164.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M2119.51 2199.99c.67 1.83 2.69-11.47 3.43-9.66.74 1.83 1.49 3.66 2.28 5.48.8 1.81 1.63 3.6 2.48 5.4.85 1.8 1.74 3.61 2.63 5.39 1.36 2.66 2.75 5.28 4.21 7.89.99 1.74 1.99 3.49 3.01 5.21 1.54 2.58 3.12 5.11 4.76 7.59l1.65 2.52c1.03 1.5 2.07 2.99 3.12 4.46l.57.81c1.07 1.47 2.14 2.94 3.25 4.38v.02a144.5 144.5 0 003.46 4.38c4.36 5.46 8.99 10.62 13.82 15.45 1.34 1.33 2.71 2.67 4.1 3.96l2.1 1.94c3.5 3.15 7.09 6.12 10.76 8.89 4.4 3.31 8.89 6.32 13.49 8.97 27.33 15.77 51.82 15.7 68.19 2.77 1.3-1.02 2.55-2.12 3.73-3.31l.88-.91 1.44-1.59 1.09-1.3c2.17-2.68 4.11-5.69 5.8-8.98a58.98 58.98 0 001.79-3.84c3.95-9.24 6.13-20.51 6.16-33.6l.06-20.99 6.5 2.56 12.52 7.89-10.34 28.79c-.2 68.45-38.3 111.02-97.86 76.63-37.49-21.65-70.45-66.99-89.68-114.7-.29-6.4 3.46-10.65 10.6-12.5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2103.6 2129.79l.03-28.29 6.58 3.79-.07 24.5c-.02 7.28.63 14.79 1.86 22.38.25 1.49.53 3.01.81 4.51.62 3.16 1.34 6.34 2.15 9.52.35 1.36.7 2.7 1.09 4.05l.46 1.59c.37 1.28.76 2.58 1.16 3.87.97 3.05 2.01 6.1 3.14 9.14.66 1.83 1.39 3.67 2.13 5.48.74 1.83 1.49 3.66 2.28 5.48.8 1.81 1.63 3.6 2.48 5.4.85 1.8 1.74 3.61 2.63 5.39 1.36 2.66 2.75 5.28 4.21 7.89.99 1.74 1.99 3.49 3.01 5.21 1.54 2.58 3.12 5.11 4.76 7.59l1.65 2.52c1.03 1.5 2.07 2.99 3.12 4.46l.57.81c1.07 1.47 2.14 2.94 3.25 4.38v.02a144.5 144.5 0 003.46 4.38c4.36 5.46 8.99 10.62 13.82 15.45 1.34 1.33 2.71 2.67 4.1 3.96l2.1 1.94c3.5 3.15 7.09 6.12 10.76 8.89 4.4 3.31 8.89 6.32 13.49 8.97 27.33 15.77 51.82 15.7 68.19 2.77 1.3-1.02 2.55-2.12 3.73-3.31l.88-.91 1.44-1.59 1.09-1.3c2.17-2.68 4.11-5.69 5.8-8.98a58.98 58.98 0 001.79-3.84c3.95-9.24 6.13-20.51 6.16-33.6l.06-29.89 6.5 3.75v33.69c-.16 60.52-42.99 84.91-95.64 54.51-52.66-30.4-95.2-104.08-95.03-164.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M2190.57 2727.54l13.56-7.83c7.6-4.38 15.07-9.29 22.4-14.69 2.39-1.76 3.71-5.35 3.07-8.34l-1.68-7.89c-.63-2.98-3.03-4.42-5.56-3.34-7.77 3.31-15.48 7.17-23.07 11.55l-13.56 7.83c-7.6 4.39-15.08 9.3-22.4 14.7-2.39 1.76-3.71 5.34-3.08 8.33l1.69 7.89c.63 2.99 3.03 4.43 5.56 3.35 7.77-3.31 15.47-7.17 23.07-11.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M2187.59 2717.48c.15 3.87.98 14.57.98 14.57l13.5-.28-1.67-15.72c-.76-2.47-4.05-5.2-5.47-5.05-3.31.34-7.51 2.3-7.34 6.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a434f",
    d: "M2189.71 2735.31c-2.07-2.84-1.23-6.6 1.87-8.4 3.1-1.8 7.29-.96 9.36 1.88 2.06 2.84 1.22 6.6-1.88 8.4-3.1 1.8-7.29.96-9.35-1.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2310.39 2457.7s-7.24 1.04-10.21 3.49c-2.99 2.45-.76 11.45 4.33 14.67 5.09 3.23 19.36-3.93 21.72-2.72 2.36 1.22 16.85-4.9 16.85-4.9l-4.7-10.35-27.99-.19",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2339.13 2495.26c-13.45 3.36-27.15-1.03-28.96-16.29-2.19-18.51 5.95-21.45 10.87-23.78 4.9-2.33 23.26-10.34 46.53-10.6 23.26-.26 26.1 12.17 26.11 20.45 0 1.19-.03 1.11-.09 2.2-.66 11.81-4.92 15.32-12.84 17.68-17.09 5.1-41.62 10.34-41.62 10.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M2315.45 2487.58c7.72 2.4 23.71-.72 39.41-4.13 15.71-3.41 27.51-3.15 28.75-18.41 1.24-15.26-3.7-18.97-10.23-19.97-6.51-1-18.89-.91-37.53 4.51-18.63 5.42-21.26 8.47-24.17 13.61-2.9 5.14-3.93 22 3.77 24.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161d1d",
    d: "M2126.38 2479.51c-2.23.98-26.93 12.02-64.16 33.29.02.04.05.07.07.11 35.45-19.73 61.78-32.31 64.09-33.4m197.21 93.17c19.51 27.31 46.39 67.52 46.39 67.52l-6.94 7.37s-73.2 40.83-110.34 63.07c37.14-22.24 110.34-63.06 110.34-63.06l6.94-7.38s-26.88-40.21-46.39-67.52m-71.76 138.48c-6.18 3.7-13.38 8.01-21.11 12.63l.21-.09c7.31-4.39 14.43-8.66 20.9-12.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M2215.42 2441.72h-.01c-3.83 0-88.87 37.71-88.87 37.71s-.05.03-.16.08c-2.31 1.09-28.64 13.67-64.09 33.4 37.12-20.66 64.25-33.48 64.25-33.48s85.04-37.71 88.87-37.71h.01c3.48 0 22.35 2.32 26.03 2.78-3.68-.46-22.55-2.78-26.03-2.78m33.12 13.33c1.5 2.44 2.96 4.8 3.97 6.45l-69.6 26.62-96.18 49.8-1.75 8.13c46.68 69.14 69.81 108.81 111.73 152.45l2.58-1.5c7.59-4.38 15.3-8.24 23.07-11.55a4.3 4.3 0 011.67-.36c1.85 0 3.4 1.39 3.89 3.7l1.68 7.89c.64 2.99-.68 6.58-3.07 8.34-4.54 3.35-9.14 6.51-13.79 9.47a651.4 651.4 0 0012.52 11.67l5.46-2.37c7.73-4.62 14.93-8.93 21.11-12.63.29-.18.58-.35.87-.52 37.14-22.24 110.34-63.07 110.34-63.07l6.94-7.37s-26.88-40.21-46.39-67.52c-15.65-21.91-58.66-91.13-75.05-117.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303942",
    d: "M2215.42 2441.72h-.01c-3.83 0-88.87 37.71-88.87 37.71s-27.13 12.82-64.25 33.48c8.19 11.79 15.7 22.79 22.69 33.14l1.75-8.13 96.18-49.8 69.6-26.62c-1.01-1.65-2.47-4.01-3.97-6.45-4.04-6.54-6.47-10.47-6.47-10.47s-.22-.03-.62-.08c-3.68-.46-22.55-2.78-26.03-2.78",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a444d",
    d: "M2224.03 2685.09c-.54 0-1.1.12-1.67.36-7.77 3.31-15.48 7.17-23.07 11.55l-2.58 1.5c5.04 5.25 10.36 10.56 16.03 15.99 4.65-2.96 9.25-6.12 13.79-9.47 2.39-1.76 3.71-5.35 3.07-8.34l-1.68-7.89c-.49-2.31-2.04-3.7-3.89-3.7",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M2203.2 2366.96l7.49 46.11 2.66 11.4-41.51 12.18-75.54 31.26-62.14 30.42c-3.18 1.95-78.06 47.93-93.12 59.12-15.02 11.15-37.95 28.89-38.38 29.24l-28.39 29.92-2.51 4.64-.82.68c-19.09-14.71-35.87-27.35-50.7-38.52-24.22-18.25-41.73-31.45-52.01-40.6-17.98-16.02-47.99-41.51-51.23-44.26l-14.18-27.22-11.31-52.67 1.26-10.12 4.32.7 10.92-3.15 43.17-33.98 117.37-68.4 60.37-26.1 14.16-11.53.49-3.39c7.2.11 38.73.84 65.31 4.87 18.12 2.76 34.02 9.32 40.01 12.01l65.63 29.48 12.82.15zm-263.36-102.71l-12.52 10.27-60.32 26.1-117.77 68.64-42.5 33.6-9.85 2.83-7.11-1.13-1.77 14.25 11.47 53.47 14.61 28.17.42.53c.27.23 32.37 27.44 51.42 44.42 10.39 9.25 27.94 22.48 52.23 40.78 15.12 11.38 32.24 24.29 51.78 39.35l1.1.85 3.22-2.7 2.7-4.86 28.03-29.56c.23-.18 23.14-17.89 38.12-29.03 14.94-11.09 92.1-58.47 92.73-58.86l61.89-30.31 75.26-31.15 44.5-13.03-3.39-14.49-7.68-47.36-77.9-59.29h-12.91l-65.29-29.33c-6.12-2.75-22.37-9.46-40.91-12.27-30.3-4.61-66.94-4.94-67.31-4.94l-1.51-.01-.74 5.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e42",
    d: "M2879.95 2802.09l-.06-.03c-6.8-3.94-10.42-11.85-9.2-20.12l.51-3.49c2.06-13.99 17.13-22.14 28.63-15.49 6.84 3.95 10.48 11.9 9.25 20.22l-.5 3.41c-2.06 14-17.13 22.15-28.63 15.5",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676a68",
    d: "M3585.29 2131.87c0-5.24 1.05-9.67 2.8-13.05 4.89-9.09 15.39-11.19 27.51-4.2 16.67 9.56 30.3 32.99 30.3 52.23 0 13.75-7.11 21.68-17.36 21.32-3.96-.11-8.28-1.39-12.94-4.08-16.67-9.68-30.31-33.09-30.31-52.22",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M3627.17 2189.4l-2.45-1.63c3.8 2.18 7.32 3.53 10.85 3.8v.28l-.27 1.35c-2.72-1.08-5.43-2.16-8.13-3.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M3582.18 2111.9c0-2.97.27-5.95.82-8.67 2.43.82 5.14 2.17 7.85 3.53-2.71 4.33-4.33 10.03-4.33 17.07 0 2.98.27 5.96.81 8.94.27 2.98 1.09 6.23 2.17 9.21.81 2.99 1.89 5.97 3.25 8.95-6.77-12.74-10.57-26.56-10.57-39.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1100)",
    d: "M3586.52 2123.83c0 8.67 2.17 18.15 6.23 27.1.81 1.63 1.36 3.25 2.44 4.87 6.24 10.58 14.09 20.05 22.76 27.37 1.9 1.36 3.8 2.98 5.69 3.8l.81.54.27.26c8.14 4.35 15.18 5.16 21.14 3.27 3.26-3.53 5.15-8.95 5.69-15.73.27-1.08.27-2.43.27-3.79 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.97zm-38.56-54.58c2.14-1.2 6.31-3.95 6.31-3.95l24.12-13.82 2.98 5.41 13.28 23.32c1.08.53 1.89 1.07 2.7 1.62 33.61 22.76 60.44 68.82 63.96 108.93v.28c.27 2.16.27 4.59.27 6.76l9.75 17.62 4.89 8.67-23.04 13.27s-4.62 2.54-6.93 3.66c-9.35 4.55-23.2 1.53-42.12-9.34-38.75-22.22-70.18-76.69-70.18-121.4 0-22.29 4.67-35.77 14.01-41.03",
    clipPath: "url(#clipPath1100)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1105)",
    d: "M3592.75 2150.93c.81 1.63 1.36 3.25 2.44 4.87 6.24 10.58 14.09 20.05 22.76 27.37 2.17 1.63 4.61 3.26 6.77 4.6 8.14 4.35 15.18 5.16 21.14 3.27 3.8-4.34 5.96-11.12 5.96-19.52 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.97 0 8.67 2.17 18.15 6.23 27.1zm-36.04-53.65c0-12.2 2.44-22.5 6.5-30.36 11.38-21.13 35.77-26.01 63.96-9.75 38.74 22.21 70.45 76.69 70.45 121.39 0 31.99-16.53 50.4-40.38 49.59-9.21-.26-19.24-3.25-30.07-9.48-38.75-22.49-70.46-76.95-70.46-121.39",
    clipPath: "url(#clipPath1105)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1110)",
    d: "M3591.94 2104.84c-3.23 4.37-5.44 10.84-5.44 19.01 0 8.64 2.21 18.11 6.24 27.08.84 1.64 1.36 3.23 2.44 4.88 6.24 10.56 14.08 20.03 22.76 27.35 1.92 1.36 3.8 2.73 5.73 3.8l.79.57.29.23c8.11 4.37 15.15 5.16 21.11 3.28 3.24-3.51 5.17-8.96 5.68-15.72.28-1.07.28-2.43.28-3.8 0-23.03-16.23-51.19-36.56-62.87-8.68-5.16-16.84-6.25-23.03-4.04zm-27.35-7.83c0-11.4 2.16-21.16 6.47-28.48 2.72-4.84 6.24-8.92 10.33-11.64 11.92-8.4 29.23-8.12 48.23 3 35.76 20.84 65.04 71 65.04 111.92 0 23.03-8.96 38.19-23.32 43.59-3.52 1.36-7.32 2.21-11.4 2.21-8.91.51-19.24-2.44-30.32-8.68-35.8-20.6-65.03-70.72-65.03-111.92",
    clipPath: "url(#clipPath1110)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2c",
    d: "M3586.5 2123.85c0 8.64 2.21 18.11 6.24 27.08.84 1.64 1.36 3.23 2.44 4.88 6.24 10.56 14.08 20.03 22.76 27.35 1.92 1.36 3.8 2.73 5.73 3.8l.79.57.29.23c8.11 4.37 15.15 5.16 21.11 3.28 3.24-3.51 5.17-8.96 5.68-15.72.28-1.07.28-2.43.28-3.8 0-23.03-16.23-51.19-36.56-62.87-8.68-5.16-16.84-6.25-23.03-4.04l-.29.23c-3.23 4.37-5.44 10.84-5.44 19.01zm-6.29-13.7c0-8.49 1.65-15.77 4.83-21.21 2.07-3.62 4.65-6.62 7.7-8.64 8.87-6.29 21.78-6.05 35.9 2.21 26.6 15.54 48.38 52.84 48.38 83.29 0 17.13-6.66 28.39-17.36 32.42-2.63 1.04-5.45 1.64-8.45 1.64-6.66.38-14.31-1.82-22.57-6.46-26.65-15.3-48.43-52.61-48.43-83.25",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1a0",
    d: "M3582.18 2111.9c0-2.97.27-5.95.82-8.67 1.62-10.83 7.04-18.15 14.35-21.4 7.86-3.26 18.44-2.17 29.82 4.33 24.92 14.37 44.97 49.05 44.97 77.5 0 12.74-4.05 22.23-10.83 27.1v.28c-6.51 4.88-15.45 5.95-26.01 2.16-2.72-1.08-5.43-2.16-8.13-3.8l-2.45-1.63c3.8 2.18 7.32 3.53 10.85 3.8v.28c3.79.53 7.04.27 10.29-.81 3.8-4.34 5.96-11.12 5.96-19.52 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06l-.27.27-1.09 1.9c-2.71 4.33-4.33 10.03-4.33 17.07 0 2.98.27 5.96.81 8.94.27 2.98 1.09 6.23 2.17 9.21.81 2.99 1.89 5.97 3.25 8.95-6.77-12.74-10.57-26.56-10.57-39.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686b6a",
    d: "M3621.7 2087.92c24.93 14.37 44.98 49.04 44.98 77.5 0 12.73-4.06 22.23-10.84 27.1v.27c-1.17.88-2.45 1.59-3.78 2.22 3.45-.64 6.57-1.96 9.25-3.97v-.28c6.78-4.87 10.83-14.36 10.83-27.1 0-28.45-20.05-63.13-44.97-77.5-11.38-6.5-21.96-7.59-29.82-4.33l-.89.47c7.18-1.33 15.93.3 25.24 5.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccecd",
    d: "M3592.21 2104.59c6.5-7.86 17.88-8.95 30.89-1.63 20.05 11.66 36.58 40.11 36.58 63.14 0 13.55-5.42 22.22-13.82 24.94 3.8-4.34 5.96-11.12 5.96-19.52 0-23.02-16.25-51.21-36.58-62.87-8.67-5.14-16.8-6.23-23.03-4.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M3617.95 2183.17c2.17 1.63 4.61 3.26 6.77 4.6l-1.62-.8c-1.89-1.08-3.52-2.17-5.15-3.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M3595.19 2155.8c6.24 10.58 14.09 20.05 22.76 27.37-9.21-6.5-17.34-16.26-22.76-27.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1a0",
    d: "M3590.01 2129.16c0-5.24 1.05-9.68 2.8-13.06 4.9-9.09 15.39-11.19 27.51-4.2 16.67 9.56 30.31 33 30.31 52.23 0 13.75-7.11 21.68-17.37 21.33-3.96-.11-8.27-1.4-12.94-4.07-16.66-9.68-30.31-33.11-30.31-52.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9bab9",
    d: "M3606.57 2133.38c0-3.35.67-6.18 1.79-8.34 3.13-5.81 9.84-7.16 17.59-2.69 10.65 6.12 19.37 21.09 19.37 33.38 0 8.8-4.55 13.87-11.1 13.64-2.54-.07-5.29-.89-8.27-2.6-10.66-6.19-19.38-21.16-19.38-33.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959795",
    d: "M3619.17 2140.63c0-1.17.23-2.15.62-2.92 1.1-2.03 3.45-2.5 6.16-.93 3.72 2.14 6.77 7.37 6.77 11.68 0 3.06-1.59 4.84-3.88 4.76-.89-.03-1.85-.31-2.89-.92-3.73-2.15-6.78-7.39-6.78-11.67",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M3621.34 2176.23c22.5 39 24.29 55.89 55.68 66.84 31.39 10.93 24.02 84.76-18.23 107.97-42.24 23.21-87.64-88.23-87.64-88.23l50.19-86.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ba1a6",
    d: "M3275.98 2041.3c10.42-2.75 16.34-1.03 30.85 3.27 14.5 4.3 175.52 101.42 175.52 101.42l61.53-35.52 9.83-42.4s-129.83-78.41-144.33-82.71c-14.51-4.3-20.43-6.01-30.84-3.27l-61.54 35.53-41.02 23.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535c5e",
    d: "M3387.86 1996.01c4.8 0 10.22 1.6 19.19 4.26 10.09 3.24 90.37 50.81 161.66 93.42l-86.28 49.83c-38.79-23.23-159.09-95.57-173.27-99.78-2.08-.62-4.02-1.19-5.85-1.71l78.33-45.22c2.3-.55 4.29-.8 6.22-.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535c5e",
    d: "M3401.35 2103.54c-3.9-29.1-93.19-64.31-93.19-64.31s-19.88 1.99-2.95 14.03c16.93 12.05 96.14 50.28 96.14 50.28",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3419.65 2084.3s-45.18 147.1 6.43 199.78c47.07 48.04 114.55 62.06 131.74 56.27 40.85-13.79 69.27-35.03 73.71-102.98-60.39-34.87-211.88-153.07-211.88-153.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3395.84 2240.75s20.37-37.7 23.81-65.41c3.45-27.7 0-91.04 0-91.04l61.54-35.52 127.44 179.4s48.59 85.24 8.92 118.39c-31 25.91-88.65-1.53-88.65-1.53l-140.2-87.64 7.14-16.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3552.1 2371.89c52.98 29.1 105.82-12.85 124.92-35.24 19.09-22.4-19.11-67.28-39.75-85.28s-111.95-131.72-135.66-128.43c-23.71 3.3-130 43.34-122.45 94.59 7.54 51.26 172.94 154.36 172.94 154.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M3527.01 2369.34l-135.47-87.93s-13.69-33.14-9.78-36.27c3.91-3.12 42.29-27.61 42.29-27.61l116.69 98.31s28.69 33.11 30.3 37.87c1.61 4.76-15.57 28.32-16.04 28.59l-27.99-12.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3384.52 1980.6l-21.92 12.69v-.11l.11-.05c3.84-5.48 7.69-9.54 12.7-11.38 2.63-1 5.63-1.42 9.11-1.15",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3253.96 2096.24c3-9.17 10.27-18.44 17.23-26.45 4.9-5.64 9.59-10.64 12.43-14.59 1.17-1.59 2.21-3.11 3.27-4.63 14.12-20.61 19.07-35.83 36.09-34.42l2.58-1.47 3.01-1.74.05-.05 23.97-13.86 9.96-5.74c-4.9 6.91-9.9 16.12-17.39 26.4-2.16 2.95-5.32 6.53-8.85 10.49l-.89 1.04c-4.64 5.23-9.7 11.12-13.75 17.24l-.53.79-.06.1c-2.42 3.75-4.42 7.53-5.63 11.32-4.27 13.02 2.89 42.47 10.75 76.24 11.74 50.8 25.07 111.39 3.32 140.47-2.01 2.69-4.7 5.28-7.75 7.7-15.44 12.22-40.78 20.34-40.78 20.34-.05-6.12-.53-13.02-1.32-20.45-6.58-61.22-35.25-159.65-25.71-188.73",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9da2b0",
    d: "M3256.07 2052.72l4.28 4.11c-.47.48-46.91 49.38-45.47 80.65 1.06 22.94 15.1 70.63 23.48 99.12 1.73 5.85 3.23 10.94 4.35 14.9 1.75 6.23 3.37 11.45 4.87 16.32 4.23 13.69.88-2.2 4.26 20.23l-5.86.88c-3.31-21.99.1-5.9-4.06-19.36-1.52-4.91-3.15-10.17-4.92-16.46-1.12-3.94-2.61-9.01-4.32-14.84-8.46-28.75-22.63-76.86-23.72-100.52-1.56-33.79 45.12-82.95 47.11-85.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3281.95 2039.81c-18.28-1.5-25.2 14.43-41.93 37.35-7.01 9.61-22.03 27.21-27.1 42.75-10.66 32.61 39.66 144.88 40.08 201.64 0 0 36.31-11.6 48.5-28-.42-56.77-37.71-176.56-27.05-209.17 5.08-15.53 22.66-31.41 29.67-41.02 16.73-22.93 21.09-40.58 39.36-39.07l-61.53 35.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ba1a6",
    d: "M3225.62 2095.29l29.97-41.09 6.07-8.33s35.98-43.25 85.35-61.59c7.27-2.74 14.86-4.9 22.65-6.27l.06-.05.63-.11c4.37-.74 8.8-1.26 13.28-1.52-2.27.95-5.27 3.05-8.22 5.42-5.85 4.64-11.7 10.38-12.7 11.38l-.11.05-.05.11-25.97 36.3-.06.16-1.1 1.47-12.28 17.18-.05.11-.06.04-1.95.8-6.48 2.63-.84.37-.26.11-4.06 1.68-38.25 15.65-2.27.95-43.3 24.55",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676a68",
    d: "M3195.83 1907.02c0-5.24 1.05-9.68 2.8-13.06 4.9-9.09 15.39-11.19 27.51-4.19 16.67 9.56 30.31 32.98 30.31 52.22 0 13.75-7.11 21.68-17.37 21.33-3.96-.12-8.27-1.4-12.94-4.08-16.67-9.67-30.31-33.1-30.31-52.22",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M3237.71 1964.55l-2.44-1.63c3.8 2.18 7.31 3.53 10.84 3.8v.27l-.27 1.36c-2.71-1.08-5.42-2.17-8.13-3.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M3192.72 1887.06c0-2.99.28-5.97.82-8.68 2.44.82 5.15 2.18 7.86 3.52-2.71 4.34-4.34 10.03-4.34 17.07 0 2.98.27 5.97.82 8.95.27 2.98 1.08 6.23 2.16 9.21.82 2.99 1.9 5.97 3.26 8.94-6.78-12.73-10.58-26.55-10.58-39.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1140)",
    d: "M3197.06 1898.97c0 8.68 2.17 18.16 6.24 27.1.81 1.64 1.35 3.26 2.44 4.88 6.23 10.57 14.08 20.06 22.75 27.37 1.9 1.36 3.8 2.98 5.69 3.8l.82.54.27.26c8.13 4.35 15.17 5.16 21.14 3.26 3.25-3.52 5.15-8.94 5.68-15.72.28-1.09.28-2.43.28-3.79 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.96zm-38.55-54.58c2.13-1.2 6.31-3.94 6.31-3.94l24.11-13.82 2.98 5.41 13.29 23.31c1.07.55 1.89 1.09 2.7 1.62 33.6 22.77 60.43 68.83 63.95 108.94v.27c.27 2.17.27 4.6.27 6.77l9.76 17.62 4.88 8.67-23.04 13.28s-4.61 2.53-6.92 3.65c-9.35 4.55-23.21 1.53-42.13-9.34-38.75-22.22-70.18-76.69-70.18-121.4 0-22.29 4.68-35.77 14.02-41.04",
    clipPath: "url(#clipPath1140)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1145)",
    d: "M3203.3 1926.07c.81 1.64 1.35 3.26 2.44 4.88 6.23 10.57 14.08 20.06 22.75 27.37 2.17 1.63 4.62 3.25 6.78 4.6 8.13 4.35 15.17 5.16 21.14 3.26 3.8-4.33 5.96-11.11 5.96-19.51 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06l-.27.27c-3.25 4.34-5.42 10.84-5.42 18.96 0 8.68 2.17 18.16 6.24 27.1zm-36.05-53.65c0-12.2 2.44-22.49 6.51-30.35 11.38-21.13 35.77-26.02 63.95-9.76 38.75 22.22 70.45 76.69 70.45 121.4 0 31.98-16.52 50.4-40.37 49.6-9.22-.27-19.25-3.26-30.08-9.49-38.75-22.49-70.46-76.95-70.46-121.4",
    clipPath: "url(#clipPath1145)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1150)",
    d: "M3202.49 1879.99c-3.24 4.37-5.44 10.84-5.44 19 0 8.65 2.2 18.12 6.24 27.08.84 1.64 1.36 3.25 2.43 4.89 6.25 10.55 14.08 20.04 22.77 27.35 1.92 1.36 3.8 2.73 5.72 3.8l.79.57.29.23c8.12 4.37 15.15 5.16 21.12 3.28 3.23-3.51 5.16-8.95 5.67-15.71.28-1.09.28-2.44.28-3.81 0-23.04-16.23-51.19-36.55-62.87-8.68-5.17-16.85-6.24-23.04-4.04zm-27.36-7.83c0-11.41 2.16-21.16 6.48-28.49 2.72-4.83 6.24-8.91 10.32-11.63 11.92-8.4 29.24-8.11 48.24 3 35.76 20.84 65.04 71 65.04 111.91 0 23.05-8.96 38.21-23.33 43.6-3.52 1.36-7.31 2.2-11.4 2.2-8.91.52-19.24-2.44-30.31-8.68-35.8-20.59-65.04-70.71-65.04-111.91",
    clipPath: "url(#clipPath1150)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2c",
    d: "M3197.05 1898.99c0 8.65 2.2 18.12 6.24 27.08.84 1.64 1.36 3.25 2.43 4.89 6.25 10.55 14.08 20.04 22.77 27.35 1.92 1.36 3.8 2.73 5.72 3.8l.79.57.29.23c8.12 4.37 15.15 5.16 21.12 3.28 3.23-3.51 5.16-8.95 5.67-15.71.28-1.09.28-2.44.28-3.81 0-23.04-16.23-51.19-36.55-62.87-8.68-5.17-16.85-6.24-23.04-4.04l-.28.23c-3.24 4.37-5.44 10.84-5.44 19zm-6.29-13.69c0-8.49 1.64-15.77 4.83-21.21 2.07-3.61 4.64-6.62 7.7-8.64 8.86-6.28 21.77-6.05 35.89 2.21 26.61 15.53 48.38 52.84 48.38 83.29 0 17.13-6.66 28.39-17.36 32.43-2.63 1.02-5.44 1.64-8.45 1.64-6.66.37-14.31-1.84-22.57-6.48-26.65-15.3-48.42-52.6-48.42-83.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1a0",
    d: "M3192.72 1887.06c0-2.99.28-5.97.82-8.68 1.63-10.83 7.05-18.16 14.36-21.41 7.86-3.24 18.43-2.16 29.81 4.34 24.93 14.36 44.98 49.04 44.98 77.5 0 12.73-4.06 22.23-10.84 27.1v.27c-6.5 4.88-15.44 5.96-26.01 2.17-2.71-1.08-5.42-2.17-8.13-3.8l-2.44-1.63c3.8 2.18 7.31 3.53 10.84 3.8v.27c3.79.55 7.05.28 10.3-.81 3.8-4.33 5.96-11.11 5.96-19.51 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06l-.27.27-1.08 1.89c-2.71 4.34-4.34 10.03-4.34 17.07 0 2.98.27 5.97.82 8.95.27 2.98 1.08 6.23 2.16 9.21.82 2.99 1.9 5.97 3.26 8.94-6.78-12.73-10.58-26.55-10.58-39.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686b6a",
    d: "M3232.25 1863.07c24.92 14.37 44.98 49.05 44.98 77.5 0 12.73-4.07 22.22-10.84 27.1v.27c-1.18.88-2.46 1.59-3.79 2.22 3.45-.64 6.57-1.97 9.25-3.98v-.27c6.78-4.87 10.84-14.37 10.84-27.1 0-28.46-20.05-63.14-44.98-77.5-11.38-6.5-21.95-7.58-29.81-4.34l-.9.48c7.19-1.34 15.93.3 25.25 5.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccecd",
    d: "M3202.75 1879.74c6.51-7.87 17.89-8.95 30.89-1.62 20.06 11.65 36.58 40.09 36.58 63.13 0 13.54-5.41 22.22-13.81 24.93 3.8-4.33 5.96-11.11 5.96-19.51 0-23.03-16.26-51.21-36.58-62.87-8.68-5.15-16.81-6.23-23.04-4.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M3228.49 1958.32c2.17 1.63 4.62 3.25 6.78 4.6l-1.63-.8c-1.89-1.08-3.52-2.17-5.15-3.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M3205.74 1930.95c6.23 10.57 14.08 20.06 22.75 27.37-9.2-6.5-17.34-16.26-22.75-27.37",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1a0",
    d: "M3200.56 1904.31c0-5.25 1.05-9.68 2.8-13.06 4.9-9.09 15.39-11.19 27.51-4.19 16.67 9.55 30.31 32.99 30.31 52.22 0 13.75-7.11 21.68-17.37 21.34-3.97-.12-8.28-1.41-12.94-4.09-16.67-9.67-30.31-33.1-30.31-52.22",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9bab9",
    d: "M3217.11 1908.53c0-3.35.68-6.19 1.8-8.34 3.13-5.82 9.83-7.16 17.58-2.69 10.65 6.11 19.37 21.09 19.37 33.38 0 8.8-4.54 13.87-11.1 13.64-2.53-.08-5.29-.9-8.27-2.61-10.66-6.19-19.38-21.16-19.38-33.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959795",
    d: "M3229.72 1915.78c0-1.17.23-2.16.62-2.92 1.1-2.03 3.44-2.5 6.15-.94 3.72 2.14 6.77 7.38 6.77 11.68 0 3.07-1.59 4.85-3.88 4.77-.88-.03-1.85-.31-2.89-.91-3.73-2.17-6.77-7.4-6.77-11.68",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1165)",
    d: "M3238.98 1909.47c-1.15 1.1-1.58 2.2-1.35 3.15l9.25 37.82c-.24-.95 11.12 48.38 12.28 47.29 2.48-2.33 11.26-3.54 14.81-2.85 1.9.36-11.78-49.32-11.52-48.24l-9.24-37.82c-.26-1.1-1.4-1.96-3.3-2.33-3.55-.68-8.45.65-10.93 2.98",
    clipPath: "url(#clipPath1165)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M3308.74 2035.39c-13.58 19.18-44.62 31.66-61.39 33.98l-.2.03c-1.61.23-3.16.39-4.58.46-41.69 2.38-109.52-60.03-117.34-110.73-.28-4.05 16.57-17.66 32.88-18.98 15.24 6.05 36.18 52.62 58.47 68.82 11.4 2.56 21.66 3.11 27.4.17 16.14-8.27 22.38-13.18 27.32-15.61 4.95-2.44 26.11 4.16 26.11 4.16s-.51 10.26-4.06 23.04c10.46 3.33 21.15 6.51 15.39 14.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3158.1 1940.15c14.4 3.04 25.74 10.57 38.22 24.79 12.48 14.22 64.39 33.49 80.53 25.23 16.15-8.28 22.39-13.2 27.32-15.62 4.95-2.43 26.11 4.16 26.11 4.16s-3.35 69.24-54.84 72.17c-41.69 2.38-109.52-60.03-117.34-110.73",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M3240.95 2063.09c-5.64-.41-7.93-4.69-3.09-6.55 4.85-1.86 14.54-1.35 19.66-1.6 12.37-.59 23.68-4.86 23.68-4.86s-12.57 8.82-23.28 11.54c-10.7 2.74-16.97 1.47-16.97 1.47",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959795",
    d: "M3275.44 2064.4l-1.74-11.9c-1.9-.2-11.12 2.26-17.63 2.4-6.52.15-11.07.26-11.07.26l2.92 21.51s19.05-2.84 27.52-12.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3385.26 1976.3c2.67 0 5.67.27 9.07.93 12.56 2.43 18.91 4.38 40.85 16.77 21.21 11.99 105.63 62.44 106.73 63.08l-4.18 7.07c-1.09-.65-85.45-51.05-106.58-63-20.97-11.84-26.56-13.58-38.39-15.88-10.29-1.95-17.2-3.09-22.24-.79-9.08 10.75-39.14 62.79-41.33 73.25-1.67 7.98-3.26 37.83 1.09 64.44 1.67 10.24 5.84 39.63 14.24 79.42 7.92 37.5-9.87 55.03-8.49 74.9l-10.02 7.9c-1.36-19.6 18.31-44.01 10.48-81.1-7.17-34.02-19.58-72.56-21.44-83.92-2.64-16.21-6.71-45.22-4.15-57.45 3.06-14.67 52.28-76.47 55.49-80.18l1.39-1.05c4.45-2.04 9.61-4.39 17.48-4.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ba1a6",
    d: "M3313.39 2048.88c-.05-1.63 0-3.8.16-6.17v-.1c.42-5.96 1.58-13.49 4.85-18.81.95-1.53 3.1-3.96 6.06-6.91 1.26-1.21 2.63-2.57 4.11-3.95l.05-.05c13.75-13.02 36.41-31.78 41.04-34.88l.06-.05.63-.11c-.37.53-1.63 1.74-3.95 3.9-4.85 4.48-9.54 10.59-13.81 17.28-6.37 9.96-11.91 21.29-16.01 30.56l-.06.16-.21.43c-4.58 10.32-7.27 17.95-7.27 17.95s-2.32-.99-4.32-.26l-1.42.53-.21.11-1.95.74c-2.53 1.05-5.11 2.1-6.54 2.73l-.84.37-.26.11s-.11-1.38-.11-3.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M3167.03 2095.24c14.22-30.3 69.97-36.62 87.09-40.73l1.47-.31c6.96-1.48 18.97-2.69 31.3-3.63 8.48-.64 17.12-1.17 24.29-1.54l2.21-.15c3.16-.16 5.96-.33 8.28-.42l1.47-.06h.16c3.58-.16 5.74-.27 5.74-.27l-2.84 88.78-2.74 84.95-.58 17.59-10.43 10.96-15.71 16.6-17.07 17.96-30.5 32.14c-16.87-22.12-44.89-59.17-57.54-88.94-10.17-23.81-17.39-44.1-22.13-61.32-1.37-4.75-2.47-9.22-3.43-13.49-6-27.3-4.89-45.73.96-58.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3323.46 2221.86c-8.12-38.42-25.66-118.72-22.98-135.05 1.16-7.16 4.38-19.23 8.96-32.67.53-1.68 1.16-3.37 1.74-5.11.74-2.11 1.53-4.22 2.37-6.32v-.1c3.27-8.69 6.95-17.55 10.91-25.72l1.1-2.21c6.7-13.54 14.18-24.97 21.45-30.4 7.27-2.74 14.86-4.9 22.65-6.27l.06-.05.63-.11c4.37-.74 8.8-1.26 13.28-1.52-2.27.95-5.27 3.05-8.22 5.42 2.63-1 5.63-1.42 9.11-1.15l-21.92 12.69h-.05c-4.9 6.91-9.9 16.12-17.39 26.4-2.16 2.95-5.32 6.53-8.85 10.49-4.58 10.32-7.27 17.95-7.27 17.95l-2.84 88.78c11.74 50.8 25.07 111.39 3.32 140.47-2.01 2.69-4.7 5.28-7.75 7.7l-25.03-18.07-9.95-7.22c11.37-3.64 19.65-6.8 25.66-9.38 10.48-4.43 13.96-7.17 14.8-8.06.32-.37-1.26-8.33-3.79-20.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9cdd0",
    d: "M3166.09 2153.35c.95 4.27 2.05 8.74 3.42 13.49 4.74 17.22 11.96 37.51 22.13 61.32 6.68 15.72 17.64 33.44 28.99 49.95 5.51 6.63 9.09 10.82 9.09 10.82 5.98-20.35 80.64-46.6 80.64-46.6s-29.4-108.9-31.28-138.79c-53.45-8.24-75.62 3.69-94.08 12.91-8.06 4.03-15.45 15.03-20.68 27.87.51 2.91 1.08 5.89 1.77 9.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbdce2",
    d: "M3214.75 2224.26c21.16 13.84 38.95-13.37 38.95-13.37s5.64-11.84-.93-28.21c-6.57-16.38-18.29-36.72-38.13-30.8-32.93 9.86.11 72.38.11 72.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M3233.37 2227.22c12.02-3.64 20.33-16.33 20.33-16.33s3.76-8.16 1.38-20.23c-3.43-3.47-7.89-5.65-12.82-5.65-10.75 0-19.46 10.02-19.46 22.39 0 8.66 4.32 16.09 10.57 19.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M3607.86 2220.42c15.07-25.31 56.92-53.54 18.09-83.64-38.84-30.1-50.58-22.48-115.25-56.73l22.24-7.69-56.84-11.5s37.51 17.95 77.61 85.13c40.1 67.18 54.15 74.43 54.15 74.43",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec3c7",
    d: "M3676.22 2300.17c8.2-37.36-97.78-90.29-110.65-189.71-5.02-38.71-23.66-53.38-23.66-53.38l-65.81 3.78 108.8 156.67 91.32 82.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535c5e",
    d: "M3476.1 2060.86c21.56 16.2 69.12 20.16 77.61 17.73-45.52-25.68-141.66-99.34-172.07-81.78l-30.4 17.56 95.26 37.11 29.6 9.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404b4d",
    d: "M3490.41 2228.18c-13.83-16.32-26.6-141.22-14.31-167.32-15.33-20.9-94.76 5.22-84.02 31.35 10.74 26.12-15.53 99.28-15.53 99.28l113.86 36.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404b4d",
    d: "M3595.77 2263.72c-46.74-35.4-101.19-63.18-105.36-87.49-4.17-24.31-14.31-115.37-14.31-115.37s-45.18 16.36-35.52 66.22c9.65 49.87-7.91 74.01 48.29 95.98 56.2 21.94 106.9 40.66 106.9 40.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535c5e",
    d: "M3650.59 2308.5c-26.5-35.4-159.7-109.2-187.2-118-27.4-8.8-50.6-29.2-79.1-6.3-17.1 13.7-21 28.9-19 44 1.2 9.9 5 19.8 9.2 29.2 10.6 23.4 54.5 48.3 54.5 48.3l126 76.6c17.4.1 30.7-2.7 46.1-8.2 39.5-14 68.6-40 49.5-65.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535c5e",
    d: "M3381.76 2245.14c3.14-7.16 67.41-45.73 79.09-45.67 10.49 6.51 180.44 125.05 173.24 137.17-7.21 12.12-71.74 47.52-79.09 45.66-6.76-8.59-173.24-137.16-173.24-137.16",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b5557",
    d: "M3650.59 2308.5c-26.5-35.4-159.7-109.2-187.2-118-27.4-8.8-50.6-29.2-79.1-6.3-17.1 13.7-21 28.9-19 44 9.1-12.6 34.2-22.6 43-22.1 10 .6 43.3 15.7 62.3 29.6 19.1 14 135.5 88 135.5 88s14.6 15.4 13.1 21.4c-1.6 6.1-22.5 24.6-64.2 37.2 17.4.1 30.7-2.7 46.1-8.2 39.5-14 68.6-40 49.5-65.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb317",
    d: "M3241.52 2120.26l31.88-3.98c3.31-.41 6.33 1.93 6.74 5.24.42 3.3-1.93 6.32-5.24 6.74l-31.88 3.99a6.043 6.043 0 01-6.74-5.25c-.41-3.31 1.93-6.33 5.24-6.74",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb317",
    d: "M3166.09 2153.35l6.9-6.96c2.32-2.37 5.53-1.9 7.17 1.11.63 1.15.94 2.53.94 3.95 0 2.16-.73 4.37-2.15 5.8l-9.44 9.59c-1.37-4.75-2.47-9.22-3.42-13.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1192)",
    d: "M3176.88 2403.88c2.16.97 4.08.87 5.39-.09l2.73-1.99c-1.3.95-3.23 1.06-5.39.09-4.09-1.83-7.5-6.81-7.62-11.11-.06-2.02.62-3.53 1.78-4.38l-2.73 1.99c-1.16.85-1.84 2.36-1.79 4.38.13 4.31 3.53 9.28 7.63 11.11",
    clipPath: "url(#clipPath1192)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1198)",
    d: "M3179.61 2401.89c2.95 1.32 5.45.64 6.56-1.46l.84-1.57c-1.02 1.92-3.3 2.54-6 1.33-3.74-1.68-6.85-6.23-6.97-10.16-.07-2.61 1.2-4.29 3.15-4.64l-1.76.31c-2.13.38-3.52 2.22-3.44 5.08.12 4.3 3.53 9.28 7.62 11.11",
    clipPath: "url(#clipPath1198)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1204)",
    d: "M3181.01 2400.19c1.98.88 3.74.79 4.93-.09l31.06-22.63c-1.2.87-2.96.97-4.94.08-3.73-1.67-6.85-6.22-6.96-10.15-.06-1.85.57-3.23 1.63-4.01l-31.05 22.63c-1.07.78-1.69 2.16-1.64 4.01.12 3.93 3.23 8.48 6.97 10.16",
    clipPath: "url(#clipPath1204)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5c7c8",
    d: "M3206.73 2363.39l-8.4 6.13c-.9.8-1.43 2.07-1.38 3.75.11 3.94 3.23 8.48 6.97 10.16 1.97.89 3.73.79 4.93-.09l-2.27 1.66.29-.14 10.13-7.39c-1.2.87-2.96.97-4.94.08-3.73-1.67-6.85-6.22-6.96-10.15-.06-1.85.57-3.23 1.63-4.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1211)",
    d: "M3212.06 2377.55l2.29.61 3.45.24c-.91-.07-1.91-.32-2.95-.79-4.81-2.16-8.82-8.02-8.97-13.08l.22-2.2-.84 3.36-.16 1.71c.11 3.93 3.23 8.48 6.96 10.15",
    clipPath: "url(#clipPath1211)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1217)",
    d: "M3214.85 2377.61c2.55 1.14 4.82 1.02 6.36-.11l5.67-4.12c-1.55 1.12-3.81 1.24-6.36.1-4.82-2.15-8.84-8.01-8.98-13.08-.06-2.38.74-4.16 2.11-5.16l-5.67 4.13c-1.36 1-2.16 2.78-2.1 5.16.15 5.06 4.16 10.92 8.97 13.08",
    clipPath: "url(#clipPath1217)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394344",
    d: "M3211.54 2360.4c-.13-5.06 3.65-7.43 8.46-5.27 4.82 2.16 8.84 8.02 8.97 13.08.15 5.07-3.64 7.43-8.45 5.27-4.82-2.15-8.84-8.01-8.98-13.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5c7c8",
    d: "M3257.1 2324.23l13.24 13.74-42.68 31.91c-.93 1.11-2.58 1.59-4.75 1.19-4.3-.78-7.41-6.07-8.87-10.15-.72-2.01-.52-3.68.37-4.77l.04-.05v-.01l42.65-31.86",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5c7c8",
    d: "M3256.67 2329.06c-1.46-4.08.85-6.77 5.15-5.97 4.29.78 7.4 6.07 8.86 10.16 1.46 4.08-.84 6.76-5.14 5.97-4.29-.78-7.41-6.07-8.87-10.16",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3347.03 2255.54c32.19 23.75-20.94 51.72-31.95 58.08-11.02 6.37-50.03-19.06-41.53-23.97s60.83-43.43 73.48-34.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3356.87 2268.7c3.77 14.05 4.93 16.9 5.43 26.1.51 9.21-142.97 70.14-143.8 65.8-.82-4.34-.94-31.78-.41-34.49.52-2.71 114.16-61.72 138.78-57.41",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3221.16 2362.58c40.3 10.27 85.91-17.31 101.4-26.96 15.68-9.54 60.39-37.53 28.58-53.07-12.39-6.05-58.63 27.6-72.78 37.24-16.11 8.99-72.89 38.79-57.2 42.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M3218.5 2360.6c-7.77-17.06-11.4-32.57-.7-50.66 10.71-18.1 22.7-31.15 38.44-42.74 15.74-11.58 78.9-15.36 90.79-11.66-13.79 31.42-128.53 105.06-128.53 105.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M3336.34 2288.49l12.97-4.1s-14.82-9.81-44.78-6.39c-29.97 3.43-60.92 22.39-72.45 34.97-11.52 12.59-20.45 31.05-17.01 39.34l3.43 8.29 117.84-72.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff0ff",
    d: "M3302.51 2338.96c-9.45 2.04-33.89 3.07-26.83-3.19 7.06-6.26 33.79-25.47 39.21-20.85 5.94 5.06 7.47 5.68 7.23 9.29-.23 3.62-19.61 14.75-19.61 14.75",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5c7c8",
    d: "M3275.7 2337.76l.83-1.03c8.8-7.81 33.45-24.35 37.53-20.84l2.33 1.96c4.09 3.41 4.61 3.94 4.45 6.28-.32 1.86-9.94 8.52-18.79 13.61-9.61 2.02-25.29 2.03-26.35.02zm-.87-2.95c-1.99 1.76-1.88 3.18-1.43 4.07 2.41 4.74 23.35 2.62 29.38 1.33l.37-.14c6.01-3.45 20.01-11.89 20.26-15.77.24-3.74-1.29-5.01-5.37-8.42l-2.32-1.94c-.78-.66-1.84-.97-3.14-.97-10.24 0-34.37 18.84-37.75 21.84",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5c7c8",
    d: "M3373.93 2257.28l32.37 2.39-46.91 23.42v-.01c-1.32.3-2.84-.29-4.23-1.83-2.76-3.05-4.43-7.29-3.17-11.19.61-1.91 1.72-3.04 3-3.34v-.01l.06-.01h.01l18.87-9.42",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1234)",
    d: "M3377.29 2274.53c2.74 1.86 5.07 1.49 6.18-.6.64-1.19 1.28-2.38 1.91-3.57-.86 1.62-2.67 1.91-4.8.46-3.08-2.08-5.66-6.97-5.77-10.92-.09-3 1.28-4.6 3.29-4.27-1.34-.21-2.67-.43-4-.65-2.59-.42-4.35 1.63-4.24 5.49.15 5.08 3.47 11.38 7.43 14.06",
    clipPath: "url(#clipPath1234)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1240)",
    d: "M3370.35 2277.96c1.84 1.25 3.5 1.49 4.72.89l6.94-3.43c-1.23.6-2.88.36-4.72-.89-3.96-2.68-7.28-8.98-7.43-14.06-.07-2.71.77-4.53 2.18-5.23l-6.94 3.43c-1.41.7-2.25 2.52-2.18 5.24.16 5.07 3.48 11.37 7.43 14.05",
    clipPath: "url(#clipPath1240)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1246)",
    d: "M3380.58 2270.82c1.43.97 2.71 1.16 3.66.69l38.05-18.82c-.95.47-2.23.28-3.66-.69-3.07-2.09-5.66-6.98-5.77-10.92-.06-2.12.6-3.52 1.69-4.07l-38.06 18.82c-1.09.55-1.74 1.96-1.68 4.07.11 3.95 2.69 8.84 5.77 10.92",
    clipPath: "url(#clipPath1246)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1252)",
    d: "M3418.63 2252c1.01.68 1.94.98 2.74.93l1.98-.12c-.86.05-1.89-.27-2.98-1.02-3.35-2.27-6.17-7.6-6.29-11.9-.05-1.71.32-3 1.01-3.79l-1.3 1.51c-.63.72-.97 1.9-.93 3.47.11 3.94 2.7 8.83 5.77 10.92",
    clipPath: "url(#clipPath1252)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1258)",
    d: "M3420.37 2251.79c1.56 1.06 2.96 1.27 4 .75l3.36-1.66c-1.03.51-2.43.3-3.99-.75-3.35-2.28-6.17-7.61-6.29-11.91-.07-2.3.65-3.85 1.84-4.43l-3.37 1.67c-1.2.58-1.91 2.13-1.84 4.43.12 4.3 2.94 9.63 6.29 11.9",
    clipPath: "url(#clipPath1258)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394344",
    d: "M3417.45 2238.22c-.13-4.3 2.48-5.95 5.83-3.68 3.35 2.28 6.17 7.6 6.3 11.91.12 4.3-2.49 5.95-5.84 3.68-3.35-2.28-6.17-7.61-6.29-11.91",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313942",
    d: "M3308.94 2382.1c-30.05 18.44-66.97 53.65-87.07-23.34 20.1-62.51 114.47-70.27 114.47-70.27s16.44 66.7-27.4 93.61",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e42",
    d: "M3516.62 2200.17l-.06-.03c-6.79-3.94-10.42-11.85-9.2-20.12l.52-3.49c2.06-13.98 17.12-22.15 28.63-15.49 6.83 3.95 10.47 11.91 9.25 20.22l-.51 3.42c-2.06 13.98-17.12 22.14-28.63 15.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M6538.36 1314.93l-81.4 53.12-222.88-145.99-434.7-342.501-57 48.421-145.06-69.121-53.23 286.451 994.27 424.2s83.59-48.29 0-254.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1269)",
    d: "M5596.69 880.559c0-55.18-2.03-118.95 46.05-91.188 48.09 27.758 87.07 95 87.07 150.18 0 55.179-38.98 77.399-87.07 49.64-48.08-27.761-46.05-53.461-46.05-108.632",
    clipPath: "url(#clipPath1269)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1274)",
    d: "M5637.53 750.559l-56.42 32.562 123.92 211.93 56.76-32.77-124.26-211.722",
    clipPath: "url(#clipPath1274)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M5612.72 806.07c0-55.172 38.98-77.398 87.07-49.629 48.08 27.758 87.07 95 87.07 150.168 0 55.192-38.99 77.403-87.07 49.641-48.09-27.75-87.07-94.988-87.07-150.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1280)",
    d: "M6294.64 1265.65c0-55.17 38.98-77.4 87.07-49.63 48.08 27.76 87.07 95 87.07 150.17 0 55.18-38.99 77.4-87.07 49.64-48.09-27.76-87.07-95-87.07-150.18",
    clipPath: "url(#clipPath1280)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1285)",
    d: "M6376.49 1177.21l-56.41 32.56 123.91 211.92 56.76-32.77-124.26-211.71",
    clipPath: "url(#clipPath1285)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M6351.69 1232.71c0-55.17 38.97-77.4 87.06-49.63 48.09 27.76 87.07 95 87.07 150.17 0 55.19-38.98 77.4-87.07 49.64-48.09-27.75-87.06-94.99-87.06-150.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5095.26 1116.32c.89 17.96 7.04 31.32 13.31 40.39 29.84 43.21 9.6-24.77 9.6-24.77l-22.91-15.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6616.17 1403.69s.9 10.07-8.28 23.98c-9.17 13.9-38.71 19.51-38.71 19.51l25.63-45.84 21.36 2.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M6610.6 1475.2s-4.75 39.72-31.58 78.09c-26.82 38.37-73.67 80.3-73.67 80.3l-21.74-67.51 113.41-93.1 13.58 2.22",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cc2e",
    d: "M6198.29 1644.96s-8.99-17.48-16.7-24.88c-7.71-7.4-73.02-53.47-73.02-53.47l-2.97-1.83v25.56c0 63.12-44.58 88.54-99.58 56.78-44.42-25.64-82.03-80.69-94.88-134.16-3.07-12.77-4.72-25.46-4.72-37.63v-33.92l-8.38-5.2-531.4-306.81v34.29c0 15.49-2.69 28.7-7.56 39.35-14.94 32.81-50.54 41.4-92.04 17.44-55-31.76-58.58-67.13-58.58-130.25v-21.73l-91.85-40.62-19.32 36.47 2.3 7.53 3.53 11.26v14.74l-5.79.72v25.43l13.18 32.68s12.9 53.77 14.51 64.28c1.08 7.16 13.04 30.74 13.94 31.97l27.35 21.58s10.39 18.96 39.1 47.82c28.69 28.85 168 150.6 191.99 170.85 24 20.24 115.24 83.73 209.05 134.46 93.81 50.73 108.44 50.02 119.48 52.52 65.23 14.77 150.04 6.76 164.62 5.83 25.69 9.93 241.34 124.11 269.19 90.53 6.42-11.52 21.41-53.02 21.41-53.02l11.56-7.07v-13.28l-7.27-18.45 5.14-29.96 7.71-9.81",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3af2a",
    d: "M6198.29 1644.96s-8.99-17.48-16.7-24.88c-7.71-7.4-73.02-53.47-73.02-53.47l-2.97-1.83v25.56c0 63.12-44.58 88.54-99.58 56.78-44.42-25.64-82.03-80.69-94.88-134.16-3.07-12.77-4.72-25.46-4.72-37.63v-33.92l-8.38-5.2-531.4-306.81v34.29c0 15.49-2.69 28.7-7.56 39.35-14.94 32.81-50.54 41.4-92.04 17.44-55-31.76-58.58-67.13-58.58-130.25v-21.73l-91.85-40.62-19.32 36.47 2.3 7.53 3.53 11.26v14.74l-5.79.72v18.8s26.89 17.48 29.89 23.63c2.99 6.16 53.82 122.25 61.53 129.65 11.15 10.71 181.47 83.34 260.56 127.66 82.66 46.32 398.82 212.12 513.13 266.48 130.64 62.12 130.64 13.03 158.99-6.25 2.46-1.66 64.01 26.16 64.01 26.16l5.14-29.96 7.71-9.81",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3af2a",
    d: "M5235.13 1252.56c-44.98-34.33-33.1-44.5-34.39-120.94 54.84 97.03 28.82 83.01 79.8 99.07 50.97 16.08 87.37 1.18 87.37 1.18s-18.41 104.92-132.78 20.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0a114",
    d: "M5911.14 1512.96c-3.07-12.77-4.72-25.46-4.72-37.63v-33.92l-8.38-5.2-531.4-306.81v34.29c0 15.49-2.69 28.7-7.56 39.35 2.66 12.97 4.35 21.1 4.35 21.1s1.58 2.88 4.48 7.73c10.51 17.58 38.31 61.17 70.05 87.29 40.49 33.33 397.11 215.63 423.45 226.78 19.14 8.1 32.17 25.72 43.05-5.66 2.32-6.7 4.53-15.6 6.68-27.32",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe945",
    d: "M5496.44 1289.88l-82.25-76.25 28.91 4.16 417.81 231.27s-40.43 1.73-65.27-12.06c-24.83-13.78-299.2-147.12-299.2-147.12",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7e00",
    d: "M5366.64 1129.4v34.29c0 15.49-2.69 28.7-7.56 39.35-14.94 32.81-50.54 41.4-92.04 17.44-55-31.76-58.58-67.13-58.58-130.25v-21.73l-91.85-40.62-19.32 36.47 19.64-9.93 75.21 42.24c6.83 70.46 15.11 108.95 74.9 143.48 43.04 24.84 80.65 19.83 100.87-8.27 10.09-13.99 15.86-33.69 15.86-58.29v-10.51l505.5 283.32v19.05c0 24.03 5.51 49.76 15.19 74.84 20.05 52.1 58.02 101.37 101.56 126.5 64.45 37.21 116.71 7.44 116.71-66.55l2.12-6.15 73.44 50.88s-8.99-17.48-16.7-24.88c-7.71-7.4-73.02-53.47-73.02-53.47l-2.97-1.83v25.56c0 63.12-44.58 88.54-99.58 56.78-44.42-25.64-82.03-80.69-94.88-134.16-3.07-12.77-4.72-25.46-4.72-37.63v-33.92l-8.38-5.2-531.4-306.81",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5289.5 1347c145.6 76.57 582.19 301.58 582.19 301.58s166.39 88.21 193.06 89.97c26.66 1.75 63.74-25.32 70.16-29.35 6.43-4.03 46.24 14.33 46.24 14.33s-14.99 41.5-21.41 53.02c-27.85 33.58-243.5-80.6-269.19-90.53-14.58.93-99.39 8.94-164.62-5.83-11.04-2.5-25.67-1.79-119.48-52.52-93.81-50.73-185.05-114.22-209.05-134.46-23.99-20.25-163.3-142-191.99-170.86-28.71-28.85-39.1-47.81-39.1-47.81s-6.01 2.33-15.65-6.44c-3.6-7.99-5.08-13.89-5.27-14.34l.93-6.04c95.36 86.69 34.41 42.06 143.18 99.28",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M5354.11 1156.46c0-55.18 2.03-80.87-46.05-108.63-48.09-27.76-87.07-5.54-87.07 49.64s-2.03 80.87 46.05 108.63c48.09 27.77 87.07 5.54 87.07-49.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcae8",
    d: "M5334.51 1145.15c0-42.76 10.8-53.32-26.45-74.84-37.27-21.51-67.47-4.28-67.47 38.47 0 42.76-10.81 53.32 26.45 74.83 37.27 21.52 67.47 4.29 67.47-38.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M6093.08 1583.11c0-55.19-38.99-122.43-87.07-150.18-48.09-27.76-87.08-5.55-87.08 49.64 0 55.17 38.99 122.41 87.08 150.17 48.08 27.77 87.07 5.54 87.07-49.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcae8",
    d: "M6073.48 1571.79c0-42.76-30.21-94.87-67.47-116.38-37.27-21.51-67.48-4.29-67.48 38.47s30.21 94.86 67.48 116.37c37.26 21.52 67.47 4.29 67.47-38.46",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97772a",
    d: "M5870.96 1549.52c-2.43 17.57-8.14 60.89-8.79 65.87l-14.45 21.58-33.45 23.09-493.14-259.74-29.7-54.03-2.07-10.13 36.76-51.05c.61-.73 60.27-72.08 65.27-76.85l1.04-1.02c5.41-5.32 16.63-16.39 39.81-3.31 25.25 14.21 409.17 227.73 430.69 239.71 1.18 9.96 10.38 88.75 8.03 105.88m-481.38-345.18l-1.01.97c-5.16 4.92-63.11 74.23-65.66 77.3l-37.38 51.89-.53.73 2.51 12.18 30.34 55.41.29.54 495.33 260.87 1.08.58 35.81-24.7 15.46-22.84.32-.86s6.28-47.67 8.86-66.34c2.57-18.72-7.71-104.32-8.14-107.96l-.12-1.03-.92-.5c-4.05-2.25-405.74-225.66-431.56-240.2-8.7-4.89-15.96-6.68-21.99-6.68-11.89 0-18.95 6.95-22.69 10.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcae8",
    d: "M6082.14 1743.44l57.46 28.37s12.85-3.27 18.63-15.41c5.79-12.15 10.61-32.96 10.61-32.96s-32.45-12.47-33.41-10.81c-.97 1.65-46.59 27.29-46.59 27.29l-6.7 3.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d29",
    d: "M5125.01 1221.01l21.16 20.81 38.72 30.94-9.39-23.29-26.12-47.74-27.09-24.23-4.12-4.43 6.85 47.92-.01.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3af2a",
    d: "M5188.75 1098.64s-73.11-40.95-77.81-41.72c-4.72-.75-13.65 11.73-13.65 11.73l2.3 3.22 25.05 8.21 23.42 14.72 6.85-3.4 33.84 7.24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe945",
    d: "M6192.71 1716.46s-14.77-12.22-33.62-21.14c-18.85-8.91-28.48 3.22-28.48 3.22l50.54 25 11.56-7.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7e00",
    d: "M5116.61 1027.88l36.5-33.868 308.96-178.391 64.98-24.699 8.04 68.379-437.8 205.049 19.32-36.47",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5527.05 790.922s-41.39 7.09-81.37 21.887c-39.98 14.812-258.08 143.05-282.32 158.121-51.92 39.2-66.07 93.42-66.07 93.42L5510.03 815l17.02-24.078",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5097.33 1124.03v-25.43l5.79-.72v-14.75l-5.83-18.78L5510.03 815l21.75 29.531-24.01 42.539-410.44 236.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5097.33 1124.03l-2.29-13.05 2.25-46.63s7.29-28.55 31.85-51.06c26.55-24.329 289.32-175.118 318.15-183.688 29.59-8.801 62.74-14.602 62.74-14.602l-30.53 33.801-337.51 194.949-44.66 80.28",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5205.41 1322.35l191.99 170.86 368.93-213-86.76-176.15-45.09-32.69-429.07 250.98",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5520.95 919.75l-410.44 236.96 14.51 64.28 17.38 30.23 397.18-231.86-18.63-99.61",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5110.51 1156.71l-13.18-32.68 410.44-236.96 13.18 32.68-410.44 236.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5097.33 1124.03v-6.63l410.44-236.97v6.64l-410.44 236.96",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5507.77 880.43c-10.61-1.532-45.33 5.25-93.54 28.172-55.69 26.48-283.46 158.108-303.56 174.878-23.81 19.86-13.34 40.55-13.34 40.55l410.44-243.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5520.95 919.75s-39.42-5.102-107.2 25c-116.25 51.629-264.46 143.82-289.12 163.53-23.76 19-14.12 48.43-14.12 48.43l5.18 21.17 269-115.43 141.45-121.54-5.19-21.16",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5528.64 985.16s-17.29 1.649-83.94 34.17c-93.55 45.65-270.22 153.82-295.57 172.63-32.74 24.29-24.12 29.05-24.12 29.05l13.95 31.95 254.68-123.82 141.46-121.53-6.46-22.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5890.55 1686.02l425.3-245.56-549.52-160.25-368.93 213 188.64 116.26 103.9 55.35 130.66 11.79 69.95 9.41",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M6159.74 1776.55l417.88-241.26-261.77-94.83-425.3 245.56s236.37 109.48 269.19 90.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5890.55 1686.02l-164.62-5.83 393.98-227.48 208.19-6.56s-.91 1.62-2.46 4.35c3.31 5.42.52 9.7-2.54 14.84-9.1 15.18-27.17 33.79-34.9 40.07-45.84 37.28-66.79 61.73-110.18 87.77-72.33 43.41-164.77 68.1-202.3 80.42-8.58 2.83-28.6 7.32-47.08 9.65-19.95 2.52-38.09 2.77-38.09 2.77",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M5870.9 1614.24c18.12 1.18 39.41-5.41 50.72-9.77 6.91-2.66 56.52-33.36 64.42-39.39 6.77-5.17-9.55-9.59-15.26-9.56-11.26 7.12-22.28 13.88-32.73 20.15a2044.384 2044.384 0 01-67.15 38.57",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M6178.02 1593.18c43.39-26.04 64.34-50.49 110.18-87.77 7.73-6.28 25.8-24.89 34.9-40.07 3.06-5.14 5.85-9.42 2.54-14.84.83-1.48 1.47-2.6 1.89-3.34-21.94.74-62.48 14.59-133.85 33.89-22.55 23.22-73.2 52.17-127.93 87.23-54.73 35.06-159.19 78.36-159.19 81.08 0 2.71 22.08 33.89 22.08 33.89 18.48-2.33 38.5-6.82 47.08-9.65 37.53-12.32 129.97-37.01 202.3-80.42",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M6093.55 1569.51l-43.54-5.58 175.55-107.58-25.78 44.03-106.23 69.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M5840.97 1632.73c-8.85 5.13-16.04 9.31-20.57 11.97-23.13 13.58-46.44 22.4-64.12 27.85 7.51 1.08 15.43 1.97 23.77 2.63 8.79.7 17.04 1.01 24.74 1.01 51.43 0 78.46-13.69 78.46-13.69l-11.57-13.94s-11.23-5.8-30.71-15.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M6331.55 1446.15l-8.4 6.18s-45.64 23.37-135.96 26.76c-90.33 3.4-143.29-14.6-143.29-14.6l64.85-35.42 219.35-23.66 3.45 40.74",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5138.04 1251.2l401.55-231.84.94.48 49.8 7.84 44.13 43.69-429.07 250.99-17.43-13.47s-43.93-47.17-49.19-56.26l-.73-1.43",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M6616.17 1403.69s-1.56-21.77-9.28-29.17c-7.7-7.4-65.57-57.75-65.57-57.75l-2.96-1.84v25.56c0 63.11-44.6 88.54-99.6 56.79-44.42-25.65-82.02-80.7-94.87-134.18-3.07-12.77-4.73-25.44-4.73-37.61v-33.94l-8.38-5.18-531.4-306.811v34.293c0 15.48-2.68 28.687-7.55 39.339-14.95 32.821-50.53 41.411-92.04 17.45-55-31.762-99.6-108.68-99.6-171.789v-21.743l-73.14 13.813L5510.03 815v19.91l3.53 11.262v14.75l-5.79.707v25.441l13.18 32.68s2.25 38.16 3.86 48.672c1.09 7.168 6.21 26.387 10.28 39.148l.01.04c1.89 5.95 3.57 10.5 4.48 11.75l1.28 1.28c9.64 8.75 50.76 8.34 50.76 8.34s15.42 14.81 44.13 43.67c28.69 28.85 106.58 187.31 130.58 207.56 23.99 20.24 115.23 83.74 209.05 134.46 93.81 50.73 108.44 50.02 119.47 52.51 65.24 14.78 206.43-25.78 221-26.72 25.7 9.93 233.92 128.41 261.77 94.83 6.42-11.52 21.4-53.01 21.4-53.01l11.58-7.08v-13.28l-3.22-21.46 1.08-26.95 7.71-9.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6616.17 1403.69s-1.56-21.77-9.28-29.17c-7.7-7.4-65.57-57.75-65.57-57.75l-2.96-1.84v25.56c0 63.11-44.6 88.54-99.6 56.79-44.41-25.65-82.02-80.7-94.87-134.17-3.07-12.78-4.73-25.45-4.73-37.62v-33.94l-8.38-5.18-531.4-306.811v34.293c0 15.48-2.68 28.687-7.55 39.339-14.95 32.821-50.53 41.411-92.04 17.438-55-31.75-99.59-108.668-99.59-171.777v-21.743l-73.15 13.813L5510.03 815v19.91l3.53 11.262v14.75l-5.79.707v18.801s28.72-.59 47.67 33.14c26.15 46.59 49.52 75.981 103.9 109.61 9.08 5.63 140.07 79 222.72 125.32 82.66 46.31 398.82 212.12 513.14 266.48 130.62 62.12 146.65 9.28 163.03-9.26 1.98-2.21 49.15 34.74 49.15 34.74l1.08-26.95 7.71-9.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5667.87 1002.71c-44.98-34.319-74.1-86.038-75.39-162.491 54.83 97.051 69.82 124.57 120.8 140.633 50.98 16.058 87.37 1.168 87.37 1.168s-18.4 104.91-132.78 20.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b8bccd",
    d: "M6343.89 1263.11c-3.07-12.78-4.73-25.45-4.73-37.62v-33.94l-8.38-5.18-531.4-306.811v34.293c0 15.48-2.68 28.687-7.55 39.339 2.66 12.969 4.34 21.11 4.34 21.11s6.24 2.347 4.48 7.719c-12 36.84 31.3 67.16 70.05 87.3 46.54 24.17 397.11 215.62 423.46 226.77 19.13 8.1 35.84 8.2 43.05-5.65 3.27-6.29 4.54-15.61 6.68-27.33",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5929.18 1040.03l-82.25-76.241 28.92 4.16 417.81 231.271s-40.44 1.73-65.27-12.06c-24.84-13.79-299.21-147.13-299.21-147.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M5799.38 879.559v34.293c0 15.48-2.68 28.687-7.55 39.339-14.95 32.821-50.53 41.411-92.04 17.438-55-31.75-99.59-108.668-99.59-171.777v-21.743l-73.15 13.813L5510.03 815l17.34 2.449 56.5-12.179c6.83 70.46 56.12 150.492 115.92 185.019 43.03 24.851 80.64 19.841 100.86-8.269 10.09-13.981 15.86-33.68 15.86-58.282v-10.519l505.51 283.311v19.06c0 24.04 5.51 49.77 15.19 74.85 20.05 52.1 58.02 101.37 101.55 126.49 64.46 37.22 116.73 7.44 116.73-66.55l2.12-6.15c54.52 30.03 58.56 59.46 58.56 59.46s-.06-16.2-4.04-26.12c-11.96-29.8-70.81-60.8-70.81-60.8l-2.96-1.84v25.56c0 63.11-44.6 88.54-99.6 56.79-44.41-25.65-82.02-80.7-94.87-134.17-3.07-12.78-4.73-25.45-4.73-37.62v-33.94l-8.38-5.18-531.4-306.811",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e8f0",
    d: "M5722.26 1097.15c145.58 76.58 582.17 301.59 582.17 301.59s166.39 88.2 193.06 89.96c26.67 1.75 63.74-25.31 70.17-29.34 6.42-4.04 31.36 22.92 31.36 22.92s-14.98 41.49-21.4 53.01c-27.85 33.58-236.07-84.9-261.77-94.83-14.57.94-114.06 49.16-221 26.72-10.19-2.14-25.66-1.78-119.47-52.51-93.82-50.72-185.06-114.22-209.05-134.46-24-20.25-101.89-178.71-130.58-207.56-28.71-28.86-44.13-43.67-44.13-43.67s-41.12.41-50.76-8.34c-3.61-8-5.57-12.58-5.76-13.03l-.01-.04s74.52 30.33 187.17 89.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M5612.72 806.07c0-55.172 38.98-77.398 87.07-49.629 48.08 27.758 87.07 95 87.07 150.168 0 55.18-38.99 77.403-87.07 49.641-48.09-27.762-87.07-95-87.07-150.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1338)",
    d: "M5612.72 806.07c0-55.172 38.98-77.398 87.07-49.629 48.08 27.758 87.07 95 87.07 150.168 0 55.18-38.99 77.403-87.07 49.641-48.09-27.762-87.07-95-87.07-150.18",
    clipPath: "url(#clipPath1338)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1343)",
    d: "M5618.15 807.082c0-53.082 37.5-74.461 83.75-47.75 46.26 26.707 83.76 91.379 83.76 144.457 0 53.082-37.5 74.461-83.76 47.75-46.25-26.707-83.75-91.379-83.75-144.457",
    clipPath: "url(#clipPath1343)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504f58",
    d: "M5629.98 813.648c0-45.199 31.93-63.41 71.32-40.656 39.39 22.738 71.33 77.817 71.33 123.02 0 45.199-31.94 63.398-71.33 40.66-39.39-22.731-71.32-77.82-71.32-123.024",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M5632.21 818.359c0-42.839 30.26-60.097 67.59-38.55 37.34 21.57 67.6 73.761 67.6 116.613 0 42.84-30.26 60.09-67.6 38.527-37.33-21.551-67.59-73.75-67.59-116.59",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1350)",
    d: "M5762.55 883.48c-2.83-24.589-15.16-52.66-34.6-74.992-19.44-22.289-41.44-33.508-59.08-32.418-7.82.532-14.76 3.418-20.2 8.918a27.677 27.677 0 00-4.8 6.024l-.81 1.32c-.99 1.68-1.86 3.418-2.55 5.277a52.497 52.497 0 00-2.43 7.692c-1.1 4.801-1.62 10.008-1.62 15.449 0 2.488.11 5.031.35 7.582.06 1.328.23 2.609.41 3.879l.34 2.598.41 2.441c.4 2.422.87 4.91 1.5 7.398.29 1.211.58 2.372.93 3.582.23 1.051.52 2.032.86 3.008a59.26 59.26 0 001.4 4.403c.34 1.101.69 2.199 1.09 3.25 1.68 4.679 3.65 9.308 5.91 13.937.46.992.92 1.91 1.38 2.832 1.63 3.129 3.31 6.199 5.15 9.262l1.39 2.258c.87 1.39 1.8 2.781 2.66 4.109 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868 2.5 2.191c10.06 8.738 20.37 14.648 30.08 17.602 17.13 5.148 32.47 1.148 41.26-12.852l.81-1.27c1.68-2.832 2.95-5.96 4-9.261 2.66-8.68 3.3-18.86 2.02-29.739",
    clipPath: "url(#clipPath1350)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M5678.99 904.02l-.63-18.981c-7.12.582-14.18 1.27-20.78 2.141.87 1.39 1.8 2.781 2.66 4.109 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868 2.5 2.191c10.06 8.738 20.37 14.648 30.08 17.602 17.13 5.148 32.47 1.148 41.26-12.852-49.13 16.852-76.73-19.73-76.73-19.73",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M5758.51 883.77s-16.38-21.7-33.23-27.43c-16.83-5.731-49.41-45.141-49.41-45.141l2.49 73.84c38.48-2.891 80.15-1.269 80.15-1.269",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1357)",
    d: "M5724.77 896.488c-2.44-21.109-13.02-45.25-29.75-64.398-9.2-10.59-19.15-18.281-28.7-22.789v-.059c-7.76-3.711-15.22-5.39-21.99-4.98l-1.57.168c-1.61.121-3.17.402-4.68.871-1.1 4.801-1.62 10.008-1.62 15.449 0 2.488.11 5.031.35 7.582.06 1.328.23 2.609.41 3.879l.34 2.598.41 2.441c.4 2.422.87 4.91 1.5 7.398.29 1.211.58 2.372.93 3.582.23 1.051.52 2.032.86 3.008a59.26 59.26 0 001.4 4.403c.34 1.101.69 2.199 1.09 3.25 1.68 4.679 3.65 9.308 5.91 13.937.46.992.92 1.91 1.38 2.832 1.63 3.129 3.31 6.199 5.15 9.262 1.28 2.137 2.67 4.289 4.05 6.367 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868 2.5 2.191c10.06 8.738 20.37 14.648 30.08 17.602 1.92-1.852 3.66-4.051 5.16-6.661a37.497 37.497 0 003.41-7.921c1.22-4.11 1.97-8.622 2.19-13.43.18-3.871 0-7.93-.45-12.102",
    clipPath: "url(#clipPath1357)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1362)",
    d: "M5676.13 861.039l1.59-14.828v-.063l-1.59 14.891-11.55 6.691-8.39 17.192c1.28 2.137 2.67 4.289 4.05 6.367 3.48 5.199 7.3 10.242 11.4 14.992 2.09 2.367 4.17 4.629 6.31 6.711.99 1.039 2.03 2.028 3.01 2.949l.92.868c2.26-1.329 4.12-2.489 4.23-2.598l-14.46-16.629 4.48-36.543",
    clipPath: "url(#clipPath1362)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1367)",
    d: "M5676.13 861.039l1.59-14.828v-.063l-11.4-36.847-5.09-16.61c-1.74-3.66 3.41-11.929 1.04-11.461-3.82.75-13.31 6.36-18.4 9.782l-.81 1.32c-.99 1.68-1.86 3.418-2.55 5.277.12.86.41 1.731.87 2.653l1.38 4.168 20.84 61.34.98 1.96 11.55-6.691",
    clipPath: "url(#clipPath1367)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1372)",
    d: "M5745.79 916.129c-.97.519-2.28.402-3.71-.418l-55.31-23.422-1.55-.879-.05-29.691 12.28 7.062 45.83 17.969c2.86 1.648 5.21 5.57 5.37 8.941.31 6.5 10.31 7.899 9.07 13.52-.23 1.059-11.2 6.527-11.93 6.918",
    clipPath: "url(#clipPath1372)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M5687.6 837.531l-24.04 49.391c-1.18 2.047-.44 5.797 1.75 8.789 2.28 3.098 4.69 6.109 7.23 9.019a124.73 124.73 0 007.73 8.129c2.51 2.422 5.27 2.661 6.45.61l24.03-49.399-23.15-26.539",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M5696.74 855.031l.06 29.699 1.54.891 55.31 23.41c2.5 1.438 4.67.707 5.22-1.769 1.23-5.621 1.67-11.762 1.35-18.25-.16-3.371-2.5-7.293-5.36-8.942l-45.84-17.968-12.28-7.071",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M5653.12 786.02c-1.62 1.261-1.67 4.41-.16 7.562l22.24 65.488.93 1.969 20.61-6.008-7.42-15.519L5672.8 786c-1.73-3.629-4.93-6.051-7.3-5.578-4.57.887-8.74 2.75-12.38 5.598",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4a4b",
    d: "M5665.48 787.73l.88 1.34 16.94 54.399 21.12 24.23 46.88 18.563c.68.386 1.75 2.09 1.8 3.097.17 3.84.07 7.5-.32 10.93l-57.06-24.418-12.68 29.688c-1.74-1.77-3.46-3.618-5.12-5.52-2.37-2.73-4.69-5.609-6.87-8.57l-.84-1.758 13.04-30.332-23.91-69.008c1.86-1.18 3.92-2.062 6.14-2.641",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c37",
    d: "M6351.68 1232.71c0-55.17 38.98-77.4 87.07-49.63 48.09 27.76 87.07 95 87.07 150.17 0 55.19-38.98 77.4-87.07 49.64-48.09-27.76-87.07-95-87.07-150.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1382)",
    d: "M6351.69 1232.71c0-55.17 38.97-77.4 87.06-49.63 48.09 27.76 87.07 95 87.07 150.17 0 55.19-38.98 77.4-87.07 49.64-48.09-27.76-87.06-95-87.06-150.18",
    clipPath: "url(#clipPath1382)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1387)",
    d: "M6357.12 1233.72c0-53.08 37.5-74.45 83.75-47.75 46.26 26.71 83.76 91.38 83.76 144.46 0 53.09-37.5 74.46-83.76 47.75-46.25-26.71-83.75-91.38-83.75-144.46",
    clipPath: "url(#clipPath1387)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504f58",
    d: "M6368.95 1240.29c0-45.19 31.93-63.41 71.31-40.66 39.4 22.74 71.33 77.82 71.33 123.02s-31.93 63.4-71.33 40.66c-39.38-22.73-71.31-77.82-71.31-123.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababe",
    d: "M6371.17 1245c0-42.84 30.27-60.1 67.6-38.54 37.33 21.56 67.6 73.75 67.6 116.6 0 42.84-30.27 60.09-67.6 38.54-37.33-21.55-67.6-73.76-67.6-116.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1394)",
    d: "M6501.51 1310.12c-2.83-24.59-15.15-52.66-34.6-74.99-19.44-22.29-41.43-33.51-59.08-32.42-7.81.53-14.75 3.42-20.19 8.92-1.8 1.68-3.42 3.7-4.81 6.02l-.81 1.32c-.98 1.68-1.84 3.42-2.55 5.28-.97 2.42-1.78 4.97-2.42 7.69-1.1 4.8-1.62 10.01-1.62 15.45 0 2.49.11 5.03.34 7.58.06 1.33.24 2.61.41 3.88l.34 2.61.41 2.43c.4 2.43.87 4.91 1.51 7.4.28 1.22.57 2.37.92 3.59.23 1.04.52 2.02.86 3.01.41 1.45.87 2.95 1.4 4.4.34 1.1.69 2.19 1.09 3.24 1.68 4.68 3.65 9.31 5.91 13.94.46.99.92 1.91 1.39 2.83 1.62 3.13 3.3 6.2 5.15 9.26l1.38 2.26c.87 1.39 1.8 2.78 2.67 4.11 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87 2.49 2.19c10.07 8.74 20.37 14.65 30.09 17.6 17.13 5.15 32.47 1.15 41.26-12.85l.81-1.27c1.68-2.83 2.95-5.96 3.99-9.26 2.67-8.68 3.3-18.86 2.02-29.74",
    clipPath: "url(#clipPath1394)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M6417.96 1330.66l-.64-18.98c-7.11.58-14.18 1.27-20.78 2.14.87 1.39 1.8 2.78 2.67 4.11 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87 2.49 2.19c10.07 8.74 20.37 14.65 30.09 17.6 17.13 5.15 32.47 1.15 41.26-12.85-49.13 16.85-76.73-19.73-76.73-19.73",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393843",
    d: "M6497.47 1310.41s-16.38-21.7-33.22-27.43-49.42-45.14-49.42-45.14l2.49 73.84c38.48-2.89 80.15-1.27 80.15-1.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1401)",
    d: "M6463.73 1323.13c-2.43-21.11-13.02-45.24-29.75-64.4-9.19-10.59-19.15-18.28-28.7-22.79v-.06c-7.75-3.71-15.21-5.38-21.99-4.98l-1.56.17c-1.61.12-3.18.4-4.68.87-1.1 4.8-1.62 10.01-1.62 15.45 0 2.49.11 5.03.34 7.58.06 1.33.24 2.61.41 3.88l.34 2.61.41 2.43c.4 2.43.87 4.91 1.51 7.4.28 1.22.57 2.37.92 3.59.23 1.04.52 2.02.86 3.01.41 1.45.87 2.95 1.4 4.4.34 1.1.69 2.19 1.09 3.24 1.68 4.68 3.65 9.31 5.91 13.94.46.99.92 1.91 1.39 2.83 1.62 3.13 3.3 6.2 5.15 9.26 1.28 2.15 2.66 4.29 4.05 6.37 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87 2.49 2.19c10.07 8.74 20.37 14.65 30.09 17.6 1.91-1.85 3.65-4.05 5.15-6.65 1.39-2.43 2.54-5.04 3.41-7.93 1.22-4.11 1.97-8.62 2.2-13.43.18-3.87 0-7.93-.46-12.1",
    clipPath: "url(#clipPath1401)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1406)",
    d: "M6415.1 1287.69l1.59-14.84v-.06l-1.59 14.9-11.56 6.68-8.38 17.19c1.28 2.15 2.66 4.29 4.05 6.37 3.47 5.2 7.29 10.24 11.4 14.99 2.09 2.37 4.17 4.63 6.3 6.71.99 1.04 2.04 2.03 3.01 2.95l.93.87c2.26-1.33 4.11-2.48 4.23-2.6l-14.46-16.63 4.48-36.53",
    clipPath: "url(#clipPath1406)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1411)",
    d: "M6415.1 1287.69l1.59-14.84v-.06l-11.41-36.85-5.08-16.61c-1.74-3.65 3.4-11.93 1.03-11.46-3.82.75-13.31 6.36-18.4 9.78l-.81 1.32c-.98 1.68-1.84 3.42-2.55 5.28.12.86.41 1.73.87 2.65l1.39 4.17 20.84 61.34.97 1.96 11.56-6.68",
    clipPath: "url(#clipPath1411)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1416)",
    d: "M6484.76 1342.77c-.97.52-2.29.4-3.72-.42l-55.31-23.41-1.54-.89-.06-29.69 12.29 7.06 45.83 17.97c2.86 1.65 5.2 5.57 5.37 8.94.31 6.5 10.3 7.9 9.07 13.52-.23 1.06-11.2 6.53-11.93 6.92",
    clipPath: "url(#clipPath1416)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M6426.56 1264.18l-24.03 49.38c-1.18 2.06-.45 5.81 1.75 8.79 2.27 3.1 4.68 6.11 7.22 9.02 2.53 2.91 5.12 5.62 7.74 8.14 2.51 2.41 5.26 2.65 6.44.6l24.04-49.39-23.16-26.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M6435.7 1281.67l.06 29.7 1.54.89 55.32 23.41c2.5 1.44 4.67.71 5.21-1.77 1.23-5.61 1.67-11.76 1.36-18.25-.17-3.36-2.5-7.29-5.36-8.94l-45.84-17.97-12.29-7.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfe3",
    d: "M6392.08 1212.66c-1.61 1.26-1.67 4.41-.16 7.57l22.24 65.48.94 1.98 20.6-6.02-7.42-15.52-16.51-53.51c-1.73-3.63-4.93-6.05-7.31-5.58-4.57.89-8.74 2.75-12.38 5.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4a4b",
    d: "M6404.44 1214.38l.88 1.33 16.95 54.4 21.12 24.23 46.87 18.56c.69.39 1.75 2.09 1.8 3.1.18 3.84.08 7.51-.31 10.93l-57.06-24.42-12.69 29.69a128.51 128.51 0 01-5.12-5.52c-2.37-2.72-4.68-5.61-6.86-8.56l-.85-1.77 13.05-30.32-23.92-69.02c1.87-1.17 3.93-2.06 6.14-2.63",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M6314.83 1307.19c0 18.59-3.87 66.15-3.87 66.42l-7.3 24.2-41.44 5.14-494.35-260.36-44.68-45.94-2.18-10.58 36.97-51.29c2.79-1.22 26.14-11.83 51.32-39.35.85-.942 2.23-3.078 4.17-6.059 9.28-14.359 31.02-47.973 52.03-36.18 25.47 14.348 416.19 231.639 431.17 239.979 1.41 7.02 18.16 91.08 18.16 114.02zm-503.08-318.92c-1.8 2.781-3.22 4.98-3.96 5.781-26.36 28.829-50.62 38.859-50.86 38.949l-.27.12-37.57 52.13-.26.37 2.43 11.73.06.3 45.2 46.47 495.03 260.77.29.16 42.73-5.3.65-.08 7.74-25.69c.04-.47 3.91-48.12 3.91-66.79 0-24.04-17.54-111.18-18.29-114.89l-.09-.45-.41-.23c-4.06-2.25-405.76-225.651-431.59-240.19-3.4-1.93-6.79-2.77-10.15-2.77-18.96 0-36.43 26.988-44.59 39.61",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M6046.48 1052.32l4.7 15.35-.07.27-7 26.15c.44 3.79 7.03 60.95 7.03 76.66 0 16.21-9.11 60.66-9.51 62.55l-.09.24-21.31 42.61-1.81-.92 21.25-42.48c.55-2.72 9.43-46.42 9.43-62 0-16.05-6.96-76.02-7.03-76.62l-.03-.2.05-.18 6.97-26.05-4.52-14.78 1.94-.6",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6308.56 1426.72l-4.13-27.98s-436.59-225.01-582.17-301.59c0 0 30.14 143.44 36.57 153.79 6.42 10.34 29.99 34.64 97.77 80.05 67.79 45.4 154.22 90.5 169.64 97.94 15.42 7.42 71.65 33.53 114.09 33.31 98.32-.52 168.23-35.52 168.23-35.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5739.63 1120.07c151.67 79.39 504.91 261.54 553.63 286.66l1.87 12.62c-20.63 8.69-79.41 30.27-154.87 30.67h-.47c-37.52 0-88.2-22.45-108.25-32.11-18.21-8.78-103.08-53.52-168.13-97.08-73.11-48.96-90.32-70.32-94.02-76.07-3.69-8.13-17.08-65.73-29.76-124.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5580.49 807.262s-54.4 13.449-59.11 12.699c-4.71-.762-11.35-.652-11.35-.652v15.601l25.05 8.199 45.72 1.852 6.86-3.422-7.17-34.277",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M6610.6 1475.2s.09-20.81-18.76-29.72c-18.85-8.92-28.49 3.21-28.49 3.21 14.27-.15 35.67 33.59 35.67 33.59l11.58-7.08",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2329",
    d: "M5225.42 1255.11c23.27-20.87 71.22-50.28 120.29-77.99 1.2-.64 2.41-1.27 3.6-1.97 1.34-.78 2.68-1.49 4.02-2.26l.42-.21c1.27-.71 2.61-1.41 3.88-2.11 14.11-7.9 28.21-15.59 41.61-22.79 1.54-.84 3.03-1.69 4.58-2.46l.07-.07c10.79-5.71 21.08-11.14 30.67-16.15l.35-.21c68.33-33.77 132.57-49.78 140.89-51.13 7.47-1.12 39.63 19.79 61.35 54.55 4.87 7.83 10.65 17.13 17.49 28.28 37.16 60.63 92.24 128.39 92.24 128.39l.63-.2c-14.32 6.35-78.42 35.74-190.74 98.99-40.55 22.85-132.22 79.69-152.67 101.62-123.18-107.4-215.35-190.63-215.35-190.63s-1.41-9.52 36.67-43.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M5469.8 1440.94c-25.4 16.56-48.68 32.84-60.88 43.78.01 0 .01 0 .02.01 12.17-10.96 35.48-27.26 60.91-43.76-.02-.01-.03-.02-.05-.03",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M5289.51 1347.01s93.96 106.59 100.39 116.95c2.7 4.27 8.36 11.03 19.02 20.76 12.2-10.94 35.48-27.22 60.88-43.78-72.63-37.67-138.45-71.93-180.29-93.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffed4a",
    d: "M5431.18 1161.5c-24.96 13.61-40.4 22.07-50.07 27.36 17.01-9.52 34.07-18.83 50.07-27.36",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5139.35 1227.2v-.04c4.11-3.5 9.41-7.74 16.21-12.79 25.39-18.82 202.06-126.97 295.57-172.64 66.66-32.52 83.98-34.15 83.98-34.15l5.42 12.26.32.78-179.33 116.22-222.75 115.79-.73-1.43c-4.81-9.13-4.4-16.79 1.31-24",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M6085.9 1472.35s-95.4 74.13-129.36 93.73c-33.95 19.6-114.78 66.08-136.14 78.62-46.86 27.52-94.47 35.49-94.47 35.49l-40.48-17.76 311.59-200.19 88.86 10.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M6577.62 1535.29c-4.46 36.58-59.48 90.82-89.63 115.88-22.07 18.33-48.98 38.72-91 63.28-46.52 27.2-142.91 57.36-252.16 68.26-8.71.86-25.56-23.91-25.56-23.91l369.49-233.62 88.86 10.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M5928.64 1683.25s-24.8.41-105.1-.44c-78.44-.83-96.26-7.46-96.26-7.46l-1.35 4.84s89.69 9.69 164.62 5.83c24.32 1.9 38.09-2.77 38.09-2.77",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcae8",
    d: "M6572.34 1521.96s-1.79 14.44-14.11 36.67c7.64-.51 14.95-7.56 14.95-7.56s9.46-15.95 17.94-34.33c7.03-15.24 3.21-30.5 3.21-30.5s-1.52-4.41-8.91-12.05c-7.38-7.64-20.15-9.86-20.15-9.86-.96 1.65-28.14 16.58-28.14 16.58l-18.66 7.39s51.38 10.15 53.87 33.66",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M5453.69 1040.51c56.34-22.74 153.21-7.78 181.56 8.99 28.36 16.77-75.22-53.379-95.67-53.121-20.44.25-85.89 44.131-85.89 44.131",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5520.95 919.75s9.68-.918 23.14 15.871c8.73 10.918 22.07 40.938 31.51 55.328 0 0-7.2 16.441-.07 23.831-64.51-24.452-88.97-15.928-118.55-1.36-29.59 14.58-69.83-28.85-69.83-28.85l133.8-64.82",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M5372.34 987.461c10.02 0 21.1 10.121 23.17 12.078l81.15-2.508 4.02 31.479c.96 7.42 5.54 13.82 12.26 17.1 9.73 4.75 26.42 12.1 50.72 20.17 33.24 11.03 49.38 30.09 49.53 30.28l-1.56 1.31c-.16-.19-15.97-18.83-48.61-29.64-24.42-8.12-41.2-15.51-50.98-20.29-7.33-3.58-12.33-10.57-13.38-18.68l-3.79-29.631-80.17 2.481-.32-.31c-.15-.17-16.22-15.851-26.66-10.788-31.14 15.058-127.29 70.688-160.21 93.538-7.89 6.62-10.59 33.11-10.61 33.37l-.05.35-.24.26-50.31 52.35-7.22 25.38 3.78 26.58c.27 1.14.49 2.41.65 3.79.45 4.05 1.8 16.34 47.94 70.9 4.17 4.95 25.19-6.14 37.44-14.33l.57-.38.58.4 37.59 26.17-1.17 1.67-37.03-25.77c-5.34 3.51-33.02 21.24-39.54 13.55-41.7-49.32-47.61-64.71-48.41-71.99-.15-1.29-.35-2.48-.62-3.63l-3.86-27.11.06-.2 7.6-26.25 50.24-52.28c.36-3.37 3.21-27.59 11.38-34.44 33.05-22.95 129.36-78.68 160.56-93.768 1.75-.852 3.61-1.211 5.5-1.211",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d29",
    d: "M5395.11 1000.58l9.69-28.978 82.1-35.981 39.24 5.309 5.64 5.531 43.82 44.488-.07 23.831s-67.52-20.358-102.15-11.43c-29.91 7.69-65.36 29.7-74.53 35.57l-3.74-38.34",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d29",
    d: "M5110.95 1158.47l12.46-24.74 45.44-30.76 27.03 14.35 4.33 37.07c-8.14 5.17-46.61 29.66-64 42.66-9.41 7.05-11.82 14.63-12.8 16.87-2.61-9.57-12.1-45.23-12.46-55.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef3d29",
    d: "M5398.85 1038.92l-198.64 115.47-8.24-24.47 211.37-123.87-4.49 32.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca240e",
    d: "M5433.44 1012.19l-269.03 156.39-4.34-5.18 277.85-162.68-4.48 11.47",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6325.64 1450.51c.18 13.86-27.94 47.18-37.44 54.9-50.64 41.18-102.1 75.5-149.28 102.98-66.68 38.85-128.03 53.66-163.2 65.21-5.07 1.67-47.08 9.65-47.08 9.65 11.44 2.77 37.12 11.84 101.59-3.06 64.95-15.02 134.54-52.8 182.08-81.32 47.54-28.52 115.79-77.67 128.7-116.59 5.11-15.45-6.19-26.57-15.37-31.78v.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M6554.92 1561.6s-16.97 6.38-46.18 5.51c-28.14-.84-102.21-8.48-192.89-37.26 9.02-4.58 4.96-2.52 4.96-2.52s144.13 36.31 194.04 32.91c28.65-3.26 35.53-5.43 35.53-5.43l4.54 6.79",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M6266.88 1756.99s-28.5 1.19-66.52-18.46c-38.02-19.67-118.26-69.26-118.26-69.26l-4.76 1.41s98.11 60.53 125.24 73.48c27.14 12.96 57.26 14.78 64.3 12.83",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca240e",
    d: "M5420.85 1018.4s46.01-22.369 60.52-23.388c9.05-.641 23.32.508 32.77 1.457V984.02l-8.45-19.282c-8.87-1.008-21.67-1.687-21.67-1.687l-59.61 25.258-4.59 14.171 1.03 15.92",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca240e",
    d: "M5130.18 1192.88l47.46-32.86-1.69-12.96-9.41-9.02-37.79 27.43-2.55 12.83 3.98 14.58",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5986.33 1396.12s25.55-31.87 48.68-98.18c10.29-29.53 8.82-29.9 8.82-29.9l-44.98-23s-6.67 57.91-40.73 136.82c-3.2 7.4 28.21 14.26 28.21 14.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7e00",
    d: "M5737.2 1281.47c1.35.95 136.73 97.01 196.62 130.87 58.72 33.23 134.85 58.42 156.73 61.08l-.24 2.01c-21.21-2.56-96.02-26.53-157.5-61.32-59.97-33.91-195.43-130.02-196.79-130.99l1.18-1.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7e00",
    d: "M5404.76 1488.6c33.77 29.74 169.71 112.83 240.56 151.3 66 35.85 92.29 36.7 92.55 36.7l-.03 2.04c-1.06-.02-26.9-.78-93.49-36.96-63.09-34.26-204.9-119.8-240.94-151.54l1.35-1.54",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M5447.29 829.602s-18.04 8.058-25.51 19.597c-7.47 11.539-34.63 23.582-34.63 23.582s-79.13 43.989-130.73 71.828c-51.62 27.84-117.14 71.991-117.14 71.991s-8.49 8.34-10.53 4.34c-2.04-4.01-2.55-4.85-2.55-4.85s7.21-16.758 31.93-36.86c10.57-8.601 251.66-146 268.06-154.492 6.83-3.527 24.49-11.609 38.82-15.558 20.14-5.551 41.51-6.95 45.02 5.82-25.59 5.16-64.99 14.332-64.99 14.332l2.25.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6551.14 1477.52s10.6-8.9 14.77-10.44c4.17-1.53 22.74 8.92 26.78 19.61-6.28 10.57-11.5 14.39-11.5 14.39s-.38-9.42-30.05-23.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6572.34 1521.96s-1.79 14.44-14.11 36.67c1.9-.12 3.77-.65 5.52-1.37 1.36-1.02 2.36-1.81 2.36-1.81s15.9-30.3 18.7-39.47c2.81-9.17 2.07-17.44 2.07-17.44l-12.24 15.01-.01-5.08s.63-2.29-9.81-10.44c-10.44-8.17-20.49-12.61-20.49-12.61l-9.54 7.31c15.29 5.03 36 14.52 37.55 29.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6127.82 1679.38l68.57-33.34c2.76-1.35 2.49-3.92-.61-5.75l-5.09-3c-3.1-1.82-7.85-2.21-10.61-.87l-68.57 33.35c-2.76 1.34-2.49 3.91.61 5.74l5.09 3c3.1 1.82 7.85 2.21 10.61.87",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6277.91 1592.37l56.12-41.77c2.27-1.69 1.82-4.38-.98-6.01l-4.62-2.68c-2.8-1.63-6.92-1.58-9.18.1l-56.12 41.78c-2.27 1.69-1.83 4.37.98 6l4.61 2.68c2.81 1.63 6.92 1.59 9.19-.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M6085.9 1476.88s-37.31 35.46-106.32 80.19c5.72 1.73 10.78 4.72 6.46 8.01-.85.65-2.19 1.59-3.92 2.76 15.43 2.5 41.06 6.24 69.94 8.8 4.82-2.82 9.41-5.61 13.69-8.36 1.02-.65 2.03-1.3 3.04-1.94l-18.78-2.41 133.11-81.58c-7.94.3-15.4.52-22.25.76-4.43.16-8.7.24-12.8.24-38.76 0-62.17-6.47-62.17-6.47",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2021",
    d: "M5979.58 1557.07c-4.14 2.68-8.39 5.39-12.76 8.14 0 0 5.67 1.07 15.3 2.63 1.73-1.17 3.07-2.11 3.92-2.76 4.32-3.29-.74-6.28-6.46-8.01",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303942",
    d: "M6319.36 1458.07c-35.65 14.94-74.29 20.42-108.17 22.82l-11.41 19.49-106.23 69.13-24.76-3.17c-1.01.64-2.02 1.29-3.04 1.94-4.28 2.75-8.87 5.54-13.69 8.36 18.78 1.67 38.95 2.84 58.56 2.84 34.3 0 66.92-3.57 87.67-14.27 54.76-38.33 89.66-58.28 121.07-107.14",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303942",
    d: "M6211.19 1480.89c-9.82.69-19.23 1.13-28.07 1.46l-133.11 81.58 18.78 2.41 24.76 3.17 106.23-69.13 11.41-19.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M5763.73 1086.2c-4.34-10.76.31-18.09 2.55-20.72 2.45-2.87 43.69 21.98 47.76 25.86 4.07 3.88 1.54 14.72.81 17.28-.73 2.56-51.12-22.42-51.12-22.42",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5798.5 1108.91l-28.17-16.26c-3.65-2.11-6.6-7.21-6.6-11.39v-1.47c0-4.17 2.95-5.86 6.6-3.75l38.74 22.36c4.36 2.52 6.59 9.79 3.6 11.69-3.69 2.34-8.81 1.91-14.17-1.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M5774.98 1087.03c0-2.25-1.58-5-3.55-6.13-1.97-1.13-3.56-.23-3.56 2.02 0 2.26 1.59 5 3.56 6.13 1.97 1.14 3.55.23 3.55-2.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9199ab",
    d: "M6062.76 1251.43c-4.33-10.76.32-18.09 2.56-20.73 2.44-2.87 43.68 21.99 47.76 25.87 4.06 3.88 1.54 14.73.81 17.29-.74 2.55-51.13-22.43-51.13-22.43",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6097.53 1274.13l-28.16-16.26c-3.65-2.1-6.61-7.2-6.61-11.39v-1.45c0-4.19 2.96-5.87 6.61-3.76l38.74 22.36c4.35 2.51 6.59 9.79 3.6 11.69-3.69 2.34-8.82 1.91-14.18-1.19",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c100f",
    d: "M6074.02 1252.26c0-2.26-1.59-5-3.55-6.14-1.96-1.13-3.56-.22-3.56 2.03s1.6 4.99 3.56 6.13c1.96 1.14 3.55.23 3.55-2.02",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424d",
    d: "M6346.04 1376.93c16.38 4.67 18.47 1.58 17.22-1.97-1.37-3.85-27.95-29.47-33.04-28.69-5.09.78 2.55 10.8-1.98 23.53 6.4 2.72 17.8 7.13 17.8 7.13",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272e36",
    d: "M5225.42 1255.11c23.27-20.87 71.22-50.28 120.29-77.99 1.2-.64 2.41-1.27 3.6-1.97 1.34-.78 2.68-1.49 4.02-2.26l.42-.21a2720.15 2720.15 0 0150.07-27.36l.07-.07c10.79-5.71 21.08-11.14 30.67-16.15l.35-.21c68.33-33.77 132.57-49.78 140.89-51.13 7.47-1.12 39.63 19.79 61.35 54.55-14.24 6.63-113.66 52.6-168.18 81.37-58.73 30.96-172.18 108.66-172.18 108.66l-108.04-23.58s-1.41-9.52 36.67-43.65",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373f45",
    d: "M5621.87 1139.41c-33.41 15.57-108.23 50.7-152.9 74.27-7.14 3.77-15.09 8.22-23.55 13.15 6.63 7.21 13.75 15.16 21.35 23.92 56.11 64.68 122.66 112.37 122.66 112.37s82.49-48.71 148.42-77.83c-14.79-16.79-74.69-91.22-115.98-145.88",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f4950",
    d: "M5576.43 1082.91c-11.98 0-36.61 10.5-77.99 25.35-53.95 19.36-117.71 56.93-117.71 56.93s22.36 15.61 64.69 61.64c8.46-4.93 16.41-9.38 23.55-13.15 44.67-23.57 119.49-58.7 152.9-74.27-17.8-23.55-32.13-43.42-37.91-53.43-1.43-2.1-3.9-3.07-7.53-3.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e42",
    d: "M5689.4 1092.7l-30.55-17.67c-4.87-2.8-7.44-7.93-6.78-13.43l4.88-40.25c.96-7.87 10.83-12.7 17.79-8.68l30.55 17.66c4.87 2.8 7.44 7.92 6.78 13.43l-4.88 40.25c-.96 7.87-10.84 12.7-17.79 8.69",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3633.48 1968.84c-19.47 0-38.66 6.37-54.38 18.85-14.01 11.13-21.11 22.26-21.11 33.09v95.21h5.79v-95.21c0-8.97 6.36-18.58 18.92-28.56 25.76-20.45 61.54-23.31 91.14-7.31 25.51 13.79 53.84 28.78 82.83 44.11 97.77 51.73 245.55 129.91 240.11 144.44-4.44 11.87-54.32 36.57-98.32 58.36-54.37 26.91-87.6 44.02-90.89 54.81-4.12 13.52 14.44 24.92 32.38 35.96 13.33 8.2 28.46 17.49 28.59 25.13.26 15.44.1 99.82.02 145.15l-.03 24.8c-.09 3.19-2.08 80.32 15.13 98.14l4.16-4.02c-12.89-13.35-14.12-72.42-13.5-94.05l.04-24.86c.07-45.35.22-129.76-.04-145.25-.18-10.81-15.32-20.12-31.34-29.97-15.32-9.42-32.69-20.1-29.87-29.35 2.79-9.17 48.01-31.55 87.91-51.31 57.95-28.69 96.3-48.47 101.18-61.51 6.74-18-87.25-69.28-242.82-151.58-28.98-15.33-57.29-30.31-82.79-44.1-13.6-7.35-28.44-10.97-43.11-10.97",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M3533.74 2189.93c-4 2.96-8.73 4.02-9.16 4.04-2.92.2-8.85-.36-12.59-9.92-1.09-2.78-1.27-5.91-.89-8.09.15-.87 2.68-5.03 3.64-6.29 2.65-3.47 6.54-5.97 7.67-4.95 1.13 1.02 11.33 25.21 11.33 25.21",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1479)",
    d: "M3568.56 2112.21c-.5-2.11-4.36-4.63-7.36-5.42l-2.34-.19-.45.15-5.59 1.89c-1.91.65-3.4 2.15-4.05 4.06l-11.06 27.64c-2.45 7.27-6.99 13.66-13.11 18.27-3.52 2.67-6.8 5.76-7.81 7.96-1.54 3.38-1.9 6.59-1.68 9.38.09 1.12.27 2.17.5 3.14.3 1.27.69 2.4 1.08 3.35.85 2.01 1.71 3.2 1.71 3.2s1.91 3.3 6.24 5.24c1.24.56 2.31.93 3.21 1.19 2.11.6 4.38.15 6.11-1.21l10.41-8.13a42.835 42.835 0 0015.67-25.57s6.39-29.94 8.11-41.11c.24-1.52.39-2.7.42-3.39l-.01-.45",
    clipPath: "url(#clipPath1479)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3542.76 2175.16c-7.34-4.42-3.56-8.55.84-16.05 4.4-7.51 12.42-17.29 15.01-16.25 2.59 1.04 1.05 14.08-2.2 22.33-3.25 8.25-6.95 12.08-8.43 12.08-1.49 0-5.22-2.11-5.22-2.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3568.56 2112.21c-.5-2.11-4.36-4.63-7.36-5.42l-2.34-.19-.45.15-5.59 1.89c-1.91.65-3.4 2.15-4.05 4.06l-11.06 27.64c-2.45 7.27-6.99 13.66-13.11 18.27-3.52 2.67-6.8 5.76-7.81 7.96-1.54 3.38-1.9 6.59-1.68 9.38.09 1.12.27 2.17.5 3.14.3 1.27.69 2.4 1.08 3.35-.02-2.45 1.03-4.75 3.1-6.77 4.53-4.4 17.21-11.51 20.06-22.77 2.85-11.26 2.33-17.99 5.43-26.4 3.11-8.41 5.5-11.77 8.35-13.52 2.84-1.75 5.37-2.2 6.85-1.94 1.1.18 5.7 1.58 7.67 5.01.24-1.52.39-2.7.42-3.39l-.01-.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeceb",
    d: "M3529.69 2192.07c-3.2-.45-7.38-2.88-7.83-3.72 4.66-2.97 18.37-13.91 18.37-13.91s3.37 2.33 5.76 3.11c-2.26 2.98-16.3 14.52-16.3 14.52",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M3520.3 2193.42s-3.06-1.41-4.33-3.2c1.75-1.26 3.5-2.51 3.5-2.51s2 2.31 4.85 3.23c-1.03.81-4.02 2.48-4.02 2.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M3547.8 2175.41c-3.72-1.17-7.17-3.43-7.17-5.11 0-1.6 7.69-16.42 14.23-21.9.96-.79 2.44-.28 2.64.94l.07.97c.07 1.1-1.01 11.45-4.23 17.8-3.21 6.33-4.83 7.52-5.54 7.3",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3561.08 2135.14l-.95-8.7 2.72 1.43z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M3561.85 2127.34l2.63 1.45-1.25-9.53z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2994.6 2406.51c-19.45 0-38.65 6.37-54.37 18.85-14.01 11.13-21.11 22.27-21.11 33.1v261.69h5.79v-261.69c0-8.98 6.36-18.59 18.92-28.57 25.75-20.45 61.54-23.32 91.14-7.3 28.05 15.16 59.23 31.56 89.38 47.42 93.44 49.13 221.41 116.44 216.12 130.56-4.44 11.87-54.32 36.57-98.33 58.36-54.35 26.9-87.59 44.01-90.88 54.8-4.12 13.52 14.44 24.93 32.38 35.96 13.34 8.2 28.46 17.5 28.59 25.14.24 14.91.11 68.01.04 99.74l-.05 22.38c-.09 3.2-2.08 80.34 15.13 98.15l4.16-4.03c-12.89-13.34-14.12-72.4-13.5-94.04l.05-22.45c.07-31.75.2-84.88-.05-99.84-.18-10.81-15.31-20.12-31.34-29.97-15.32-9.43-32.69-20.11-29.87-29.36 2.79-9.17 48.01-31.55 87.91-51.3 57.95-28.69 96.31-48.48 101.18-61.51 6.37-17.04-65.28-56.96-218.84-137.72-30.14-15.85-61.31-32.23-89.33-47.39-13.6-7.35-28.44-10.98-43.12-10.98",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M2894.87 2794.09c-4.01 2.96-8.73 4.02-9.16 4.05-2.92.19-8.85-.37-12.58-9.93-1.09-2.78-1.28-5.91-.9-8.08.15-.88 2.68-5.03 3.64-6.3 2.65-3.46 6.54-5.96 7.67-4.94 1.13 1.02 11.33 25.2 11.33 25.2",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1495)",
    d: "M2929.7 2716.37c-.52-2.1-4.37-4.63-7.37-5.41l-2.34-.19-.45.15-5.58 1.89a6.478 6.478 0 00-4.06 4.06l-11.06 27.64c-2.45 7.26-6.99 13.65-13.11 18.27-3.52 2.66-6.8 5.75-7.81 7.96-1.53 3.38-1.89 6.59-1.67 9.37.08 1.13.25 2.18.48 3.15.31 1.27.7 2.4 1.1 3.34.84 2.02 1.7 3.2 1.7 3.2s1.91 3.3 6.24 5.24c1.25.56 2.31.94 3.21 1.19 2.11.6 4.38.15 6.11-1.2l10.41-8.13a42.86 42.86 0 0015.67-25.58s6.38-29.94 8.12-41.1c.23-1.53.38-2.71.42-3.4l-.01-.45",
    clipPath: "url(#clipPath1495)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2903.89 2779.32c-7.34-4.42-3.56-8.54.84-16.05 4.4-7.5 12.42-17.28 15.01-16.25 2.58 1.04 1.05 14.09-2.2 22.34-3.25 8.24-6.95 12.07-8.43 12.07-1.48 0-5.22-2.11-5.22-2.11",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2929.7 2716.37c-.52-2.1-4.37-4.63-7.37-5.41l-2.34-.19-.45.15-5.58 1.89a6.478 6.478 0 00-4.06 4.06l-11.06 27.64c-2.45 7.26-6.99 13.65-13.11 18.27-3.52 2.66-6.8 5.75-7.81 7.96-1.53 3.38-1.89 6.59-1.67 9.37.08 1.13.25 2.18.48 3.15.31 1.27.7 2.4 1.1 3.34-.02-2.44 1.02-4.75 3.09-6.77 4.53-4.4 17.21-11.51 20.06-22.76 2.84-11.26 2.33-18 5.44-26.41 3.1-8.41 5.49-11.77 8.34-13.52 2.85-1.75 5.37-2.2 6.86-1.94 1.09.19 5.69 1.59 7.67 5.02.23-1.53.38-2.71.42-3.4l-.01-.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeceb",
    d: "M2890.82 2796.24c-3.2-.45-7.38-2.88-7.83-3.73 4.66-2.97 18.38-13.9 18.38-13.9s3.36 2.33 5.75 3.1c-2.26 2.98-16.3 14.53-16.3 14.53",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M2881.43 2797.59s-3.07-1.42-4.33-3.2l3.5-2.52s2.01 2.32 4.85 3.24c-1.04.8-4.02 2.48-4.02 2.48",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M2908.94 2779.58c-3.73-1.18-7.19-3.43-7.19-5.11 0-1.61 7.7-16.43 14.25-21.91.94-.79 2.43-.28 2.62.94l.09.97c.06 1.1-1.02 11.45-4.23 17.8-3.22 6.34-4.84 7.53-5.54 7.31",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2922.21 2739.3l-.95-8.7 2.72 1.44z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M2922.97 2731.51l2.65 1.44-1.25-9.53z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1819.93 702.781c-18.47 0-36.86 4.449-53.6 13.258l-151.53 79.77a112.65 112.65 0 00-59.4 86.472c-5.83 49.231-12.78 111.961-12.78 131.089h8.19c0-18.729 6.92-81.1 12.72-130.14a104.474 104.474 0 0155.09-80.171l151.53-79.77c27.49-14.469 59.83-16.289 88.73-4.937 63 24.718 97.45 47.929 92.16 62.097-5.06 13.52-33.58 14.082-63.77 14.68-39.79.781-84.9 1.672-98.21 32.5-1.8 4.18-1.76 8.519.14 12.91 5.21 12.07 25.44 24.57 60.12 37.152 23.42 8.481 39.07 31.098 38.94 56.27-.18 36.43-.38 86.869-.38 124.779 0 67.75 0 95.42 19.69 108.37l4.5-6.86c-16-10.51-16-36.88-16-100.59 0-38.81.2-89.25.39-125.672.14-28.617-17.68-54.34-44.35-64.019-31.55-11.43-51.23-23.047-55.39-32.68-.99-2.289-1.03-4.328-.13-6.418 11.21-25.98 53.52-26.812 90.84-27.551 34.49-.672 64.27-1.261 71.28-20 7.49-20.031-25.09-44.449-96.83-72.609a114.995 114.995 0 00-41.95-7.93",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M1508.27 1118.12c-5.68 4.18-12.37 5.69-12.98 5.73-4.14.27-12.54-.52-17.82-14.06-1.55-3.95-1.81-8.37-1.27-11.46.21-1.24 3.8-7.13 5.16-8.92 3.74-4.9 9.26-8.44 10.86-7.01 1.6 1.45 16.05 35.72 16.05 35.72",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1511)",
    d: "M1557.6 1008.01c-.72-2.97-6.19-6.55-10.44-7.67-1.27-.33-2.42-.449-3.31-.26l-.64.21-7.91 2.69a9.09 9.09 0 00-5.73 5.74l-15.68 39.15c-3.47 10.29-9.9 19.35-18.56 25.88-5 3.78-9.64 8.14-11.07 11.28-2.18 4.78-2.69 9.34-2.38 13.28.12 1.59.38 3.08.7 4.45.43 1.8.98 3.4 1.55 4.74 1.19 2.86 2.41 4.54 2.41 4.54s2.7 4.67 8.84 7.41c1.76.79 3.27 1.33 4.54 1.69 3 .85 6.21.21 8.66-1.7l14.74-11.52a60.65 60.65 0 0022.2-36.23s9.05-42.41 11.5-58.21c.33-2.17.54-3.84.59-4.83l-.01-.64",
    clipPath: "url(#clipPath1511)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1521.04 1097.19c-10.4-6.26-5.04-12.1 1.2-22.74 6.23-10.63 17.58-24.48 21.25-23.01 3.67 1.46 1.5 19.95-3.11 31.63-4.6 11.68-9.84 17.1-11.94 17.1-2.1 0-7.4-2.98-7.4-2.98",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1557.6 1008.01c-.72-2.97-6.19-6.55-10.44-7.67-1.27-.33-2.42-.449-3.31-.26l-.64.21-7.91 2.69a9.09 9.09 0 00-5.73 5.74l-15.68 39.15c-3.47 10.29-9.9 19.35-18.56 25.88-5 3.78-9.64 8.14-11.07 11.28-2.18 4.78-2.69 9.34-2.38 13.28.12 1.59.38 3.08.7 4.45.43 1.8.98 3.4 1.55 4.74-.03-3.47 1.45-6.74 4.38-9.58 6.42-6.23 24.38-16.32 28.41-32.27 4.03-15.94 3.3-25.47 7.7-37.39 4.4-11.91 7.79-16.68 11.82-19.16 4.03-2.47 7.61-3.1 9.71-2.74 1.55.27 8.07 2.24 10.87 7.12.33-2.17.54-3.84.59-4.83l-.01-.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeceb",
    d: "M1502.53 1121.14c-4.54-.62-10.45-4.07-11.09-5.26 6.6-4.22 26.03-19.71 26.03-19.71s4.77 3.3 8.16 4.41c-3.21 4.21-23.1 20.56-23.1 20.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M1489.23 1123.06s-4.34-2.01-6.13-4.52c2.48-1.79 4.95-3.58 4.95-3.58s2.84 3.29 6.87 4.59c-1.46 1.14-5.69 3.51-5.69 3.51",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M1528.19 1097.55c-5.28-1.67-10.17-4.85-10.17-7.24 0-2.27 10.9-23.26 20.17-31.02 1.35-1.14 3.45-.41 3.72 1.32l.12 1.38c.09 1.55-1.44 16.22-5.99 25.21-4.55 8.97-6.86 10.66-7.85 10.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1546.99 1040.5l-1.34-12.33 3.85 2.04z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M1548.08 1029.45l3.74 2.05-1.78-13.5z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4b8",
    d: "M5616.64 3284.59l-19.34-11.17c-3.07-1.78-4.71-5.02-4.28-8.51l3.08-25.48c.61-4.98 6.86-8.03 11.26-5.49l19.34 11.18c3.08 1.78 4.72 5.02 4.29 8.5l-3.09 25.48c-.61 4.99-6.86 8.04-11.26 5.49",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5605.43 3272.42c5.76 3.64 11.76.46 13.41-7.08 1.65-7.54-1.66-16.61-7.42-20.25-5.73-3.63-11.73-.44-13.38 7.1-1.65 7.54 1.66 16.6 7.39 20.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5873.54 692.289c-33.64 0-66.81 11.012-93.99 32.582-24.21 19.219-36.48 38.461-36.48 57.188v164.543h10V782.059c0-15.528 11-32.129 32.7-49.348 44.52-35.332 106.35-40.313 157.52-12.652 541.81 292.971 894.22 500.451 897.8 528.581-7.57 19.93-29.96 31.9-51.61 43.47-22.05 11.79-42.88 22.93-48.93 42.83-7.12 23.37 24.94 43.09 55.94 62.15 23.06 14.17 49.19 30.24 49.41 43.46.45 26.69.19 172.51.07 250.85l-.07 42.84h10l.07-42.83c.12-78.37.38-224.25-.07-251.04-.31-18.69-26.47-34.77-54.17-51.8-26.48-16.28-56.49-34.73-51.62-50.72 4.86-15.95 23.91-26.13 44.08-36.92 23.29-12.44 47.36-25.32 56.39-49.45 3.34-8.91 10.27-27.46-363.15-241.31-197.1-112.881-422.54-235.729-539.38-298.9-23.52-12.719-49.14-18.981-74.51-18.981",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d5e60",
    d: "M6964.36 2196.83l-338.74 196.85-50.91-29.39 338.74-196.85 50.91 29.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d5e60",
    d: "M6913.45 2167.44l1.27-581.09 50.91 29.38-1.27 581.1-50.91-29.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d2d2",
    d: "M6880.78 1551.12l-83.48 48.51-168.79 98.12-57.05 33.13a49.705 49.705 0 00-24.74 42.88l-1.36 608.69 334.02-194.07 1.4-637.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e5e4",
    d: "M6899.71 2223.64l-333.97 194.08-20.36-35.26 333.97-194.08 20.36 35.26",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ded8d7",
    d: "M6946.9 2250.89l-333.97 194.09-47.19-27.26 333.97-194.08 47.19 27.25",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aea4a4",
    d: "M6899.71 2223.64l-20.36-35.26 1.42-637.24 7.45-4.25 42.71 24.66a34.897 34.897 0 0117.44 30.3l-1.47 649.04-47.19-27.25",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b3f40",
    d: "M6837.84 1685.91v267.9c-101.38 61.94-244.19 146.86-244.19 146.86-2.26 1.31-4.12-.09-4.12-3.12v-267.89c0-3.03 146.93-87.85 248.31-143.75",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ea82f",
    d: "M6711.2 2162.83l25.04-23.06-29.69 82.77z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ea82f",
    d: "M6718.06 2112.71l-2.65 55.39-24.29 23.59z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ea82f",
    d: "M6687.61 2238.22c-4.77 0-9.12-1.09-12.93-3.3-9.44-5.44-14.62-17.17-14.62-33.04 0-34.46 24.44-76.62 54.49-93.97 13.97-8.06 26.9-9.49 36.42-3.97 9.42 5.43 14.61 17.16 14.61 33.03 0 34.48-24.44 76.63-54.49 93.98-8.37 4.83-16.37 7.27-23.48 7.27zm50.45-144.5c-8.34 0-17.51 2.75-26.97 8.21-31.95 18.45-57.94 63.29-57.94 99.95 0 18.44 6.42 32.3 18.07 39.03 11.74 6.78 27.13 5.38 43.33-3.99 31.94-18.43 57.93-63.28 57.93-99.95 0-18.43-6.42-32.29-18.06-39.02-4.89-2.82-10.41-4.23-16.36-4.23",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b3f40",
    d: "M6797.3 1676.65v-77.02l-168.79 98.12v76.74l168.79-97.84",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b3f40",
    d: "M6589.53 1829.66l248.31-143.75-40.54-9.27-168.8 97.85-38.97 55.17",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0486b8",
    d: "M6634.62 2020.62l156.41-90.31v-165.06l-156.41 90.31v165.06",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29b8f0",
    d: "M6669.9 1910.02l85.84-49.56v-46.14l-85.84 49.56v46.14",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5882.18 2931.2c-10.15 0-19.28 3.17-26.8 9.36-16.32 13.4-24.94 40.27-24.94 77.68 0 15.14 3.62 38.67 7.82 65.93 11.09 72.15 27.85 181.18-20.39 193.95l2.56 9.67c56.93-15.08 40.04-124.93 27.7-205.13-4.12-26.86-7.69-50.04-7.69-64.42 0-33.84 7.57-58.68 21.29-69.96 7.76-6.38 17.51-8.47 28.95-6.21 22.86 4.5 233.97 131.99 373.67 216.35 73.44 44.35 131.45 79.38 147.79 88.08 54 28.74 111.16 1.9 149.45-20.83 12.04-7.13 21.17-9.01 27.13-5.64 12.04 6.86 13.58 35.46 13.58 59.61v153.97c0 37.14 13.5 47.44 26.69 52.63l3.66-9.32c-9.85-3.85-20.35-10.71-20.35-43.31v-153.97c0-29.96-2.25-58.97-18.63-68.29-9.45-5.39-21.61-3.53-37.19 5.73-39.26 23.31-90.65 46.69-139.63 20.6-16.12-8.58-74.02-43.55-147.34-87.82-192.75-116.4-354.16-213.12-376.89-217.59-3.59-.72-7.06-1.07-10.44-1.07",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M5686.6 3275.43c-2.97-8.07-2.44-16.43-2.28-17.16 1.08-4.94 4.88-14.5 22.55-16.08 5.14-.46 10.42.74 13.85 2.42 1.38.68 7.05 6.88 8.68 9.09 4.48 6.06 6.75 13.73 4.51 15.11-2.24 1.39-47.31 6.62-47.31 6.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1541)",
    d: "M5824.16 3294.55c-2.7-12.28-10.92-24.76-18.42-26.26-7.5-1.51-31.8 5.55-31.42 11.61.38 6.05 22.67 33.97 22.67 33.97l27.17-19.32",
    clipPath: "url(#clipPath1541)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1548)",
    d: "M5820.87 3295.49c4.18-3.7 5.64-6.47 6.27-9.18.61-2.69-1.75-10.88-1.75-10.88-.55-3.44-11.84-1.96-14.34-1.3l-54.34 13.1c-5.31-1.25-9.02.55-13.72-11.82-2.72-7.14-6.95-13.43-9.45-16.82-7.93-10.8-24.94-6.72-24.94-6.72s-6.76 1.72-20.64 11.92c-3.06 2.25-4.42 8.03-3.01 11.55l8.46 21.2c1.19 2.99 2.58 5.89 4.13 8.67 14.66 26.22 47.89 36.88 74.4 22.76l.71-.38c2.35-1.28 31.5-17.3 48.22-32.1",
    clipPath: "url(#clipPath1548)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5753.24 3331.59c-19.61 3.12-43.72-10.43-46.11-17.01-2.39-6.57 12.28-9.66 16.41-9.47 4.11.19 11.25 18.12 39.12 16.71 12.18-.62 5.6 7.37-9.42 9.77",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5719.74 3251.1c13.75 24.83 20.62 41.1 27.91 42.33 19.79 3.33 56.04-14.47 65.62-15.47 9.59-.99 12.07 13.2 9.84 15.37-2.24 2.16 5.79-6.36 5.79-6.36s.21-12.71-3.54-15.42c-3.75-2.71-13.75-1.25-13.75-1.25l-54.13 15.21s-8.37-.42-9.62-3.33c-1.25-2.92-10.42-20.97-12.29-25.7-1.88-4.72-15.83-5.38-15.83-5.38",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#483b46",
    d: "M5947.41 2829.66c-50.68 0-91.78 18.76-91.78 41.9 0 23.14 41.1 41.9 91.78 41.9 50.69 0 91.79-18.76 91.79-41.9 0-23.14-41.1-41.9-91.79-41.9",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612f10",
    d: "M5978.98 3598.38c46.88 16.53 62.46-43.58 45.21-76.2-16.81-31.78 6.23-49.21 33.9-42.52-6.26-40.83-42-34.61-61.76-21.99-19.76 12.61-36.07 36.59-26.14 72.09 9.91 35.51 8.79 68.62 8.79 68.62",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M6025.31 2928.54c7.36-15 9.46-21.9 7.51-30.16-1.95-8.25-3.15-7.95-2.55-20.25.6-12.3-1.91-14.86-1.91-14.86s-1.69-1.05-2.89-.75c-1.2.3-4.81 1.95-4.81 1.95s1.65 19.21.31 19.81c-1.35.6-7.43-25.68-19.21-34.21-13.58-9.84-32.79-13.96-40.13-7.28-4.29 12.53 6.37 24.21 11.17 33.08 2.39 4.41 11.37 19.32 17.83 30.39 6.56 11.26 10.61 18.69 16.73 21.18 12.16 4.95 17.95 1.1 17.95 1.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1557)",
    d: "M5997.86 2970.33c.78-8.7 1.11-16.63.76-22.79-1.66-28.82-3.36-39.42-3.36-39.42s31.41-7.2 31.83 6.79c.39 12.71 2.41 24.98 3.67 46.21-11.72 3.62-20.93 6.53-32.9 9.21",
    clipPath: "url(#clipPath1557)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1561)",
    d: "M6027.37 2920.71s2.44-7.92-6.1-16.47c-8.56-8.56-22.36-31.87-36.02-29.02-13.65 2.86 7.28 22.95 11.57 47.08 1.37 7.75 1.11 14.22 1.11 14.22l29.44-15.81",
    clipPath: "url(#clipPath1561)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3d6",
    d: "M5933.44 2946.42c8.6-4.7 10.86-12.21 9.21-25.21-1.04-8.15-1.17-6.91-2.37-14.68-1.2-7.77-.26-15.19-2.18-16.95-1.93-1.77-6.28 0-6.28 0l-2.59 12.19c-.45.9-6.93-1-13.1-13.72-6.16-12.71-19.49-25.51-44.86-26.31-7.13-.63-14.95 1.99-15.03 7.93-.1 6.59 19.63 24.67 27.19 33.19 7.55 8.52 12.7 21.34 21.45 29.71 8.75 8.36 5.71 14.85 9.76 16.05 4.04 1.2 18.8-2.2 18.8-2.2",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1566)",
    d: "M5904.1 2939.46c.03-8.84-13.62-28.5-17.82-38.25-4.21-9.76 19.93-2.14 26.25 6.13 6.31 8.27 17.86 11.72 24.01 19.53 6.16 7.8.78 22.48.78 22.48l-33.22-9.89",
    clipPath: "url(#clipPath1566)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1570)",
    d: "M5898.93 2986.53c3.75-25.78 6.34-47.96 4.84-51.99-3.82-10.18-6.37-15.06-6.37-15.06s15.32-1.01 26.78 5.57 15.11 15.68 15.11 15.68-1.38 19.48-1.53 40.4c-12.87 1.99-25.83 3.85-38.83 5.4",
    clipPath: "url(#clipPath1570)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a3638",
    d: "M5979.84 3073.45s-5.85 13.76-1.11-14.17c4.74-27.93 14.88-109.35 15.1-130.56 0 0 4.48-5.66 16.29-5.69 17.84-.04 19.94 9.82 20.64 15.27.31 2.44 7.5 88.25-.05 121.26-7.56 33.01-18.91 48.99-18.91 48.99l-31.96-35.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283436",
    d: "M5891.56 3076.8c3.25-26.89 7.42-125.56 9.35-132.64 1.91-7.08 21.76-9.63 29.01-2.28 7.26 7.35 8.54 14.17 8.54 14.17s12.29 87.73 8.07 112.81c-4.22 25.08-10.84 32.03-10.84 32.03l-44.13-24.09",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1576)",
    d: "M5884.44 3428.93s-20.27-64.2-20.97-70.83c-.71-6.63 19.28-32.35 27.53-24.28 8.24 8.08 18.4 76.52 18.4 76.52l-24.96 18.59",
    clipPath: "url(#clipPath1576)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ea82f",
    d: "M5934.22 3488.29c-12.63 5.1-28.79-4.17-36.33-17.07-7.53-12.91-23.5-44.64-26.31-56.83-2.8-12.18 33.94-20.67 36.78-18.37 2.83 2.29 25.86 92.27 25.86 92.27",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1581)",
    d: "M5846.27 3309.68c12.6 4.78 25.68 9.67 37.13 16.87 2.47 1.56 5.41 3.37 6.93 5.96 6.13 10.47-6.75 17.38-6.75 17.38-1.29 2.33-18.52 7.98-20.13 6.43-1.6-1.54-40.35-34.78-41.31-35.08l-3.26.89c-2.08.7-4.15 1.42-6.27 2-2.32.63-4.16.82-6.51.63-3.22-.27-6.5.57-9.61 1.3-1.76.42-3.53.83-5.2 1.54-1.34.56-2.6 1.3-3.9 1.93-3.56 1.72-7.52 2.6-11.47 2.56l-2.21-.47c-.86-.58-1.21-1.71-1.07-2.74.12-1.02.66-1.95 1.25-2.8 2.98-4.31 7.58-7.27 12.41-9.33 2.82-1.21 6.06-1.86 8.75-3.29 3.2-1.71 6.21-4.12 9.24-6.13 6.25-4.13 12.49-8.26 18.74-12.38l1.13-.4c1.08.18 1.94 3.9 2.56 4.85 1.36 2.13 3.11 4.01 5.41 5.12 4.42 2.15 9.53 3.41 14.14 5.16",
    clipPath: "url(#clipPath1581)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1585)",
    d: "M6016.91 3347.75c.65-1.29 3.36-36.21 4.91-41.78 1.54-5.56 8.24-7.57 18.88-4.2 10.66 3.37 19.35 10.11 19.61 19.74.27 9.63-.69 29-.69 29l-42.71-2.76",
    clipPath: "url(#clipPath1585)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283436",
    d: "M5899.88 3317.37c-5.84-2-13.72-33.9-15.17-95.84-.74-30.89-.52-130.45 8.46-148.48s39.98-7.59 44.69 1.94c4.71 9.53 2.41 137.88 4.9 156.98 2.49 19.11-13.99 59.99-13.99 59.99s-19.79 28.52-28.89 25.41",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a3638",
    d: "M5921.58 3271s-5.02-35.48-.06-57.4 17.68-20.69 17.68-20.69 30.69-126.35 41.33-135.84c10.64-9.5 36.91-12.06 38.38 16.04 1.46 28.09 11.14 136.67 8.12 164.12-3.01 27.46-10.59 50.57-10.59 50.57l-94.86-16.8",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f9e17",
    d: "M5969.12 3489.54c25.38-7.68 14.13-5.82 26.83-11.29 12.69-5.47 34.74-18.12 42.34-26.07 9.23-9.65-17.57-54.82-20.84-77.57-3.27-22.75-1.38-81.31-2.31-86.43-2.85-15.47-38.69-35.57-77.76-26.76-41.3 9.31-38.27 25.72-41.25 44.96-1.43 9.32 5.62 34.07-5.2 76.55-5.86 23 3.63 46.87 10.76 63.83 6.03 14.37 8.87 22.85 14.87 31.32 11.85 16.71 38.71 11.07 38.71 11.07l13.85.39",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f9e17",
    d: "M5901.69 3446.76s-23.41-36.45-24.26-54.51c-.84-18.07 21.33-28.18 33.52-21.67 12.19 6.5-9.26 76.18-9.26 76.18",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#619200",
    d: "M6013.6 3416.46c-5.64-8.79-10.52-21.22-11.62-34.36-.71-8.52-3.68-18.01-9.95-22.59-14.65-10.73-34.89-6.28-49.56 3.33 11.26-9.41 31.27-20.66 51.83-11.97 12.68 5.36 18.83 27.91 23.47 44.14 3.63 12.7-4.17 21.45-4.17 21.45",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1594)",
    d: "M5941.27 3502.71c1.02-4.54-1.13-26.64-2.82-35.91-1.69-9.27 5.89-15.18 20.85-16.85 14.96-1.67 30.1 8.39 36.19 16.58 6.08 8.18-5.07 18.95-5.53 27.28-.46 8.32-1.4 20.03 1.6 28.33 3.01 8.3 4.04 26.16-5.39 27.39-9.43 1.24-44.9-46.82-44.9-46.82",
    clipPath: "url(#clipPath1594)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1598)",
    d: "M5988.43 3540.45s-5.28-30.89-11.28-36.48c-6.01-5.59-31.34-17.83-38.54-18.13-7.2-.3-11.75.74-14.22 5.63-2.46 4.9-8.28 19.09-7.8 37.73.47 18.65 6.05 46.35 8.59 50.24 2.53 3.88 37.82 9.03 40.76 3.97 2.95-5.05 22.49-42.96 22.49-42.96",
    clipPath: "url(#clipPath1598)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d381b",
    d: "M5936.44 3577.47c3.61-3.53 19.63-6.27 25.83-12.51 6.19-6.25 15.85-20.36 15.05-26.8-.78-6.43 1.13-15.3 1.13-15.3s2.83 12.39 7.33 15.38 4.3 2.3 7.63 1.28c3.34-1.02-2.18-15.72-2.18-15.72s-3.95-10.26-4.84-14.46c-.89-4.2 3.46-13.72 3.46-13.72s-.68 8.2 11.2 24.44c6.62 9.02 20.61 35.52 9.56 55.5-11.05 19.98-29.44 22.17-29.44 22.17s-11.06 7.79-24.78 7.74c-21.9-.08-32.1-18.84-33.96-27.18-1.94-8.72-.36-8.85-.36-8.85l3.99 8.38 10.38-.35",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1603)",
    d: "M5988.59 3535.14s4.15 5.52 7.19 5.19c3.04-.33 6.31-4.67 3.34-11.77-2.97-7.09-6.97-11.97-11.92-11.3-4.96.66 1.39 17.88 1.39 17.88",
    clipPath: "url(#clipPath1603)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1607)",
    d: "M6029.28 3313.8s-8.34-1.32-7.46-7.83c.89-6.5 3.09-79.17-.31-91.03s-7.47-19.46-7.47-19.46-5.04-.72-6.74-5.87c-1.7-5.16-6.2-18.63-8.34-21.25-2.16-2.61.83-7.02.83-7.02s-.27-3.5 3.22-7.49 4.21-4.32 11.57-2.77c7.35 1.56 18.45 6.91 20.68 12.95 2.24 6.04 2.41 30.53 2.41 30.53s20.64 85.64 21.8 103.68c1.17 18.04.37 19.84.37 19.84l-30.56-4.28",
    clipPath: "url(#clipPath1607)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ea82f",
    d: "M6032.99 3455.55c-13.14 1.88-23.12-17.04-27.16-40.11-4.03-23.07 10.16-84.34 10.64-87.53.5-3.19 19.63-7.67 33.76-2.65 14.13 5.01 13.18 19.48 12.67 22.49-.51 3.01-15.09 80.47-18.71 93.38-3.62 12.9-11.2 14.42-11.2 14.42",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1612)",
    d: "M5793.12 3281.09c1.19.04 2.34.56 3.53.52 1.06-.03 2.07-.49 3.04-.95 3.25-1.52 6.5-3.04 9.74-4.57.97-.46 2.02-.99 2.4-1.98l-.2-2.26c-.69-1.44-2.13-2.43-3.66-2.91-1.52-.48-3.16-.51-4.77-.46-3.25.09-6.51.48-9.62 1.43-3.07.94-5.95 2.43-8.62 4.22-1.38.93-2.66 1.99-3.99 2.97-1.17.85-5.74 1.67-6.65 2.8-1.71 2.09 2.37 4.43 4.51 5.72 2.56 1.53 5.06.68 7.3-.89 2.12-1.48 4.19-3.75 6.99-3.64",
    clipPath: "url(#clipPath1612)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1a1",
    d: "M5701.16 1074.39c-6.92 5.12-15.09 6.95-15.84 7.01-5.05.33-15.29-.64-21.75-17.16-1.87-4.82-2.2-10.22-1.54-13.99.26-1.51 4.63-8.69 6.3-10.87 4.57-5.98 11.29-10.31 13.25-8.55 1.96 1.76 19.58 43.56 19.58 43.56",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1620)",
    d: "M5761.35 940.07c-.88-3.629-7.55-8-12.74-9.359-1.54-.41-2.96-.539-4.04-.332l-.78.262-9.65 3.281a11.136 11.136 0 00-7 7.008l-19.13 47.769c-4.22 12.551-12.06 23.601-22.64 31.571-6.09 4.6-11.76 9.94-13.5 13.76-2.66 5.84-3.28 11.39-2.91 16.2.15 1.95.46 3.76.85 5.43.53 2.2 1.21 4.15 1.89 5.79 1.46 3.48 2.95 5.54 2.95 5.54s3.29 5.69 10.79 9.05c2.14.95 3.98 1.61 5.54 2.06 3.65 1.03 7.56.25 10.55-2.08l17.99-14.06a74 74 0 0027.09-44.21s11.04-51.738 14.02-71.02c.41-2.652.67-4.679.74-5.89l-.02-.77",
    clipPath: "url(#clipPath1620)",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5716.75 1048.86c-12.7-7.63-6.15-14.76 1.45-27.73 7.6-12.98 21.46-29.88 25.93-28.079 4.47 1.781 1.83 24.339-3.79 38.589-5.61 14.25-12.01 20.86-14.58 20.86-2.56 0-9.01-3.64-9.01-3.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5761.35 940.07c-.88-3.629-7.55-8-12.74-9.359-1.54-.41-2.96-.539-4.04-.332l-.78.262-9.65 3.281a11.136 11.136 0 00-7 7.008l-19.13 47.769c-4.22 12.551-12.06 23.601-22.64 31.571-6.09 4.6-11.76 9.94-13.5 13.76-2.66 5.84-3.28 11.39-2.91 16.2.15 1.95.46 3.76.85 5.43.53 2.2 1.21 4.15 1.89 5.79-.03-4.23 1.78-8.22 5.35-11.69 7.83-7.61 29.74-19.91 34.67-39.36 4.91-19.459 4.02-31.091 9.39-45.619 5.36-14.551 9.5-20.359 14.43-23.383 4.91-3.019 9.27-3.789 11.84-3.347 1.89.328 9.85 2.738 13.25 8.679.41-2.652.67-4.679.74-5.89l-.02-.77",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeceb",
    d: "M5694.16 1078.1c-5.54-.78-12.75-4.98-13.53-6.43 8.05-5.14 31.75-24.04 31.75-24.04s5.82 4.03 9.95 5.37c-3.9 5.14-28.17 25.1-28.17 25.1",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M5677.93 1080.43s-5.29-2.44-7.48-5.52c3.03-2.18 6.04-4.35 6.04-4.35s3.47 4 8.38 5.58c-1.78 1.4-6.94 4.29-6.94 4.29",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M5725.47 1049.31c-6.45-2.03-12.41-5.93-12.41-8.83 0-2.77 13.3-28.39 24.61-37.86 1.64-1.37 4.21-.5 4.54 1.62l.14 1.69c.11 1.89-1.75 19.78-7.31 30.74-5.55 10.96-8.36 13.02-9.57 12.64",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5748.41 979.699l-1.64-15.039 4.69 2.488z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279d2",
    d: "M5749.73 966.23l4.56 2.5-2.16-16.468z",
    transform: "matrix(.13333 0 0 -.13333 0 600)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargers);
export default __webpack_public_path__ + "static/media/chargers.c80443fa728c7cd001147652d34724e1.svg";
export { ForwardRef as ReactComponent };